webpackJsonp([3],{

/***/ "/Zy+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tutorial-tool-competitiveness-1.5eac119.jpg";

/***/ }),

/***/ "0EUV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0gU3":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAABHNCSVQICAgIfAhkiAAAAx5JREFUWIXFmD1T20AQht+VrcoF9gx4UiqtVIRGdUQLRZTBR0MBtDQkv8D2PyAFM+kYt0gzKAUMXaxaDS6kWj+AmbhxdcCmQHb8gW2dv/JWsrS398x573b3CIpyXbdcKBS+aJrmMnOZiMoAdrPPj8zcJaL09fW1/fLy8isIgq6Kf8preHh46BLRBRE5KhMwcxtA0/f99kqAarWaA6CuCrIo2EwgIcQ1gNNlQN4Bu/R9/7sSkOu65WKxeLvsqsyAaj8/P399L74mgFzXLeu6/hv/AnVdepRS7o1DaeNWxWLxdgMwALCbzTWiwvAPIcQ1EbkbgAEAEJFhWVYlSZKHwbv+Q61Wc4jot4pD27axv78Py7IAAHEcw/M8JEmiBMbMe/3dN1gh0zSvicjI6+T8/BzHx8eoVquDd9VqFY7ztg8UoYwkSVpAFkPZoZd7R9m2PZj4PQkhYJpmbhoicrLz7g1I07RvuUcDODg4WInNGFQDACjb5n9UBt/c3OSyOzo6UoKSUlY0Xdc3tqvmSdd1V2NmZaA8ARtFkTIQMztaVj4o6e7ubiU24yIiQwOwpTowiiK029OT9iJnUaatgmVZPxcZGUUR0jRFpVLBzs4OgLe/8urqCmEYLuISAD6QEIIXHb0OaQA6/xtiSJ0iAKWaty/DMLC9vQ3DGM02aZri6ekJaZou4rZbZOaUiD7nsTZNc5BMS6XSTNter4c4jnF/f587wJk5JSHEKYDrWYaGYeDk5GSQ1VUVxzFarVaeVTubmzoMw0C9Xp+7IvPU6/XQbDZnQkkpK1pWQk7dp0KIpWEAoFQqQQgxyyQMgqCrAQAzN6ZZ2ba9NEweX30GDQCyam3h02wFCvsV46DIn7VK69bw3CNtkBDiEsDFhnl+eJ43KBAn+jIhRBtArnNpBQo9zxuphSf6Mimli82kk04214gmgIIg6EopHaw3yEMppZOrlR7WmmJqJGbGVZj2AQCSJHkwTTMkoo8AcvdsUxQy85nv+zPrr9wXVlln24B6wIfM3FjZhdW4stznMrOTdbplAJ+yzx0A3ayCaEspA9Urvb9UY0aihEyS+AAAAABJRU5ErkJggg=="

/***/ }),

/***/ "27GY":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tutorial-normal-attraction-1.667ca2a.jpg";

/***/ }),

/***/ "2CkK":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./tutorial-normal-competitiveness-3.jpg": "4ymT",
	"./tutorial-tool-competitiveness-3.jpg": "J2nI"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2CkK";

/***/ }),

/***/ "2PDt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./src/constants/global/data.js
var global_data = __webpack_require__("x2hU");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/mixins/toastMethods.vue





/* harmony default export */ var toastMethods = ({
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['addToastAction']), {
    addToast: function addToast(type, content) {
      if (content.message_code) {
        if (global_data["a" /* apiI18n */][content.message_code]) {
          content = global_data["a" /* apiI18n */][content.message_code]['zh-TW'];
        } else if (content.message) {
          content = content.message;
        } else {
          content = content.message_code;
        }
      }
      var data = {
        type: type,
        content: content
      };
      this.addToastAction(data);
    }
  })
});
// CONCATENATED MODULE: ./src/mixins/toastMethods.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  toastMethods,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var mixins_toastMethods = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4fS2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tutorial-tool-attraction-3.3e0223f.jpg";

/***/ }),

/***/ "4ymT":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tutorial-normal-competitiveness-3.f56b016.jpg";

/***/ }),

/***/ "598Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_ls__ = __webpack_require__("yXtV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_ls___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_ls__);



var options = {
  namespace: 'tari_'
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_ls___default.a, options);

/***/ }),

/***/ "5Ivo":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICA8ZyBpZD0i44Kw44Or44O844OXXzIwODQiIGRhdGEtbmFtZT0i44Kw44Or44O844OXIDIwODQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yNzggLTMxNykiPgogICAgPGcgaWQ9IumVt+aWueW9ol8xMTQzIiBkYXRhLW5hbWU9IumVt+aWueW9oiAxMTQzIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyNzggMzE3KSIgZmlsbD0iI2ZmZiIgc3Ryb2tlPSIjNzA3MDcwIiBzdHJva2Utd2lkdGg9IjEiPgogICAgICA8cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHJ4PSIyIiBzdHJva2U9Im5vbmUiLz4KICAgICAgPHJlY3QgeD0iMC41IiB5PSIwLjUiIHdpZHRoPSIxNSIgaGVpZ2h0PSIxNSIgcng9IjEuNSIgZmlsbD0ibm9uZSIvPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ "5xS/":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "64nW":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tutorial-report-2.d55ce4b.jpg";

/***/ }),

/***/ "6uzY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7Huh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7Sse":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tutorial-normal-attraction-3.3e0223f.jpg";

/***/ }),

/***/ "7kqe":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICA8ZyBpZD0i44Kw44Or44O844OXXzIwODQiIGRhdGEtbmFtZT0i44Kw44Or44O844OXIDIwODQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yNzggLTMxNykiPgogICAgPHBhdGggaWQ9ImNoZWNrLXNxdWFyZS1zb2xpZCIgZD0iTTE0LjI4Niw0OEgxLjcxNEExLjcxNCwxLjcxNCwwLDAsMSwwLDQ2LjI4NlYzMy43MTRBMS43MTQsMS43MTQsMCwwLDEsMS43MTQsMzJIMTQuMjg2QTEuNzE0LDEuNzE0LDAsMCwxLDE2LDMzLjcxNFY0Ni4yODZBMS43MTQsMS43MTQsMCwwLDEsMTQuMjg2LDQ4Wm0tNy4zMS0zLjUsNi41NzEtNi41NzFhLjU3MS41NzEsMCwwLDAsMC0uODA4bC0uODA4LS44MDhhLjU3MS41NzEsMCwwLDAtLjgwOCwwTDYuNTcxLDQxLjY2OWwtMi41LTIuNWEuNTcxLjU3MSwwLDAsMC0uODA4LDBsLS44MDguODA4YS41NzEuNTcxLDAsMCwwLDAsLjgwOEw2LjE2Nyw0NC41YS41NzEuNTcxLDAsMCwwLC44MDgsMFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDI3OCAyODUpIiBmaWxsPSIjOWJjNzM3Ii8+CiAgICA8ZyBpZD0i6ZW35pa55b2iXzExNDMiIGRhdGEtbmFtZT0i6ZW35pa55b2iIDExNDMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDI3OCAzMTcpIiBmaWxsPSJub25lIiBzdHJva2U9IiM3MDcwNzAiIHN0cm9rZS13aWR0aD0iMSI+CiAgICAgIDxyZWN0IHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgcng9IjIiIHN0cm9rZT0ibm9uZSIvPgogICAgICA8cmVjdCB4PSIwLjUiIHk9IjAuNSIgd2lkdGg9IjE1IiBoZWlnaHQ9IjE1IiByeD0iMS41IiBmaWxsPSJub25lIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "9Z7k":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9iLM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return matchEmail; });
/* eslint-disable */
var matchEmail = /^[a-zA-Z0-9.!\#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
/* eslint-enable */

/***/ }),

/***/ "AFvp":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICA8ZyBpZD0i5qWV5YaG5b2iXzE0MCIgZGF0YS1uYW1lPSLmpZXlhoblvaIgMTQwIiBmaWxsPSIjZmZmIiBzdHJva2U9IiM3NzciIHN0cm9rZS13aWR0aD0iMSI+CiAgICA8Y2lyY2xlIGN4PSIxMCIgY3k9IjEwIiByPSIxMCIgc3Ryb2tlPSJub25lIi8+CiAgICA8Y2lyY2xlIGN4PSIxMCIgY3k9IjEwIiByPSI5LjUiIGZpbGw9Im5vbmUiLz4KICA8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ "BdG8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/tool/switchButton.vue

//
//
//
//
//
//

/* harmony default export */ var switchButton = ({
  props: {
    disabled: Boolean,
    type: String,
    size: String,
    checked: Boolean
  },
  data: function data() {
    return {
      value: false
    };
  },

  computed: {
    classObject: function classObject() {
      var _ref;

      var type = this.type,
          size = this.size,
          value = this.value;

      return _ref = {}, defineProperty_default()(_ref, 'is-' + type, type), defineProperty_default()(_ref, 'is-' + size, size), defineProperty_default()(_ref, 'checked', value), _ref;
    }
  },
  mounted: function mounted() {
    this.value = this.checked;
  },

  watch: {
    checked: function checked() {
      this.value = this.checked;
    },
    value: function value(val) {
      this.$emit('input', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23a84469","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/switchButton.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:_vm.classObject,style:({ opacity: this.disabled ? 0.7 : 1, cursor: this.disabled ? 'not-allowed' : 'pointer' }),attrs:{"id":"switch-button"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],style:({ cursor: this.disabled ? 'not-allowed' : 'pointer' }),attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":Array.isArray(_vm.value)?_vm._i(_vm.value,null)>-1:(_vm.value)},on:{"change":function($event){var $$a=_vm.value,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.value=$$a.concat([$$v]))}else{$$i>-1&&(_vm.value=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.value=$$c}}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var tool_switchButton = (esExports);
// CONCATENATED MODULE: ./src/components/tool/switchButton.vue
function injectStyle (ssrContext) {
  __webpack_require__("vBfX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  switchButton,
  tool_switchButton,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_tool_switchButton = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "C0KS":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNi41IiBoZWlnaHQ9IjIyIiB2aWV3Qm94PSIwIDAgMTYuNSAyMiI+CiAgPHBhdGggaWQ9ImZpbGUtY29udHJhY3QtcmVndWxhciIgZD0iTTguNDUsMTUuNjEybC0uNi0xLjc4OGExLjAzMiwxLjAzMiwwLDAsMC0xLjk1OCwwbC0uNzgzLDIuMzQ4YS40NzguNDc4LDAsMCwxLS40NTUuMzI4SDQuMTI1YS42ODguNjg4LDAsMCwwLDAsMS4zNzVoLjUzM2ExLjg1NCwxLjg1NCwwLDAsMCwxLjc2LTEuMjY5bC40NTYtMS4zN0w3LjYsMTcuNGEuNjg3LjY4NywwLDAsMCwuNi40NjhsLjA0OCwwYS42ODguNjg4LDAsMCwwLC42MTUtLjM4MWwuMzI5LS42NTlhLjQ2OS40NjksMCwwLDEsLjQzMS0uMjY2LjQ3NS40NzUsMCwwLDEsLjQzOC4yODEsMS44NDgsMS44NDgsMCwwLDAsMS42NTksMS4wMjRoLjY1M2EuNjg4LjY4OCwwLDAsMCwwLTEuMzc1aC0uNjUzYS40ODMuNDgzLDAsMCwxLS40MzctLjI3OSwxLjkyOSwxLjkyOSwwLDAsMC0yLjgzNi0uNjA4Wm03LjQ0MS0xMS40LTMuNi0zLjZBMi4wNjIsMi4wNjIsMCwwLDAsMTAuODMsMEgyLjA2MkEyLjA2OSwyLjA2OSwwLDAsMCwwLDIuMDY2VjE5LjkzOEEyLjA2MywyLjA2MywwLDAsMCwyLjA2MiwyMkgxNC40MzRBMi4wNjYsMi4wNjYsMCwwLDAsMTYuNSwxOS45MzhWNS42NzFhMi4wNzUsMi4wNzUsMCwwLDAtLjYwOS0xLjQ2MVpNMTEsMi4yMzQsMTQuMjY3LDUuNUgxMVYyLjIzNFptMy40NCwxNy43SDIuMDYyVjIuMDY2SDguOTM2VjYuNTM0QTEuMDI4LDEuMDI4LDAsMCwwLDkuOTY3LDcuNTY1aDQuNDdaTTMuNzgxLDQuODEzSDcuMjE5YS4zNDQuMzQ0LDAsMCwwLC4zNDQtLjM0NFYzLjc4MWEuMzQ0LjM0NCwwLDAsMC0uMzQ0LS4zNDRIMy43ODFhLjM0NC4zNDQsMCwwLDAtLjM0NC4zNDR2LjY4OEEuMzQ0LjM0NCwwLDAsMCwzLjc4MSw0LjgxM1ptMCwyLjc1SDcuMjE5YS4zNDQuMzQ0LDAsMCwwLC4zNDQtLjM0NFY2LjUzMWEuMzQ0LjM0NCwwLDAsMC0uMzQ0LS4zNDRIMy43ODFhLjM0NC4zNDQsMCwwLDAtLjM0NC4zNDR2LjY4OEEuMzQ0LjM0NCwwLDAsMCwzLjc4MSw3LjU2M1oiIGZpbGw9IiMzOTY3YTYiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "Cduz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export imageUrlReader */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return imageReader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return sortData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return dateFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return toFormdata; });
/* unused harmony export groupBy */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return toPriceString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return downloadFile; });
/* unused harmony export convolve */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return html2DataUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return nco; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return convertFileSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fileTypeCheck; });
/* unused harmony export dataUrlToBlobUrl */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return htmlDecode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return toDivideNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isValidDate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_html2canvas__ = __webpack_require__("eMjc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_html2canvas__);









var _this = this;



var imageUrlReader = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee(urls) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'blobUrl';
    var maxWidth = arguments[2];
    var maxHeight = arguments[3];

    var getContent, content, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, url;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (urls) {
              _context.next = 2;
              break;
            }

            return _context.abrupt('return');

          case 2:
            getContent = function getContent(url) {
              return new __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default.a(function (resolve) {
                var img = new Image();
                img.onload = function (e) {
                  var canvas = document.createElement('canvas');
                  var targetWidth = img.width;
                  var targetHeight = img.height;
                  maxWidth = maxWidth || img.width;
                  maxHeight = maxHeight || img.height;
                  if (targetWidth > maxWidth || targetHeight > maxHeight) {
                    if (targetWidth / targetHeight > maxWidth / maxHeight) {
                      targetHeight = Math.round(maxWidth * (targetHeight / targetWidth));
                      targetWidth = maxWidth;
                    } else {
                      targetHeight = maxHeight;
                      targetWidth = Math.round(maxHeight * (targetWidth / targetHeight));
                    }
                  }
                  canvas.width = targetWidth;
                  canvas.height = targetHeight;
                  canvas.getContext('2d').drawImage(img, 0, 0, targetWidth, targetHeight);
                  canvas.toBlob(function (blob) {
                    if (type === 'blobUrl') {
                      resolve(URL.createObjectURL(blob));
                    } else if (type === 'blob') {
                      resolve(blob);
                    }
                  });
                };
                img.setAttribute('crossOrigin', 'Anonymous');
                img.src = url;
              });
            };

            content = [];
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _iteratorError = undefined;
            _context.prev = 7;
            _iterator = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(urls);

          case 9:
            if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
              _context.next = 19;
              break;
            }

            url = _step.value;
            _context.t0 = content;
            _context.next = 14;
            return getContent(url);

          case 14:
            _context.t1 = _context.sent;

            _context.t0.push.call(_context.t0, _context.t1);

          case 16:
            _iteratorNormalCompletion = true;
            _context.next = 9;
            break;

          case 19:
            _context.next = 25;
            break;

          case 21:
            _context.prev = 21;
            _context.t2 = _context['catch'](7);
            _didIteratorError = true;
            _iteratorError = _context.t2;

          case 25:
            _context.prev = 25;
            _context.prev = 26;

            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }

          case 28:
            _context.prev = 28;

            if (!_didIteratorError) {
              _context.next = 31;
              break;
            }

            throw _iteratorError;

          case 31:
            return _context.finish(28);

          case 32:
            return _context.finish(25);

          case 33:
            return _context.abrupt('return', content);

          case 34:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this, [[7, 21, 25, 33], [26,, 28, 32]]);
  }));

  return function imageUrlReader(_x) {
    return _ref.apply(this, arguments);
  };
}();

var imageReader = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3(files) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'dataUrl';
    var maxWidth = arguments[2];
    var maxHeight = arguments[3];

    var getContent, content, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, file;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (files) {
              _context3.next = 2;
              break;
            }

            return _context3.abrupt('return');

          case 2:
            getContent = function getContent(file) {
              return new __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default.a(function (resolve) {
                var reader = new FileReader();
                reader.onload = function () {
                  var _ref3 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2(e) {
                    var dataUrl;
                    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            dataUrl = e.target.result.startsWith('data:image/') ? e.target.result : '';

                            if (!(maxWidth || maxHeight || type === 'blob' || type === 'blobUrl')) {
                              _context2.next = 9;
                              break;
                            }

                            _context2.t0 = resolve;
                            _context2.next = 5;
                            return imageUrlReader([dataUrl], type === 'dataUrl' ? 'blobUrl' : type, maxWidth, maxHeight);

                          case 5:
                            _context2.t1 = _context2.sent;
                            (0, _context2.t0)(_context2.t1);
                            _context2.next = 10;
                            break;

                          case 9:
                            if (type === 'dataUrl') {
                              resolve(dataUrl);
                            } else {
                              resolve('');
                            }

                          case 10:
                          case 'end':
                            return _context2.stop();
                        }
                      }
                    }, _callee2, _this);
                  }));

                  return function (_x5) {
                    return _ref3.apply(this, arguments);
                  };
                }();
                reader.readAsDataURL(file);
              });
            };

            content = [];
            _iteratorNormalCompletion2 = true;
            _didIteratorError2 = false;
            _iteratorError2 = undefined;
            _context3.prev = 7;
            _iterator2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(files);

          case 9:
            if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
              _context3.next = 19;
              break;
            }

            file = _step2.value;
            _context3.t0 = content;
            _context3.next = 14;
            return getContent(file);

          case 14:
            _context3.t1 = _context3.sent;

            _context3.t0.push.call(_context3.t0, _context3.t1);

          case 16:
            _iteratorNormalCompletion2 = true;
            _context3.next = 9;
            break;

          case 19:
            _context3.next = 25;
            break;

          case 21:
            _context3.prev = 21;
            _context3.t2 = _context3['catch'](7);
            _didIteratorError2 = true;
            _iteratorError2 = _context3.t2;

          case 25:
            _context3.prev = 25;
            _context3.prev = 26;

            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }

          case 28:
            _context3.prev = 28;

            if (!_didIteratorError2) {
              _context3.next = 31;
              break;
            }

            throw _iteratorError2;

          case 31:
            return _context3.finish(28);

          case 32:
            return _context3.finish(25);

          case 33:
            return _context3.abrupt('return', content);

          case 34:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this, [[7, 21, 25, 33], [26,, 28, 32]]);
  }));

  return function imageReader(_x3) {
    return _ref2.apply(this, arguments);
  };
}();

var sortData = function sortData(arr, keys, orders) {
  if (!arr || !(arr instanceof Array)) {
    return arr;
  }
  if (keys instanceof Object && !(keys instanceof Array) && !(keys instanceof Function)) {
    return arr;
  }
  keys = keys instanceof Array ? keys : [keys];
  orders = orders instanceof Array ? orders : [orders];
  if (keys.length <= 0) {
    return arr;
  }
  var sortBy = function sortBy(keys, orders) {
    return function (o1, o2) {
      var key = keys[0];
      var order = orders[0] !== 'desc' ? 1 : -1;
      var co1 = key instanceof Function ? key(o1) : o1[key];
      var co2 = key instanceof Function ? key(o2) : o2[key];
      co1 = co1 instanceof Array ? co1.length : co1;
      co2 = co2 instanceof Array ? co2.length : co2;
      if (co1 === null || co1 === undefined || co1 < co2) {
        return -1 * order;
      } else if (co2 === null || co2 === undefined || co1 > co2) {
        return 1 * order;
      } else {
        return keys.length === 0 ? 0 : sortBy(keys.slice(1), orders.length > 0 ? orders.slice(1) : orders)(o1, o2);
      }
    };
  };
  return [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(arr)).sort(sortBy(keys, orders));
};

var dateFormat = function dateFormat(date, fmt) {
  date.setHours(date.getHours() - (date.getTimezoneOffset() - new Date().getTimezoneOffset()) / 60);
  var o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
    'q+': Math.floor((date.getMonth() + 3) / 3),
    'S': date.getMilliseconds()
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
    }
  }
  return fmt;
};

var toFormdata = function toFormdata(object) {
  var needEmpty = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var formData = new FormData();
  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(object)), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      var kv = _step3.value;

      if (needEmpty || kv[1] !== null && kv[1] !== undefined) {
        if (kv[1] instanceof Array) {
          var _iteratorNormalCompletion4 = true;
          var _didIteratorError4 = false;
          var _iteratorError4 = undefined;

          try {
            for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(kv[1]), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
              var data = _step4.value;

              formData.append(kv[0] + '[]', data);
            }
          } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion4 && _iterator4.return) {
                _iterator4.return();
              }
            } finally {
              if (_didIteratorError4) {
                throw _iteratorError4;
              }
            }
          }
        } else {
          formData.append(kv[0], kv[1]);
        }
      }
    }
  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3.return) {
        _iterator3.return();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }

  return formData;
};

var groupBy = function groupBy(ary, f) {
  var needKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var groups = {};
  var _iteratorNormalCompletion5 = true;
  var _didIteratorError5 = false;
  var _iteratorError5 = undefined;

  try {
    for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(ary), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
      var item = _step5.value;

      var key = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(f(item));
      if (key) {
        groups[key] = groups[key] || [];
        groups[key].push(item);
      }
    }
  } catch (err) {
    _didIteratorError5 = true;
    _iteratorError5 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion5 && _iterator5.return) {
        _iterator5.return();
      }
    } finally {
      if (_didIteratorError5) {
        throw _iteratorError5;
      }
    }
  }

  return needKey ? groups : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(groups);
};

var toPriceString = function toPriceString(price) {
  return (price + '').split('.').map(function (s) {
    return s.replace(/(?!^)(?=(\d{3})+($|\.))/g, ',');
  }).join('.');
};

var downloadFile = function downloadFile(fileName, urlData, target) {
  var aLink = document.createElement('a');
  if (fileName) {
    aLink.download = fileName;
  }
  if (target) {
    aLink.target = target;
  }
  aLink.href = urlData;
  aLink.click();
};

var convolve = function convolve(imageData, kernel, amount) {
  var pixelData = imageData.data;
  var imageWidth = imageData.width;
  var imageHeight = imageData.height;
  var output = new ImageData(new Uint8ClampedArray(imageData.data), imageData.width, imageData.height);
  var side = Math.sqrt(kernel.length);
  var half = Math.floor(side / 2);
  var outputPixelData = output.data;
  for (var y = 0; y < imageHeight; y++) {
    for (var x = 0; x < imageWidth; x++) {
      var dstOff = (y * imageWidth + x) * 4;
      var totalR = 0;
      var totalG = 0;
      var totalB = 0;
      for (var row = 0; row < side; row++) {
        for (var col = 0; col < side; col++) {
          var srcY = y + row - half;
          var srcX = x + col - half;
          if (srcY < 0 || srcY > imageHeight || srcX < 0 || srcX > imageWidth) {
            continue;
          }
          var srcOff = (srcY * imageWidth + srcX) * 4;
          var weight = kernel[row * side + col];
          var _ref4 = [pixelData[srcOff], pixelData[srcOff + 1], pixelData[srcOff + 2]],
              r = _ref4[0],
              g = _ref4[1],
              b = _ref4[2];

          totalR += r * weight;
          totalG += g * weight;
          totalB += b * weight;
        }
      }
      if (amount || amount === 0) {
        outputPixelData[dstOff] = totalR * amount + outputPixelData[dstOff] * (1 - amount);
        outputPixelData[dstOff + 1] = totalG * amount + outputPixelData[dstOff + 1] * (1 - amount);
        outputPixelData[dstOff + 2] = totalB * amount + outputPixelData[dstOff + 2] * (1 - amount);
      } else {
        outputPixelData[dstOff] = totalR;
        outputPixelData[dstOff + 1] = totalG;
        outputPixelData[dstOff + 2] = totalB;
      }
    }
  }
  return output;
};

var html2DataUrl = function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee4(content) {
    var mime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'png';
    var amount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var width, height, customCanvas, scale, options, canvas, context, imageData, pageData;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            width = content.offsetWidth;
            height = content.offsetHeight;
            customCanvas = document.createElement('canvas');
            scale = 2;

            customCanvas.width = width * scale;
            customCanvas.height = height * scale;
            customCanvas.getContext('2d').scale(scale, scale);
            options = {
              scale: scale,
              canvas: customCanvas,
              width: width,
              height: height,
              backgroundColor: null,
              useCORS: true
            };
            _context4.next = 10;
            return __WEBPACK_IMPORTED_MODULE_8_html2canvas___default()(content, options);

          case 10:
            canvas = _context4.sent;
            context = canvas.getContext('2d');

            context.mozImageSmoothingEnabled = false;
            context.webkitImageSmoothingEnabled = false;
            context.msImageSmoothingEnabled = false;
            context.imageSmoothingEnabled = false;
            imageData = context.getImageData(0, 0, canvas.width, canvas.height);

            imageData = convolve(imageData, [-1, -1, -1, -1, 9, -1, -1, -1, -1], amount);
            context.putImageData(imageData, 0, 0);
            pageData = canvas.toDataURL('image/' + mime, 1.0);
            return _context4.abrupt('return', pageData);

          case 21:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, _this);
  }));

  return function html2DataUrl(_x8) {
    return _ref5.apply(this, arguments);
  };
}();

var nco = function nco(operation, _default) {
  try {
    var result = operation();
    return result !== null && result !== undefined ? result : _default;
  } catch (e) {
    return _default;
  }
};

var convertFileSize = function convertFileSize(_byte) {
  var sizeType = ['', 'K', 'M', 'G', 'T', 'P', 'E', 'Z', 'Y', 'B', 'Ge'];
  var type = 0;
  for (; _byte > 1024 || type === sizeType.length; _byte /= 1024, type++) {}
  return Math.round(_byte) + sizeType[type] + 'B';
};

var fileTypeCheck = function fileTypeCheck(e, operation, onError) {
  var acceptTypes = e.target.getAttribute('accept');
  acceptTypes = acceptTypes ? acceptTypes.split(',') : null;
  var extension = e.target.getAttribute('extension');
  extension = extension ? extension.split(',') : null;
  var match = function match(arys, s) {
    var _iteratorNormalCompletion6 = true;
    var _didIteratorError6 = false;
    var _iteratorError6 = undefined;

    try {
      for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(arys), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
        var ary = _step6.value;

        var rgx = new RegExp(ary);
        if (rgx.test(s)) {
          return true;
        }
      }
    } catch (err) {
      _didIteratorError6 = true;
      _iteratorError6 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion6 && _iterator6.return) {
          _iterator6.return();
        }
      } finally {
        if (_didIteratorError6) {
          throw _iteratorError6;
        }
      }
    }

    return false;
  };
  var _iteratorNormalCompletion7 = true;
  var _didIteratorError7 = false;
  var _iteratorError7 = undefined;

  try {
    for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(e.target.files), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
      var file = _step7.value;

      var fileType = file.type;
      var fileExtension = file.name.split('.');
      fileExtension = fileExtension[fileExtension.length - 1];
      if (extension && !match(extension, fileExtension)) {
        e.target.value = '';
        if (onError) {
          onError(e, extension);
        }
        return;
      }
      if (acceptTypes && !match(acceptTypes, fileType)) {
        e.target.value = '';
        if (onError) {
          onError(e, acceptTypes);
        }
        return;
      }
    }
  } catch (err) {
    _didIteratorError7 = true;
    _iteratorError7 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion7 && _iterator7.return) {
        _iterator7.return();
      }
    } finally {
      if (_didIteratorError7) {
        throw _iteratorError7;
      }
    }
  }

  operation(e);
};

var dataUrlToBlobUrl = function dataUrlToBlobUrl(dataUrl) {
  var arr = dataUrl.split(',');
  var mime = arr[0].match(/:(.*?);/)[1];
  var bstr = atob(arr[1]);
  var n = bstr.length;
  var u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return URL.createObjectURL(new Blob([u8arr], { type: mime }));
};

var htmlDecode = function htmlDecode(input) {
  var e = document.createElement('div');
  e.innerHTML = input;
  return e.childNodes[0].nodeValue;
};

var toDivideNumber = function toDivideNumber(number, base) {
  var reverse = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isNormal = !reverse && number >= 0 || reverse && number < 0;
  return number + (isNormal ? base - Math.abs(number) % base : -Math.abs(number) % base) * (number >= 0 ? 1 : -1);
};

var isValidDate = function isValidDate(d) {
  return d instanceof Date && !isNaN(d);
};

/***/ }),

/***/ "DBs5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__("sUu7");



var config = {
  locale: 'zh',
  events: 'input',
  dictionary: {
    zh: {
      messages: {
        required: function required(field) {
          return field + ' 為必填欄位';
        },
        min: function min(field, args) {
          return field + ' 最少 ' + args + ' 個字';
        },
        max: function max(field, args) {
          return field + ' 不得超過 ' + args + ' 個字';
        },
        digits: function digits(field, args) {
          return field + ' 請輸入 ' + args + ' 位數字';
        },
        min_value: function min_value(field, args) {
          return field + ' 不得低於 ' + args;
        },
        max_value: function max_value(field, args) {
          return field + ' 不得超過 ' + args;
        },
        integer: function integer(field) {
          return field + ' 必須為整數';
        },
        mimes: function mimes(field, args) {
          return field + ' 必須符合MIME類型 ' + args;
        },
        ext: function ext(field, args) {
          return field + ' 必須符合檔案類型 ' + args;
        },
        dimensions: function dimensions(field, args) {
          return field + ' 寬與高須分別為 ' + args;
        },
        regex: function regex(field) {
          return '請輸入正確格式';
        },
        email: function email(field) {
          return field + ' 請輸入正確Email格式';
        },
        confirmed: function confirmed() {
          return '密碼不相符';
        },
        youtubeLink: function youtubeLink(field) {
          return field + ' 不是youtube內嵌影片連結格式';
        }
      },
      attributes: {
        account: '帳號',
        password: '密碼'
      }
    }
  }
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vee_validate__["b" /* default */], config);

/***/ }),

/***/ "DMDf":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/main-logo.b5108ae.png";

/***/ }),

/***/ "ECQw":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIxNyIgdmlld0JveD0iMCAwIDIwIDE3Ij4KICA8ZyBpZD0i5aSa6KeS5b2iXzQyIiBkYXRhLW5hbWU9IuWkmuinkuW9oiA0MiIgZmlsbD0iI2ZmZiI+CiAgICA8cGF0aCBkPSJNIDE5LjEyNTc4OTY0MjMzMzk4IDE2LjUgTCAwLjg3NDIxMTE5MjEzMTA0MjUgMTYuNSBMIDEwIDAuOTg2MTU5MDI2NjIyNzcyMiBMIDE5LjEyNTc4OTY0MjMzMzk4IDE2LjUgWiIgc3Ryb2tlPSJub25lIi8+CiAgICA8cGF0aCBkPSJNIDEwIDEuOTcyMzAwNTI5NDc5OTggTCAxLjc0ODQxMzA4NTkzNzUgMTYgTCAxOC4yNTE1ODY5MTQwNjI1IDE2IEwgMTAgMS45NzIzMDA1Mjk0Nzk5OCBNIDEwIDAgTCAyMCAxNyBMIDAgMTcgTCAxMCAwIFoiIHN0cm9rZT0ibm9uZSIgZmlsbD0iIzc3NyIvPgogIDwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ "F7NO":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/loading.ae373e2.gif";

/***/ }),

/***/ "Fqd/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fontawesome-webfont.912ec66.svg";

/***/ }),

/***/ "IMLV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.b06871f.ttf";

/***/ }),

/***/ "IREq":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMC44MjgiIGhlaWdodD0iMjAuODI5IiB2aWV3Qm94PSIwIDAgMjAuODI4IDIwLjgyOSI+CiAgPGcgaWQ9IuOCsOODq+ODvOODl18yMDU1IiBkYXRhLW5hbWU9IuOCsOODq+ODvOODlyAyMDU1IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNzUzOS41ODYgLTkwNy41ODYpIj4KICAgIDxsaW5lIGlkPSLnt5pfMTY0IiBkYXRhLW5hbWU9Iue3miAxNjQiIHgyPSIxOCIgeTI9IjE4IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3NTQxIDkwOSkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzU1NSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiLz4KICAgIDxsaW5lIGlkPSLnt5pfMTY1IiBkYXRhLW5hbWU9Iue3miAxNjUiIHgxPSIxOCIgeTI9IjE4IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3NTQxIDkwOSkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzU1NSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiLz4KICA8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ "J2nI":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tutorial-tool-competitiveness-3.f56b016.jpg";

/***/ }),

/***/ "Jlw2":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIxNSIgdmlld0JveD0iMCAwIDIwIDE1Ij4KICA8cGF0aCBpZD0iaW1hZ2UtcmVndWxhciIgZD0iTTE4LjEyNSw2NEgxLjg3NUExLjg3NSwxLjg3NSwwLDAsMCwwLDY1Ljg3NXYxMS4yNUExLjg3NSwxLjg3NSwwLDAsMCwxLjg3NSw3OWgxNi4yNUExLjg3NSwxLjg3NSwwLDAsMCwyMCw3Ny4xMjVWNjUuODc1QTEuODc1LDEuODc1LDAsMCwwLDE4LjEyNSw2NFptLS4yMzQsMTMuMTI1SDIuMTA5YS4yMzQuMjM0LDAsMCwxLS4yMzQtLjIzNFY2Ni4xMDlhLjIzNC4yMzQsMCwwLDEsLjIzNC0uMjM0SDE3Ljg5MWEuMjM0LjIzNCwwLDAsMSwuMjM0LjIzNFY3Ni44OTFBLjIzNC4yMzQsMCwwLDEsMTcuODkxLDc3LjEyNVpNNSw2Ny40MzhBMS41NjMsMS41NjMsMCwxLDAsNi41NjMsNjksMS41NjMsMS41NjMsMCwwLDAsNSw2Ny40MzhaTTMuNzUsNzUuMjVoMTIuNVY3Mi4xMjVsLTMuNDE5LTMuNDE5YS40NjkuNDY5LDAsMCwwLS42NjMsMEw3LjUsNzMuMzc1LDUuOTU2LDcxLjgzMWEuNDY5LjQ2OSwwLDAsMC0uNjYzLDBMMy43NSw3My4zNzVaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIC02NCkiIGZpbGw9IiNiYmIiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "MpsS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NBIZ":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDE0IDE0Ij4KICA8cGF0aCBpZD0ibWludXMtY2lyY2xlLXNvbGlkIiBkPSJNMTUsOGE3LDcsMCwxLDAsNyw3QTcsNywwLDAsMCwxNSw4Wm0tMy43MjYsOC4xMjlhLjM0LjM0LDAsMCwxLS4zMzktLjMzOVYxNC4yMWEuMzQuMzQsMCwwLDEsLjMzOS0uMzM5aDcuNDUyYS4zNC4zNCwwLDAsMSwuMzM5LjMzOVYxNS43OWEuMzQuMzQsMCwwLDEtLjMzOS4zMzlaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtOCAtOCkiIGZpbGw9IiNmMDNjM2MiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/entries.js
var entries = __webpack_require__("W3Iv");
var entries_default = /*#__PURE__*/__webpack_require__.n(entries);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("M4fF");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./src/api/index.js
var src_api = __webpack_require__("gyMJ");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/tool/borCor.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var borCor = ({
  props: {
    type: {
      type: String,
      default: function _default() {
        return 'bottom';
      }
    },
    reverse: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    arrow: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    },
    alwaysDisplay: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    // style
    width: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    background: {
      type: String,
      default: function _default() {
        return 'white';
      }
    },
    border: {
      type: String,
      default: function _default() {
        return '#aaaaaa';
      }
    },
    radius: {
      type: String,
      default: function _default() {
        return '3px';
      }
    },
    shadow: {
      type: String,
      default: function _default() {
        return '0px 0px 0px transparent';
      }
    },
    cursorStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    blockStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    menuBlockStyle: function menuBlockStyle() {
      var style = {
        width: this.width || 'auto',
        'white-space': this.width ? 'pre-line' : 'nowrap',
        '--bg-color': this.background,
        '--bd-color': this.border,
        '--br-value': this.radius
      };
      return extends_default()({}, style, this.blockStyle);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d2d88ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/borCor.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bor-cor",class:{ 'no-arrow': !_vm.arrow }},[_c('div',{staticClass:"trigger",class:{ 'always-display': _vm.alwaysDisplay }},[_vm._t("trigger")],2),_vm._v(" "),_c('div',{staticClass:"menu-container",class:[_vm.type, { reverse: _vm.reverse }],style:({ '--sd-style': _vm.shadow })},[_c('div',{staticClass:"menu-block default-shadow",style:(_vm.menuBlockStyle)},[_vm._t("content")],2),_vm._v(" "),_c('span',{staticClass:"cursor-bor-cor",style:(_vm.cursorStyle)}),_vm._v(" "),(_vm.arrow)?[_c('span',{staticClass:"menu-bor-cor shadow-top",style:({ '--bd-color': _vm.border })}),_vm._v(" "),_c('span',{staticClass:"menu-bor-cor shadow-left",style:({ '--bd-color': _vm.border })}),_vm._v(" "),_c('span',{staticClass:"menu-bor-cor shadow-right",style:({ '--bd-color': _vm.border })}),_vm._v(" "),_c('span',{staticClass:"menu-bor-cor",style:({ '--bg-color': _vm.background })})]:_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var tool_borCor = (esExports);
// CONCATENATED MODULE: ./src/components/tool/borCor.vue
function injectStyle (ssrContext) {
  __webpack_require__("YXKW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  borCor,
  tool_borCor,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_tool_borCor = (Component.exports);

// EXTERNAL MODULE: ./src/mixins/toastMethods.vue + 1 modules
var toastMethods = __webpack_require__("2PDt");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/mixins/responsitive.vue

/* harmony default export */ var responsitive = ({
  data: function data() {
    return {
      windowWidth: 0,
      windowHeight: 0
    };
  },

  computed: {
    isMobile: function isMobile() {
      return this.windowWidth <= 1070.9;
    }
  },
  created: function created() {
    var _this = this;

    var handler = function handler() {
      _this.windowWidth = window.innerWidth;
      _this.windowHeight = window.innerHeight;
    };
    document.addEventListener('visibilitychange', handler);
    window.addEventListener('DOMContentLoaded', handler);
    window.addEventListener('resize', handler);
    window.dispatchEvent(new Event('resize'));
  }
});
// CONCATENATED MODULE: ./src/mixins/responsitive.vue
var responsitive_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var responsitive___vue_template_functional__ = false
/* styles */
var responsitive___vue_styles__ = null
/* scopeId */
var responsitive___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var responsitive___vue_module_identifier__ = null
var responsitive_Component = responsitive_normalizeComponent(
  responsitive,
  __vue_template__,
  responsitive___vue_template_functional__,
  responsitive___vue_styles__,
  responsitive___vue_scopeId__,
  responsitive___vue_module_identifier__
)

/* harmony default export */ var mixins_responsitive = (responsitive_Component.exports);

// EXTERNAL MODULE: ./src/mixins/loginData.vue + 1 modules
var loginData = __webpack_require__("P6mg");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/layout/header.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var header = ({
  components: {
    borCor: components_tool_borCor
  },
  mixins: [toastMethods["a" /* default */], mixins_responsitive, loginData["a" /* default */]],
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['isLogin', 'user', 'normalPage']), {
    // static data
    categorys: function categorys() {
      var _this = this;

      return {
        product: {
          name: '農產品分析',
          width: '115px',
          lists: [{
            name: '市場吸引力',
            value: 'attraction',
            to: { name: 'attraction' }
          }, {
            name: '市場競爭力',
            value: 'competitiveness',
            to: { name: 'competitiveness' }
          }, {
            name: '零售價格分析',
            value: 'productPrice',
            to: { name: 'productPrice' }
          }]
        },
        tool: {
          name: '農業機械分析',
          width: '115px',
          lists: [{
            name: '市場吸引力',
            value: 'toolattraction',
            to: { name: 'toolattraction' }
          }, {
            name: '市場競爭力',
            value: 'toolcompetitiveness',
            to: { name: 'toolcompetitiveness' }
          }]
        },
        report: {
          name: '分析報告',
          to: { name: 'report' }
        },
        tutorial: {
          name: '介紹與教學',
          to: { name: 'tutorial' }
        },
        admin: {
          name: '管理者專區',
          width: '142px',
          lists: [{
            name: '會員帳號管理',
            value: 'admin',
            to: { name: 'admin' }
          }, {
            name: '零售價格資料管理',
            value: 'adminProductPrice',
            to: { name: 'adminProductPrice' }
          }, {
            name: '分析報告管理',
            value: 'adminReport',
            to: { name: 'adminReport' }
          }, {
            name: '會員操作記錄',
            value: 'adminAccessLog',
            to: { name: 'adminAccessLog' }
          }],
          display: function display() {
            return _this.user.role === 'admin';
          }
        }
      };
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setModalAction']), {
    logoutClick: function logoutClick() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var config;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                config = _this2.$ls.get('userInfo');
                _context.next = 4;
                return Object(src_api["e" /* deleteUser */])(config);

              case 4:
                _this2.setUserData(null);
                _this2.$router.push({ name: 'main' });
                _this2.addToast('success', '登出成功');
                _context.next = 13;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](0);

                _this2.setLoginAction(true);
                _this2.addToast('error', !_context.t0.response ? _context.t0.message : _context.t0.response.data.message || _context.t0.response.data.errors.join('<br>'));

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 9]]);
      }))();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7efee268","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/header.vue
var header_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[(_vm.isLogin)?_c('div',{staticClass:"max-width row-block"},[_c('div',{staticClass:"left row-block"},[_c('router-link',{staticClass:"logo row-block",attrs:{"to":{ name: !_vm.isLogin ? 'main' : 'tutorial' }}},[_c('img',{attrs:{"src":__webpack_require__("DMDf"),"alt":""}}),_vm._v(" "),_c('span',[_vm._v("農產業貿易潛力分析平台")])]),_vm._v(" "),_c('div',{staticClass:"tab-container row-block"},_vm._l((Object.entries(_vm.categorys).filter(function (ref) {
	var key = ref[0];
	var value = ref[1];

	return (value.display || (function () { return true; }))();
})),function(ref,index){
var value = ref[0];
var data = ref[1];
return _c('div',{key:index},[(data.to)?_c('router-link',{attrs:{"to":data.to}},[_c('div',{staticClass:"user-col"},[_c('button',{staticClass:"menu-button",class:{ selected: value === _vm.$route.name }},[_c('div',{staticClass:"main-field"},[_c('div',{staticClass:"title"},[_c('span',[_vm._v(_vm._s(data.name))])])])])])]):(data.lists)?_c('borCor',{attrs:{"type":'bottom',"width":data.width,"cursorStyle":{ width: '100px' }}},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('div',{staticClass:"user-col"},[_c('button',{staticClass:"menu-button",class:{ selected: data.lists.some(function (list) { return list.value === _vm.$route.name; }) }},[_c('div',{staticClass:"main-field"},[_c('div',{staticClass:"title"},[_c('span',[_vm._v(_vm._s(data.name))])])])])])]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},_vm._l((data.lists.filter(function (list) { return (list.display || (function () { return true; }))(); })),function(list,lindex){return _c('router-link',{key:lindex,attrs:{"to":list.to}},[_c('div',{staticClass:"list-button row-block",class:{ selected: list.value === _vm.$route.name }},[_c('div',{staticClass:"list-block"},[_vm._v(_vm._s(list.name))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])}),1)]):_vm._e()],1)}),0)],1),_vm._v(" "),_c('div',{staticClass:"center"}),_vm._v(" "),_c('div',{staticClass:"right row-block"},[_c('router-link',{attrs:{"to":{ name: 'user' }}},[_c('div',{staticClass:"user row-block"},[_c('img',{attrs:{"src":__webpack_require__("0gU3")}}),_vm._v(" "),_c('div',{style:({ width: '10px' })}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.user.name))])])]),_vm._v(" "),_c('div',{style:({ width: '36px' })}),_vm._v(" "),_c('div',{staticClass:"logout row-block"},[_c('button',{staticClass:"main-button",attrs:{"type":"button","name":"button"},on:{"click":function (e) { return _vm.logoutClick(); }}},[_c('span',[_vm._v("登出")])])])],1)]):_vm._e()])}
var header_staticRenderFns = []
var header_esExports = { render: header_render, staticRenderFns: header_staticRenderFns }
/* harmony default export */ var layout_header = (header_esExports);
// CONCATENATED MODULE: ./src/components/layout/header.vue
var header_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var header___vue_template_functional__ = false
/* styles */
var header___vue_styles__ = null
/* scopeId */
var header___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var header___vue_module_identifier__ = null
var header_Component = header_normalizeComponent(
  header,
  layout_header,
  header___vue_template_functional__,
  header___vue_styles__,
  header___vue_scopeId__,
  header___vue_module_identifier__
)

/* harmony default export */ var components_layout_header = (header_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/layout/footer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var footer = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['source']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-baaab86c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/footer.vue
var footer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"max-width row-block"},[_c('div',{staticClass:"row-block",style:({ flex: 1 })},[_vm._m(0),_vm._v(" "),_c('div',{style:({ flex: 1, maxWidth: '20px', minWidth: '10px' })}),_vm._v(" "),_c('div',{staticClass:"info"},[_c('span',[_vm._v("數據更新日期")]),_vm._v(" "),(_vm.source && Object.keys(_vm.source).length)?_c('div',{staticClass:"info-container"},[_c('span',{staticClass:"info-bor-cor"}),_vm._v(" "),_c('div',{staticClass:"info-block default-shadow"},[_c('div',{staticClass:"title"},[_vm._v("數據更新日期:")]),_vm._v(" "),_c('div',{staticClass:"content col-block"},_vm._l((_vm.source),function(update,source,index){return _c('div',{key:index,staticClass:"data row-block"},[_c('span',[_vm._v(_vm._s(source))]),_vm._v(" "),_c('div',{style:({ width: '10px' })}),_vm._v(" "),_c('span',[_vm._v(_vm._s(update))])])}),0)])]):_vm._e()]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('a',{staticClass:"title",attrs:{"href":"https://www.tari.gov.tw","target":"_blank"}},[_vm._v("農業部農業試驗所 版權所有 © 2019")]),_vm._v(" "),_c('span',{staticClass:"row-block",style:({ flex: 1 })},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('a',{staticClass:"title",attrs:{"href":"https://www.compassbioinfo.com","target":"_blank"}},[_vm._v("康百事生物資訊股份有限公司")])])])])}
var footer_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v("聯絡管理員："),_c('a',{attrs:{"href":"mailto:agritrade@tari.gov.tw"}},[_vm._v("agritrade@tari.gov.tw")])])}]
var footer_esExports = { render: footer_render, staticRenderFns: footer_staticRenderFns }
/* harmony default export */ var layout_footer = (footer_esExports);
// CONCATENATED MODULE: ./src/components/layout/footer.vue
var footer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var footer___vue_template_functional__ = false
/* styles */
var footer___vue_styles__ = null
/* scopeId */
var footer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var footer___vue_module_identifier__ = null
var footer_Component = footer_normalizeComponent(
  footer,
  layout_footer,
  footer___vue_template_functional__,
  footer___vue_styles__,
  footer___vue_scopeId__,
  footer___vue_module_identifier__
)

/* harmony default export */ var components_layout_footer = (footer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/tool/toast.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var toast = ({
  computed: Object(vuex_esm["c" /* mapGetters */])(['messages']),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['deleteToastAction']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fc479480","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/toast.vue
var toast_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toast-position"},[_c('div',{staticClass:"toast-container"},[_c('transition-group',{attrs:{"name":"toastDown"}},_vm._l((_vm.messages),function(msg,index){return _c('div',{key:index + 0,staticClass:"toast",class:[msg.type]},[_c('div',{staticClass:"option"},[_c('i',{staticClass:"fa fa-times",attrs:{"aria-hidden":"true"},on:{"click":function (e) { return _vm.deleteToastAction(index); }}})]),_vm._v(" "),_c('div',{staticClass:"content-block row-block"},[_c('img',{attrs:{"src":{
            success: __webpack_require__("ct0j"),
            error: __webpack_require__("fc/Z")
          }[msg.type]}}),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('div',{staticClass:"content",class:[msg.type],style:({ flex: 1 }),domProps:{"innerHTML":_vm._s(msg.content)}})])])}),0)],1)])}
var toast_staticRenderFns = []
var toast_esExports = { render: toast_render, staticRenderFns: toast_staticRenderFns }
/* harmony default export */ var tool_toast = (toast_esExports);
// CONCATENATED MODULE: ./src/components/tool/toast.vue
var toast_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var toast___vue_template_functional__ = false
/* styles */
var toast___vue_styles__ = null
/* scopeId */
var toast___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var toast___vue_module_identifier__ = null
var toast_Component = toast_normalizeComponent(
  toast,
  tool_toast,
  toast___vue_template_functional__,
  toast___vue_styles__,
  toast___vue_scopeId__,
  toast___vue_module_identifier__
)

/* harmony default export */ var components_tool_toast = (toast_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/layout/loading.vue
//
//
//
//
//
//
//
//
//

/* harmony default export */ var loading = ({});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c44699a2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/loading.vue
var loading_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-page"},[_c('div',{staticClass:"img-box"},[_c('img',{attrs:{"src":__webpack_require__("5xS/"),"alt":""}})])])}
var loading_staticRenderFns = []
var loading_esExports = { render: loading_render, staticRenderFns: loading_staticRenderFns }
/* harmony default export */ var layout_loading = (loading_esExports);
// CONCATENATED MODULE: ./src/components/layout/loading.vue
var loading_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var loading___vue_template_functional__ = false
/* styles */
var loading___vue_styles__ = null
/* scopeId */
var loading___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var loading___vue_module_identifier__ = null
var loading_Component = loading_normalizeComponent(
  loading,
  layout_loading,
  loading___vue_template_functional__,
  loading___vue_styles__,
  loading___vue_scopeId__,
  loading___vue_module_identifier__
)

/* harmony default export */ var components_layout_loading = (loading_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/layout/uploading.vue
//
//
//
//
//
//
//
//
//

/* harmony default export */ var uploading = ({
  props: {
    content: {
      type: String,
      default: function _default() {
        return '';
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f975c05c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/uploading.vue
var uploading_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uploading-page"},[_c('div',{staticClass:"img-box"},[_c('h1',[_vm._v(_vm._s(_vm.content !== null ? _vm.content : '上傳中'))]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("5xS/"),"alt":""}})])])}
var uploading_staticRenderFns = []
var uploading_esExports = { render: uploading_render, staticRenderFns: uploading_staticRenderFns }
/* harmony default export */ var layout_uploading = (uploading_esExports);
// CONCATENATED MODULE: ./src/components/layout/uploading.vue
var uploading_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var uploading___vue_template_functional__ = false
/* styles */
var uploading___vue_styles__ = null
/* scopeId */
var uploading___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var uploading___vue_module_identifier__ = null
var uploading_Component = uploading_normalizeComponent(
  uploading,
  layout_uploading,
  uploading___vue_template_functional__,
  uploading___vue_styles__,
  uploading___vue_scopeId__,
  uploading___vue_module_identifier__
)

/* harmony default export */ var components_layout_uploading = (uploading_Component.exports);

// EXTERNAL MODULE: ./src/constants/global/util.js
var util = __webpack_require__("Cduz");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/main/main.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var main = ({
  mixins: [loginData["a" /* default */], toastMethods["a" /* default */]],
  props: {
    minHeight: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      user: {
        account: '',
        password: ''
      },
      onSubmit: false
    };
  },

  computed: {
    onError: function onError() {
      var value = true;
      if (this.errors.items.length === 0) {
        value = false;
      }
      if (this.loading) {
        value = true;
      }
      return value;
    }
  },
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setModalAction', 'setLoadingAction']), {
    validateUserLogin: function validateUserLogin() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var result;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.onSubmit = true;
                _context.next = 3;
                return _this.$validator.validateAll();

              case 3:
                result = _context.sent;

                if (!result) {
                  _context.next = 9;
                  break;
                }

                _context.next = 7;
                return _this.userLogin();

              case 7:
                _context.next = 10;
                break;

              case 9:
                _this.onSubmit = false;

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    userLogin: function userLogin() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var data, response;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                data = _this2.user;
                _context2.next = 4;
                return Object(src_api["S" /* postUser */])(data);

              case 4:
                response = _context2.sent;

                _this2.$router.push({ name: 'tutorial' });
                _this2.setUserData(response);
                _this2.onSubmit = false;
                _context2.next = 15;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](0);

                _this2.setLoginAction(false);
                _this2.addToast('error', !_context2.t0.response ? _context2.t0.message : _context2.t0.response.data.message || _context2.t0.response.data.errors.join('<br>'));
                _this2.onSubmit = false;

              case 15:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 10]]);
      }))();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-658965e0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/main/main.vue
var main_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-page col-block",style:({ minHeight: _vm.minHeight })},[_c('div',{staticClass:"content-container center-block",style:({ flex: 1 })},[_c('div',{staticClass:"login-container col-block default-shadow"},[_c('div',{staticClass:"description-container col-block"},[_c('div',{staticClass:"logo-container row-block"},[_c('div',{staticClass:"logo-block"},[_c('img',{attrs:{"src":__webpack_require__("DMDf")}})]),_vm._v(" "),_c('div',{staticClass:"content-block col-block"},[_c('div',{staticClass:"title"},[_vm._v("農業部農業試驗所")]),_vm._v(" "),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s([
                'Taiwan Agricultural Research Institute',
                'Ministry of Agriculture'
              ].join('<br/>'))}})])]),_vm._v(" "),_c('div',{staticClass:"title-container"},[_c('div',{staticClass:"title"},[_vm._v("農產業貿易潛力分析平台")]),_vm._v(" "),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s([
              '本平台是您進入國際貿易事業決策最佳小幫手，',
              '讓您快速掌握市場趨勢，',
              '從整合數據中綜合分析市場潛力。'
            ].join('<br/>'))}}),_vm._v(" "),_c('div',{staticClass:"sub-content",domProps:{"innerHTML":_vm._s([
              '',
              '建議使用Chrome、Edge、Firefox與1600x900以上之解析度，獲取最佳操作體驗。'
            ].join('<br/>'))}})])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"main-container col-block",style:({ flex: 1 })},[_c('div',{staticClass:"title-container row-block"},[_c('div',{staticClass:"title"},[_vm._v("會員登入")]),_vm._v(" "),_c('div',{staticClass:"register"},[_c('router-link',{staticClass:"link",attrs:{"to":{ name: 'register' }}},[_vm._v("註冊新帳號")])],1)]),_vm._v(" "),_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"input-container"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-group col"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.account),expression:"user.account"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"type":"text","id":"username","name":"username","placeholder":"帳號"},domProps:{"value":(_vm.user.account)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return (function (e) { return _vm.$refs.password.focus(); })($event)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "account", $event.target.value)}}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('username')),expression:"errors.has('username')"}],staticClass:"error"},[_vm._v(_vm._s((_vm.errors.first('username') || '').replace('username', '帳號')))])])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-group col"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.password),expression:"user.password"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"password",attrs:{"type":"password","id":"password","name":"password","placeholder":"密碼"},domProps:{"value":(_vm.user.password)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return (function (e) { return _vm.validateUserLogin(); })($event)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "password", $event.target.value)}}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('password')),expression:"errors.has('password')"}],staticClass:"error"},[_vm._v(_vm._s((_vm.errors.first('password') || '').replace('password', '密碼')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"link input-group col"},[_c('router-link',{staticClass:"link",attrs:{"to":{ name: 'forgot' }}},[_vm._v("忘記密碼？")])],1)])]),_vm._v(" "),_c('div',{style:({ flex: 3 })}),_vm._v(" "),_c('div',{staticClass:"button-container"},[_c('button',{staticClass:"main-button field-button",class:{ loading: _vm.onSubmit },attrs:{"type":"button","name":"button","disabled":_vm.onError},on:{"click":function (e) { return _vm.validateUserLogin(); }}},[_c('span',[_vm._v("登入")])])])])])])])}
var main_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"title input-group col"},[_c('span',[_vm._v("帳號*")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"title input-group col"},[_c('span',[_vm._v("密碼*")])])])}]
var main_esExports = { render: main_render, staticRenderFns: main_staticRenderFns }
/* harmony default export */ var main_main = (main_esExports);
// CONCATENATED MODULE: ./src/pages/main/main.vue
var main_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var main___vue_template_functional__ = false
/* styles */
var main___vue_styles__ = null
/* scopeId */
var main___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var main___vue_module_identifier__ = null
var main_Component = main_normalizeComponent(
  main,
  main_main,
  main___vue_template_functional__,
  main___vue_styles__,
  main___vue_scopeId__,
  main___vue_module_identifier__
)

/* harmony default export */ var pages_main_main = (main_Component.exports);

// EXTERNAL MODULE: ./src/constants/global/regex.js
var regex = __webpack_require__("9iLM");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/main/forgot.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var forgot = ({
  mixins: [loginData["a" /* default */], toastMethods["a" /* default */]],
  props: {
    minHeight: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      forgot: {
        email: ''
      },
      onSubmit: false
    };
  },

  computed: {
    onError: function onError() {
      var value = true;
      if (this.errors.items.length === 0) {
        value = false;
      }
      if (this.loading) {
        value = true;
      }
      return value;
    },

    // global
    matchEmail: function matchEmail() {
      return regex["a" /* matchEmail */];
    }
  },
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setModalAction']), {
    validateForgotPassword: function validateForgotPassword() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var result;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.onSubmit = true;
                _context.next = 3;
                return _this.$validator.validateAll();

              case 3:
                result = _context.sent;

                if (!result) {
                  _context.next = 9;
                  break;
                }

                _context.next = 7;
                return _this.forgotPassword();

              case 7:
                _context.next = 10;
                break;

              case 9:
                _this.onSubmit = false;

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    forgotPassword: function forgotPassword() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var data;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                data = extends_default()({}, _this2.forgot, {
                  redirect_url: window.location.origin + '/reset'
                });
                _context2.next = 4;
                return Object(src_api["N" /* postForgotUserPassword */])(data);

              case 4:
                _this2.addToast('success', 'Email已寄出');
                _this2.$router.push({ name: 'main' });
                _this2.onSubmit = false;
                _context2.next = 14;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](0);

                _this2.setLoginAction(false);
                _this2.addToast('error', !_context2.t0.response ? _context2.t0.message : _context2.t0.response.data.message || _context2.t0.response.data.errors.join('<br>'));
                _this2.onSubmit = false;

              case 14:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 9]]);
      }))();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05b27687","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/main/forgot.vue
var forgot_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"forgot-page col-block",style:({ minHeight: _vm.minHeight })},[_c('div',{staticClass:"content-container col-block",style:({ flex: 1 })},[_c('div',{staticClass:"forgot-container col-block default-shadow"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"content-block",style:({ width: '100%' })},[_c('div',[_vm._v("請輸入您註冊帳號時的E-mail，才能收取密碼修改郵件，若您有進一步的問題，請聯絡管理員。")]),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('div',{staticClass:"main-container"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-group col"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.forgot.email),expression:"forgot.email"},{name:"validate",rawName:"v-validate",value:({ required: true, regex: _vm.matchEmail, max: 100 }),expression:"{ required: true, regex: matchEmail, max: 100 }"}],attrs:{"type":"text","id":"email","name":"email"},domProps:{"value":(_vm.forgot.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.forgot, "email", $event.target.value)}}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('email')),expression:"errors.has('email')"}],staticClass:"error"},[_vm._v(_vm._s((_vm.errors.first('email') || '').replace('email', 'E-mail')))])])])]),_vm._v(" "),_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"options-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'main' }}},[_c('button',{staticClass:"gray-button",attrs:{"type":"button","name":"button"}},[_c('span',[_vm._v("取消")])])]),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('button',{staticClass:"main-button",class:{ loading: _vm.onSubmit },attrs:{"type":"button","name":"button","disabled":_vm.onError},on:{"click":function (e) { return _vm.validateForgotPassword(); }}},[_c('span',[_vm._v("送出")])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})],1)]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{staticClass:"footer-container"})])}
var forgot_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-container sub-title center-block"},[_c('span',[_vm._v("忘記密碼")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("管理員信箱："),_c('a',{attrs:{"href":"mailto:agritrade@tari.gov.tw"}},[_vm._v("agritrade@tari.gov.tw")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"input-group no-padding col"},[_vm._v("電子信箱"),_c('span',{staticClass:"alert"},[_vm._v("*")])])])}]
var forgot_esExports = { render: forgot_render, staticRenderFns: forgot_staticRenderFns }
/* harmony default export */ var main_forgot = (forgot_esExports);
// CONCATENATED MODULE: ./src/pages/main/forgot.vue
var forgot_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var forgot___vue_template_functional__ = false
/* styles */
var forgot___vue_styles__ = null
/* scopeId */
var forgot___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var forgot___vue_module_identifier__ = null
var forgot_Component = forgot_normalizeComponent(
  forgot,
  main_forgot,
  forgot___vue_template_functional__,
  forgot___vue_styles__,
  forgot___vue_scopeId__,
  forgot___vue_module_identifier__
)

/* harmony default export */ var pages_main_forgot = (forgot_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/main/reset.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var main_reset = ({
  mixins: [loginData["a" /* default */], toastMethods["a" /* default */]],
  props: {
    minHeight: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      reset: {
        password: '',
        confirmed: '',
        usr_id: '',
        reset_password_token: ''
      },
      onSubmit: false
    };
  },

  computed: {
    onError: function onError() {
      var value = true;
      if (this.errors.items.length === 0) {
        value = false;
      }
      if (this.loading) {
        value = true;
      }
      return value;
    }
  },
  created: function created() {
    if (this.$route.query.user_id && this.$route.query.reset_password_token) {
      this.reset.reset_password_token = this.$route.query.reset_password_token;
      this.reset.user_id = this.$route.query.user_id;
    } else {
      this.$router.push({ name: 'main' });
    }
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setModalAction']), {
    validatePasswordReset: function validatePasswordReset() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var result;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.onSubmit = true;
                _context.next = 3;
                return _this.$validator.validateAll();

              case 3:
                result = _context.sent;

                if (!result) {
                  _context.next = 14;
                  break;
                }

                if (!(_this.reset.password === _this.reset.confirmed)) {
                  _context.next = 10;
                  break;
                }

                _context.next = 8;
                return _this.passwordReset();

              case 8:
                _context.next = 12;
                break;

              case 10:
                _this.addToast('error', '兩次密碼輸入不相同');
                _this.onSubmit = false;

              case 12:
                _context.next = 15;
                break;

              case 14:
                _this.onSubmit = false;

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    passwordReset: function passwordReset() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var data;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                data = _this2.reset;
                _context2.next = 4;
                return Object(src_api["R" /* postResetUserPassword */])(data);

              case 4:
                _this2.addToast('success', '重設成功');
                _this2.$router.push({ name: 'main' });
                _this2.onSubmit = false;
                _context2.next = 14;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](0);

                _this2.setLoginAction(false);
                _this2.addToast('error', !_context2.t0.response ? _context2.t0.message : _context2.t0.response.data.message || _context2.t0.response.data.errors.join('<br>'));
                _this2.onSubmit = false;

              case 14:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 9]]);
      }))();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-630176ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/main/reset.vue
var reset_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reset-page col-block",style:({ minHeight: _vm.minHeight })},[_c('div',{staticClass:"content-container col-block",style:({ flex: 1 })},[_c('div',{staticClass:"reset-container col-block default-shadow"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"content-block",style:({ width: '100%' })},[_c('div',[_vm._v("請以6碼以上字元設定新密碼。")])]),_vm._v(" "),_c('div',{staticClass:"main-container"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-group col"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reset.password),expression:"reset.password"},{name:"validate",rawName:"v-validate",value:('required|min:6|max:250'),expression:"'required|min:6|max:250'"}],attrs:{"type":"password","id":"password","name":"password"},domProps:{"value":(_vm.reset.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.reset, "password", $event.target.value)}}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('password')),expression:"errors.has('password')"}],staticClass:"error"},[_vm._v(_vm._s('密碼不符規定，請設6碼以上英數字之密碼'))])])]),_vm._v(" "),_c('div',{staticClass:"row",style:({ height: '10px' })}),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-group col"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reset.confirmed),expression:"reset.confirmed"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"type":"password","id":"confirmed","name":"confirmed"},domProps:{"value":(_vm.reset.confirmed)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.reset, "confirmed", $event.target.value)}}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('confirmed')),expression:"errors.has('confirmed')"}],staticClass:"error"},[_vm._v(_vm._s((_vm.errors.first('confirmed') || '').replace('confirmed', '確認密碼')))])])])]),_vm._v(" "),_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"options-container col-block"},[_c('button',{staticClass:"main-button",class:{ loading: _vm.onSubmit },attrs:{"type":"button","name":"button","disabled":_vm.onError},on:{"click":function (e) { return _vm.validatePasswordReset(); }}},[_c('span',[_vm._v("送出")])])])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{staticClass:"footer-container"})])}
var reset_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-container sub-title center-block"},[_c('span',[_vm._v("重設密碼")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"input-group no-padding col"},[_vm._v("新密碼"),_c('span',{staticClass:"alert"},[_vm._v("*")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"input-group no-padding col"},[_vm._v("確認密碼"),_c('span',{staticClass:"alert"},[_vm._v("*")])])])}]
var reset_esExports = { render: reset_render, staticRenderFns: reset_staticRenderFns }
/* harmony default export */ var pages_main_reset = (reset_esExports);
// CONCATENATED MODULE: ./src/pages/main/reset.vue
var reset_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var reset___vue_template_functional__ = false
/* styles */
var reset___vue_styles__ = null
/* scopeId */
var reset___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var reset___vue_module_identifier__ = null
var reset_Component = reset_normalizeComponent(
  main_reset,
  pages_main_reset,
  reset___vue_template_functional__,
  reset___vue_styles__,
  reset___vue_scopeId__,
  reset___vue_module_identifier__
)

/* harmony default export */ var src_pages_main_reset = (reset_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/main/redirect.vue



//
//
//
//
//






/* harmony default export */ var main_redirect = ({
  mixins: [loginData["a" /* default */], toastMethods["a" /* default */]],
  props: {
    minHeight: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      data: {
        user_id: '',
        confirm_email_token: ''
      }
    };
  },
  created: function created() {
    var _this = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      var config, response;
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(_this.$route.query.user_id && _this.$route.query.confirm_email_token)) {
                _context.next = 28;
                break;
              }

              _this.setLoadingAction(true);
              _this.data.user_id = _this.$route.query.user_id - 0;
              _this.data.confirm_email_token = _this.$route.query.confirm_email_token;
              _context.next = 6;
              return _this.confirmEmail();

            case 6:
              _this.setLoadingAction(false);
              _context.t0 = _this.$route.params.type;
              _context.next = _context.t0 === 'register' ? 10 : _context.t0 === 'email' ? 13 : 26;
              break;

            case 10:
              _this.setUserData(null);
              _this.$router.push({ name: 'main' });
              return _context.abrupt('break', 26);

            case 13:
              _context.prev = 13;
              config = _this.$ls.get('userInfo');
              _context.next = 17;
              return Object(src_api["G" /* getUserToken */])(config);

            case 17:
              response = _context.sent;

              _this.setUserData(response, config['access_token']);
              _context.next = 24;
              break;

            case 21:
              _context.prev = 21;
              _context.t1 = _context['catch'](13);

              _this.setUserData(null);

            case 24:
              _this.$router.push({ name: 'user' });
              return _context.abrupt('break', 26);

            case 26:
              _context.next = 29;
              break;

            case 28:
              _this.$router.push({ name: 'main' });

            case 29:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[13, 21]]);
    }))();
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setLoadingAction']), {
    confirmEmail: function confirmEmail() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var data, response;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                data = _this2.data;
                _context2.next = 4;
                return Object(src_api["M" /* postConfirmEmail */])(data);

              case 4:
                response = _context2.sent;

                _this2.addToast('success', response.data.data);
                _context2.next = 12;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2['catch'](0);

                _this2.addToast('error', !_context2.t0.response ? _context2.t0.message : _context2.t0.response.data.message || _context2.t0.response.data.errors.join('<br>'));
                _this2.setLoadingAction(false);

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 8]]);
      }))();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60020926","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/main/redirect.vue
var redirect_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"redirect-page col-block",style:({ minHeight: _vm.minHeight })})}
var redirect_staticRenderFns = []
var redirect_esExports = { render: redirect_render, staticRenderFns: redirect_staticRenderFns }
/* harmony default export */ var pages_main_redirect = (redirect_esExports);
// CONCATENATED MODULE: ./src/pages/main/redirect.vue
var redirect_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var redirect___vue_template_functional__ = false
/* styles */
var redirect___vue_styles__ = null
/* scopeId */
var redirect___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var redirect___vue_module_identifier__ = null
var redirect_Component = redirect_normalizeComponent(
  main_redirect,
  pages_main_redirect,
  redirect___vue_template_functional__,
  redirect___vue_styles__,
  redirect___vue_scopeId__,
  redirect___vue_module_identifier__
)

/* harmony default export */ var src_pages_main_redirect = (redirect_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./src/api/config.js
var api_config = __webpack_require__("T452");

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/get-iterator.js
var get_iterator = __webpack_require__("BO1k");
var get_iterator_default = /*#__PURE__*/__webpack_require__.n(get_iterator);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/tool/customFilter.vue





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var customFilter = ({
  props: {
    datas: {
      type: Array,
      default: function _default() {
        return null;
      }
    },
    init: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    filters: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      conditions: {},
      output: {}
    };
  },

  watch: {
    'datas': function datas() {
      this.datas && this.$emit('filted', this.dataFilter(this.datas, this.output));
    },
    'init': function init() {
      this.initialConditions();
    },
    'filters': function filters() {
      this.initialConditions();
    },

    'conditions': {
      handler: function () {
        var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
          return regenerator_default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return this.afterTreatment(this.conditions);

                case 2:
                  this.output = _context.sent;

                  this.$emit('change', this.output);
                  this.datas && this.$emit('filted', this.dataFilter(this.datas, this.output));

                case 5:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function handler() {
          return _ref.apply(this, arguments);
        }

        return handler;
      }(),
      deep: true
    }
  },
  created: function created() {
    this.initialConditions();
  },

  methods: {
    initialConditions: function initialConditions() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var input, initials;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this.preTreatment(_this.init);

              case 2:
                input = _context2.sent;
                initials = {
                  input: function input() {
                    return '';
                  },
                  datalist: function datalist() {
                    return '';
                  },
                  select: function select() {
                    return '';
                  },
                  single: function single() {
                    return '';
                  },
                  multiple: function multiple() {
                    return [];
                  },
                  range: function range() {
                    return ['', ''];
                  },
                  date: function date() {
                    return ['', ''];
                  },
                  time: function time() {
                    return ['', ''];
                  },
                  tags: function tags() {
                    return [];
                  }
                };

                _this.conditions = _this.filters.reduce(function (s, c) {
                  return extends_default()({}, s, defineProperty_default()({}, c.value, input[c.value] || initials[c.type]()));
                }, {});

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    },
    preTreatment: function preTreatment(init) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var input, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, filter;

        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                input = {};
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context4.prev = 4;
                _iterator = get_iterator_default()(_this2.filters);

              case 6:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context4.next = 14;
                  break;
                }

                filter = _step.value;
                _context4.next = 10;
                return (filter.inputFormat || function () {
                  var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3(x) {
                    return regenerator_default.a.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            return _context3.abrupt('return', x);

                          case 1:
                          case 'end':
                            return _context3.stop();
                        }
                      }
                    }, _callee3, _this2);
                  }));

                  return function (_x) {
                    return _ref2.apply(this, arguments);
                  };
                }())(init[filter.value]);

              case 10:
                input[filter.value] = _context4.sent;

              case 11:
                _iteratorNormalCompletion = true;
                _context4.next = 6;
                break;

              case 14:
                _context4.next = 20;
                break;

              case 16:
                _context4.prev = 16;
                _context4.t0 = _context4['catch'](4);
                _didIteratorError = true;
                _iteratorError = _context4.t0;

              case 20:
                _context4.prev = 20;
                _context4.prev = 21;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 23:
                _context4.prev = 23;

                if (!_didIteratorError) {
                  _context4.next = 26;
                  break;
                }

                throw _iteratorError;

              case 26:
                return _context4.finish(23);

              case 27:
                return _context4.finish(20);

              case 28:
                return _context4.abrupt('return', input);

              case 29:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this2, [[4, 16, 20, 28], [21,, 23, 27]]);
      }))();
    },
    afterTreatment: function afterTreatment(conditions) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
        var output, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, filter;

        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                output = {};
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context6.prev = 4;
                _iterator2 = get_iterator_default()(_this3.filters);

              case 6:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context6.next = 14;
                  break;
                }

                filter = _step2.value;
                _context6.next = 10;
                return (filter.outputFormat || function () {
                  var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5(x) {
                    return regenerator_default.a.wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            return _context5.abrupt('return', x);

                          case 1:
                          case 'end':
                            return _context5.stop();
                        }
                      }
                    }, _callee5, _this3);
                  }));

                  return function (_x2) {
                    return _ref3.apply(this, arguments);
                  };
                }())(conditions[filter.value]);

              case 10:
                output[filter.value] = _context6.sent;

              case 11:
                _iteratorNormalCompletion2 = true;
                _context6.next = 6;
                break;

              case 14:
                _context6.next = 20;
                break;

              case 16:
                _context6.prev = 16;
                _context6.t0 = _context6['catch'](4);
                _didIteratorError2 = true;
                _iteratorError2 = _context6.t0;

              case 20:
                _context6.prev = 20;
                _context6.prev = 21;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 23:
                _context6.prev = 23;

                if (!_didIteratorError2) {
                  _context6.next = 26;
                  break;
                }

                throw _iteratorError2;

              case 26:
                return _context6.finish(23);

              case 27:
                return _context6.finish(20);

              case 28:
                return _context6.abrupt('return', output);

              case 29:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this3, [[4, 16, 20, 28], [21,, 23, 27]]);
      }))();
    },
    dataFilter: function dataFilter(datas, conditions) {
      var getDefaultFilter = function getDefaultFilter(type) {
        switch (type) {
          case 'input':
          case 'datalist':
            {
              return function (d, c, f) {
                return !c[f.value] || d[f.value].includes(c[f.value]);
              };
            }
          case 'select':
          case 'single':
            {
              return function (d, c, f) {
                return !c[f.value] || d[f.value] === c[f.value];
              };
            }
          case 'multiple':
          case 'tags':
            {
              return function (d, c, f) {
                return c[f.value].length === 0 || c[f.value].includes(d[f.value]);
              };
            }
          case 'range':
          case 'time':
            {
              return function (d, c, f) {
                return (!c[f.value][0] || d[f.value] >= c[f.value][0]) && (!c[f.value][1] || d[f.value] <= c[f.value][1]);
              };
            }
          case 'date':
            {
              return function (d, c, f) {
                return (!c[f.value][0] || new Date(d[f.value]) >= new Date(c[f.value][0])) && (!c[f.value][1] || new Date(d[f.value]) <= new Date(c[f.value][1]));
              };
            }
        }
      };
      var filtedDatas = datas;
      this.filters.forEach(function (filter, index) {
        filtedDatas = filtedDatas.filter(function (data) {
          return (filter.filter || getDefaultFilter(filter.type))(data, conditions, filter);
        });
      });
      return filtedDatas;
    },
    datalistOnChange: function datalistOnChange(filter, conditions) {
      setTimeout(function () {
        return (filter.onChange || function () {})(conditions[filter.value], conditions);
      }, 50);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b76803c8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/customFilter.vue
var customFilter_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"custom-filter-container"}},_vm._l((_vm.filters),function(filter,index){return _c('div',{key:index,staticClass:"custom-filter-group"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(filter.title))]),_vm._v(" "),_c('div',{staticClass:"options",class:[filter.type]},[(filter.type === 'input')?[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.conditions[filter.value]),expression:"conditions[filter.value]"}],attrs:{"type":"text","placeholder":(filter.placeholder || (function () { return ''; }))(filter)},domProps:{"value":(_vm.conditions[filter.value])},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();$event.stopPropagation();_vm.$emit('pressEnter')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.conditions, filter.value, $event.target.value)}}})])]:_vm._e(),_vm._v(" "),(filter.type === 'select')?[_c('div',{staticClass:"input-group"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.conditions[filter.value]),expression:"conditions[filter.value]"}],style:(_vm.conditions[filter.value] ? {} : { color: '#a9a9a9' }),on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();$event.stopPropagation();_vm.$emit('pressEnter')},"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.conditions, filter.value, $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function (e) { return (filter.onChange || (function () {}))(_vm.conditions[filter.value], _vm.conditions); }]}},[(filter.placeholder)?_c('option',{attrs:{"disabled":"","value":""}},[_vm._v(_vm._s(filter.placeholder(filter)))]):_vm._e(),_vm._v(" "),_vm._l((filter.options.filter(filter.optionDisplay ? filter.optionDisplay(_vm.conditions) : (function () { return true; }))),function(option,index){return _c('option',{key:index,domProps:{"value":option.value}},[_vm._v(_vm._s(option.title))])})],2)])]:_vm._e(),_vm._v(" "),(filter.type === 'datalist')?[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.conditions[filter.value]),expression:"conditions[filter.value]"}],attrs:{"type":"text","list":filter.value + '-filter-lists',"placeholder":(filter.placeholder || (function () { return ''; }))(filter)},domProps:{"value":(_vm.conditions[filter.value])},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();$event.stopPropagation();_vm.$emit('pressEnter')},"change":function (e) { return _vm.datalistOnChange(filter, _vm.conditions); },"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.conditions, filter.value, $event.target.value)}}}),_vm._v(" "),(filter.customList)?[((filter.lists(_vm.conditions[filter.value], _vm.conditions) || []).length)?_c('div',{staticClass:"datalist"},_vm._l((filter.lists(_vm.conditions[filter.value], _vm.conditions)),function(option){return _c('div',{key:option + index,staticClass:"option",on:{"click":function (e) { return _vm.conditions[filter.value] = option; }}},[_vm._v(_vm._s(option))])}),0):_vm._e()]:[((filter.lists(_vm.conditions[filter.value], _vm.conditions) || []).length)?_c('datalist',{attrs:{"id":filter.value + '-filter-lists'}},_vm._l((filter.lists(_vm.conditions[filter.value], _vm.conditions)),function(option,index){return _c('option',{key:index},[_vm._v(_vm._s(option))])}),0):_vm._e()]],2)]:(filter.type === 'single')?_vm._l((filter.options),function(option,index){return _c('div',{key:index,staticClass:"input-group"},[_c('label',{attrs:{"for":filter.value + '_' + option.value}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.conditions[filter.value]),expression:"conditions[filter.value]"}],attrs:{"type":"radio","id":filter.value + '_' + option.value,"name":filter.value},domProps:{"value":option.value,"checked":_vm._q(_vm.conditions[filter.value],option.value)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();$event.stopPropagation();_vm.$emit('pressEnter')},"change":function($event){_vm.$set(_vm.conditions, filter.value, option.value)}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(option.title))])])])}):(filter.type === 'multiple')?_vm._l((filter.options),function(option,index){return _c('div',{key:index,staticClass:"input-group"},[_c('label',{class:{ disabled: filter.range && ((filter.range[0] === (_vm.conditions[filter.value] || []).length && _vm.conditions[filter.value].includes(option.value)) || (filter.range[1] === (_vm.conditions[filter.value] || []).length && !_vm.conditions[filter.value].includes(option.value))) },attrs:{"for":filter.value + '_' + option.value}},[_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"},{name:"model",rawName:"v-model",value:(_vm.conditions[filter.value]),expression:"conditions[filter.value]"}],attrs:{"type":"checkbox","id":filter.value + '_' + option.value,"disabled":filter.range && ((filter.range[0] === (_vm.conditions[filter.value] || []).length && _vm.conditions[filter.value].includes(option.value)) || (filter.range[1] === (_vm.conditions[filter.value] || []).length && !_vm.conditions[filter.value].includes(option.value))),"name":filter.value},domProps:{"value":option.value,"checked":Array.isArray(_vm.conditions[filter.value])?_vm._i(_vm.conditions[filter.value],option.value)>-1:(_vm.conditions[filter.value])},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();$event.stopPropagation();_vm.$emit('pressEnter')},"change":function($event){var $$a=_vm.conditions[filter.value],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=option.value,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.conditions, filter.value, $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.conditions, filter.value, $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.conditions, filter.value, $$c)}}}}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("TEyu")("./checkbox-" + ((_vm.conditions[filter.value] || []).includes(option.value) ? 'true' : 'false') + '.svg')}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(option.title))])])])}):(filter.type === 'range')?[(_vm.conditions[filter.value])?_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.conditions[filter.value][0]),expression:"conditions[filter.value][0]"}],attrs:{"type":"number","step":filter.step,"min":filter.range ? filter.range[0] : null,"max":filter.range ? filter.range[1] : null,"placeholder":(filter.placeholder || (function () { return ['', '']; }))(filter)[0]},domProps:{"value":(_vm.conditions[filter.value][0])},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();$event.stopPropagation();_vm.$emit('pressEnter')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.conditions[filter.value], 0, $event.target.value)}}}),_vm._v(" "),_c('span',{style:({ opacity: 0, height: '5px' })},[_vm._v("~")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.conditions[filter.value][1]),expression:"conditions[filter.value][1]"}],attrs:{"type":"number","step":filter.step,"min":filter.range ? filter.range[0] : null,"max":filter.range ? filter.range[1] : null,"placeholder":(filter.placeholder || (function () { return ['', '']; }))(filter)[1]},domProps:{"value":(_vm.conditions[filter.value][1])},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();$event.stopPropagation();_vm.$emit('pressEnter')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.conditions[filter.value], 1, $event.target.value)}}})]):_vm._e()]:(filter.type === 'date')?[(_vm.conditions[filter.value])?_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.conditions[filter.value][0]),expression:"conditions[filter.value][0]"}],style:(_vm.conditions[filter.value][0] ? {} : { color: '#777777' }),attrs:{"type":"date","min":filter.range ? filter.range[0] : null,"max":filter.range ? filter.range[1] : null,"placeholder":filter.placeholder(filter)[0]},domProps:{"value":(_vm.conditions[filter.value][0])},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();$event.stopPropagation();_vm.$emit('pressEnter')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.conditions[filter.value], 0, $event.target.value)}}}),_vm._v(" "),_c('span',{style:({ opacity: 0, height: '5px' })},[_vm._v("~")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.conditions[filter.value][1]),expression:"conditions[filter.value][1]"}],style:(_vm.conditions[filter.value][1] ? {} : { color: '#777777' }),attrs:{"type":"date","min":filter.range ? filter.range[0] : null,"max":filter.range ? filter.range[1] : null,"placeholder":filter.placeholder(filter)[1]},domProps:{"value":(_vm.conditions[filter.value][1])},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();$event.stopPropagation();_vm.$emit('pressEnter')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.conditions[filter.value], 1, $event.target.value)}}})]):_vm._e()]:(filter.type === 'time')?[(_vm.conditions[filter.value])?_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.conditions[filter.value][0]),expression:"conditions[filter.value][0]"}],style:(_vm.conditions[filter.value][0] ? {} : { color: '#777777' }),attrs:{"type":"time","min":filter.range ? filter.range[0] : null,"max":filter.range ? filter.range[1] : null},domProps:{"value":(_vm.conditions[filter.value][0])},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();$event.stopPropagation();_vm.$emit('pressEnter')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.conditions[filter.value], 0, $event.target.value)}}}),_vm._v(" "),_c('span',{style:({ opacity: 0, height: '5px' })},[_vm._v("~")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.conditions[filter.value][1]),expression:"conditions[filter.value][1]"}],style:(_vm.conditions[filter.value][1] ? {} : { color: '#777777' }),attrs:{"type":"time","min":filter.range ? filter.range[0] : null,"max":filter.range ? filter.range[1] : null},domProps:{"value":(_vm.conditions[filter.value][1])},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();$event.stopPropagation();_vm.$emit('pressEnter')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.conditions[filter.value], 1, $event.target.value)}}})]):_vm._e()]:(filter.type === 'tags')?[_c('div',{staticClass:"input-group"},[_c('input',{ref:filter.value,refInFor:true,attrs:{"type":"text","placeholder":(filter.placeholder || (function () { return ''; }))(filter)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();$event.stopPropagation();_vm.$emit('pressEnter')}}}),_vm._v(" "),_c('button',{on:{"click":function (e) { _vm.conditions[filter.value] = _vm.conditions[filter.value].concat([_vm.$refs[filter.value][0].value]).filter(function (x, i, s) { return s.indexOf(x) === i; }); _vm.$refs[filter.value][0].value = '' }}},[_vm._v("+")])]),_vm._v(" "),_vm._l((_vm.conditions[filter.value]),function(option,index){return _c('div',{key:index,staticClass:"input-group"},[_c('label',[_c('span',[_vm._v(_vm._s(option))]),_vm._v(" "),_c('button',{on:{"click":function (e) { return _vm.conditions[filter.value].splice(index, 1); }}},[_vm._v("x")])])])})]:_vm._e()],2)])}),0)}
var customFilter_staticRenderFns = []
var customFilter_esExports = { render: customFilter_render, staticRenderFns: customFilter_staticRenderFns }
/* harmony default export */ var tool_customFilter = (customFilter_esExports);
// CONCATENATED MODULE: ./src/components/tool/customFilter.vue
function customFilter_injectStyle (ssrContext) {
  __webpack_require__("n/Hc")
}
var customFilter_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var customFilter___vue_template_functional__ = false
/* styles */
var customFilter___vue_styles__ = customFilter_injectStyle
/* scopeId */
var customFilter___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var customFilter___vue_module_identifier__ = null
var customFilter_Component = customFilter_normalizeComponent(
  customFilter,
  tool_customFilter,
  customFilter___vue_template_functional__,
  customFilter___vue_styles__,
  customFilter___vue_scopeId__,
  customFilter___vue_module_identifier__
)

/* harmony default export */ var components_tool_customFilter = (customFilter_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/admin/filter.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var admin_filter = ({
  components: {
    customFilter: components_tool_customFilter
  },
  props: {
    minHeight: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    filters: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      init: {},
      conditions: {
        filters: {}
      }
    };
  },
  created: function created() {
    this.init = this.filters.init;
  },

  watch: {
    'filters': function filters() {
      this.init = this.filters.init;
    }
  },
  methods: {
    filtersOnChange: function filtersOnChange(conditions) {
      // const init = !Object.values(this.conditions.filters).every(x => x)
      this.conditions.filters = conditions;
      this.updateFilter(false);
    },
    updateFilter: function updateFilter() {
      var search = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      this.$emit('changeFilters', JSON.parse(stringify_default()(value || this.conditions.filters)), search);
    },
    clearFilter: function clearFilter() {
      var _this = this;

      this.init = {};
      setTimeout(function () {
        return _this.updateFilter(true, {});
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-356c87ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/filter.vue
var filter_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-filter-page col-block default-shadow",style:({ height: _vm.minHeight })},[(_vm.disabled)?_c('div',{staticClass:"mask"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"title-container center-block"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"filter-container",style:({ flex: 1 })},[_c('customFilter',{attrs:{"init":_vm.init,"filters":_vm.filters.options},on:{"change":function (conditions) { return _vm.filtersOnChange(conditions); },"pressEnter":function () { return _vm.updateFilter(); }}}),_vm._v(" "),_c('div',{staticClass:"button col-block"},[_c('button',{staticClass:"main-button",attrs:{"type":"button","name":"button"},on:{"click":function (e) { return _vm.updateFilter(); }}},[_c('span',[_vm._v("搜尋")])]),_vm._v(" "),_c('div',{style:({ height: '15px' })}),_vm._v(" "),_c('button',{staticClass:"white-button",attrs:{"type":"button","name":"button"},on:{"click":function (e) { return _vm.clearFilter(); }}},[_c('span',[_vm._v("清除")])])])],1)])}
var filter_staticRenderFns = []
var filter_esExports = { render: filter_render, staticRenderFns: filter_staticRenderFns }
/* harmony default export */ var components_admin_filter = (filter_esExports);
// CONCATENATED MODULE: ./src/components/admin/filter.vue
var filter_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var filter___vue_template_functional__ = false
/* styles */
var filter___vue_styles__ = null
/* scopeId */
var filter___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var filter___vue_module_identifier__ = null
var filter_Component = filter_normalizeComponent(
  admin_filter,
  components_admin_filter,
  filter___vue_template_functional__,
  filter___vue_styles__,
  filter___vue_scopeId__,
  filter___vue_module_identifier__
)

/* harmony default export */ var src_components_admin_filter = (filter_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/array/from.js
var from = __webpack_require__("c/Tr");
var from_default = /*#__PURE__*/__webpack_require__.n(from);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/tool/pageButtons.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var pageButtons = ({
  props: {
    default: {
      type: Number,
      default: 1
    },
    display: {
      type: Number,
      required: true
    },
    total: {
      type: Number,
      required: true
    },
    buttonRange: {
      type: Number,
      default: 5
    },
    showFirst: {
      type: Boolean,
      default: true
    },
    showLast: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      page: this.default
    };
  },

  watch: {
    'page': function page(val) {
      this.fixRange();
    },
    'total': function total(val) {
      this.fixRange();
    },
    'display': function display(val) {
      this.fixRange();
    }
  },
  computed: {
    first: function first() {
      return 1;
    },
    last: function last() {
      return this.total > 0 && this.display > 0 ? Math.ceil(this.total / this.display) : 1;
    },
    nowList: function nowList() {
      var _this = this;

      return from_default()(new Array(this.buttonRange), function (v, i) {
        return i + _this.page - Math.floor(_this.buttonRange / 2);
      }).filter(function (n) {
        return n >= _this.first && n <= _this.last;
      });
    }
  },
  methods: {
    selectPage: function selectPage(page) {
      this.page = page !== 'pre' ? page !== 'next' ? page : Math.min(this.page + 1, this.last) : Math.max(this.page - 1, this.first);
      this.$emit('selectPage', this.page);
    },
    fixRange: function fixRange() {
      this.selectPage(this.page >= this.first ? this.page <= this.last ? this.page : this.last : this.first);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d6e357f0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/pageButtons.vue
var pageButtons_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-group"},[(_vm.nowList[0] !== _vm.first)?_c('div',{staticClass:"first"},[(_vm.showFirst)?_c('a',{on:{"click":function($event){_vm.selectPage(_vm.first)}}},[_vm._v(_vm._s(_vm.first))]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"ellipsis"},[_vm._v("...")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"now"},_vm._l((_vm.nowList),function(n,i){return _c('a',{key:i,class:{ 'active': _vm.page === n, 'first': n === _vm.first, 'last': n === _vm.last },on:{"click":function($event){_vm.selectPage(n)}}},[_vm._v(_vm._s(n))])}),0),_vm._v(" "),(_vm.nowList[_vm.nowList.length - 1] !== _vm.last)?_c('div',{staticClass:"last"},[_c('a',{staticClass:"ellipsis"},[_vm._v("...")]),_vm._v(" "),(_vm.showLast)?_c('a',{on:{"click":function($event){_vm.selectPage(_vm.last)}}},[_vm._v(_vm._s(_vm.last))]):_vm._e()]):_vm._e()])}
var pageButtons_staticRenderFns = []
var pageButtons_esExports = { render: pageButtons_render, staticRenderFns: pageButtons_staticRenderFns }
/* harmony default export */ var tool_pageButtons = (pageButtons_esExports);
// CONCATENATED MODULE: ./src/components/tool/pageButtons.vue
function pageButtons_injectStyle (ssrContext) {
  __webpack_require__("0EUV")
}
var pageButtons_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var pageButtons___vue_template_functional__ = false
/* styles */
var pageButtons___vue_styles__ = pageButtons_injectStyle
/* scopeId */
var pageButtons___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var pageButtons___vue_module_identifier__ = null
var pageButtons_Component = pageButtons_normalizeComponent(
  pageButtons,
  tool_pageButtons,
  pageButtons___vue_template_functional__,
  pageButtons___vue_styles__,
  pageButtons___vue_scopeId__,
  pageButtons___vue_module_identifier__
)

/* harmony default export */ var components_tool_pageButtons = (pageButtons_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/mixins/routeLoading.vue








/* harmony default export */ var routeLoading = ({
  mixins: [toastMethods["a" /* default */], loginData["a" /* default */]],
  computed: Object(vuex_esm["c" /* mapGetters */])(['initial']),
  data: function data() {
    return {
      initiated: false
    };
  },
  created: function created() {
    if (this.initial !== null) {
      this.fetch(this.initial);
    }
  },

  watch: {
    '$route': function $route() {
      if (this.initial !== null) {
        this.fetch(this.initial);
      }
    },
    'initial': function initial(value) {
      if (this.initial !== null) {
        this.fetch(this.initial);
      }
    }
  },
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setLoadingAction', 'setDialogLoadingAction']), {
    fetch: function fetch(initial) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var isListEmptyMessages, isListEmptyError, defaultActionAlert, customActions, action, redirect;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this.setLoadingAction(true);

                if (!_this.preSetData) {
                  _context.next = 5;
                  break;
                }

                _context.next = 5;
                return _this.preSetData();

              case 5:
                if (!_this.fetchDataGuest) {
                  _context.next = 8;
                  break;
                }

                _context.next = 8;
                return _this.fetchDataGuest();

              case 8:
                if (!(initial && _this.fetchData)) {
                  _context.next = 11;
                  break;
                }

                _context.next = 11;
                return _this.fetchData();

              case 11:
                if (!_this.afterSetData) {
                  _context.next = 14;
                  break;
                }

                _context.next = 14;
                return _this.afterSetData();

              case 14:
                _this.setLoadingAction(false);
                _this.initiated = true;
                _context.next = 26;
                break;

              case 18:
                _context.prev = 18;
                _context.t0 = _context['catch'](0);
                isListEmptyMessages = [];

                isListEmptyError = function isListEmptyError(data) {
                  return isListEmptyMessages.includes(data.message_code);
                };

                defaultActionAlert = function defaultActionAlert(data) {
                  var msg = data.message || data.errors.join('<br>') || '頁面不存在，或是權限不足';
                  _this.addToast('error', msg);
                };

                customActions = [{
                  status: 401,
                  alert: function alert(data) {
                    _this.setUserData(null);
                    _this.addToast('error', '權限不足');
                  }
                }];
                action = customActions.find(function (x) {
                  return (!x.name || _context.t0.message && x.name === _context.t0.message) && (!x.api || _context.t0.request && new RegExp(x.api).test(_context.t0.request.responseURL)) && (!x.status || _context.t0.response && x.status === _context.t0.response.status) && (!x.path || new RegExp(x.path).test(_this.$route.fullPath));
                });

                if (action) {
                  redirect = action.alert ? action.alert() : defaultActionAlert();

                  _this.setLoadingAction(false);
                  _this.setDialogLoadingAction(false);
                  _this.$router.push(redirect || { name: 'main' });
                } else if (_context.t0.response && !isListEmptyError(_context.t0.response.data)) {
                  defaultActionAlert(_context.t0.response.data);
                  _this.setLoadingAction(false);
                  _this.setDialogLoadingAction(false);
                  setTimeout(function () {
                    return window.location.reload();
                  }, 500);
                } else {
                  _this.setLoadingAction(false);
                  _this.setDialogLoadingAction(false);
                }

              case 26:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 18]]);
      }))();
    }
  })
});
// CONCATENATED MODULE: ./src/mixins/routeLoading.vue
var routeLoading_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var routeLoading___vue_template__ = null
/* template functional */
var routeLoading___vue_template_functional__ = false
/* styles */
var routeLoading___vue_styles__ = null
/* scopeId */
var routeLoading___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var routeLoading___vue_module_identifier__ = null
var routeLoading_Component = routeLoading_normalizeComponent(
  routeLoading,
  routeLoading___vue_template__,
  routeLoading___vue_template_functional__,
  routeLoading___vue_styles__,
  routeLoading___vue_scopeId__,
  routeLoading___vue_module_identifier__
)

/* harmony default export */ var mixins_routeLoading = (routeLoading_Component.exports);

// EXTERNAL MODULE: ./src/constants/global/data.js
var global_data = __webpack_require__("x2hU");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/main/admin.vue





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ var main_admin = ({
  components: {
    adminFilter: src_components_admin_filter,
    pageButtons: components_tool_pageButtons
  },
  mixins: [mixins_routeLoading, toastMethods["a" /* default */]],
  props: {
    minHeight: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      accounts: [],
      init: {},
      filters: {},
      onSearch: false,
      pageData: {
        selectedPage: 1,
        display: 12,
        total: null,
        buttonRange: 7
      },
      sort: {
        value: [],
        order: []
      }
    };
  },

  computed: {
    recodeLink: function recodeLink() {
      var config = this.$ls.get('userInfo');
      return api_config["a" /* API_ROOT */] + '/admin/api_logs?access_token=' + config['access_token'];
    },

    // static
    filterOptions: function filterOptions() {
      return [{
        title: '關鍵字搜尋',
        value: 'query',
        type: 'input',
        placeholder: function placeholder() {
          return '如：帳號、姓名、電子信箱...';
        }
      }];
    },
    tableOptions: function tableOptions() {
      return [{
        title: '帳號',
        value: 'account',
        width: '150px'
      }, {
        title: '姓名',
        value: 'name',
        width: '150px'
      }, {
        title: '電子信箱',
        value: 'email',
        sortMap: function sortMap(data) {
          return data.activated_at;
        }
      }, {
        title: '身份',
        value: 'occupation',
        width: '150px',
        display: function display(value) {
          return value ? global_data["b" /* occupationOptions */].map(function (option) {
            return option.value;
          }).includes(value) ? value : '其他(' + value + ')' : '';
        }
      }, {
        title: '註冊日期',
        value: 'created_at',
        width: '150px',
        display: function display(value) {
          return value ? Object(util["b" /* dateFormat */])(new Date(value), 'yyyy/MM/dd') : '';
        }
      }, {
        title: '管理',
        value: '_OPTIONS',
        width: '240px',
        sort: false
      }];
    },

    // global
    roleOptions: function roleOptions() {
      return global_data["c" /* roleOptions */];
    }
  },
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setLoadingAction', 'setModalAction']), {
    fetchData: function fetchData() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.fetchAccounts();

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    fetchAccounts: function fetchAccounts(filters) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var config, data, response, accounts;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                config = _this2.$ls.get('userInfo');

                filters = filters || _this2.filters || {};
                data = extends_default()({}, entries_default()(filters).filter(function (kv) {
                  return kv[1];
                }).reduce(function (s, kv) {
                  return extends_default()({}, s, defineProperty_default()({}, kv[0], kv[1]));
                }, {}));

                _this2.pageData.selectedPage && (data.page = _this2.pageData.selectedPage);
                _this2.pageData.display && (data.item_per_page = _this2.pageData.display);
                _this2.sort.value[0] && (data.order_by = _this2.sort.value[0]);
                _this2.sort.order[0] && (data.order_method = _this2.sort.order[0].replace(/^-/, ''));
                _context2.next = 10;
                return Object(src_api["f" /* getAccounts */])(data, config);

              case 10:
                response = _context2.sent;
                accounts = response.data.data.elements;

                _this2.pageData.total = response.data.data.items_count;
                _this2.accounts = accounts.map(function (account) {
                  return extends_default()({}, account, {
                    occupation: account.occupation || account.role
                  });
                });
                _context2.next = 19;
                break;

              case 16:
                _context2.prev = 16;
                _context2.t0 = _context2['catch'](0);
                throw _context2.t0;

              case 19:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 16]]);
      }))();
    },
    searchDatas: function searchDatas(init) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.onSearch = true;
                if (init) {
                  _this3.init = init;
                  _this3.filter = init;
                }
                _context3.next = 4;
                return _this3.fetchAccounts(init);

              case 4:
                _this3.onSearch = false;

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    updateAccountRole: function updateAccountRole(account) {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var config, id, role;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                account.onSubmitRole = true;
                _context4.prev = 1;
                config = _this4.$ls.get('userInfo');
                id = account.id;
                role = account.role || 'normal';
                _context4.next = 7;
                return Object(src_api["V" /* putUpdateAccountRole */])(id, role, config);

              case 7:
                _this4.addToast('success', '更新成功');
                account.onSubmitRole = false;
                _context4.next = 15;
                break;

              case 11:
                _context4.prev = 11;
                _context4.t0 = _context4['catch'](1);

                _this4.addToast('error', !_context4.t0.response ? _context4.t0.message : _context4.t0.response.data.message || _context4.t0.response.data.errors.join('<br>'));
                account.onSubmitRole = false;

              case 15:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[1, 11]]);
      }))();
    },
    deleteAccount: function deleteAccount(account) {
      var _this5 = this;

      this.setModalAction({
        action: 'toast',
        customStyles: {
          padding: '0px'
        },
        param: {
          type: 'error',
          content: '<span>此動作不可復原，<br>確認是否刪除帳號: ' + account.account + ' ?</span>',
          buttons: [{
            title: '取消',
            type: 'gray',
            icon: 'fa-repeat',
            result: false
          }, {
            title: '刪除',
            type: 'alert',
            icon: 'fa-trash-o',
            result: true
          }]
        },
        callback: function () {
          var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5(result) {
            var config, id;
            return regenerator_default.a.wrap(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    if (!result) {
                      _context5.next = 16;
                      break;
                    }

                    _this5.setLoadingAction(true);
                    _context5.prev = 2;
                    config = _this5.$ls.get('userInfo');
                    id = account.id;
                    _context5.next = 7;
                    return Object(src_api["a" /* deleteAccount */])(id, config);

                  case 7:
                    _this5.addToast('success', '刪除成功');
                    _this5.accounts.splice(_this5.accounts.indexOf(account), 1);
                    _this5.setLoadingAction(false);
                    _context5.next = 16;
                    break;

                  case 12:
                    _context5.prev = 12;
                    _context5.t0 = _context5['catch'](2);

                    _this5.addToast('error', !_context5.t0.response ? _context5.t0.message : _context5.t0.response.data);
                    _this5.setLoadingAction(false);

                  case 16:
                  case 'end':
                    return _context5.stop();
                }
              }
            }, _callee5, _this5, [[2, 12]]);
          }));

          return function callback(_x) {
            return _ref.apply(this, arguments);
          };
        }()
      });
    },
    tableSortBy: function tableSortBy(value) {
      var position = this.sort.value.indexOf(value);
      if (position === 0) {
        var order = this.sort.order[position] === '-asc' ? '-desc' : '-asc';
        this.sort.order.splice(position, 1);
        this.sort.order.unshift(order);
      } else {
        var _order = position !== -1 ? this.sort.order[position] === '-asc' ? '-desc' : '-asc' : undefined;
        position = position !== -1 ? position : 0;
        this.sort.value.splice(position, 1);
        this.sort.order.splice(position, 1);
        this.sort.value.unshift(value);
        this.sort.order.unshift(_order || '-asc');
      }
      this.searchDatas();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e0c31c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/main/admin.vue
var admin_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-page row-block",style:({ minHeight: _vm.minHeight })},[_c('div',{staticClass:"filter-container",style:({ width: '250px' })},[_c('adminFilter',{attrs:{"minHeight":_vm.minHeight,"disabled":false,"title":'會員帳號搜尋',"filters":{
        init: _vm.init,
        options: _vm.filterOptions
      }},on:{"changeFilters":function (c, search) { _vm.filters = c; search && _vm.searchDatas(c) }}})],1),_vm._v(" "),_c('div',{staticClass:"main-container row-block",style:({ flex: 1, height: _vm.minHeight })},[(_vm.onSearch)?_c('div',{staticClass:"mask center-block",style:({ height: '100%', width: '100%', 'min-width': '1350px' })},[_c('img',{attrs:{"src":__webpack_require__("5xS/"),"alt":""}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"main-block col-block",style:({ height: '100%', width: '100%', 'min-width': '1350px' })},[_c('div',{staticClass:"title-container row-block"},[_c('div',{staticClass:"title"},[_vm._v("會員帳號管理")]),_vm._v(" "),_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('a',{staticClass:"link record",attrs:{"href":_vm.recodeLink,"target":"_blank"}},[_vm._v("平台使用者人數記錄")])]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"table-feild col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-container col-block",style:({ height: '50px' })},[_c('div',{staticClass:"thead default-shadow"},[_c('div',{staticClass:"tr row-block"},_vm._l((_vm.tableOptions),function(option,index){return _c('div',{key:index,staticClass:"th row-block",class:option.class,style:(option.width ? { width: option.width } : { flex: 1 }),on:{"click":function (e) { return option.sort !== false && _vm.tableSortBy(option.value); }}},[_c('span',[_vm._v(_vm._s(option.title))]),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),(option.sort !== false)?_c('i',{class:['fa', 'fa-sort' + (_vm.sort.order[_vm.sort.value.indexOf(option.value)] || '')],attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "),_c('div',{style:({ flex: 1 })})])}),0)])]),_vm._v(" "),_c('div',{staticClass:"table-container col-block sub-shadow",style:({ flex: 1 })},[_c('div',{staticClass:"tbody",style:({ flex: 1 })},[_c('div',{style:({ height: 0 })},_vm._l((_vm.accounts),function(account,cindex){return _c('div',{key:cindex,staticClass:"tr row-block"},[_c('div',{staticClass:"container-block row-block"},_vm._l((_vm.tableOptions),function(option,index){return _c('div',{key:index,staticClass:"td row-block",class:option.class,style:(option.width ? { width: option.width } : { flex: 1 })},[(option.value === 'email')?_c('div',{staticClass:"row-block",style:({ width: '100%' })},[(account.activated_at)?_c('img',{attrs:{"src":__webpack_require__("SPQO")}}):_vm._e(),_vm._v(" "),_c('div',{style:({ width: '10px' })}),_vm._v(" "),_c('span',{style:((option.style || (function () {}))(account[option.value])),attrs:{"title":(option.display || (function (x) { return x; }))(account[option.value], cindex)}},[_vm._v(_vm._s((option.display || (function (x) { return x; }))(account[option.value], cindex) || '--'))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]):(option.value === '_OPTIONS')?_c('div',[(account.role !== 'admin')?_c('div',{staticClass:"option row-block"},[_c('div',{staticClass:"row-block",style:({ flex: 1 })},[_c('select',{domProps:{"value":account.role},on:{"change":function (e) { return account.role = e.target.value; }}},_vm._l((_vm.roleOptions),function(option,index){return _c('option',{key:index,domProps:{"value":option.value}},[_vm._v(_vm._s(option.title))])}),0),_vm._v(" "),_c('div',{style:({ width: '10px' })}),_vm._v(" "),_c('button',{staticClass:"main-button option-button update",class:{ loading: account.onSubmitRole },attrs:{"type":"button","name":"button"},on:{"click":function (e) { return _vm.updateAccountRole(account); }}},[_c('span',[_vm._v("更新")])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('div',{staticClass:"row-block"},[_c('button',{staticClass:"main-button delete",attrs:{"type":"button","name":"button"},on:{"click":function (e) { return _vm.deleteAccount(account); }}},[_c('i',{staticClass:"fa fa-trash-o",attrs:{"aria-hidden":"true"}})])])]):_vm._e()]):_c('span',{style:((option.style || (function () {}))(account[option.value])),attrs:{"title":(option.display || (function (x) { return x; }))(account[option.value], cindex)}},[_vm._v(_vm._s((option.display || (function (x) { return x; }))(account[option.value], cindex) || '--'))])])}),0)])}),0)])]),_vm._v(" "),_c('div',{staticClass:"page-container center-block"},[(_vm.pageData.total)?_c('pageButtons',{attrs:{"default":_vm.pageData.selectedPage,"display":_vm.pageData.display,"total":_vm.pageData.total,"buttonRange":_vm.pageData.buttonRange},on:{"selectPage":function (page) { _vm.pageData.selectedPage = page; _vm.searchDatas() }}}):_vm._e()],1)])])])])}
var admin_staticRenderFns = []
var admin_esExports = { render: admin_render, staticRenderFns: admin_staticRenderFns }
/* harmony default export */ var pages_main_admin = (admin_esExports);
// CONCATENATED MODULE: ./src/pages/main/admin.vue
var admin_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var admin___vue_template_functional__ = false
/* styles */
var admin___vue_styles__ = null
/* scopeId */
var admin___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var admin___vue_module_identifier__ = null
var admin_Component = admin_normalizeComponent(
  main_admin,
  pages_main_admin,
  admin___vue_template_functional__,
  admin___vue_styles__,
  admin___vue_scopeId__,
  admin___vue_module_identifier__
)

/* harmony default export */ var src_pages_main_admin = (admin_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("Gu7T");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/slicedToArray.js
var slicedToArray = __webpack_require__("d7EF");
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/main/adminProductPrice.vue







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var adminProductPrice = ({
  components: {
    adminFilter: src_components_admin_filter,
    pageButtons: components_tool_pageButtons
  },
  mixins: [mixins_routeLoading, toastMethods["a" /* default */]],
  props: {
    minHeight: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      productPrices: [],
      cropNames: [],
      init: {},
      filters: {},
      onSearch: false,
      pageData: {
        selectedPage: 1,
        display: 12,
        total: null,
        buttonRange: 7
      },
      sort: {
        value: [],
        order: []
      }
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['countrys']), {
    kindOptions: function kindOptions() {
      return [{ title: '蔬菜', value: 'vegetable' }, { title: '水果', value: 'fruit' }];
    },
    statusOptions: function statusOptions() {
      return [{ title: '通過', value: 'passed' }, { title: '不通過', value: 'failed' }, { title: '待審', value: 'not_reviewed' }];
    },
    packingMethodOptions: function packingMethodOptions() {
      return [{ title: '散裝', value: 'bulk', style: { color: '#EF6577' } }, { title: '有包裝', value: 'packed', style: { color: '#3967A6' } }, { title: '截切', value: 'cut', style: { color: '#3967A6' } }];
    },
    marketKindOptions: function marketKindOptions() {
      return [{ title: '傳統市場', value: 'traditional_market' }, { title: '批發市場', value: 'wholesale_market' }, { title: '超市', value: 'supermarket' }, { title: '量販店', value: 'hyper_market' }, { title: '便利商店', value: 'convenience_store' }, { title: '蔬果專賣店', value: 'vegetable_and_fruit_store' }, { title: '農夫(假日)市集', value: 'farmers_market' }];
    },
    countryOptions: function countryOptions() {
      return this.countrys.map(function (_ref) {
        var _ref2 = slicedToArray_default()(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        return {
          title: value.chinese_name + '(' + value.iso_name + ')',
          value: key,
          country: value
        };
      });
    },
    cropNameOptions: function cropNameOptions() {
      return this.cropNames.map(function (data) {
        return { title: data.name, value: data.name, kind: data.kind };
      });
    },

    // static
    filterOptions: function filterOptions() {
      var _this = this;

      return [{
        title: '產品類別',
        value: 'kind',
        type: 'select',
        options: this.kindOptions,
        placeholder: function placeholder() {
          return '蔬菜 / 水果';
        },
        onChange: function onChange(value, conditions) {
          _this.init = extends_default()({}, _this.init, conditions, {
            crop_name: ''
          });
        }
      }, {
        title: '作物(產品)',
        value: 'crop_name',
        type: 'datalist',
        lists: function lists(value, conditions) {
          return _this.cropNameOptions.filter(function (option) {
            return conditions.kind === option.kind && option.title.startsWith(value) && option.title !== value;
          }).filter(function (_, index) {
            return value || index < 99999;
          }).map(function (option) {
            return option.title;
          });
        },
        options: this.cropNameOptions,
        placeholder: function placeholder() {
          return '請輸入產品關鍵字';
        },
        onChange: function onChange(value) {
          if (value && !_this.cropNameOptions.some(function (option) {
            return option.title === value;
          })) {
            _this.init = extends_default()({}, _this.init, _this.filters, {
              crop_name: ''
            });
          }
        }
      }, {
        title: '市場所在國家',
        value: 'market_country',
        type: 'datalist',
        lists: function lists(value) {
          return _this.countryOptions.map(function (option) {
            return option.title;
          });
        },
        placeholder: function placeholder() {
          return '請選擇國家';
        },
        onChange: function onChange(value) {
          if (value && !_this.countryOptions.some(function (option) {
            return option.title === value;
          })) {
            _this.init = extends_default()({}, _this.init, _this.filters, {
              market_country: ''
            });
          }
        }
      }, {
        title: '產地 (國家)',
        value: 'country',
        type: 'datalist',
        lists: function lists(value) {
          return [{ title: '無', country: { iso_name: '', chinese_name: '' } }].concat(toConsumableArray_default()(_this.countryOptions)).map(function (option) {
            return option.title;
          });
        },
        placeholder: function placeholder() {
          return '請選擇國家';
        },
        onChange: function onChange(value) {
          if (value && value !== '無' && !_this.countryOptions.some(function (option) {
            return option.title === value;
          })) {
            _this.init = extends_default()({}, _this.init, _this.filters, {
              country: ''
            });
          }
        }
      }, {
        title: '資料狀態',
        value: 'review_status',
        type: 'select',
        options: this.statusOptions,
        placeholder: function placeholder() {
          return '請選擇資料狀態';
        }
      }];
    },
    tableOptions: function tableOptions() {
      var _this2 = this;

      return [{
        title: '',
        value: '_CHECK',
        width: '30px',
        class: ['center-block'],
        sort: false
      }, {
        title: '上傳者',
        value: 'uploader',
        width: '120px'
      }, {
        title: '拍攝日期',
        value: 'date',
        width: '120px',
        display: function display(value) {
          return value ? Object(util["b" /* dateFormat */])(new Date(value), 'yyyy/MM/dd') : '';
        }
      }, {
        title: '產品類別',
        value: 'kind',
        width: '100px',
        display: function display(value) {
          return (_this2.kindOptions.find(function (option) {
            return option.value === value;
          }) || {}).title;
        }
      }, {
        title: '作物(產品)',
        value: 'crop_name',
        width: '130px'
      }, {
        title: '產地(國家)',
        value: 'country',
        width: '150px',
        display: function display(value) {
          return (_this2.countryOptions.find(function (option) {
            return option.value === value;
          }) || {}).title || '無';
        }
      }, {
        title: '包裝方式',
        value: 'packing_method',
        width: '100px',
        display: function display(value) {
          return (_this2.packingMethodOptions.find(function (option) {
            return option.value === value;
          }) || {}).title;
        }
      }, {
        title: '價格',
        value: 'price',
        width: '80px'
      }, {
        title: '貨幣單位',
        value: 'currency_name',
        width: '100px'
      }, {
        title: '市場所在國家',
        value: 'market_country',
        width: '150px',
        display: function display(value) {
          return (_this2.countryOptions.find(function (option) {
            return option.value === value;
          }) || {}).title;
        }
      }, {
        title: '市場類型',
        value: 'market_kind',
        width: '100px',
        display: function display(value) {
          return (_this2.marketKindOptions.find(function (option) {
            return option.value === value;
          }) || {}).title;
        }
      }, {
        title: '管理',
        value: '_OPTIONS',
        class: ['center-block'],
        sort: false
      }];
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setLoadingAction', 'setModalAction']), {
    fetchData: function fetchData() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this3.fetchAdminCrops();

              case 2:
                _context.next = 4;
                return _this3.fetchAdminProductPrices();

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    fetchAdminCrops: function fetchAdminCrops() {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var config, response, cropNames;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                config = _this4.$ls.get('userInfo');
                _context2.next = 4;
                return Object(src_api["h" /* getAdminCrops */])('', config);

              case 4:
                response = _context2.sent;
                cropNames = response.data.data;

                _this4.cropNames = cropNames;
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](0);
                throw _context2.t0;

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4, [[0, 9]]);
      }))();
    },
    fetchAdminProductPrices: function fetchAdminProductPrices(filters) {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var config, data, response, productPrices;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                config = _this5.$ls.get('userInfo');

                filters = filters || _this5.filters || {};
                data = extends_default()({}, entries_default()(filters).filter(function (kv) {
                  return kv[1];
                }).reduce(function (s, kv) {
                  return extends_default()({}, s, defineProperty_default()({}, kv[0], kv[1]));
                }, {}), {
                  country: filters.country === '無' ? '' : (_this5.countryOptions.find(function (option) {
                    return option.title === filters.country;
                  }) || {}).value || null,
                  market_country: (_this5.countryOptions.find(function (option) {
                    return option.title === filters.market_country;
                  }) || {}).value || null
                });

                _this5.pageData.selectedPage && (data.page = _this5.pageData.selectedPage);
                _this5.pageData.display && (data.item_per_page = _this5.pageData.display);
                _this5.sort.value[0] && (data.order_by = _this5.sort.value[0]);
                _this5.sort.order[0] && (data.order_method = _this5.sort.order[0].replace(/^-/, ''));
                _context3.next = 10;
                return Object(src_api["j" /* getAdminProductPrices */])(data, config);

              case 10:
                response = _context3.sent;
                productPrices = response.data.data.elements;

                _this5.pageData.total = response.data.data.items_count;
                _this5.productPrices = productPrices;
                _context3.next = 19;
                break;

              case 16:
                _context3.prev = 16;
                _context3.t0 = _context3['catch'](0);
                throw _context3.t0;

              case 19:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5, [[0, 16]]);
      }))();
    },
    searchDatas: function searchDatas(init) {
      var _this6 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this6.onSearch = true;
                if (init) {
                  _this6.init = init;
                  _this6.filter = init;
                }
                _context4.next = 4;
                return _this6.fetchAdminProductPrices(init);

              case 4:
                _this6.onSearch = false;

              case 5:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this6);
      }))();
    },
    detailProductPrice: function detailProductPrice(productPrice) {
      var _this7 = this;

      this.setModalAction({
        action: 'editProductPrice',
        width: '900px',
        customStyles: {
          padding: '0px',
          margin: '20px auto',
          borderRadius: '0'
        },
        param: {
          title: productPrice.review_status === 'passed' ? '零售價格資料編輯' : '零售價格資料查核',
          data: productPrice,
          admin: true,
          image: true,
          review: productPrice.review_status !== 'passed',
          editable: true
        },
        callback: function () {
          var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5(result) {
            return regenerator_default.a.wrap(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    if (!result) {
                      _context5.next = 5;
                      break;
                    }

                    _context5.next = 3;
                    return _this7.fetchAdminCrops();

                  case 3:
                    _context5.next = 5;
                    return _this7.searchDatas();

                  case 5:
                  case 'end':
                    return _context5.stop();
                }
              }
            }, _callee5, _this7);
          }));

          return function callback(_x) {
            return _ref3.apply(this, arguments);
          };
        }()
      });
    },
    deleteAdminProductPrice: function deleteAdminProductPrice(productPrice) {
      var _this8 = this;

      this.setModalAction({
        action: 'toast',
        customStyles: {
          padding: '0px'
        },
        param: {
          type: 'error',
          content: '<span>此動作不可復原，<br>確認是否刪除該數據 ?</span>',
          buttons: [{
            title: '取消',
            type: 'gray',
            icon: 'fa-repeat',
            result: false
          }, {
            title: '刪除',
            type: 'alert',
            icon: 'fa-trash-o',
            result: true
          }]
        },
        callback: function () {
          var _ref4 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6(result) {
            var config, id;
            return regenerator_default.a.wrap(function _callee6$(_context6) {
              while (1) {
                switch (_context6.prev = _context6.next) {
                  case 0:
                    if (!result) {
                      _context6.next = 20;
                      break;
                    }

                    _this8.setLoadingAction(true);
                    _context6.prev = 2;
                    config = _this8.$ls.get('userInfo');
                    id = productPrice.id;
                    _context6.next = 7;
                    return Object(src_api["b" /* deleteAdminProductPrice */])(id, config);

                  case 7:
                    _this8.addToast('success', '刪除成功');
                    _this8.productPrices.splice(_this8.productPrices.indexOf(productPrice), 1);
                    _context6.next = 11;
                    return _this8.fetchAdminCrops();

                  case 11:
                    _context6.next = 13;
                    return _this8.searchDatas();

                  case 13:
                    _this8.setLoadingAction(false);
                    _context6.next = 20;
                    break;

                  case 16:
                    _context6.prev = 16;
                    _context6.t0 = _context6['catch'](2);

                    _this8.addToast('error', !_context6.t0.response ? _context6.t0.message : _context6.t0.response.data);
                    _this8.setLoadingAction(false);

                  case 20:
                  case 'end':
                    return _context6.stop();
                }
              }
            }, _callee6, _this8, [[2, 16]]);
          }));

          return function callback(_x2) {
            return _ref4.apply(this, arguments);
          };
        }()
      });
    },
    batchUpload: function batchUpload() {
      var _this9 = this;

      this.setModalAction({
        action: 'batchUpload',
        width: '600px',
        customStyles: {
          padding: '0px',
          margin: '20px auto',
          borderRadius: '0'
        },
        callback: function () {
          var _ref5 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7(result) {
            return regenerator_default.a.wrap(function _callee7$(_context7) {
              while (1) {
                switch (_context7.prev = _context7.next) {
                  case 0:
                    if (!result) {
                      _context7.next = 5;
                      break;
                    }

                    _context7.next = 3;
                    return _this9.fetchAdminCrops();

                  case 3:
                    _context7.next = 5;
                    return _this9.searchDatas();

                  case 5:
                  case 'end':
                    return _context7.stop();
                }
              }
            }, _callee7, _this9);
          }));

          return function callback(_x3) {
            return _ref5.apply(this, arguments);
          };
        }()
      });
    },
    tableSortBy: function tableSortBy(value) {
      var position = this.sort.value.indexOf(value);
      if (position === 0) {
        var order = this.sort.order[position] === '-asc' ? '-desc' : '-asc';
        this.sort.order.splice(position, 1);
        this.sort.order.unshift(order);
      } else {
        var _order = position !== -1 ? this.sort.order[position] === '-asc' ? '-desc' : '-asc' : undefined;
        position = position !== -1 ? position : 0;
        this.sort.value.splice(position, 1);
        this.sort.order.splice(position, 1);
        this.sort.value.unshift(value);
        this.sort.order.unshift(_order || '-asc');
      }
      this.searchDatas();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ca1cede","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/main/adminProductPrice.vue
var adminProductPrice_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-product-price-page row-block",style:({ minHeight: _vm.minHeight })},[_c('div',{staticClass:"filter-container",style:({ width: '250px' })},[_c('adminFilter',{attrs:{"minHeight":_vm.minHeight,"disabled":false,"title":'零售價格資料搜尋',"filters":{
        init: _vm.init,
        options: _vm.filterOptions
      }},on:{"changeFilters":function (c, search) { _vm.filters = c; search && _vm.searchDatas(c) }}})],1),_vm._v(" "),_c('div',{staticClass:"main-container row-block",style:({ flex: 1, height: _vm.minHeight })},[(_vm.onSearch)?_c('div',{staticClass:"mask center-block",style:({ height: '100%', width: '100%', 'min-width': '1350px' })},[_c('img',{attrs:{"src":__webpack_require__("5xS/"),"alt":""}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"main-block col-block",style:({ height: '100%', width: '100%', 'min-width': '1350px' })},[_c('div',{staticClass:"title-container row-block"},[_c('div',{staticClass:"title"},[_vm._v("零售價格資料管理")]),_vm._v(" "),_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"main-button option-button update",attrs:{"type":"button","name":"button"},on:{"click":function (e) { return _vm.batchUpload(); }}},[_c('span',[_vm._v("批次上傳")])])]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"table-feild col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-container col-block",style:({ height: '50px' })},[_c('div',{staticClass:"thead default-shadow"},[_c('div',{staticClass:"tr row-block"},_vm._l((_vm.tableOptions),function(option,index){return _c('div',{key:index,staticClass:"th row-block",class:option.class,style:(option.width ? { width: option.width } : { flex: 1 }),on:{"click":function (e) { return option.sort !== false && _vm.tableSortBy(option.value); }}},[_c('span',[_vm._v(_vm._s(option.title))]),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),(option.sort !== false)?_c('i',{class:['fa', 'fa-sort' + (_vm.sort.order[_vm.sort.value.indexOf(option.value)] || '')],attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "),_c('div',{style:({ flex: 1 })})])}),0)])]),_vm._v(" "),_c('div',{staticClass:"table-container col-block sub-shadow",style:({ flex: 1 })},[_c('div',{staticClass:"tbody",style:({ flex: 1 })},[_c('div',{style:({ height: 0 })},_vm._l((_vm.productPrices),function(productPrice,cindex){return _c('div',{key:cindex,staticClass:"tr row-block"},[_c('div',{staticClass:"container-block row-block"},_vm._l((_vm.tableOptions),function(option,index){return _c('div',{key:index,staticClass:"td",class:option.class || ['row-block'],style:(option.width ? { width: option.width } : { flex: 1 })},[(option.value === '_CHECK')?_c('div',[_c('div',{staticClass:"check center-block"},[(productPrice.review_status === 'passed')?_c('img',{attrs:{"src":__webpack_require__("rlvA"),"alt":""}}):(productPrice.review_status === 'failed')?_c('img',{attrs:{"src":__webpack_require__("XTQ4"),"alt":""}}):(productPrice.review_status === 'not_reviewed')?_c('div'):_vm._e()])]):(option.value === '_OPTIONS')?_c('div',{style:({ width: '100%' })},[_c('div',{staticClass:"option row-block"},[_c('div',{staticClass:"row-block"},[_c('button',{staticClass:"main-button option-button update",attrs:{"type":"button","name":"button"},on:{"click":function (e) { return _vm.detailProductPrice(productPrice); }}},[_c('span',[_vm._v(_vm._s(productPrice.review_status === 'passed' ? '編輯' : '查核'))])])]),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),(['passed', 'failed'].includes(productPrice.review_status))?_c('div',{staticClass:"row-block"},[_c('button',{staticClass:"main-button delete",attrs:{"type":"button","name":"button"},on:{"click":function (e) { return _vm.deleteAdminProductPrice(productPrice); }}},[_c('i',{staticClass:"fa fa-trash-o",attrs:{"aria-hidden":"true"}})])]):_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]):_c('span',{style:((option.style || (function () {}))(productPrice[option.value])),attrs:{"title":(option.display || (function (x) { return x; }))(productPrice[option.value], cindex)}},[_vm._v(_vm._s((option.display || (function (x) { return x; }))(productPrice[option.value], cindex) || '--'))])])}),0)])}),0)])]),_vm._v(" "),_c('div',{staticClass:"page-container center-block"},[(_vm.pageData.total)?_c('pageButtons',{attrs:{"default":_vm.pageData.selectedPage,"display":_vm.pageData.display,"total":_vm.pageData.total,"buttonRange":_vm.pageData.buttonRange},on:{"selectPage":function (page) { _vm.pageData.selectedPage = page; _vm.searchDatas() }}}):_vm._e()],1)])])])])}
var adminProductPrice_staticRenderFns = []
var adminProductPrice_esExports = { render: adminProductPrice_render, staticRenderFns: adminProductPrice_staticRenderFns }
/* harmony default export */ var main_adminProductPrice = (adminProductPrice_esExports);
// CONCATENATED MODULE: ./src/pages/main/adminProductPrice.vue
var adminProductPrice_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var adminProductPrice___vue_template_functional__ = false
/* styles */
var adminProductPrice___vue_styles__ = null
/* scopeId */
var adminProductPrice___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var adminProductPrice___vue_module_identifier__ = null
var adminProductPrice_Component = adminProductPrice_normalizeComponent(
  adminProductPrice,
  main_adminProductPrice,
  adminProductPrice___vue_template_functional__,
  adminProductPrice___vue_styles__,
  adminProductPrice___vue_scopeId__,
  adminProductPrice___vue_module_identifier__
)

/* harmony default export */ var pages_main_adminProductPrice = (adminProductPrice_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/main/adminReport.vue








//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var adminReport = ({
  components: {
    adminFilter: src_components_admin_filter,
    pageButtons: components_tool_pageButtons
  },
  mixins: [mixins_routeLoading, toastMethods["a" /* default */]],
  props: {
    minHeight: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      reports: [],
      productByCategorys: [],
      init: {},
      filters: {},
      onSearch: false,
      pageData: {
        selectedPage: 1,
        display: 12,
        total: null,
        buttonRange: 7
      },
      sort: {
        value: ['publish_time'],
        order: ['-desc']
      }
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['countrys']), {
    categoryOptions: function categoryOptions() {
      return [].concat(toConsumableArray_default()(keys_default()(this.productByCategorys).map(function (category) {
        return { title: category, value: category };
      })), [{ title: '其他', value: '其他' }]);
    },
    productOptions: function productOptions() {
      return [].concat(toConsumableArray_default()(Array.prototype.concat.apply([], entries_default()(this.productByCategorys).map(function (_ref) {
        var _ref2 = slicedToArray_default()(_ref, 2),
            category = _ref2[0],
            products = _ref2[1];

        return entries_default()(products).map(function (_ref3) {
          var _ref4 = slicedToArray_default()(_ref3, 2),
              code = _ref4[0],
              product = _ref4[1];

          return { title: product.chinese_name, value: code, type: product.product_type, category: category };
        });
      }))), [{ title: '其他', value: '其他', type: '其他', category: '其他' }]);
    },
    moduleOptions: function moduleOptions() {
      return [{ title: '市場吸引力', value: 'market_attractiveness' }, { title: '市場競爭力', value: 'market_competitiveness' }, { title: '零售價格分析', value: 'product_prices' }, { title: '其他', value: 'others' }];
    },
    yearOptions: function yearOptions() {
      var year = new Date().getFullYear();
      return [{ title: '無', value: '無' }].concat(toConsumableArray_default()(new Array(year - 2000).fill('').map(function (_, i) {
        return { title: year - i + '', value: year - i + '' };
      })));
    },
    countryOptions: function countryOptions() {
      return this.countrys.map(function (_ref5) {
        var _ref6 = slicedToArray_default()(_ref5, 2),
            key = _ref6[0],
            value = _ref6[1];

        return {
          title: value.chinese_name + '(' + value.iso_name + ')',
          value: key,
          country: value
        };
      });
    },

    // static
    filterOptions: function filterOptions() {
      var _this = this;

      return [{
        title: '標題關鍵字',
        value: 'title',
        type: 'input',
        placeholder: function placeholder() {
          return '如：產業報告...等';
        }
      }, {
        title: '產品類別',
        value: 'category',
        type: 'select',
        options: this.categoryOptions,
        placeholder: function placeholder() {
          return '水果、蔬菜、農業機械...等';
        },
        onChange: function onChange(value, conditions) {
          setTimeout(function () {
            _this.init = extends_default()({}, _this.init, conditions, {
              product_code: ''
            });
          });
        }
      }, {
        title: '產品名稱',
        value: 'product_code',
        type: 'select',
        options: this.productOptions,
        optionDisplay: function optionDisplay(result) {
          return function (option) {
            return option.category === result.category;
          };
        },
        placeholder: function placeholder() {
          return '請選擇產品';
        }
      }, {
        title: '國家',
        value: 'countries',
        type: 'datalist',
        lists: function lists(value) {
          return _this.countryOptions.map(function (option) {
            return option.title;
          });
        },
        placeholder: function placeholder() {
          return '請選擇國家';
        },
        onChange: function onChange(value) {
          if (value && !_this.countryOptions.some(function (option) {
            return option.title === value;
          })) {
            _this.init = extends_default()({}, _this.init, _this.filters, {
              countries: ''
            });
          }
        }
      }, {
        title: '分析模組',
        value: 'module',
        type: 'select',
        options: this.moduleOptions,
        placeholder: function placeholder() {
          return '請選擇分析模組';
        }
      }, {
        title: '年份',
        value: 'year',
        type: 'select',
        options: this.yearOptions,
        placeholder: function placeholder() {
          return '請選擇年份';
        }
      }];
    },
    tableOptions: function tableOptions() {
      var _this2 = this;

      return [{
        title: '發表時間',
        value: 'publish_time',
        width: '150px',
        display: function display(value) {
          return value ? Object(util["b" /* dateFormat */])(new Date(value), 'yyyy/MM/dd hh:mm') : '';
        }
      }, {
        title: '報告標題',
        value: 'title',
        width: '350px'
      }, {
        title: '產品名稱',
        value: 'product_name',
        width: '230px',
        display: function display(value) {
          return value || '其他';
        }
      }, {
        title: '國家',
        value: 'countries',
        width: '200px',
        display: function display(value) {
          return _this2.countryOptions.filter(function (option) {
            return value.includes(option.value);
          }).map(function (option) {
            return option.country.chinese_name;
          }).join(', ');
        }
      }, {
        title: '分析模組',
        value: 'module',
        width: '150px',
        display: function display(value) {
          return (_this2.moduleOptions.find(function (option) {
            return option.value === value;
          }) || {}).title;
        }
      }, {
        title: '年份',
        value: 'year',
        width: '100px',
        display: function display(value) {
          return value || '無';
        }
      }, {
        title: '管理',
        value: '_OPTIONS',
        class: ['center-block'],
        sort: false
      }];
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setLoadingAction', 'setModalAction']), {
    fetchData: function fetchData() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this3.fetchProductByCategorys();

              case 2:
                _context.next = 4;
                return _this3.fetchAdminReports();

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    fetchProductByCategorys: function fetchProductByCategorys() {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var config, response, productByCategorys;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                config = _this4.$ls.get('userInfo');
                _context2.next = 4;
                return Object(src_api["r" /* getProductByCategorys */])(config);

              case 4:
                response = _context2.sent;
                productByCategorys = response.data;

                _this4.productByCategorys = productByCategorys;
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](0);
                throw _context2.t0;

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4, [[0, 9]]);
      }))();
    },
    fetchAdminReports: function fetchAdminReports(filters) {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var config, data, response, reports;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                config = _this5.$ls.get('userInfo');

                filters = filters || _this5.filters || {};
                data = extends_default()({}, entries_default()(filters).filter(function (kv) {
                  return kv[1];
                }).reduce(function (s, kv) {
                  return extends_default()({}, s, defineProperty_default()({}, kv[0], kv[1]));
                }, {}), {
                  year: filters.year === '無' ? '' : filters.year || null,
                  product_code: filters.product_code === '其他' ? '' : filters.product_code || null,
                  countries: (_this5.countryOptions.find(function (option) {
                    return option.title === filters.countries;
                  }) || {}).value || null
                });

                _this5.pageData.selectedPage && (data.page = _this5.pageData.selectedPage);
                _this5.pageData.display && (data.item_per_page = _this5.pageData.display);
                _this5.sort.value[0] && (data.order_by = _this5.sort.value[0]);
                _this5.sort.order[0] && (data.order_method = _this5.sort.order[0].replace(/^-/, ''));
                _context3.next = 10;
                return Object(src_api["l" /* getAdminReports */])(data, config);

              case 10:
                response = _context3.sent;
                reports = response.data.data.elements;

                _this5.pageData.total = response.data.data.items_count;
                _this5.reports = reports;
                _context3.next = 19;
                break;

              case 16:
                _context3.prev = 16;
                _context3.t0 = _context3['catch'](0);
                throw _context3.t0;

              case 19:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5, [[0, 16]]);
      }))();
    },
    searchDatas: function searchDatas(init) {
      var _this6 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this6.onSearch = true;
                if (init) {
                  _this6.init = init;
                  _this6.filter = init;
                }
                _context4.next = 4;
                return _this6.fetchAdminReports(init);

              case 4:
                _this6.onSearch = false;

              case 5:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this6);
      }))();
    },
    editReport: function editReport(report) {
      var _this7 = this;

      this.setModalAction({
        action: 'editReport',
        width: '900px',
        customStyles: {
          padding: '0px',
          margin: '20px auto',
          borderRadius: '0'
        },
        param: {
          title: report ? '編輯分析報告' : '新增分析報告',
          data: report,
          editable: true
        },
        callback: function () {
          var _ref7 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5(result) {
            return regenerator_default.a.wrap(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    if (result) {
                      _this7.searchDatas();
                    }

                  case 1:
                  case 'end':
                    return _context5.stop();
                }
              }
            }, _callee5, _this7);
          }));

          return function callback(_x) {
            return _ref7.apply(this, arguments);
          };
        }()
      });
    },
    deleteAdminReport: function deleteAdminReport(report) {
      var _this8 = this;

      this.setModalAction({
        action: 'toast',
        customStyles: {
          padding: '0px'
        },
        param: {
          type: 'error',
          content: '<span>此動作不可復原，<br>確認是否刪除文章: ' + report.title + ' ?</span>',
          buttons: [{
            title: '取消',
            type: 'gray',
            icon: 'fa-repeat',
            result: false
          }, {
            title: '刪除',
            type: 'alert',
            icon: 'fa-trash-o',
            result: true
          }]
        },
        callback: function () {
          var _ref8 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6(result) {
            var config, id;
            return regenerator_default.a.wrap(function _callee6$(_context6) {
              while (1) {
                switch (_context6.prev = _context6.next) {
                  case 0:
                    if (!result) {
                      _context6.next = 16;
                      break;
                    }

                    _this8.setLoadingAction(true);
                    _context6.prev = 2;
                    config = _this8.$ls.get('userInfo');
                    id = report.id;
                    _context6.next = 7;
                    return Object(src_api["c" /* deleteAdminReport */])(id, config);

                  case 7:
                    _this8.addToast('success', '刪除成功');
                    _this8.reports.splice(_this8.reports.indexOf(report), 1);
                    _this8.setLoadingAction(false);
                    _context6.next = 16;
                    break;

                  case 12:
                    _context6.prev = 12;
                    _context6.t0 = _context6['catch'](2);

                    _this8.addToast('error', !_context6.t0.response ? _context6.t0.message : _context6.t0.response.data);
                    _this8.setLoadingAction(false);

                  case 16:
                  case 'end':
                    return _context6.stop();
                }
              }
            }, _callee6, _this8, [[2, 12]]);
          }));

          return function callback(_x2) {
            return _ref8.apply(this, arguments);
          };
        }()
      });
    },
    tableSortBy: function tableSortBy(value) {
      var position = this.sort.value.indexOf(value);
      if (position === 0) {
        var order = this.sort.order[position] === '-asc' ? '-desc' : '-asc';
        this.sort.order.splice(position, 1);
        this.sort.order.unshift(order);
      } else {
        var _order = position !== -1 ? this.sort.order[position] === '-asc' ? '-desc' : '-asc' : undefined;
        position = position !== -1 ? position : 0;
        this.sort.value.splice(position, 1);
        this.sort.order.splice(position, 1);
        this.sort.value.unshift(value);
        this.sort.order.unshift(_order || '-asc');
      }
      this.searchDatas();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1acefd31","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/main/adminReport.vue
var adminReport_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-report-page row-block",style:({ minHeight: _vm.minHeight })},[_c('div',{staticClass:"filter-container",style:({ width: '250px' })},[_c('adminFilter',{attrs:{"minHeight":_vm.minHeight,"disabled":false,"title":'分析報告搜尋',"filters":{
        init: _vm.init,
        options: _vm.filterOptions
      }},on:{"changeFilters":function (c, search) { _vm.filters = c; search && _vm.searchDatas(c) }}})],1),_vm._v(" "),_c('div',{staticClass:"main-container row-block",style:({ flex: 1, height: _vm.minHeight })},[(_vm.onSearch)?_c('div',{staticClass:"mask center-block",style:({ height: '100%', width: '100%', 'min-width': '1350px' })},[_c('img',{attrs:{"src":__webpack_require__("5xS/"),"alt":""}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"main-block col-block",style:({ height: '100%', width: '100%', 'min-width': '1350px' })},[_c('div',{staticClass:"title-container row-block"},[_c('div',{staticClass:"title"},[_vm._v("分析報告管理")]),_vm._v(" "),_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"main-button option-button update",attrs:{"type":"button","name":"button"},on:{"click":function (e) { return _vm.editReport(); }}},[_c('span',[_vm._v("新增報告")])])]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"table-feild col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-container col-block",style:({ height: '50px' })},[_c('div',{staticClass:"thead default-shadow"},[_c('div',{staticClass:"tr row-block"},_vm._l((_vm.tableOptions),function(option,index){return _c('div',{key:index,staticClass:"th row-block",class:option.class,style:(option.width ? { width: option.width } : { flex: 1 }),on:{"click":function (e) { return option.sort !== false && _vm.tableSortBy(option.value); }}},[_c('span',[_vm._v(_vm._s(option.title))]),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),(option.sort !== false)?_c('i',{class:['fa', 'fa-sort' + (_vm.sort.order[_vm.sort.value.indexOf(option.value)] || '')],attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "),_c('div',{style:({ flex: 1 })})])}),0)])]),_vm._v(" "),_c('div',{staticClass:"table-container col-block sub-shadow",style:({ flex: 1 })},[_c('div',{staticClass:"tbody",style:({ flex: 1 })},[_c('div',{style:({ height: 0 })},_vm._l((_vm.reports),function(report,cindex){return _c('div',{key:cindex,staticClass:"tr row-block"},[_c('div',{staticClass:"container-block row-block"},_vm._l((_vm.tableOptions),function(option,index){return _c('div',{key:index,staticClass:"td row-block",class:option.class,style:(option.width ? { width: option.width } : { flex: 1 })},[(option.value === '_OPTIONS')?_c('div',[_c('div',{staticClass:"option row-block"},[_c('div',{staticClass:"row-block",style:({ flex: 1 })},[_c('button',{staticClass:"main-button option-button update",attrs:{"type":"button","name":"button"},on:{"click":function (e) { return _vm.editReport(report); }}},[_c('span',[_vm._v("編輯")])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('div',{staticClass:"row-block"},[_c('button',{staticClass:"main-button delete",attrs:{"type":"button","name":"button"},on:{"click":function (e) { return _vm.deleteAdminReport(report); }}},[_c('i',{staticClass:"fa fa-trash-o",attrs:{"aria-hidden":"true"}})])])])]):(option.value === 'title')?_c('div',{style:({ width: '100%' })},[_c('div',{staticClass:"title row-block"},[_c('span',{style:((option.style || (function () {}))(report[option.value])),attrs:{"title":(option.display || (function (x) { return x; }))(report[option.value], cindex)}},[_vm._v(_vm._s((option.display || (function (x) { return x; }))(report[option.value], cindex) || '--'))]),_vm._v(" "),_c('div',{style:({ width: '15px' })}),_vm._v(" "),_c('div',{staticClass:"row-block",style:({ width: '42px', 'flex-shrink': 0 })},[(report.has_cover_photo)?_c('img',{attrs:{"src":__webpack_require__("Jlw2")}}):_c('div',{style:({ flex: 1 })}),_vm._v(" "),(report.has_attachments)?_c('img',{attrs:{"src":__webpack_require__("benM")}}):_c('div',{style:({ flex: 1 })})])])]):_c('span',{style:((option.style || (function () {}))(report[option.value])),attrs:{"title":(option.display || (function (x) { return x; }))(report[option.value], cindex)}},[_vm._v(_vm._s((option.display || (function (x) { return x; }))(report[option.value], cindex) || '--'))])])}),0)])}),0)])]),_vm._v(" "),_c('div',{staticClass:"page-container center-block"},[(_vm.pageData.total)?_c('pageButtons',{attrs:{"default":_vm.pageData.selectedPage,"display":_vm.pageData.display,"total":_vm.pageData.total,"buttonRange":_vm.pageData.buttonRange},on:{"selectPage":function (page) { _vm.pageData.selectedPage = page; _vm.searchDatas() }}}):_vm._e()],1)])])])])}
var adminReport_staticRenderFns = []
var adminReport_esExports = { render: adminReport_render, staticRenderFns: adminReport_staticRenderFns }
/* harmony default export */ var main_adminReport = (adminReport_esExports);
// CONCATENATED MODULE: ./src/pages/main/adminReport.vue
var adminReport_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var adminReport___vue_template_functional__ = false
/* styles */
var adminReport___vue_styles__ = null
/* scopeId */
var adminReport___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var adminReport___vue_module_identifier__ = null
var adminReport_Component = adminReport_normalizeComponent(
  adminReport,
  main_adminReport,
  adminReport___vue_template_functional__,
  adminReport___vue_styles__,
  adminReport___vue_scopeId__,
  adminReport___vue_module_identifier__
)

/* harmony default export */ var pages_main_adminReport = (adminReport_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/main/adminAccessLog.vue








//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ var adminAccessLog = ({
  components: {
    adminFilter: src_components_admin_filter,
    pageButtons: components_tool_pageButtons
  },
  mixins: [mixins_routeLoading, toastMethods["a" /* default */]],
  props: {
    minHeight: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      accessLogs: [],
      productByCategorys: [],
      init: {},
      filters: {},
      onSearch: false,
      pageData: {
        selectedPage: 1,
        display: 12,
        total: null,
        buttonRange: 7
      },
      sort: {
        value: ['created_at'],
        order: ['-desc']
      }
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['countrys']), {
    moduleOptions: function moduleOptions() {
      return [{ title: '市場吸引力', value: 'market_attractiveness' }, { title: '單一國市場吸引力', value: 'single_country_market_attractiveness' }, { title: '市場競爭力', value: 'market_competitiveness' }, { title: '單一國市場競爭力', value: 'single_country_market_competitiveness' }, { title: '零售價格分析', value: 'product_prices' }];
    },
    categoryOptions: function categoryOptions() {
      return [].concat(toConsumableArray_default()(keys_default()(this.productByCategorys).map(function (category) {
        return { title: category, value: category };
      })), [{ title: '其他', value: '其他' }]);
    },
    productOptions: function productOptions() {
      return [].concat(toConsumableArray_default()(Array.prototype.concat.apply([], entries_default()(this.productByCategorys).map(function (_ref) {
        var _ref2 = slicedToArray_default()(_ref, 2),
            category = _ref2[0],
            products = _ref2[1];

        return entries_default()(products).map(function (_ref3) {
          var _ref4 = slicedToArray_default()(_ref3, 2),
              code = _ref4[0],
              product = _ref4[1];

          return { title: product.chinese_name, value: code, type: product.product_type, category: category };
        });
      }))), [{ title: '其他', value: '其他', type: '其他', category: '其他' }]);
    },
    fileTypeOptions: function fileTypeOptions() {
      return [{ title: '資料表 (一般)', value: 'normal_data_sheet' }, { title: '資料表 (進階)', value: 'advanced_data_sheet' }, { title: 'xy散佈圖', value: 'xy_scatter_diagram' }, { title: '泡泡圖', value: 'bubble_chart' }, { title: '累積長條圖', value: 'cumulative_bar_graph' }, { title: '雷達圖', value: 'radar_chart' }, { title: '原始數據', value: 'raw_data' }];
    },
    countryOptions: function countryOptions() {
      return this.countrys.map(function (_ref5) {
        var _ref6 = slicedToArray_default()(_ref5, 2),
            key = _ref6[0],
            value = _ref6[1];

        return {
          title: value.chinese_name + '(' + value.iso_name + ')',
          value: key,
          country: value
        };
      });
    },

    // static
    filterOptions: function filterOptions() {
      var _this = this;

      return [{
        title: '日期起始與結束',
        value: 'time',
        type: 'date',
        range: [null, Object(util["b" /* dateFormat */])(new Date(), 'yyyy-MM-dd')],
        placeholder: function placeholder() {
          return ['請選擇起始日', '請選擇結束日'];
        }
      }, {
        title: '分析模組',
        value: 'module',
        type: 'select',
        options: this.moduleOptions,
        placeholder: function placeholder() {
          return '請選擇分析模組';
        }
      }, {
        title: '產品類別',
        value: 'category',
        type: 'select',
        options: this.categoryOptions,
        placeholder: function placeholder() {
          return '水果、蔬菜、農業機械...等';
        },
        onChange: function onChange(value, conditions) {
          setTimeout(function () {
            _this.init = extends_default()({}, _this.init, conditions, {
              product_code: ''
            });
          });
        }
      }, {
        title: '產品名稱',
        value: 'product_code',
        type: 'select',
        options: this.productOptions,
        optionDisplay: function optionDisplay(result) {
          return function (option) {
            return option.category === result.category;
          };
        },
        placeholder: function placeholder() {
          return '請選擇產品';
        }
      }, {
        title: '目標國家',
        value: 'partner',
        type: 'datalist',
        lists: function lists(value) {
          return _this.countryOptions.map(function (option) {
            return option.title;
          });
        },
        options: this.countryOptions,
        placeholder: function placeholder() {
          return '請選擇國家';
        },
        onChange: function onChange(value) {
          if (value && !_this.countryOptions.some(function (option) {
            return option.title === value;
          })) {
            _this.init = extends_default()({}, _this.init, _this.filters, {
              partner: ''
            });
          }
        }
      }, {
        title: '競爭國家',
        value: 'countries',
        type: 'datalist',
        lists: function lists(value) {
          return _this.countryOptions.map(function (option) {
            return option.title;
          });
        },
        options: this.countryOptions,
        placeholder: function placeholder() {
          return '請選擇國家';
        },
        onChange: function onChange(value) {
          if (value && !_this.countryOptions.some(function (option) {
            return option.title === value;
          })) {
            _this.init = extends_default()({}, _this.init, _this.filters, {
              countries: ''
            });
          }
        }
      }, {
        title: '資料類型',
        value: 'access_file_type',
        type: 'select',
        options: this.fileTypeOptions,
        placeholder: function placeholder() {
          return '請選擇資料格式';
        }
      }];
    },
    tableOptions: function tableOptions() {
      var _this2 = this;

      return [{
        title: '操作時間',
        value: 'created_at',
        width: '150px',
        display: function display(value) {
          return value ? Object(util["b" /* dateFormat */])(new Date(value), 'yyyy/MM/dd hh:mm') : '';
        }
      }, {
        title: '使用者',
        value: 'user_display',
        width: '150px'
      }, {
        title: '分析模組',
        value: 'module',
        width: '150px',
        display: function display(value) {
          return (_this2.moduleOptions.find(function (option) {
            return option.value === value;
          }) || {}).title;
        }
      }, {
        title: '年度',
        value: 'year',
        width: '100px'
      }, {
        title: '產品名稱',
        value: 'product_name',
        width: '150px',
        display: function display(value) {
          return value || '其他';
        }
      }, {
        title: '目標國',
        value: 'partner',
        width: '150px',
        display: function display(value) {
          return ((_this2.countryOptions.find(function (option) {
            return option.value === value;
          }) || {}).country || {}).chinese_name;
        }
      }, {
        title: '競爭國',
        value: 'country',
        width: '150px',
        display: function display(value) {
          return ((_this2.countryOptions.find(function (option) {
            return option.value === value;
          }) || {}).country || {}).chinese_name;
        }
      }, {
        title: '資料類型',
        value: 'access_file_type',
        display: function display(value) {
          return (_this2.fileTypeOptions.find(function (option) {
            return option.value === value;
          }) || {}).title;
        }
      }];
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setLoadingAction', 'setModalAction']), {
    fetchData: function fetchData() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this3.fetchProductByCategorys();

              case 2:
                _context.next = 4;
                return _this3.fetchAdminAccessLogs();

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    fetchProductByCategorys: function fetchProductByCategorys() {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var config, response, productByCategorys;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                config = _this4.$ls.get('userInfo');
                _context2.next = 4;
                return Object(src_api["r" /* getProductByCategorys */])(config);

              case 4:
                response = _context2.sent;
                productByCategorys = response.data;

                _this4.productByCategorys = productByCategorys;
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](0);
                throw _context2.t0;

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4, [[0, 9]]);
      }))();
    },
    fetchAdminAccessLogs: function fetchAdminAccessLogs(filters) {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var config, data, response, accessLogs;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                config = _this5.$ls.get('userInfo');

                filters = filters || _this5.filters || {};
                data = extends_default()({}, entries_default()(filters).filter(function (kv) {
                  return kv[1];
                }).reduce(function (s, kv) {
                  return extends_default()({}, s, defineProperty_default()({}, kv[0], kv[1]));
                }, {}), {
                  start_time: (filters.time || {})[0] ? (filters.time || {})[0] + ' 00:00' : (filters.time || {})[0],
                  end_time: (filters.time || {})[1] ? (filters.time || {})[1] + ' 23:59' : (filters.time || {})[1],
                  product_code: filters.product_code === '其他' ? '' : filters.product_code || null,
                  partner: (_this5.countryOptions.find(function (option) {
                    return option.title === filters.partner;
                  }) || {}).value || null,
                  country: (_this5.countryOptions.find(function (option) {
                    return option.title === filters.country;
                  }) || {}).value || null
                });

                _this5.pageData.selectedPage && (data.page = _this5.pageData.selectedPage);
                _this5.pageData.display && (data.item_per_page = _this5.pageData.display);
                _this5.sort.value[0] && (data.order_by = _this5.sort.value[0]);
                _this5.sort.order[0] && (data.order_method = _this5.sort.order[0].replace(/^-/, ''));
                _context3.next = 10;
                return Object(src_api["g" /* getAdminAccessLogs */])(data, config);

              case 10:
                response = _context3.sent;
                accessLogs = response.data.data.elements;

                _this5.pageData.total = response.data.data.items_count;
                _this5.accessLogs = accessLogs.map(function (accessLog) {
                  return extends_default()({}, accessLog, {
                    user_display: accessLog.user_name + (accessLog.user_occupation ? ' (' + accessLog.user_occupation + ')' : '')
                  });
                });
                _context3.next = 19;
                break;

              case 16:
                _context3.prev = 16;
                _context3.t0 = _context3['catch'](0);
                throw _context3.t0;

              case 19:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5, [[0, 16]]);
      }))();
    },
    searchDatas: function searchDatas(init) {
      var _this6 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this6.onSearch = true;
                if (init) {
                  _this6.init = init;
                  _this6.filter = init;
                }
                _context4.next = 4;
                return _this6.fetchAdminAccessLogs(init);

              case 4:
                _this6.onSearch = false;

              case 5:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this6);
      }))();
    },
    exportExcel: function exportExcel() {
      var config = this.$ls.get('userInfo');
      var filters = this.filters;
      var data = extends_default()({}, config, entries_default()(filters).filter(function (kv) {
        return kv[1];
      }).reduce(function (s, kv) {
        return extends_default()({}, s, defineProperty_default()({}, kv[0], kv[1]));
      }, {}), {
        time: null,
        start_time: (filters.time || {})[0],
        end_time: (filters.time || {})[1],
        product_code: filters.product_code === '其他' ? '' : filters.product_code || null,
        partner: (this.countryOptions.find(function (option) {
          return option.title === filters.partner;
        }) || {}).value || null,
        country: (this.countryOptions.find(function (option) {
          return option.title === filters.country;
        }) || {}).value || null
      });
      var url = api_config["a" /* API_ROOT */] + 'admin/access_logs/export.xlsx';
      url = url + '?' + entries_default()(data).map(function (_ref7) {
        var _ref8 = slicedToArray_default()(_ref7, 2),
            key = _ref8[0],
            value = _ref8[1];

        return value ? key + '=' + value : '';
      }).filter(function (x) {
        return x;
      }).join('&');
      Object(util["c" /* downloadFile */])(null, url, '_target');
    },
    tableSortBy: function tableSortBy(value) {
      var position = this.sort.value.indexOf(value);
      if (position === 0) {
        var order = this.sort.order[position] === '-asc' ? '-desc' : '-asc';
        this.sort.order.splice(position, 1);
        this.sort.order.unshift(order);
      } else {
        var _order = position !== -1 ? this.sort.order[position] === '-asc' ? '-desc' : '-asc' : undefined;
        position = position !== -1 ? position : 0;
        this.sort.value.splice(position, 1);
        this.sort.order.splice(position, 1);
        this.sort.value.unshift(value);
        this.sort.order.unshift(_order || '-asc');
      }
      this.searchDatas();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c21a4b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/main/adminAccessLog.vue
var adminAccessLog_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-access-log-page row-block",style:({ minHeight: _vm.minHeight })},[_c('div',{staticClass:"filter-container",style:({ width: '250px' })},[_c('adminFilter',{attrs:{"minHeight":_vm.minHeight,"disabled":false,"title":'會員操作記錄搜尋',"filters":{
        init: _vm.init,
        options: _vm.filterOptions
      }},on:{"changeFilters":function (c, search) { _vm.filters = c; search && _vm.searchDatas(c) }}})],1),_vm._v(" "),_c('div',{staticClass:"main-container row-block",style:({ flex: 1, height: _vm.minHeight })},[(_vm.onSearch)?_c('div',{staticClass:"mask center-block",style:({ height: '100%', width: '100%', 'min-width': '1350px' })},[_c('img',{attrs:{"src":__webpack_require__("5xS/"),"alt":""}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"main-block col-block",style:({ height: '100%', width: '100%', 'min-width': '1350px' })},[_c('div',{staticClass:"title-container row-block"},[_c('div',{staticClass:"title"},[_vm._v("會員操作記錄")]),_vm._v(" "),_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"main-button option-button update",attrs:{"type":"button","name":"button"},on:{"click":function (e) { return _vm.exportExcel(); }}},[_c('span',[_vm._v("匯出excel")])])]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"table-feild col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-container col-block",style:({ height: '50px' })},[_c('div',{staticClass:"thead default-shadow"},[_c('div',{staticClass:"tr row-block"},_vm._l((_vm.tableOptions),function(option,index){return _c('div',{key:index,staticClass:"th row-block",class:option.class,style:(option.width ? { width: option.width } : { flex: 1 }),on:{"click":function (e) { return option.sort !== false && _vm.tableSortBy(option.value); }}},[_c('span',[_vm._v(_vm._s(option.title))]),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),(option.sort !== false)?_c('i',{class:['fa', 'fa-sort' + (_vm.sort.order[_vm.sort.value.indexOf(option.value)] || '')],attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "),_c('div',{style:({ flex: 1 })})])}),0)])]),_vm._v(" "),_c('div',{staticClass:"table-container col-block sub-shadow",style:({ flex: 1 })},[_c('div',{staticClass:"tbody",style:({ flex: 1 })},[_c('div',{style:({ height: 0 })},_vm._l((_vm.accessLogs),function(report,cindex){return _c('div',{key:cindex,staticClass:"tr row-block"},[_c('div',{staticClass:"container-block row-block"},_vm._l((_vm.tableOptions),function(option,index){return _c('div',{key:index,staticClass:"td row-block",class:option.class,style:(option.width ? { width: option.width } : { flex: 1 })},[_c('span',{style:((option.style || (function () {}))(report[option.value])),attrs:{"title":(option.display || (function (x) { return x; }))(report[option.value], cindex)}},[_vm._v(_vm._s((option.display || (function (x) { return x; }))(report[option.value], cindex) || '--'))])])}),0)])}),0)])]),_vm._v(" "),_c('div',{staticClass:"page-container center-block"},[(_vm.pageData.total)?_c('pageButtons',{attrs:{"default":_vm.pageData.selectedPage,"display":_vm.pageData.display,"total":_vm.pageData.total,"buttonRange":_vm.pageData.buttonRange},on:{"selectPage":function (page) { _vm.pageData.selectedPage = page; _vm.searchDatas() }}}):_vm._e()],1)])])])])}
var adminAccessLog_staticRenderFns = []
var adminAccessLog_esExports = { render: adminAccessLog_render, staticRenderFns: adminAccessLog_staticRenderFns }
/* harmony default export */ var main_adminAccessLog = (adminAccessLog_esExports);
// CONCATENATED MODULE: ./src/pages/main/adminAccessLog.vue
var adminAccessLog_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var adminAccessLog___vue_template_functional__ = false
/* styles */
var adminAccessLog___vue_styles__ = null
/* scopeId */
var adminAccessLog___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var adminAccessLog___vue_module_identifier__ = null
var adminAccessLog_Component = adminAccessLog_normalizeComponent(
  adminAccessLog,
  main_adminAccessLog,
  adminAccessLog___vue_template_functional__,
  adminAccessLog___vue_styles__,
  adminAccessLog___vue_scopeId__,
  adminAccessLog___vue_module_identifier__
)

/* harmony default export */ var pages_main_adminAccessLog = (adminAccessLog_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/tutorial/main.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var tutorial_main = ({
  props: {
    type: {
      type: String,
      default: function _default() {
        return null;
      }
    },
    params: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    scrollToID: {
      type: String,
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {
      renderItem: null,
      display: null,
      toggle: null
    };
  },

  computed: {
    tutorialCards: function tutorialCards() {
      return {
        '農產品使用的吸引力指標': [{
          title: '產量(公噸)',
          value: '產量(公噸)',
          content: '當一個國家對於產品的需求大於國內可生產供應數量時，會傾向進口產品補足國內需求，顯示這個國家對此產品具有高度市場吸引力，因此，採用產量作為市場吸引力評估指標的意涵為，該目標市場產量越低可視為對其他國家進口產品的需求越大，市場吸引力越高。<b>本平台產量數據來源為聯合國農糧組織網站</b>，<span class=\'alert\'>部分產品的分類方式與國際貿易中心不同，使用時請注意網站提醒。</span>'
        }, {
          title: '出口值 (千美元)',
          value: '出口值 (千美元)',
          content: '當一個國家能出口產品可視為該國家對該產品的真實需求並非在其國內市場，而是其他國外市場，因此，採用出口值作為市場吸引力評估指標的意涵為，該目標市場出口量越高可視為其對於從其他國家進口產品的需求越低，市場吸引力越低。<b>本平台出口值數據來源為國際貿易中心。</b>'
        }, {
          title: '進口值 (千美元)',
          value: '進口值 (千美元)',
          content: '當一個國家對進口產品的金額高可視為該國家對產品需求大且具獲利機會，因此，採用進口值作為市場吸引力評估指標的意涵為，該目標市場進口值越高可視為該國家對產品的需求越高，市場吸引力越高。<b>本平台進口值數據來源為國際貿易中心。</b>'
        }, {
          title: '市場規模 (千美元)',
          value: '市場規模 (千美元)',
          content: '市場規模可顯示一個國家的需求程度，市場規模越大，進口市場後可獲利的機會越高，因此採用市場規模作為市場吸引力評估指標意涵為，該目標市場規模越大，獲利機會越大，市場吸引力越高。<b>本平台市場規模數值由之產值+進口值-出口值 計算獲得。</b>'
        }, {
          title: '進口市場成長趨勢(%)',
          value: '進口市場成長趨勢(%)',
          content: '年成長率可用來了解該國進口市場處於何種時期(萌芽、成長、成熟與衰退期)，並評估該市場未來發展前景，成長趨勢越高則發展前景越佳，因此採用進口市場成長趨勢作為市場吸引力評估指標意涵為，市場年成長趨勢越高且處於成長期，市場吸引力越高，<b>本平台進口市場成長趨勢由 (本年度之總進口值 - 去年度之總進口值) / 去年度之總進口值</b> 計算獲得。'
        }, {
          title: '貿易專業化指數TSI',
          value: '貿易專業化指數TSI',
          content: 'TSI 可用以了解該國家產品之淨出口或淨進口狀況，如進出口平衡狀態則貿易專業化指標為零，而如該國家以出口為導向，則貿易專業化指數為正值則顯示出口大於進口，該產品偏向出口導向，因此採用貿易專業化指數作為市場吸引力評估指標意涵為，貿易專業化指數為正值則出口量能越強，則市場吸引力越低，貿易專業化指數為負值擇進口為多，市場吸引力越高，<b>本平台貿易專業化指數由 (目標市場國之產品總出口值 - 目標市場國之產品總進口值) / (目標市場國之產品總出口值 + 目標市場國之產品總進口值)</b> 計算獲得。'
        }, {
          title: '市場距離(公里)',
          value: '市場距離(公里)',
          content: '蔬果為易腐產品長途運輸不易，運輸過程經營者需承擔高度風險，因此出口目標市場距離越長，則品質耗損風險越高，因此採用目標市場與我國之距離作為市場吸引力評估指標意涵為，市場距離越大則需承擔風險越高，市場吸引力越低。本平台<b>使用google提供的國家間直線距離作為市場距離指標內容。</b>'
        }, {
          title: '全球貿易市場佔有率(%)',
          value: '全球貿易市場佔有率(%)',
          content: '市場佔有率可用以比較各國對該產品進口值佔全球總進口佔比，該國市場佔有率越高則該國市場在全球進口市場的重要性越高，因此採用全球貿易市場佔有率作為市場吸引力評估指標意涵為，該國家於全球貿易市場佔有率約高，則市場吸引力越高，本平台<b>全球貿易市場佔有率由 (目標市場國之該農產品進口值 / 全球之該農產品進口值)</b> 計算獲得。'
        }, {
          title: '平均每人GDP(美元)',
          value: '平均每人GDP(美元)',
          content: '人均GDP可用以了解該國家之總體的消費力，一般認為較高人均GDP的國家較有能力能購買價格偏高之進口產品，因此採用平均每人GDP作為市場吸引力評估指標意涵為，該國家人均GDP越高消費力越強，則市場吸引力越高，本平台<b>人均GDP資料數據來源為世界銀行網站。</b>'
        }, {
          title: '人口數',
          value: '人口數',
          content: '人口數可視為市場規模影響因素，人口數越多代表對於農產品的需求量越多，因此採用人口數作為市場吸引力評估指標意涵為，人口數越多則市場吸引力越高。<b>人口數資料數據來源為世界銀行網站。</b>'
        }, {
          title: '市場成長相對強度(%)',
          value: '市場成長相對強度(%)',
          content: '市場成長相對強度可使用於比較目標市場進口成長率與全球進口成長率之差異，如該市場進口成長率遠高於全球，顯示該市場需求快速成長，因此採用市場成長相對強度作為市場吸引力評估指標意涵為，市場成長相對強度越高，則市場吸引力越高，本平台<b>市場成長相對強度由 [(本年目標市場國之產品進口值-5年前目標市場國之產品進口值) / (5年前目標市場國之產品進口值)] - [(本年全球之產品進口值-5年前全球之產品進口值) / (5年前全球之產品進口值)]</b> 計算獲得。'
        }, {
          title: '進口市場表現(%)',
          value: '進口市場表現(%)',
          content: '進口市場表現用於了解我國於目標市場是否仍有成長空間或已經接近市場飽和，進口市場表現指標為「該農產品目標市場佔全球市場佔有率」減去「台灣出口該農產品到目標市場佔台灣該農產品總出口之比例」，以該目標市場佔全球市場比率為指標，比較我國目前出口該市場的佔比是否低於指標 (正值) 或是高於指標 (負值)，因此採用進口市場表現作為市場吸引力評估指標意涵為，數值為正值表示我國在該目標市場出口尚有成長空間，數值為負值則表示成長空間低且可能有依賴目標市場的現象。進口市場表現由 <b>[(目標市場國之該農產品進口值 / 全球之該農產品進口值) - (台灣之該農產品出口至目標市場國之出口值 / 台灣之該農產品總出口值)]</b> 計算獲得。'
        }, {
          title: '市場開放程度(%)',
          value: '市場開放程度(%)',
          content: '各國間產品關稅為影響農產品貿易重要因子，農產品關稅稅率可視作該國家市場對該產品採開放程度，因此採用進口國關稅作為市場吸引力評估指標意涵為，進口國關稅越高則市場吸引力越低。<b>本平台關稅數據來源為國家貿易中心。</b></br><span class=\'alert\'>注意！</span> 因ITC關稅資料僅有最新年度之資料，並無歷年資料，因此各年度均以最新年度之關稅率作為分析數據之依據。'
        }, {
          title: '市場相對優惠關稅(%)',
          value: '市場相對優惠關稅(%)',
          content: '比較我國與目標市場前五大進口國平均關稅可了解該市場對我國與其他國家開放程度差異，本平台市場相對優惠關稅由<b>(目標市場國前五大進口國產品之平均關稅率 - 台灣至目標市場國之產品關稅率)</b> 計算獲得，因此採用市場相對優惠關稅作為市場吸引力評估指標意涵為，數值越大顯示市場吸引力越高，市場對我國產品關稅率低於前五大進口國平均關稅率。</br><span class=\'alert\'>注意！</span> 因ITC關稅資料僅有最新年度之資料，並無歷年資料，因此各年度均以最新年度之關稅率作為分析數據之依據。'
        }],
        '農業機械使用的吸引力指標': [{
          title: '出口值(千美元)',
          value: '出口值(千美元)',
          content: '當一個國家能出口農機可視為該國家在生產面具備一定的數量與能力，可間接推測這個國家對相同產品的進口需求低，因此，採用出口值作為市場吸引力評估指標的意涵為，該目標市場出口量越高可視為其對於從其他國家進口產品的需求越低，市場吸引力越低，<b>本平台出口值數據來源為國際貿易中心。</b>'
        }, {
          title: '進口值(千美元)',
          value: '進口值(千美元)',
          content: '當一個國家對進口產品的金額高可視為該國家對產品需求大且具獲利機會，因此，採用進口值作為市場吸引力評估指標的意涵為，該目標市場 進口值越高可視為該國家對農機產品的需求越高，市場吸引力越高，<b>本平台進口值數據來源為國際貿易中心。</b>'
        }, {
          title: '進口市場成長趨勢(%)',
          value: '進口市場成長趨勢(%)',
          content: '年成長率可用來了解該國進口市場處於何種時期(萌芽、成長、成熟與衰退期)，並評估該市場未來發展前景，成長趨勢越高則發展前景越佳，因此採用進口市場成長趨勢作為市場吸引力評估指標意涵為，市場年成長趨勢越高且處於成長期，市場吸引力越高，本平台進口市場成長趨勢由 <b>(本年度之總進口值 - 去年度之總進口值) / 去年度之總進口值</b> 計算獲得。'
        }, {
          title: '貿易專業化指數(TSI)',
          value: '貿易專業化指數(TSI)',
          content: '貿易專業化指數可用以了解該國家產品之淨出口或淨進口狀況，如進出口平衡狀態則貿易專業化指標為零，而如該國家以出口為導向，則貿易專業化指數為正值則顯示出口大於進口，該產品偏向出口導向，因此採用貿易專業化指數作為市場吸引力評估指標意涵為，貿易專業化指數為正值則出口量能越強，則市場吸引力越低，貿易專業化指數為負值擇進口為多，市場吸引力越高，本平台貿易專業化指數由 <b>(目標市場國農機出口值-目標市場國農機進口值) / (目標市場國農機出口值+目標市場國農機進口值)</b> 計算獲得。'
        }, {
          title: '全球貿易市場佔有率(%)',
          value: '全球貿易市場佔有率(%)',
          content: '市場佔有率可用以比較各國對該產品進口值佔全球總進口佔比，該國市場佔有率越高則該國市場在全球進口市場的重要性越高，因此採用全球貿易市場佔有率作為市場吸引力評估指標意涵為，該國家於全球貿易市場佔有率約高，則市場吸引力越高，本平台全球貿易市場佔有率由 <b>(目標市場國農機進口值 / 世界農機進口值)</b> 計算獲得。'
        }, {
          title: '平均每人GDP(美元)',
          value: '平均每人GDP(美元)',
          content: '人均GDP可用以了解該國家經濟發展情況，一般認為較高人均GDP的國家經濟發展較好，或該國家之勞力薪資水準較高，因此採用平均每人GDP作為市場吸引力評估指標意涵為，該國家人均GDP越高經濟發展越好且農業勞力成本越高，對農機需求越高，市場吸引力越大，<b>本平台人均GDP資料數據來源為世界銀行網站。</b>'
        }, {
          title: 'GNI (美元)',
          value: 'GNI (美元)',
          content: 'GNI可用以了解該國家經濟發展情況，一般認為GNI高的國家經濟發展較好，或該國家之勞力薪資水準較高，因此採用GNI作為市場吸引力評估指標意涵為，該國家GNI越高經濟發展越好且農業勞力成本越高，對農機需求越高，市場吸引力越大，<b>本平台GNI資料數據來源為世界銀行網站。</b>'
        }, {
          title: '農業人口比率(%)',
          value: '農業人口比率(%)',
          content: '當一個國家農業人口比率越高，可視為該國家從事農業生產者佔總人口多，農業勞動力充足，因此，採用農業人口比率作為市場吸引力指標的涵意為，該目標市場農業人口比率越高則對農機需求越低，市場吸引力越低，<b>本平農業人口比率資料來源為世界銀行。</b>'
        }, {
          title: '農業人口比率趨勢',
          value: '農業人口比率趨勢',
          content: '當一個國家農業人口比率逐漸降低，可視為該國家從事農業生產者人口逐漸減少，造成農業勞動力減少，因此，採用農業人口比率趨勢作為市場吸引力指標的意涵為，該目標市場農業人口比率成長趨勢減少則對農機需求越高，市場吸引力越高，農業人口比率趨勢由 <b>[(本年目標市場國之農業人口比率-去年目標市場國之農業人口比率) / 去年目標市場國之農業人口比率]</b> 計算獲得。'
        }, {
          title: '耕地面積(平方公里)',
          value: '耕地面積(平方公里)',
          content: '當一個國家耕地面積越大可視為，該國家農業生產偏向土地型利用農業生產模式，或該國家視農業為重要經濟活動，因此，採用耕地面積作為市場吸引力指標的涵意為，該目標市場耕地面積越大可視為對農機需求越高，市場吸引力越高，<b>本平台耕地面積數據來源為世界銀行。</b>'
        }, {
          title: '平均農業人口耕地面積(平方公里/人)',
          value: '平均農業人口耕地面積(平方公里/人)',
          content: '當一個國家平均農業人口耕地面積越大，可視為該國家農業耕作偏向規模較大生產方式，因此，採用平均農業人口耕地面積作為市場吸引力的涵意為，該目標市場平均農業人口耕地面積越高則對農機需求越高，市場吸引力越大，平均農業人口耕地面積由 <b>[目標市場國之耕地面積/(目標市場國之總人口數*目標市場國之農業人口比率)]</b> 計算獲得。'
        }, {
          title: '市場成長相對強度(%)',
          value: '市場成長相對強度(%)',
          content: '市場成長相對強度可使用於比較目標市場進口成長率與全球進口成長率之差異，如該市場進口成長率遠高於全球，顯示該市場需求快速成長，因刺採用市場成長相對強度作為市場吸引力評估指標意涵為，市場成長相對強度越高，則市場吸引力越高，本平台市場成長相對強度由 <b>[(本年目標市場國之農機進口值-5年前目標市場國之農機進口值) / (5年前目標市場國之農機進口值)] - [(本年全球之農機進口值-5年前全球之農機進口值) / (5年前全球之農機進口值)]</b> 計算獲得。'
        }, {
          title: '進口市場表現(%)',
          value: '進口市場表現(%)',
          content: '進口市場表現用於了解我國於目標市場是否仍有成長空間或已經接近市場飽和，進口市場表現指標為「該農機產品目標市場佔全球市場佔有率」減去「台灣出口該農機產品到目標市場佔台灣該農產品總出口之比例」，以該目標市場佔全球市場比率為指標，比較我國目前出口該市場的佔比是否低於指標 (正值) 或是高於指標 (負值)，因此採用進口市場表現作為市場吸引力評估指標意涵為，數值為正值表示我國在該目標市場出口尚有成長空間，數值為負值則表示成長空間低且可能有依賴目標市場的現象。進口市場表現由 <b>[(目標市場國之該農機進口值/全球之該農機進口值) - (台灣之該農機出口至目標市場國之出口值/台灣之該農機總出口值)]</b> 計算獲得。'
        }, {
          title: '市場開放程度(%)',
          value: '市場開放程度(%)',
          content: '各國間產品關稅為影響農機貿易重要因子，農機關稅稅率可視作該國家市場對該產品採開放程度，因此採用進口國關稅作為市場吸引力評估指標意涵為，進口國關稅越高則市場吸引力越低。<b>本平台關稅數據來源為國家貿易中心。</b></br><span class=\'alert\'>注意！</span> 因ITC關稅資料僅有最新年度之資料，並無歷年資料，因此各年度均以最新年度之關稅率作為分析數據之依據。'
        }, {
          title: '市場相對優惠關稅(%)',
          value: '市場相對優惠關稅(%)',
          content: '比較我國與目標市場前五大進口國平均關稅可了解該市場對我國與其他國家開放程度差異，本平台市場相對優惠關稅由<b>「目標市場國前五大進口國農機之平均關稅率 - 台灣至目標市場國之農機關稅率」</b>計算獲得，因此採用市場相對優惠關稅作為市場吸引力評估指標意涵為，數值越大顯示市場吸引力越高，市場對我國產品關稅率低於前五大進口國平均關稅率。</br><span class=\'alert\'>注意！</span> 因ITC關稅資料僅有最新年度之資料，並無歷年資料，因此各年度均以最新年度之關稅率作為分析數據之依據。'
        }],
        '農產品使用的競爭力指標': [{
          title: '產量(公噸)',
          value: '產量(公噸)',
          content: '一個國家農產品產量可用以了解是否具有可外銷的數量與能力，產量越高則代表在外銷供應上與其他國家相較越具有競爭力，因此採用產量作為市場競爭力指標意涵為，產量越高，此國家在外銷目標國的市場競爭力越強。<b>本平台產量數據來源為聯合國農糧組織網站，</b><span class=\'alert\'>部分產品的分類方式與國際貿易中心不同，使用時請注意網站提醒</span>。'
        }, {
          title: '單位面積產量 (百克/公頃)',
          value: '單位面積產量 (百克/公頃)',
          content: '一個國家農產品單位面積產量可用以了解是否具有可外銷的能力，單位面積產量越高則代表在產品生產技術上與其他國家相較越具有競爭力，因此採用單位面積產量作為市場競爭力指標意涵為，單位面積產量越高，此國家在外銷目標國的市場競爭力越強。<b>本平台產量數據來源為聯合國農糧組織網站，</b><span class=\'alert\'>部分產品的分類方式與國際貿易中心不同，使用時請注意網站提醒</span>。'
        }, {
          title: '生產者價格 (美元/公噸)',
          value: '生產者價格 (美元/公噸)',
          content: '一個國家生產者價格可視為了解該國生產成本高低的指標，而生產成本高則代表在外銷供應上該國不具價格優勢，因此採用生產者價格作為市場競爭力指標意涵為，生產者價格越高，此國家在外銷目標國的市場競爭力越低。<b>本平台產量數據來源為聯合國農糧組織網站，</b><span class=\'alert\'>部分產品的分類方式與國際貿易中心不同，使用時請注意網站提醒。</span><span class=\'alert\'><b>我國生產者價格部分資料來源為農糧署生產成本調查系統</b></span>。'
        }, {
          title: '進口單價 (美元/公斤)',
          value: '進口單價 (美元/公斤)',
          content: '一個國家在市場端之進口單價可間接了解，出口國於外銷供應時的成本，而市場進口單價高代表在外銷供應上該國不具價格優勢，因此採用市場進口單價作為市場競爭力指標意涵為，進口單價越高，此國家在外銷目標國的市場競爭力越低。本平台進口單價由 <b>(目標市場國進口競爭國之產品進口值 / 目標市場國進口競爭國之產品進口量)</b> 計算獲得。'
        }, {
          title: '顯示性比較利益指數 (RCA)',
          value: '顯示性比較利益指數 (RCA)',
          content: 'RCA可用來評估一個國家某項產品出口競爭力表現，RCA指數越高代表該產品出口競爭力越強，因此採用顯示性比較利益指數作為市場競爭力指標意涵為，顯示性比較利益指數越高，此國家在外銷目標國的市場競爭力越高。本平台顯示性比較利益指數由 <b>[(競爭國出口產品至目標市場國總出口值 / 全球出口產品至目標市場總出口值) / (競爭國出口水果 (蔬菜) 至目標市場總出口值 / 全球出口水果 (蔬菜) 至目標市場總出口值)]</b> 計算獲得。'
        }, {
          title: '貿易密集度指數(TII)',
          value: '貿易密集度指數(TII)',
          content: 'TII可用來評估進口國與出口國之在某個品項的貿易往來程度，貿易往來越多，供應網絡越密切，則出口國在目標市場的競爭力越強，因此採用貿易密集度作為市場競爭力指標意涵為，貿易密集度越高，則此國家在外銷目標國的市場競爭力越高。本平台貿易密集度由 <b>(目標市場進口競爭國之產品總進口值 / 目標市場國進口全球之產品總進口值) / [競爭國出口全球之產品總出口值 / (產品全球總出口值 - 目標市場國出口全球之產品總出口值)]</b> 計算獲得。'
        }, {
          title: '市場距離(公里)',
          value: '市場距離(公里)',
          content: '蔬果為易腐產品長途運輸不易，運輸過程經營者需承擔高度風險，因此出口目標市場距離越長，則品質耗損風險越高，因此採用競爭國與市場之距離作為市場競爭力評估指標意涵為，競爭國與市場距離越小則需承擔風險越小，市場吸競爭力越高。<b>本平台使用google提供的國家間直線距離作為市場距離指標內容。</b>'
        }],
        '農業機械使用的競爭力指標': [{
          title: '進口單價 (美元/公斤)',
          value: '進口單價 (美元/公斤)',
          content: '一個國家在市場端之進口單價可間接了解，出口國於外銷供應時的成本，而市場進口單價高代表在外銷供應上該國不具價格優勢，因此採用市場進口單價作為市場競爭力指標意涵為，進口單價越高，此國家在外銷目標國的市場競爭力越低。本平台進口單價由 <b>(目標市場國進口競爭國之農機進口值 / 目標市場國進口競爭國之農機進口量)</b> 計算獲得。'
        }, {
          title: '顯示性比較利益指數 (RCA)',
          value: '顯示性比較利益指數 (RCA)',
          content: 'RCA可用來評估一個國家某項產品出口競爭力表現，RCA指數越高代表該產品出口競爭力越強，因此採用顯示性比較利益指數作為市場競爭力指標意涵為，顯示性比較利益指數越高，此國家在外銷目標國的市場競爭力越高。本平台顯示性比較利益指數由 <b>[(競爭國出口農機至目標市場國總出口值 / 全球出口農機至目標市場總出口值) / (競爭國出口農機 (4碼) 至目標市場總出口值/全球出口農機 (4碼) 至目標市場總出口值)]</b> 計算獲得。'
        }, {
          title: '貿易密集度指數 (TII)',
          value: '貿易密集度指數 (TII)',
          content: 'TII可用來評估進口國與出口國之在某個品項的貿易往來程度，貿易往來越多，供應網絡越密切，則出口國在目標市場的競爭力越強，因此採用貿易密集度作為市場競爭力指標意涵為，貿易密集度越高，則此國家在外銷目標國的市場競爭力越高。本平台貿易密集度由 <b>(目標市場進口競爭國之農機總進口值 / 目標市場國進口全球之農機總進口值) / [競爭國出口全球之農機總出口值 / (農機全球總出口值-目標市場國出口全球之農機總出口值)]</b> 計算獲得。'
        }],
        '零售價格分析與指標': [{
          title: '通路型態',
          value: '通路型態',
          content: '蔬果的訂價差異，受到不同通路鎖定目標消費者可接受價格範圍影響，比較不同通路蔬果零售價格，可作為進入不同通路時，自己產品的價格定位參考。'
        }, {
          title: '市場所在國與產地',
          value: '市場所在國與產地',
          content: '蔬果的訂價差異，受到成本與市場消費者可接受價格影響，比較不同市場國與同一市場中競爭產品價格，可作為進入該國家，自己產品的價格定位參考。'
        }, {
          title: '產品形式',
          value: '產品形式',
          content: '蔬果價格差異，受到不同產品形式影響，比較不同販售包裝之零售價格，可作為自己產品包裝改進與價格定位參考。'
        }, {
          title: '照片(進階功能)',
          value: '照片(進階功能)',
          content: '為讓使用者更比較產品外觀、產品包裝與標籤等內容，此平台提供進階使用者可觀看本平台中零售端陳列照片功能，如您希望可以使用者功能，請與我們共享您的照片與資料。'
        }]
      };
    },
    tutorialImgs: function tutorialImgs() {
      var imgType = this.type === 'tool' ? 'tool' : 'normal';
      return {
        '市場吸引力操作教學說明': [{
          title: '數據搜尋',
          description: '',
          img: __webpack_require__("SZ5X")("./tutorial-" + imgType + '-attraction-1.jpg'),
          items: [{
            contents: ['選擇品項、年份後，按下搜尋，數據結果會顯示在右側表格。']
          }, {
            contents: ['可自行調整指標權重，會即時顯示與動態調整結果與排名。']
          }, {
            contents: ['可勾選決定是否採計該國資料，也可點選國名查看單一國歷年數據。<b>圖示代表有相關分析報告</b>。']
          }, {
            contents: ['可下載數據表格csv檔案，進階會員可載原始數據表格。']
          }, {
            contents: ['可切換到<b>分頁：統計圖呈現</b>，繪製多種統計圖。']
          }]
        }, {
          title: '統計圖呈現',
          description: '',
          img: __webpack_require__("xPuW")("./tutorial-" + imgType + '-attraction-2.jpg'),
          items: [{
            contents: ['可點選<b>分頁：統計圖呈現</b>，繪製多種統計圖。']
          }, {
            contents: ['可選擇圖類型：XY散佈圖、泡泡圖、累計長條圖、雷達圖。', '每種統計圖都有不同的參數可設定，如：軸的指標。', '可點選<b>分頁：數據選擇</b>，勾選決定是否採計該國資料。']
          }, {
            contents: ['可點另存圖檔，下載統計圖。']
          }]
        }, {
          title: '單一國家歷年分數表',
          description: '使用者點選<span class="link">國家</span>後會跳出此分頁',
          img: __webpack_require__("ZMG5")("./tutorial-" + imgType + '-attraction-3.jpg'),
          items: [{
            contents: ['數據結果、統計圖呈現操作請參考上方操作。']
          }, {
            contents: ['若有相關報告，會有<b>分析報告分頁</b>，使用者可點選瀏覽與閱讀。']
          }, {
            contents: ['可點選國家概況分頁，更暸解該國家的基本資訊，如：天氣。']
          }]
        }, {
          title: '單一國家歷年數據：國家概況',
          description: '點選<b>國家概況</b>預設進入<b>天氣</b>分頁',
          img: __webpack_require__("z3m9")("./tutorial-" + imgType + '-attraction-4.jpg'),
          items: [{
            contents: ['使用者可點選數字放大地圖，或點選圖標，查看氣候資訊與繪製']
          }, {
            contents: ['站點的基本資訊會呈現於此，若需要更完整氣候資訊，可點連結到NOAA網站查詢。']
          }, {
            contents: ['選好站點後，可切換日/月資料查看不同範圍的天氣歷史資料。']
          }, {
            contents: ['可選擇起訖時間後按繪圖，該區間折線圖會呈現於右側。']
          }, {
            contents: ['使用者可以下載該統計圖，也可下載該區間天氣數據csv檔案。']
          }]
        }],
        '市場競爭力操作教學說明': [{
          title: '數據搜尋',
          description: '',
          img: __webpack_require__("QLzv")("./tutorial-" + imgType + '-competitiveness-1.jpg'),
          items: [{
            contents: ['選擇品項、年份後，按下搜尋，數據結果會顯示在右側表格。']
          }, {
            contents: ['可自行調整指標權重，會即時顯示與動態調整結果與排名。']
          }, {
            contents: ['可勾選決定是否採計該國資料，也可點選國名查看單一國歷年數據。<b>圖示代表有相關分析報告</b>。']
          }, {
            contents: ['可下載數據表格csv檔案，進階會員可載原始數據表格。']
          }, {
            contents: ['可切換到<b>分頁：統計圖呈現</b>，繪製多種統計圖。']
          }]
        }, {
          title: '統計圖呈現',
          description: '',
          img: __webpack_require__("eJjw")("./tutorial-" + imgType + '-competitiveness-2.jpg'),
          items: [{
            contents: ['可點選<b>分頁：統計圖呈現</b>，繪製多種統計圖。']
          }, {
            contents: ['可選擇圖類型：XY散佈圖、泡泡圖、累計長條圖、雷達圖。', '每種統計圖都有不同的參數可設定，如：軸的指標。', '可點選<b>分頁：數據選擇</b>，勾選決定是否採計該國資料。']
          }, {
            contents: ['可點另存圖檔，下載統計圖。']
          }]
        }, {
          title: '單一國家歷年分數表',
          description: '使用者點選<span class="link">國家</span>後會跳出此分頁',
          img: __webpack_require__("2CkK")("./tutorial-" + imgType + '-competitiveness-3.jpg'),
          items: [{
            contents: ['數據結果、統計圖呈現操作請參考上方操作。']
          }, {
            contents: ['若有相關報告，會有<b>分析報告分頁</b>，使用者可點選瀏覽與閱讀。']
          }, {
            contents: ['可點選國家概況分頁，更暸解該國家的基本資訊，如：天氣。']
          }]
        }, {
          title: '單一國家歷年數據：國家概況',
          description: '點選<b>國家概況</b>預設進入<b>天氣</b>分頁',
          img: __webpack_require__("xYqJ")("./tutorial-" + imgType + '-competitiveness-4.jpg'),
          items: [{
            contents: ['使用者可點選數字放大地圖，或點選圖標，查看氣候資訊與繪製']
          }, {
            contents: ['站點的基本資訊會呈現於此，若需要更完整氣候資訊，可點連結到NOAA網站查詢。']
          }, {
            contents: ['選好站點後，可切換日/月資料查看不同範圍的天氣歷史資料。']
          }, {
            contents: ['可選擇起訖時間後按繪圖，該區間折線圖會呈現於右側。']
          }, {
            contents: ['使用者可以下載該統計圖，也可下載該區間天氣數據csv檔案。']
          }]
        }],
        '零售價格分析操作教學說明': [{
          title: '數據搜尋',
          description: '',
          img: __webpack_require__("eXbr"),
          items: [{
            contents: ['使用者可選擇產品類別、產品名稱，按下搜尋，結果會顯示於右側作圖區。']
          }, {
            contents: ['可選擇X、Z軸的指標來繪製散佈圖，並可選擇要顯示的資料集。']
          }, {
            contents: ['可點選圖面上的資料點，查看單一筆數據及其鄰近條件數據的詳細資訊。']
          }, {
            contents: ['可以點另存圖檔，下載當前顯示的統計圖。', '<b>進階使用者</b>可點原始數據下載，獲取該產品零售價格之詳細資訊與照片。']
          }, {
            contents: ['<b>進階使用者</b>可新增上傳零售價格資料，並能在上傳記錄分頁看到過往的記錄。']
          }]
        }, {
          title: '零售價格詳細資料',
          description: '<span class="dark">使用者點選<b>單一圖點</b>後會跳出此分頁<span>',
          img: __webpack_require__("cEEl"),
          items: [{
            contents: ['頁面會呈現單一筆數據及其鄰近條件數據群列表，使用者可以點選分頁瀏覽列表。', '每筆數據的詳細資料都會呈現在下方。(照片僅供<b>進階使用者</b>操作)']
          }]
        }],
        '分析報告與操作說明': [{
          title: '瀏覽與搜尋',
          description: '',
          img: __webpack_require__("zscX"),
          items: [{
            contents: ['報告會按照日期新舊排序，使用者可點選<span class="link">更多內容</span>閱讀報告內容。', '使用者可查看<span class="link">標籤</span>，或點選<span class="link">標籤</span>，來搜尋相關報告。']
          }, {
            contents: ['可輸入各種條件來搜尋報告。']
          }]
        }, {
          title: '閱讀報告',
          description: '',
          img: __webpack_require__("64nW"),
          items: [{
            contents: ['使用者可閱讀報告內容。也可查看<span class="link">標籤</span>，或點選<span class="link">標籤</span>，來搜尋相關報告。']
          }, {
            contents: ['<b>進階使用者</b>可下載報告內的附件檔案與對報告文章留言。']
          }]
        }]
      };
    }
  },
  created: function created() {
    this.renderItem = this.params.renderItem || {
      '農產業貿易潛力分析平台': true,
      '市場吸引力分析': true,
      '市場吸引力指標': true,
      '市場吸引力操作教學說明': true,
      '市場競爭力分析': true,
      '市場競爭力指標': true,
      '市場競爭力操作教學說明': true,
      '零售價格分析與指標': true,
      '零售價格分析操作教學說明': true,
      '分析報告與操作說明': true
    };
    this.display = this.params.display || {
      '農產業貿易潛力分析平台': null,
      '市場吸引力分析': true,
      '市場吸引力指標': true,
      '市場吸引力操作教學說明': true,
      '市場競爭力分析': true,
      '市場競爭力指標': true,
      '市場競爭力操作教學說明': true,
      '零售價格分析與指標': true,
      '零售價格分析操作教學說明': true,
      '分析報告與操作說明': true
    };
    this.toggle = this.params.toggle || {
      '農產品使用的吸引力指標': null,
      '農業機械使用的吸引力指標': null,
      '農產品使用的競爭力指標': null,
      '農業機械使用的競爭力指標': null,
      '零售價格分析與指標': null
    };
  },
  mounted: function mounted() {
    if (this.$route.query.to) {
      this.scrollTo(this.$route.query.to, false);
    }
  },

  watch: {
    'scrollToID': function scrollToID(nv, ov) {
      if (nv && nv !== ov) {
        this.scrollTo(nv);
      }
    }
  },
  methods: {
    scrollTo: function scrollTo(id) {
      var animated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      this.display[id] = true;
      var target = document.getElementById(id);
      target && target.scrollIntoView({ behavior: animated ? 'smooth' : 'auto' });
    },
    toggleCard: function toggleCard(type, card) {
      this.toggle[type] = this.toggle[type] !== card ? card : null;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46f11f86","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tutorial/main.vue
var tutorial_main_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tutorial-main-page row-block default-shadow"},[_c('div',{staticClass:"fixed-container col-block"},[_c('div',{style:({ height: '30px' })}),_vm._v(" "),_c('img',{style:({ width: '250px', height: '421px' }),attrs:{"src":__webpack_require__("lCiF")}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),(_vm.renderItem && _vm.display && _vm.toggle)?_c('div',{staticClass:"tutorial-block row-block"},[_c('div',{staticClass:"content-container col-block",style:({ flex: 1 })},[(_vm.renderItem['農產業貿易潛力分析平台'])?_c('div',{staticClass:"tutorial-block col-block",attrs:{"id":"農產業貿易潛力分析平台"}},[_c('div',{staticClass:"tutorial-title-container row-block",class:{ active: _vm.display['農產業貿易潛力分析平台'] || _vm.display['農產業貿易潛力分析平台'] === null, display: _vm.display['農產業貿易潛力分析平台'] !== null },on:{"click":function (e) { return _vm.display['農產業貿易潛力分析平台'] !== null && (_vm.display['農產業貿易潛力分析平台'] = !_vm.display['農產業貿易潛力分析平台']); }}},[_c('div',{staticClass:"tutorial-title"},[_vm._v("農產業貿易潛力分析平台 AgriTrade")]),_vm._v(" "),(_vm.display['農產業貿易潛力分析平台'] !== null)?[_c('div',{style:({ width: '15px' })}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("yBtO"),"alt":""}})]:_vm._e(),_vm._v(" "),_c('div',{style:({ flex: 1 })})],2),_vm._v(" "),(_vm.display['農產業貿易潛力分析平台'] || _vm.display['農產業貿易潛力分析平台'] === null)?[_c('div',{style:({ height: '10px' })}),_vm._v(" "),_vm._m(0)]:_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.renderItem['市場吸引力分析'])?_c('div',{staticClass:"tutorial-block col-block",attrs:{"id":"市場吸引力分析"}},[_c('div',{staticClass:"tutorial-title-container row-block",class:{ active: _vm.display['市場吸引力分析'] || _vm.display['市場吸引力分析'] === null, display: _vm.display['市場吸引力分析'] !== null },on:{"click":function (e) { return _vm.display['市場吸引力分析'] !== null && (_vm.display['市場吸引力分析'] = !_vm.display['市場吸引力分析']); }}},[_c('div',{staticClass:"tutorial-title",domProps:{"innerHTML":_vm._s({
              normal: '農產品的市場吸引力',
              tool: '農業機械的市場吸引力'
            }[_vm.type] || '市場吸引力分析')}}),_vm._v(" "),(_vm.display['市場吸引力分析'] !== null)?[_c('div',{style:({ width: '15px' })}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("yBtO"),"alt":""}})]:_vm._e(),_vm._v(" "),_c('div',{style:({ flex: 1 })})],2),_vm._v(" "),(_vm.display['市場吸引力分析'])?[_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"tutorial-content-container block"},[(_vm.type !== 'tool')?[(!_vm.type)?_c('div',{staticClass:"tutorial-content-title"},[_vm._v("農產品的市場吸引力")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"tutorial-content"},[_vm._v("對農產品而言，市場可以視為區域、國家、特定一群消費者，一個具有吸引力的市場，表示進入市場後可以為事業帶來長期獲利，本平台市場吸引力分析工具為針對國家層面的數據進行分析，可提供做為篩選目標市場的工具，用以了解不同國家對您預計出口產品之吸引力，市場吸引力分析可回答以下問題：")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{style:({ height: '20px' })})]:_vm._e(),_vm._v(" "),(_vm.type !== 'normal')?[(!_vm.type)?_c('div',{staticClass:"tutorial-content-title"},[_vm._v("農業機械的市場吸引力")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"tutorial-content"},[_vm._v("農業機械的市場吸引力可提供做為市場篩選之工具，用以了解此市場對台灣出口產品之吸引力，市場吸引力分析可回答以下問題：")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{style:({ height: '20px' })})]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"tutorial-content"},[_vm._v("本平台市場吸引力分析可針對您選擇的產品與年份，在資料庫中快速彙整與計算市場吸引力評估指標，並依國家間市場吸引力高低顯示排序前20名國家於平台，此外市場吸引力工具還提供您可刪除與加權不同指標的功能，動態計算調整前20個對您選擇的產品最具吸引力的國家的排序。本分析功能也提供您針對分析結果進行繪圖，讓您可以自行選擇不同指標製作累計長條圖、散布圖、泡泡圖與雷達圖，產出更具策略涵意之分析結果。")]),_vm._v(" "),_c('div',{staticClass:"tutorial-content"},[_vm._v("如您想要了解特定國家，歷年市場吸引力指標變化趨勢，可點選國家名稱進入單一國家歷年市場吸引力分析結果，此處您也可以使用平台提供的繪圖功能，繪製出您有興趣的國家在不同年度的市場吸引力指標變化比較結果，輔助您掌握趨勢變化。")])],2)]:_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.renderItem['市場吸引力指標'])?_c('div',{staticClass:"tutorial-block col-block",attrs:{"id":"市場吸引力指標"}},[_c('div',{staticClass:"tutorial-title-container row-block",class:{ active: _vm.display['市場吸引力指標'] || _vm.display['市場吸引力指標'] === null, display: _vm.display['市場吸引力指標'] !== null },on:{"click":function (e) { return _vm.display['市場吸引力指標'] !== null && (_vm.display['市場吸引力指標'] = !_vm.display['市場吸引力指標']); }}},[_c('div',{staticClass:"tutorial-title"},[_vm._v("市場吸引力指標")]),_vm._v(" "),(_vm.display['市場吸引力指標'] !== null)?[_c('div',{style:({ width: '15px' })}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("yBtO"),"alt":""}})]:_vm._e(),_vm._v(" "),_c('div',{style:({ flex: 1 })})],2),_vm._v(" "),(_vm.display['市場吸引力指標'] || _vm.display['市場吸引力指標'] === null)?[_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"tutorial-content-container"},[_c('div',{staticClass:"tutorial-subcontent-container"},[_c('div',{staticClass:"tutorial-subtitle-continaer"},[_c('div',{staticClass:"tutorial-subtitle"},[_vm._v("農產品使用的吸引力指標")]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"tutorial-subcontent-block card row-block"},_vm._l((_vm.tutorialCards['農產品使用的吸引力指標']),function(card,index){return _c('div',{key:index,staticClass:"tutorial-card-container",style:({ width: _vm.toggle['農產品使用的吸引力指標'] === card.value ? '33.33333%' : '33.33333%' })},[(_vm.toggle['農產品使用的吸引力指標'] !== card.value)?_c('div',{staticClass:"tutorial-card-block row-block",on:{"click":function (e) { return _vm.toggleCard('農產品使用的吸引力指標', card.value); }}},[_c('div',{staticClass:"tutorial-card-title"},[_vm._v(_vm._s(card.title))]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("l9jg"),"alt":""}})]):_c('div',{staticClass:"tutorial-card-content-block col-block",on:{"click":function (e) { return _vm.toggleCard('農產品使用的吸引力指標', card.value); }}},[_c('div',{staticClass:"tutorial-card-content-title-container row-block"},[_c('div',{staticClass:"tutorial-card-content-title"},[_vm._v(_vm._s(card.title))]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("l9jg"),"alt":""}})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"tutorial-card-content-container",domProps:{"innerHTML":_vm._s(card.content)}})])])}),0)]),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"tutorial-subcontent-container"},[_c('div',{staticClass:"tutorial-subtitle-continaer"},[_c('div',{staticClass:"tutorial-subtitle"},[_vm._v("農業機械使用的吸引力指標")]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"tutorial-subcontent-block card row-block"},_vm._l((_vm.tutorialCards['農業機械使用的吸引力指標']),function(card,index){return _c('div',{key:index,staticClass:"tutorial-card-container",style:({ width: _vm.toggle['農業機械使用的吸引力指標'] === card.value ? '33.33333%' : '33.33333%' })},[(_vm.toggle['農業機械使用的吸引力指標'] !== card.value)?_c('div',{staticClass:"tutorial-card-block row-block",on:{"click":function (e) { return _vm.toggleCard('農業機械使用的吸引力指標', card.value); }}},[_c('div',{staticClass:"tutorial-card-title"},[_vm._v(_vm._s(card.title))]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("l9jg"),"alt":""}})]):_c('div',{staticClass:"tutorial-card-content-block col-block",on:{"click":function (e) { return _vm.toggleCard('農業機械使用的吸引力指標', card.value); }}},[_c('div',{staticClass:"tutorial-card-content-title-container row-block"},[_c('div',{staticClass:"tutorial-card-content-title"},[_vm._v(_vm._s(card.title))]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("l9jg"),"alt":""}})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"tutorial-card-content-container",domProps:{"innerHTML":_vm._s(card.content)}})])])}),0)])])]:_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.renderItem['市場吸引力操作教學說明'])?_c('div',{staticClass:"tutorial-block col-block",attrs:{"id":"市場吸引力操作教學說明"}},[_c('div',{staticClass:"tutorial-title-container row-block",class:{ active: _vm.display['市場吸引力操作教學說明'] || _vm.display['市場吸引力操作教學說明'] === null, display: _vm.display['市場吸引力操作教學說明'] !== null },on:{"click":function (e) { return _vm.display['市場吸引力操作教學說明'] !== null && (_vm.display['市場吸引力操作教學說明'] = !_vm.display['市場吸引力操作教學說明']); }}},[_c('div',{staticClass:"tutorial-title"},[_vm._v("市場吸引力操作教學說明")]),_vm._v(" "),(_vm.display['市場吸引力操作教學說明'] !== null)?[_c('div',{style:({ width: '15px' })}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("yBtO"),"alt":""}})]:_vm._e(),_vm._v(" "),_c('div',{style:({ flex: 1 })})],2),_vm._v(" "),(_vm.display['市場吸引力操作教學說明'] || _vm.display['市場吸引力操作教學說明'] === null)?[_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"tutorial-content-container"},[_c('div',{staticClass:"tutorial-subcontent-container"},[_c('div',{staticClass:"tutorial-subcontent-block img row-block"},[_c('div',{staticClass:"tutorial-img-container"},_vm._l((_vm.tutorialImgs['市場吸引力操作教學說明']),function(img,index){return _c('div',{key:index,staticClass:"tutorial-img-block row-block stretch"},[_c('div',{staticClass:"content-container",style:({ flex: 1 })},[_c('div',{staticClass:"content-title",domProps:{"innerHTML":_vm._s(img.title)}}),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),(img.description)?[_c('div',{staticClass:"content-description",domProps:{"innerHTML":_vm._s(img.description)}}),_vm._v(" "),_c('div',{style:({ height: '10px' })})]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"content-items col-block"},_vm._l((img.items),function(item,iindex){return _c('div',{key:iindex,staticClass:"content-item-block row-block"},[_c('div',{staticClass:"content-item-number center-block"},[_vm._v(_vm._s(iindex + 1))]),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('div',{staticClass:"content-item-contents col-block",style:({ flex: 1 })},_vm._l((item.contents),function(content,cindex){return _c('div',{key:cindex,staticClass:"content-item-content",domProps:{"innerHTML":_vm._s(content)}})}),0)])}),0)],2),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('div',{staticClass:"img-container",style:({ width: '745px' })},[_c('img',{attrs:{"src":img.img,"alt":""}})])])}),0)])])])]:_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.renderItem['市場競爭力分析'])?_c('div',{staticClass:"tutorial-block col-block",attrs:{"id":"市場競爭力分析"}},[_c('div',{staticClass:"tutorial-title-container row-block",class:{ active: _vm.display['市場競爭力分析'] || _vm.display['市場競爭力分析'] === null, display: _vm.display['市場競爭力分析'] !== null },on:{"click":function (e) { return _vm.display['市場競爭力分析'] !== null && (_vm.display['市場競爭力分析'] = !_vm.display['市場競爭力分析']); }}},[_c('div',{staticClass:"tutorial-title",domProps:{"innerHTML":_vm._s({
              normal: '農產品的市場競爭力',
              tool: '農業機械的市場競爭力'
            }[_vm.type] || '市場競爭力分析')}}),_vm._v(" "),(_vm.display['市場競爭力分析'] !== null)?[_c('div',{style:({ width: '15px' })}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("yBtO"),"alt":""}})]:_vm._e(),_vm._v(" "),_c('div',{style:({ flex: 1 })})],2),_vm._v(" "),(_vm.display['市場競爭力分析'])?[_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"tutorial-content-container block"},[(_vm.type !== 'tool')?[(!_vm.type)?_c('div',{staticClass:"tutorial-content-title"},[_vm._v("農產品的市場競爭力")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"tutorial-content"},[_vm._v("對農產品而言全球運銷越來越頻繁，各種運銷技術進步，多數蔬果包括亞熱帶或熱帶果品都已成為重要各國全球貿易商品，對我國而言，外銷目標市場競爭越來越競爭，因此事先評估進入後會遇到的競爭國家，並時刻關注競爭國家動態，十分的重要性。本平台市場競爭力分析，可使用數個不同指標評估，並讓使用者依專業看法組合指標，藉此評估進入產品進入您有興趣的市場後，與他國的競爭力差異。")]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{style:({ height: '20px' })})]:_vm._e(),_vm._v(" "),(_vm.type !== 'normal')?[(!_vm.type)?_c('div',{staticClass:"tutorial-content-title"},[_vm._v("農業機械的市場競爭力")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"tutorial-content"},[_vm._v("因勞力成本不斷上揚，且消費者越來越重視產品品質，開發中國家農產業也逐漸使用機械設備協助生產過程與採後處理作業，對我國而言，以開發中國家做為農業機械與設備外銷目標國，為重要策略。事先評估進入後會遇到的競爭國家，並時刻關注競爭國家動態，十分重要。本平台市場競爭力分析，可使用數個不同指標評估，並讓使用者依專業看法組合指標，藉此評估產品進入您有興趣的市場後，與他國的競爭力差異，本市場競爭力分析可針對某一目標市場，評估台灣與其他競爭國的競爭力現況。")]),_vm._v(" "),_c('div',{staticClass:"tutorial-lists"}),_vm._v(" "),_c('div',{style:({ height: '20px' })})]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"tutorial-content"},[_vm._v("本平台市場競爭力分析可針對您選擇的產品、目標市場國與年份，在資料庫中快速彙整與計算市場競爭力評估指標，並依目標市場國的進口值前5名的國家與我國顯示競爭力指標分數與排名(未加權狀態)，此外市場吸引力工具還提供您可刪除與加權不同指標的功能，動態計算調整該市場的5(6)個競爭國的競爭力排序。本分析功能也提供您針對分析結果進行繪圖，讓您可以自行選擇不同指標製作累計長條圖、散布圖、泡泡圖與雷達圖，產出更具策略涵意之分析結果。如您想要了解特定國家，歷年市場吸引力指標變化趨勢，可點選國家名稱進入單一國家歷年市場競爭力分析結果，此處您也可以使用平台提供的繪圖功能，繪製出您有興趣的國家在不同年度的市場競爭力指標變化比較結果，輔助您掌握趨勢變化。")])],2)]:_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.renderItem['市場競爭力指標'])?_c('div',{staticClass:"tutorial-block col-block",attrs:{"id":"市場競爭力指標"}},[_c('div',{staticClass:"tutorial-title-container row-block",class:{ active: _vm.display['市場競爭力指標'] || _vm.display['市場競爭力指標'] === null, display: _vm.display['市場競爭力指標'] !== null },on:{"click":function (e) { return _vm.display['市場競爭力指標'] !== null && (_vm.display['市場競爭力指標'] = !_vm.display['市場競爭力指標']); }}},[_c('div',{staticClass:"tutorial-title"},[_vm._v("市場競爭力指標")]),_vm._v(" "),(_vm.display['市場競爭力指標'] !== null)?[_c('div',{style:({ width: '15px' })}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("yBtO"),"alt":""}})]:_vm._e(),_vm._v(" "),_c('div',{style:({ flex: 1 })})],2),_vm._v(" "),(_vm.display['市場競爭力指標'] || _vm.display['市場競爭力指標'] === null)?[_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"tutorial-content-container"},[_c('div',{staticClass:"tutorial-subcontent-container"},[_c('div',{staticClass:"tutorial-subtitle-continaer"},[_c('div',{staticClass:"tutorial-subtitle"},[_vm._v("農產品使用的競爭力指標")]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"tutorial-subcontent-block card row-block"},_vm._l((_vm.tutorialCards['農產品使用的競爭力指標']),function(card,index){return _c('div',{key:index,staticClass:"tutorial-card-container",style:({ width: _vm.toggle['農產品使用的競爭力指標'] === card.value ? '33.33333%' : '33.33333%' })},[(_vm.toggle['農產品使用的競爭力指標'] !== card.value)?_c('div',{staticClass:"tutorial-card-block row-block",on:{"click":function (e) { return _vm.toggleCard('農產品使用的競爭力指標', card.value); }}},[_c('div',{staticClass:"tutorial-card-title"},[_vm._v(_vm._s(card.title))]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("l9jg"),"alt":""}})]):_c('div',{staticClass:"tutorial-card-content-block col-block",on:{"click":function (e) { return _vm.toggleCard('農產品使用的競爭力指標', card.value); }}},[_c('div',{staticClass:"tutorial-card-content-title-container row-block"},[_c('div',{staticClass:"tutorial-card-content-title"},[_vm._v(_vm._s(card.title))]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("l9jg"),"alt":""}})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"tutorial-card-content-container",domProps:{"innerHTML":_vm._s(card.content)}})])])}),0)]),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"tutorial-subcontent-container"},[_c('div',{staticClass:"tutorial-subtitle-continaer"},[_c('div',{staticClass:"tutorial-subtitle"},[_vm._v("農業機械使用的競爭力指標")]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"tutorial-subcontent-block card row-block"},_vm._l((_vm.tutorialCards['農業機械使用的競爭力指標']),function(card,index){return _c('div',{key:index,staticClass:"tutorial-card-container",style:({ width: _vm.toggle['農業機械使用的競爭力指標'] === card.value ? '33.33333%' : '33.33333%' })},[(_vm.toggle['農業機械使用的競爭力指標'] !== card.value)?_c('div',{staticClass:"tutorial-card-block row-block",on:{"click":function (e) { return _vm.toggleCard('農業機械使用的競爭力指標', card.value); }}},[_c('div',{staticClass:"tutorial-card-title"},[_vm._v(_vm._s(card.title))]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("l9jg"),"alt":""}})]):_c('div',{staticClass:"tutorial-card-content-block col-block",on:{"click":function (e) { return _vm.toggleCard('農業機械使用的競爭力指標', card.value); }}},[_c('div',{staticClass:"tutorial-card-content-title-container row-block"},[_c('div',{staticClass:"tutorial-card-content-title"},[_vm._v(_vm._s(card.title))]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("l9jg"),"alt":""}})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"tutorial-card-content-container",domProps:{"innerHTML":_vm._s(card.content)}})])])}),0)])])]:_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.renderItem['市場競爭力操作教學說明'])?_c('div',{staticClass:"tutorial-block col-block",attrs:{"id":"市場競爭力操作教學說明"}},[_c('div',{staticClass:"tutorial-title-container row-block",class:{ active: _vm.display['市場競爭力操作教學說明'] || _vm.display['市場競爭力操作教學說明'] === null, display: _vm.display['市場競爭力操作教學說明'] !== null },on:{"click":function (e) { return _vm.display['市場競爭力操作教學說明'] !== null && (_vm.display['市場競爭力操作教學說明'] = !_vm.display['市場競爭力操作教學說明']); }}},[_c('div',{staticClass:"tutorial-title"},[_vm._v("市場競爭力操作教學說明")]),_vm._v(" "),(_vm.display['市場競爭力操作教學說明'] !== null)?[_c('div',{style:({ width: '15px' })}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("yBtO"),"alt":""}})]:_vm._e(),_vm._v(" "),_c('div',{style:({ flex: 1 })})],2),_vm._v(" "),(_vm.display['市場競爭力操作教學說明'] || _vm.display['市場競爭力操作教學說明'] === null)?[_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"tutorial-content-container"},[_c('div',{staticClass:"tutorial-subcontent-container"},[_c('div',{staticClass:"tutorial-subcontent-block img row-block"},[_c('div',{staticClass:"tutorial-img-container"},_vm._l((_vm.tutorialImgs['市場競爭力操作教學說明']),function(img,index){return _c('div',{key:index,staticClass:"tutorial-img-block row-block stretch"},[_c('div',{staticClass:"content-container",style:({ flex: 1 })},[_c('div',{staticClass:"content-title",domProps:{"innerHTML":_vm._s(img.title)}}),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),(img.description)?[_c('div',{staticClass:"content-description",domProps:{"innerHTML":_vm._s(img.description)}}),_vm._v(" "),_c('div',{style:({ height: '10px' })})]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"content-items col-block"},_vm._l((img.items),function(item,iindex){return _c('div',{key:iindex,staticClass:"content-item-block row-block"},[_c('div',{staticClass:"content-item-number center-block"},[_vm._v(_vm._s(iindex + 1))]),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('div',{staticClass:"content-item-contents col-block",style:({ flex: 1 })},_vm._l((item.contents),function(content,cindex){return _c('div',{key:cindex,staticClass:"content-item-content",domProps:{"innerHTML":_vm._s(content)}})}),0)])}),0)],2),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('div',{staticClass:"img-container",style:({ width: '745px' })},[_c('img',{attrs:{"src":img.img,"alt":""}})])])}),0)])])])]:_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.renderItem['零售價格分析與指標'])?_c('div',{staticClass:"tutorial-block col-block",attrs:{"id":"零售價格分析與指標"}},[_c('div',{staticClass:"tutorial-title-container row-block",class:{ active: _vm.display['零售價格分析與指標'] || _vm.display['零售價格分析與指標'] === null, display: _vm.display['零售價格分析與指標'] !== null },on:{"click":function (e) { return _vm.display['零售價格分析與指標'] !== null && (_vm.display['零售價格分析與指標'] = !_vm.display['零售價格分析與指標']); }}},[_c('div',{staticClass:"tutorial-title"},[_vm._v("零售價格分析與指標")]),_vm._v(" "),(_vm.display['零售價格分析與指標'] !== null)?[_c('div',{style:({ width: '15px' })}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("yBtO"),"alt":""}})]:_vm._e(),_vm._v(" "),_c('div',{style:({ flex: 1 })})],2),_vm._v(" "),(_vm.display['零售價格分析與指標'])?[_c('div',{style:({ height: '10px' })}),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"tutorial-content-container"},[_c('div',{staticClass:"tutorial-subcontent-container"},[_c('div',{staticClass:"tutorial-subcontent-block card row-block"},_vm._l((_vm.tutorialCards['零售價格分析與指標']),function(card,index){return _c('div',{key:index,staticClass:"tutorial-card-container",style:({ width: _vm.toggle['零售價格分析與指標'] === card.value ? '33.33333%' : '33.33333%' })},[(_vm.toggle['零售價格分析與指標'] !== card.value)?_c('div',{staticClass:"tutorial-card-block row-block",on:{"click":function (e) { return _vm.toggleCard('零售價格分析與指標', card.value); }}},[_c('div',{staticClass:"tutorial-card-title"},[_vm._v(_vm._s(card.title))]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("l9jg"),"alt":""}})]):_c('div',{staticClass:"tutorial-card-content-block col-block",on:{"click":function (e) { return _vm.toggleCard('零售價格分析與指標', card.value); }}},[_c('div',{staticClass:"tutorial-card-content-title-container row-block"},[_c('div',{staticClass:"tutorial-card-content-title"},[_vm._v(_vm._s(card.title))]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("l9jg"),"alt":""}})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"tutorial-card-content-container",domProps:{"innerHTML":_vm._s(card.content)}})])])}),0)])])]:_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.renderItem['零售價格分析操作教學說明'])?_c('div',{staticClass:"tutorial-block col-block",attrs:{"id":"零售價格分析操作教學說明"}},[_c('div',{staticClass:"tutorial-title-container row-block",class:{ active: _vm.display['零售價格分析操作教學說明'] || _vm.display['零售價格分析操作教學說明'] === null, display: _vm.display['零售價格分析操作教學說明'] !== null },on:{"click":function (e) { return _vm.display['零售價格分析操作教學說明'] !== null && (_vm.display['零售價格分析操作教學說明'] = !_vm.display['零售價格分析操作教學說明']); }}},[_c('div',{staticClass:"tutorial-title"},[_vm._v("零售價格分析操作教學說明")]),_vm._v(" "),(_vm.display['零售價格分析操作教學說明'] !== null)?[_c('div',{style:({ width: '15px' })}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("yBtO"),"alt":""}})]:_vm._e(),_vm._v(" "),_c('div',{style:({ flex: 1 })})],2),_vm._v(" "),(_vm.display['零售價格分析操作教學說明'] || _vm.display['零售價格分析操作教學說明'] === null)?[_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"tutorial-content-container"},[_c('div',{staticClass:"tutorial-subcontent-container"},[_c('div',{staticClass:"tutorial-subcontent-block img row-block"},[_c('div',{staticClass:"tutorial-img-container"},_vm._l((_vm.tutorialImgs['零售價格分析操作教學說明']),function(img,index){return _c('div',{key:index,staticClass:"tutorial-img-block row-block stretch"},[_c('div',{staticClass:"content-container",style:({ flex: 1 })},[_c('div',{staticClass:"content-title",domProps:{"innerHTML":_vm._s(img.title)}}),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),(img.description)?[_c('div',{staticClass:"content-description",domProps:{"innerHTML":_vm._s(img.description)}}),_vm._v(" "),_c('div',{style:({ height: '10px' })})]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"content-items col-block"},_vm._l((img.items),function(item,iindex){return _c('div',{key:iindex,staticClass:"content-item-block row-block"},[_c('div',{staticClass:"content-item-number center-block"},[_vm._v(_vm._s(iindex + 1))]),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('div',{staticClass:"content-item-contents col-block",style:({ flex: 1 })},_vm._l((item.contents),function(content,cindex){return _c('div',{key:cindex,staticClass:"content-item-content",domProps:{"innerHTML":_vm._s(content)}})}),0)])}),0)],2),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('div',{staticClass:"img-container",style:({ width: '745px' })},[_c('img',{attrs:{"src":img.img,"alt":""}})])])}),0)])])])]:_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.renderItem['分析報告與操作說明'])?_c('div',{staticClass:"tutorial-block col-block",attrs:{"id":"分析報告與操作說明"}},[_c('div',{staticClass:"tutorial-title-container row-block",class:{ active: _vm.display['分析報告與操作說明'] || _vm.display['分析報告與操作說明'] === null, display: _vm.display['分析報告與操作說明'] !== null },on:{"click":function (e) { return _vm.display['分析報告與操作說明'] !== null && (_vm.display['分析報告與操作說明'] = !_vm.display['分析報告與操作說明']); }}},[_c('div',{staticClass:"tutorial-title"},[_vm._v("分析報告與操作說明")]),_vm._v(" "),(_vm.display['分析報告與操作說明'] !== null)?[_c('div',{style:({ width: '15px' })}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("yBtO"),"alt":""}})]:_vm._e(),_vm._v(" "),_c('div',{style:({ flex: 1 })})],2),_vm._v(" "),(_vm.display['分析報告與操作說明'])?[_c('div',{style:({ height: '10px' })}),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"tutorial-content-container"},[_c('div',{staticClass:"tutorial-subcontent-container"},[_c('div',{staticClass:"tutorial-subcontent-block img row-block"},[_c('div',{staticClass:"tutorial-img-container"},_vm._l((_vm.tutorialImgs['分析報告與操作說明']),function(img,index){return _c('div',{key:index,staticClass:"tutorial-img-block row-block stretch"},[_c('div',{staticClass:"content-container",style:({ flex: 1 })},[_c('div',{staticClass:"content-title",domProps:{"innerHTML":_vm._s(img.title)}}),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),(img.description)?[_c('div',{staticClass:"content-description",domProps:{"innerHTML":_vm._s(img.description)}}),_vm._v(" "),_c('div',{style:({ height: '10px' })})]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"content-items col-block"},_vm._l((img.items),function(item,iindex){return _c('div',{key:iindex,staticClass:"content-item-block row-block"},[_c('div',{staticClass:"content-item-number center-block"},[_vm._v(_vm._s(iindex + 1))]),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('div',{staticClass:"content-item-contents col-block",style:({ flex: 1 })},_vm._l((item.contents),function(content,cindex){return _c('div',{key:cindex,staticClass:"content-item-content",domProps:{"innerHTML":_vm._s(content)}})}),0)])}),0)],2),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('div',{staticClass:"img-container",style:({ width: '745px' })},[_c('img',{attrs:{"src":img.img,"alt":""}})])])}),0)])])])]:_vm._e()],2):_vm._e(),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ width: '30px' })}),_vm._v(" "),_c('div',{staticClass:"img-container col-block",style:({ opacity: 0 })},[_c('div',{style:({ height: '30px' })}),_vm._v(" "),_c('div',{style:({ width: '250px' })}),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]):_vm._e()])}
var tutorial_main_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tutorial-content-container"},[_c('div',{staticClass:"tutorial-content"},[_vm._v("因技術與市場開放影響下，各國對於水果的進口需求增加，蔬果成為全球化商業運銷系統中的重要商品，此外，我國農業機械也逐漸於國際市場中展現實力，而要能具有外銷競爭力且能持續經營，出口者要同時擁有穩定品質、價格與數量的產品供應能力，並且要能敏銳掌握目標市場需求變化並隨之調整，因此對於不是全球運籌跨國企業的貿易商與小農生產結構的國家而言，要成功進入國際市場並能於重重挑戰中勝出，並不是一件容易的事情，需要花費時間整合與推動供應鏈密切合作，也要花費時間蒐集與整理各種市場資料，因此提供給產業與專家，能快速掌握市場的分析工具十分重要。此平台的目標為快速彙整與計算評估指標，提供產業與專家團隊，分析比較結果圖表與市場報告，輔助團隊快速掌握目標市場概況並能從平台隨時掌握市場變化趨勢，讓使用者在綜合資訊輔助下，了解您最有機會獲利的目標市場。本平台目前提供的工具有：市場吸引力分析工具、市場競爭力分析工具、零售價格分析工具與分析報告瀏覽功能。")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tutorial-lists"},[_c('div',{staticClass:"list"},[_c('b',[_vm._v("1. 消費者是否具備消費能力？")])]),_vm._v(" "),_c('div',{staticClass:"list-content"},[_vm._v("人均國內生產總值，表示消費能力越佳，則市場吸引力越大。")]),_vm._v(" "),_c('div',{staticClass:"list"},[_c('b',[_vm._v("2. 市場的規模大小？")])]),_vm._v(" "),_c('div',{staticClass:"list-content"},[_vm._v("人口數越多、產品市場規模越大、產品進口值越高、產品市場占有率越高，則市場吸引力越大。")]),_vm._v(" "),_c('div',{staticClass:"list"},[_c('b',[_vm._v("3. 市場是否已經為飽和市場？ 是否還有成長空間？")])]),_vm._v(" "),_c('div',{staticClass:"list-content"},[_vm._v("進口市場成長趨勢、進口市場表現、市場相對成長強度越大，則市場吸引力越大。")]),_vm._v(" "),_c('div',{staticClass:"list"},[_c('b',[_vm._v("4. 市場是否能為業者帶來利潤？")])]),_vm._v(" "),_c('div',{staticClass:"list-content"},[_vm._v("市場開放程度以關稅評估，關稅越低則市場吸引力越大，市場相對優惠關稅為前五大進口國關稅平均與台灣關稅差異，市場相對優惠關稅數值越大則市場吸引力越大。")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tutorial-lists"},[_c('div',{staticClass:"list"},[_c('b',[_vm._v("1. 消費水準與經濟發展程度?")])]),_vm._v(" "),_c('div',{staticClass:"list-content"},[_vm._v("人均國內生產總值與本地居民總收入越高，表示市場吸引力越大。")]),_vm._v(" "),_c('div',{staticClass:"list"},[_c('b',[_vm._v("2. 市場的規模大小？")])]),_vm._v(" "),_c('div',{staticClass:"list-content"},[_vm._v("出口值、農業人口比率越低則市場吸引力越大，耕地面積、平均農業人口耕地面積、進口值、佔全球市場佔有率越高則市場吸引力越大。")]),_vm._v(" "),_c('div',{staticClass:"list"},[_c('b',[_vm._v("3. 市場是否已經為飽和市場？是否還有成長空間？")])]),_vm._v(" "),_c('div',{staticClass:"list-content"},[_vm._v("進口市場成長趨勢、農業人口比率趨勢、進口市場表現、市場相對成長強度越大則吸引力越大。")]),_vm._v(" "),_c('div',{staticClass:"list"},[_c('b',[_vm._v("4. 市場是否能為業者帶來利潤？")])]),_vm._v(" "),_c('div',{staticClass:"list-content"},[_vm._v("市場開放程度以關稅評估，關稅越低則市場吸引力越大，市場相對優惠關稅為前五大進口國關稅平均與台灣關稅差異，市場相對優惠關稅數值越大則市場吸引力越大。")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tutorial-lists"},[_c('div',{staticClass:"list"},[_c('b',[_vm._v("1. 產量與單位面積產量：")]),_vm._v("穩定且大量的生產量是評估競爭力的重要指標項目，而單位面積產量越高代表生產技術較成熟具優勢。")]),_vm._v(" "),_c('div',{staticClass:"list"},[_c('b',[_vm._v("2. 生產者價格、進口單價與市場距離：")]),_vm._v("生產者價格若越低代表生產成本越低，生產成本越低的產品越有競爭優勢，進口單價亦是，此外因生鮮蔬果長途運輸不易，因此進出口國家距離近，較具競爭優勢。")]),_vm._v(" "),_c('div',{staticClass:"list"},[_c('b',[_vm._v("3. 貿易密集度(TII)與顯示性比較利益指數(RCA)：")]),_vm._v("貿易密集度主要是評估競爭國與目標市場國間貿易關係強弱，若數值越高則代表該競爭國與目標市場的貿易關係密切，越具備市場競爭力；顯示性比較利益指數則用以了解出口強度，若數值越高則代表競爭國出口強度高於世界平均，越具備市場競爭力。")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tutorial-content-container block"},[_c('div',{staticClass:"tutorial-content"},[_vm._v("零售價格分析模組，可比較不同通路型態、國家、產品形式之產品售價差異，讓使用者可評估產品定位，此外，使用者可從產品照片了解產品包裝方式、陳列以及產品外觀，藉以評估產品市場定位。")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tutorial-content-container block"},[_c('div',{staticClass:"tutorial-content"},[_vm._v("時刻掌握想要進入或已經在經營的海外市場環境變化，再進一步評估此變化對事業的影響程度並隨之調整事業方向，對能長期獲利有正面幫助。環境變化包括:消費者與市場偏好、競爭對手動態等，此分析平台可提供報告，讓您可於市場吸引力與市場競爭力分析時使用。")])])}]
var tutorial_main_esExports = { render: tutorial_main_render, staticRenderFns: tutorial_main_staticRenderFns }
/* harmony default export */ var components_tutorial_main = (tutorial_main_esExports);
// CONCATENATED MODULE: ./src/components/tutorial/main.vue
var tutorial_main_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tutorial_main___vue_template_functional__ = false
/* styles */
var tutorial_main___vue_styles__ = null
/* scopeId */
var tutorial_main___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tutorial_main___vue_module_identifier__ = null
var tutorial_main_Component = tutorial_main_normalizeComponent(
  tutorial_main,
  components_tutorial_main,
  tutorial_main___vue_template_functional__,
  tutorial_main___vue_styles__,
  tutorial_main___vue_scopeId__,
  tutorial_main___vue_module_identifier__
)

/* harmony default export */ var src_components_tutorial_main = (tutorial_main_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/main/tutorial.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tutorial = ({
  components: {
    tutorialMain: src_components_tutorial_main
  },
  props: {
    minHeight: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      scrollToID: null
    };
  },

  methods: {
    scrollTo: function scrollTo(id) {
      this.scrollToID = id;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-686ed5b0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/main/tutorial.vue
var tutorial_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tutorial-page row-block default-shadow",style:({ minHeight: _vm.minHeight })},[_c('div',{staticClass:"menu-container",style:({ width: '250px' })},[_c('div',{staticClass:"tutorial-menu-page col-block default-shadow",style:({ height: _vm.minHeight })},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"main-container",style:({ flex: 1 })},[_c('ul',{staticClass:"custom"},[_c('li',[_c('span',{on:{"click":function (e) { return _vm.scrollTo('農產業貿易潛力分析平台'); }}},[_vm._v("本平台介紹")]),_vm._v(" "),_c('ul',{staticClass:"custom"},[_c('li',[_c('span',{on:{"click":function (e) { return _vm.scrollTo('市場吸引力分析'); }}},[_vm._v("市場吸引力")]),_vm._v(" "),_c('ul',{staticClass:"custom"},[_c('li',[_c('span',{on:{"click":function (e) { return _vm.scrollTo('市場吸引力指標'); }}},[_vm._v("市場吸引力指標")])]),_vm._v(" "),_c('li',[_c('span',{on:{"click":function (e) { return _vm.scrollTo('市場吸引力操作教學說明'); }}},[_vm._v("市場吸引力操作教學說明")])])])])]),_vm._v(" "),_c('ul',{staticClass:"custom"},[_c('li',[_c('span',{on:{"click":function (e) { return _vm.scrollTo('市場競爭力分析'); }}},[_vm._v("市場競爭力")]),_vm._v(" "),_c('ul',{staticClass:"custom"},[_c('li',[_c('span',{on:{"click":function (e) { return _vm.scrollTo('市場競爭力指標'); }}},[_vm._v("市場競爭力指標")])]),_vm._v(" "),_c('li',[_c('span',{on:{"click":function (e) { return _vm.scrollTo('市場競爭力操作教學說明'); }}},[_vm._v("市場競爭力操作教學說明")])])])])]),_vm._v(" "),_c('ul',{staticClass:"custom"},[_c('li',[_c('span',{on:{"click":function (e) { return _vm.scrollTo('零售價格分析與指標'); }}},[_vm._v("零售價格分析與指標")]),_vm._v(" "),_c('ul',{staticClass:"custom"},[_c('li',[_c('span',{on:{"click":function (e) { return _vm.scrollTo('零售價格分析操作教學說明'); }}},[_vm._v("零售價格分析操作說明")])])])])]),_vm._v(" "),_c('ul',{staticClass:"custom"},[_c('li',[_c('span',{on:{"click":function (e) { return _vm.scrollTo('分析報告與操作說明'); }}},[_vm._v("分析報告與操作說明")])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"main-container",style:({ flex: 1, height: _vm.minHeight })},[_c('div',{staticClass:"main-block col-block",style:({ height: '100%', width: '100%', 'min-width': '1350px' })},[_c('div',{staticClass:"title-container row-block"},[_c('div',{staticClass:"title"},[_vm._v("介紹與教學")]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',[_c('div',{style:({ height: '10px' })})]),_vm._v(" "),_c('tutorialMain',{attrs:{"scrollToID":_vm.scrollToID}})],1)])])}
var tutorial_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-container center-block"},[_c('div',{staticClass:"title"},[_vm._v("介紹與教學")])])}]
var tutorial_esExports = { render: tutorial_render, staticRenderFns: tutorial_staticRenderFns }
/* harmony default export */ var main_tutorial = (tutorial_esExports);
// CONCATENATED MODULE: ./src/pages/main/tutorial.vue
var tutorial_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tutorial___vue_template_functional__ = false
/* styles */
var tutorial___vue_styles__ = null
/* scopeId */
var tutorial___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tutorial___vue_module_identifier__ = null
var tutorial_Component = tutorial_normalizeComponent(
  tutorial,
  main_tutorial,
  tutorial___vue_template_functional__,
  tutorial___vue_styles__,
  tutorial___vue_scopeId__,
  tutorial___vue_module_identifier__
)

/* harmony default export */ var pages_main_tutorial = (tutorial_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/mixins/userPermission.vue




/* harmony default export */ var userPermission = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['user'])),
  methods: {
    rolePermission: function rolePermission(roles) {
      return roles.includes((this.user || {}).role);
    }
  }
});
// CONCATENATED MODULE: ./src/mixins/userPermission.vue
var userPermission_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var userPermission___vue_template__ = null
/* template functional */
var userPermission___vue_template_functional__ = false
/* styles */
var userPermission___vue_styles__ = null
/* scopeId */
var userPermission___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var userPermission___vue_module_identifier__ = null
var userPermission_Component = userPermission_normalizeComponent(
  userPermission,
  userPermission___vue_template__,
  userPermission___vue_template_functional__,
  userPermission___vue_styles__,
  userPermission___vue_scopeId__,
  userPermission___vue_module_identifier__
)

/* harmony default export */ var mixins_userPermission = (userPermission_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/productPrice/filter.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var productPrice_filter = ({
  components: {
    customFilter: components_tool_customFilter
  },
  mixins: [mixins_userPermission],
  props: {
    minHeight: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    filters: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      init: {},
      conditions: {
        filters: {}
      }
    };
  },
  created: function created() {
    this.init = this.filters.init || {};
  },

  watch: {
    'filters.init': function filtersInit(nv, ov) {
      if (stringify_default()(nv) !== stringify_default()(ov)) {
        this.init = this.filters.init || this.init;
      }
    },
    'conditions.filters': function conditionsFilters(nv, ov) {
      if (nv.kind !== ov.kind) {
        this.init = extends_default()({}, this.init, this.conditions.filters, {
          crop_name: ''
        });
      }
    }
  },
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setModalAction']), {
    filtersOnChange: function filtersOnChange(conditions) {
      var init = false;
      this.conditions.filters = conditions;
      if (init) {
        this.updateFilter();
      }
    },
    updateFilter: function updateFilter() {
      this.$emit('changeFilters', JSON.parse(stringify_default()(this.conditions.filters)));
    },
    createProductPrice: function createProductPrice() {
      var _this = this;

      this.setModalAction({
        action: 'editProductPrice',
        width: '900px',
        customStyles: {
          padding: '0px',
          margin: '20px auto',
          borderRadius: '0'
        },
        param: {
          title: '新增零售價格資料',
          editable: true
        },
        callback: function () {
          var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(result) {
            return regenerator_default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    if (result) {
                      _this.$emit('updateList');
                    }

                  case 1:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, _this);
          }));

          return function callback(_x) {
            return _ref.apply(this, arguments);
          };
        }()
      });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-96947b3a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/productPrice/filter.vue
var productPrice_filter_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-price-filter-page col-block default-shadow",style:({ height: _vm.minHeight })},[(_vm.disabled)?_c('div',{staticClass:"mask"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"title-container center-block"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"filter-container"},[_c('customFilter',{attrs:{"init":_vm.init,"filters":_vm.filters.options},on:{"change":function (conditions) { return _vm.filtersOnChange(conditions); },"pressEnter":function () { return _vm.updateFilter(); }}}),_vm._v(" "),_c('div',{staticClass:"button"},[_c('button',{staticClass:"main-button",attrs:{"type":"button","name":"button"},on:{"click":function (e) { return _vm.updateFilter(); }}},[_c('span',[_vm._v("搜尋")])])])],1),_vm._v(" "),(_vm.rolePermission(['advance', 'admin']))?[_c('hr'),_vm._v(" "),_c('div',{staticClass:"other-container col-block",style:({ flex: 1 })},[_c('div',{staticClass:"other-title"},[_vm._v("零售價格資料上傳")]),_vm._v(" "),_c('div',{style:({ height: '15px' })}),_vm._v(" "),_c('div',{staticClass:"button"},[_c('button',{staticClass:"main-button",attrs:{"type":"button","name":"button"},on:{"click":function (e) { return _vm.createProductPrice(); }}},[_c('span',[_vm._v("新增")])])]),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"other-info"},[_vm._v("您可點選右側分頁查看上傳紀錄。")]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]:_c('div',{style:({ flex: 1 })})],2)}
var productPrice_filter_staticRenderFns = []
var productPrice_filter_esExports = { render: productPrice_filter_render, staticRenderFns: productPrice_filter_staticRenderFns }
/* harmony default export */ var components_productPrice_filter = (productPrice_filter_esExports);
// CONCATENATED MODULE: ./src/components/productPrice/filter.vue
var productPrice_filter_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var productPrice_filter___vue_template_functional__ = false
/* styles */
var productPrice_filter___vue_styles__ = null
/* scopeId */
var productPrice_filter___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var productPrice_filter___vue_module_identifier__ = null
var productPrice_filter_Component = productPrice_filter_normalizeComponent(
  productPrice_filter,
  components_productPrice_filter,
  productPrice_filter___vue_template_functional__,
  productPrice_filter___vue_styles__,
  productPrice_filter___vue_scopeId__,
  productPrice_filter___vue_module_identifier__
)

/* harmony default export */ var src_components_productPrice_filter = (productPrice_filter_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/productPrice/table.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var table = ({
  components: {
    pageButtons: components_tool_pageButtons
  },
  mixins: [mixins_routeLoading],
  props: {
    update: {
      type: Number,
      required: true
    }
  },
  data: function data() {
    return {
      records: [],
      status: {},
      pageData: {
        selectedPage: 1,
        display: 12,
        total: null,
        buttonRange: 7
      },
      sort: {
        value: [],
        order: []
      },
      onSearch: false
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['countrys']), {
    kindOptions: function kindOptions() {
      return [{ title: '蔬菜', value: 'vegetable' }, { title: '水果', value: 'fruit' }];
    },
    packingMethodOptions: function packingMethodOptions() {
      return [{ title: '散裝', value: 'bulk', style: { color: '#EF6577' } }, { title: '有包裝', value: 'packed', style: { color: '#3967A6' } }, { title: '截切', value: 'cut', style: { color: '#3967A6' } }];
    },
    marketKindOptions: function marketKindOptions() {
      return [{ title: '傳統市場', value: 'traditional_market' }, { title: '批發市場', value: 'wholesale_market' }, { title: '超市', value: 'supermarket' }, { title: '量販店', value: 'hyper_market' }, { title: '便利商店', value: 'convenience_store' }, { title: '蔬果專賣店', value: 'vegetable_and_fruit_store' }, { title: '農夫(假日)市集', value: 'farmers_market' }];
    },
    countryOptions: function countryOptions() {
      return this.countrys.map(function (_ref) {
        var _ref2 = slicedToArray_default()(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        return {
          title: value.chinese_name + '(' + value.iso_name + ')',
          value: key
        };
      });
    },

    // static
    tableOptions: function tableOptions() {
      var _this = this;

      return [{
        title: '',
        value: '_CHECK',
        width: '30px',
        class: ['center-block'],
        sort: false
      }, {
        title: '拍攝日期',
        value: 'date',
        width: '120px',
        display: function display(value) {
          return value ? Object(util["b" /* dateFormat */])(new Date(value), 'yyyy/MM/dd') : '';
        }
      }, {
        title: '產品類別',
        value: 'kind',
        width: '100px',
        display: function display(value) {
          return (_this.kindOptions.find(function (option) {
            return option.value === value;
          }) || {}).title;
        }
      }, {
        title: '作物(產品)',
        value: 'crop_name',
        width: '220px'
      }, {
        title: '產地(國家)',
        value: 'country',
        width: '150px',
        display: function display(value) {
          return (_this.countryOptions.find(function (option) {
            return option.value === value;
          }) || {}).title || '無';
        }
      }, {
        title: '包裝方式',
        value: 'packing_method',
        width: '100px',
        display: function display(value) {
          return (_this.packingMethodOptions.find(function (option) {
            return option.value === value;
          }) || {}).title;
        }
      }, {
        title: '價格',
        value: 'price',
        width: '100px'
      }, {
        title: '貨幣單位',
        value: 'currency_name',
        width: '100px'
      }, {
        title: '市場所在國家',
        value: 'market_country',
        width: '150px',
        display: function display(value) {
          return (_this.countryOptions.find(function (option) {
            return option.value === value;
          }) || {}).title;
        }
      }, {
        title: '市場類型',
        value: 'market_kind',
        width: '150px',
        display: function display(value) {
          return (_this.marketKindOptions.find(function (option) {
            return option.value === value;
          }) || {}).title;
        }
      }, {
        title: '管理',
        value: '_OPTIONS',
        class: ['center-block'],
        sort: false
      }];
    }
  }),
  watch: {
    'update': function update(nv, ov) {
      if (nv > ov) {
        this.fetchRecords();
      }
    }
  },
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setModalAction']), {
    fetchData: function fetchData() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.fetchRecords();

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    fetchRecords: function fetchRecords() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var config, data, response, records;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                config = _this3.$ls.get('userInfo');
                data = {};

                _this3.pageData.selectedPage && (data.page = _this3.pageData.selectedPage);
                _this3.pageData.display && (data.item_per_page = _this3.pageData.display);
                _this3.sort.value[0] && (data.order_by = _this3.sort.value[0]);
                _this3.sort.order[0] && (data.order_method = _this3.sort.order[0].replace(/^-/, ''));
                _context2.next = 9;
                return Object(src_api["x" /* getProductPrices */])(data, config);

              case 9:
                response = _context2.sent;
                records = response.data.data.elements;

                _this3.pageData.total = response.data.data.items_count;
                _this3.status = response.data.data.review_statuses;
                _this3.records = records;
                _context2.next = 19;
                break;

              case 16:
                _context2.prev = 16;
                _context2.t0 = _context2['catch'](0);
                throw _context2.t0;

              case 19:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[0, 16]]);
      }))();
    },
    searchDatas: function searchDatas() {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this4.onSearch = true;
                _context3.next = 3;
                return _this4.fetchRecords();

              case 3:
                _this4.onSearch = false;

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    detailProductPrice: function detailProductPrice(record) {
      this.setModalAction({
        action: 'editProductPrice',
        width: '900px',
        customStyles: {
          padding: '0px',
          margin: '20px auto',
          borderRadius: '0'
        },
        param: {
          title: '查看零售價格資料',
          data: record,
          image: true,
          editable: false
        }
      });
    },
    tableSortBy: function tableSortBy(value) {
      var position = this.sort.value.indexOf(value);
      if (position === 0) {
        var order = this.sort.order[position] === '-asc' ? '-desc' : '-asc';
        this.sort.order.splice(position, 1);
        this.sort.order.unshift(order);
      } else {
        var _order = position !== -1 ? this.sort.order[position] === '-asc' ? '-desc' : '-asc' : undefined;
        position = position !== -1 ? position : 0;
        this.sort.value.splice(position, 1);
        this.sort.order.splice(position, 1);
        this.sort.value.unshift(value);
        this.sort.order.unshift(_order || '-asc');
      }
      this.searchDatas();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5680fcf6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/productPrice/table.vue
var table_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-price-table-page col-block"},[_c('div',{staticClass:"info-container row-block",style:({ height: '40px' })},[_c('div',{staticClass:"info-title",domProps:{"innerHTML":_vm._s('您已上傳 <b>' + this.pageData.total + '筆</b> 資料，<b>' + this.status.passed + '筆</b> 已通過管理員審核後收入資料庫，<b>' + this.status.failed + '筆</b> 未通過審核，<b>' + this.status.not_reviewed + '筆</b> 待審核。若有任何疑問請與管理員聯絡。')}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{staticClass:"table-main-container row-block",style:({ flex: 1 })},[(_vm.onSearch)?_c('div',{staticClass:"mask center-block"},[_c('img',{attrs:{"src":__webpack_require__("5xS/"),"alt":""}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"table-main-block col-block",style:({ height: '100%', width: '100%' })},[_c('div',{staticClass:"table-feild col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-container col-block",style:({ height: '50px' })},[_c('div',{staticClass:"thead default-shadow"},[_c('div',{staticClass:"tr row-block"},_vm._l((_vm.tableOptions),function(option,index){return _c('div',{key:index,staticClass:"th",class:option.class || ['row-block'],style:(option.width ? { width: option.width } : { flex: 1 }),on:{"click":function (e) { return option.sort !== false && _vm.tableSortBy(option.value); }}},[_c('span',[_vm._v(_vm._s(option.title))]),_vm._v(" "),(option.sort !== false)?[_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('i',{class:['fa', 'fa-sort' + (_vm.sort.order[_vm.sort.value.indexOf(option.value)] || '')],attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})]:_vm._e()],2)}),0)])]),_vm._v(" "),_c('div',{staticClass:"table-container col-block sub-shadow",style:({ flex: 1 })},[_c('div',{staticClass:"tbody",style:({ flex: 1 })},[_c('div',{style:({ height: 0 })},_vm._l((_vm.records),function(record,cindex){return _c('div',{key:cindex,staticClass:"tr row-block"},[_c('div',{staticClass:"container-block row-block"},_vm._l((_vm.tableOptions),function(option,index){return _c('div',{key:index,staticClass:"td",class:option.class || ['row-block'],style:(option.width ? { width: option.width } : { flex: 1 })},[(option.value === '_CHECK')?_c('div',[_c('div',{staticClass:"check center-block"},[(record.review_status === 'passed')?_c('img',{attrs:{"src":__webpack_require__("rlvA"),"alt":""}}):(record.review_status === 'failed')?_c('img',{attrs:{"src":__webpack_require__("XTQ4"),"alt":""}}):(record.review_status === 'not_reviewed')?_c('div'):_vm._e()])]):(option.value === '_OPTIONS')?_c('div',[_c('div',{staticClass:"option row-block"},[_c('button',{staticClass:"main-button option-button",attrs:{"type":"button","name":"button"},on:{"click":function (e) { return _vm.detailProductPrice(record); }}},[_c('span',[_vm._v("查看")])])])]):_c('span',{style:((option.style || (function () {}))(record[option.value])),attrs:{"title":(option.display || (function (x) { return x; }))(record[option.value], cindex)}},[_vm._v(_vm._s((option.display || (function (x) { return x; }))(record[option.value], cindex) || '--'))])])}),0)])}),0)])]),_vm._v(" "),_c('div',{staticClass:"page-container center-block"},[(_vm.pageData.total)?_c('pageButtons',{attrs:{"default":_vm.pageData.selectedPage,"display":_vm.pageData.display,"total":_vm.pageData.total,"buttonRange":_vm.pageData.buttonRange},on:{"selectPage":function (page) { _vm.pageData.selectedPage = page; _vm.searchDatas() }}}):_vm._e()],1)])])])])}
var table_staticRenderFns = []
var table_esExports = { render: table_render, staticRenderFns: table_staticRenderFns }
/* harmony default export */ var productPrice_table = (table_esExports);
// CONCATENATED MODULE: ./src/components/productPrice/table.vue
var table_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var table___vue_template_functional__ = false
/* styles */
var table___vue_styles__ = null
/* scopeId */
var table___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var table___vue_module_identifier__ = null
var table_Component = table_normalizeComponent(
  table,
  productPrice_table,
  table___vue_template_functional__,
  table___vue_styles__,
  table___vue_scopeId__,
  table___vue_module_identifier__
)

/* harmony default export */ var components_productPrice_table = (table_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/values.js
var values = __webpack_require__("gRE1");
var values_default = /*#__PURE__*/__webpack_require__.n(values);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/define-properties.js
var define_properties = __webpack_require__("HSQo");
var define_properties_default = /*#__PURE__*/__webpack_require__.n(define_properties);

// EXTERNAL MODULE: ./node_modules/echarts/lib/echarts.js
var echarts = __webpack_require__("Icdr");
var echarts_default = /*#__PURE__*/__webpack_require__.n(echarts);

// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__("O4Lo");
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);

// EXTERNAL MODULE: ./node_modules/resize-detector/esm/index.js
var esm = __webpack_require__("472O");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-echarts/components/ECharts.vue


//
//
//
//
//
//
//
//
//
//
//





// enumerating ECharts events for now
var EVENTS = ['legendselectchanged', 'legendselected', 'legendunselected', 'legendscroll', 'datazoom', 'datarangeselected', 'timelinechanged', 'timelineplaychanged', 'restore', 'dataviewchanged', 'magictypechanged', 'geoselectchanged', 'geoselected', 'geounselected', 'pieselectchanged', 'pieselected', 'pieunselected', 'mapselectchanged', 'mapselected', 'mapunselected', 'axisareaselected', 'focusnodeadjacency', 'unfocusnodeadjacency', 'brush', 'brushselected', 'rendered', 'finished', 'click', 'dblclick', 'mouseover', 'mouseout', 'mousemove', 'mousedown', 'mouseup', 'globalout', 'contextmenu'];

var INIT_TRIGGERS = ['theme', 'initOptions', 'autoresize'];
var REWATCH_TRIGGERS = ['manualUpdate', 'watchShallow'];

/* harmony default export */ var ECharts = ({
  props: {
    options: Object,
    theme: [String, Object],
    initOptions: Object,
    group: String,
    autoresize: Boolean,
    watchShallow: Boolean,
    manualUpdate: Boolean
  },
  data: function data() {
    return {
      lastArea: 0
    };
  },

  watch: {
    group: function group(_group) {
      this.chart.group = _group;
    }
  },
  methods: {
    // provide a explicit merge option method
    mergeOptions: function mergeOptions(options, notMerge, lazyUpdate) {
      if (this.manualUpdate) {
        this.manualOptions = options;
      }

      if (!this.chart) {
        this.init();
      } else {
        this.delegateMethod('setOption', options, notMerge, lazyUpdate);
      }
    },

    // just delegates ECharts methods to Vue component
    // use explicit params to reduce transpiled size for now
    appendData: function appendData(params) {
      this.delegateMethod('appendData', params);
    },
    resize: function resize(options) {
      this.delegateMethod('resize', options);
    },
    dispatchAction: function dispatchAction(payload) {
      this.delegateMethod('dispatchAction', payload);
    },
    convertToPixel: function convertToPixel(finder, value) {
      return this.delegateMethod('convertToPixel', finder, value);
    },
    convertFromPixel: function convertFromPixel(finder, value) {
      return this.delegateMethod('convertFromPixel', finder, value);
    },
    containPixel: function containPixel(finder, value) {
      return this.delegateMethod('containPixel', finder, value);
    },
    showLoading: function showLoading(type, options) {
      this.delegateMethod('showLoading', type, options);
    },
    hideLoading: function hideLoading() {
      this.delegateMethod('hideLoading');
    },
    getDataURL: function getDataURL(options) {
      return this.delegateMethod('getDataURL', options);
    },
    getConnectedDataURL: function getConnectedDataURL(options) {
      return this.delegateMethod('getConnectedDataURL', options);
    },
    clear: function clear() {
      this.delegateMethod('clear');
    },
    dispose: function dispose() {
      this.delegateMethod('dispose');
    },
    delegateMethod: function delegateMethod(name) {
      var _chart;

      if (!this.chart) {
        this.init();
      }

      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return (_chart = this.chart)[name].apply(_chart, toConsumableArray_default()(args));
    },
    delegateGet: function delegateGet(methodName) {
      if (!this.chart) {
        this.init();
      }
      return this.chart[methodName]();
    },
    getArea: function getArea() {
      return this.$el.offsetWidth * this.$el.offsetHeight;
    },
    init: function init() {
      var _this = this;

      if (this.chart) {
        return;
      }

      var chart = echarts_default.a.init(this.$el, this.theme, this.initOptions);

      if (this.group) {
        chart.group = this.group;
      }

      chart.setOption(this.manualOptions || this.options || {}, true);

      // expose ECharts events as custom events
      EVENTS.forEach(function (event) {
        chart.on(event, function (params) {
          _this.$emit(event, params);
        });
      });

      if (this.autoresize) {
        this.lastArea = this.getArea();
        this.__resizeHandler = debounce_default()(function () {
          if (_this.lastArea === 0) {
            // emulate initial render for initially hidden charts
            _this.mergeOptions({}, true);
            _this.resize();
            _this.mergeOptions(_this.options || _this.manualOptions || {}, true);
          } else {
            _this.resize();
          }
          _this.lastArea = _this.getArea();
        }, 100, { leading: true });
        Object(esm["a" /* addListener */])(this.$el, this.__resizeHandler);
      }

      define_properties_default()(this, {
        // Only recalculated when accessed from JavaScript.
        // Won't update DOM on value change because getters
        // don't depend on reactive values
        width: {
          configurable: true,
          get: function get() {
            return _this.delegateGet('getWidth');
          }
        },
        height: {
          configurable: true,
          get: function get() {
            return _this.delegateGet('getHeight');
          }
        },
        isDisposed: {
          configurable: true,
          get: function get() {
            return !!_this.delegateGet('isDisposed');
          }
        },
        computedOptions: {
          configurable: true,
          get: function get() {
            return _this.delegateGet('getOption');
          }
        }
      });

      this.chart = chart;
    },
    initOptionsWatcher: function initOptionsWatcher() {
      var _this2 = this;

      if (this.__unwatchOptions) {
        this.__unwatchOptions();
        this.__unwatchOptions = null;
      }

      if (!this.manualUpdate) {
        this.__unwatchOptions = this.$watch('options', function (val, oldVal) {
          if (!_this2.chart && val) {
            _this2.init();
          } else {
            // mutating `options` will lead to merging
            // replacing it with new reference will lead to not merging
            // eg.
            // `this.options = Object.assign({}, this.options, { ... })`
            // will trigger `this.chart.setOption(val, true)
            // `this.options.title.text = 'Trends'`
            // will trigger `this.chart.setOption(val, false)`
            _this2.chart.setOption(val, val !== oldVal);
          }
        }, { deep: !this.watchShallow });
      }
    },
    destroy: function destroy() {
      if (this.autoresize) {
        Object(esm["b" /* removeListener */])(this.$el, this.__resizeHandler);
      }
      this.dispose();
      this.chart = null;
    },
    refresh: function refresh() {
      if (this.chart) {
        this.destroy();
        this.init();
      }
    }
  },
  created: function created() {
    var _this3 = this;

    this.initOptionsWatcher();

    INIT_TRIGGERS.forEach(function (prop) {
      _this3.$watch(prop, function () {
        _this3.refresh();
      }, { deep: true });
    });

    REWATCH_TRIGGERS.forEach(function (prop) {
      _this3.$watch(prop, function () {
        _this3.initOptionsWatcher();
        _this3.refresh();
      });
    });
  },
  mounted: function mounted() {
    // auto init if `options` is already provided
    if (this.options) {
      this.init();
    }
  },
  activated: function activated() {
    if (this.autoresize) {
      this.chart && this.chart.resize();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.destroy();
  },
  connect: function connect(group) {
    if (typeof group !== 'string') {
      group = group.map(function (chart) {
        return chart.chart;
      });
    }
    echarts_default.a.connect(group);
  },
  disconnect: function disconnect(group) {
    echarts_default.a.disConnect(group);
  },
  registerMap: function registerMap(mapName, geoJSON, specialAreas) {
    echarts_default.a.registerMap(mapName, geoJSON, specialAreas);
  },
  registerTheme: function registerTheme(name, theme) {
    echarts_default.a.registerTheme(name, theme);
  },

  graphic: echarts_default.a.graphic
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65292532","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-echarts/components/ECharts.vue
var ECharts_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"echarts"})}
var ECharts_staticRenderFns = []
var ECharts_esExports = { render: ECharts_render, staticRenderFns: ECharts_staticRenderFns }
/* harmony default export */ var components_ECharts = (ECharts_esExports);
// CONCATENATED MODULE: ./node_modules/vue-echarts/components/ECharts.vue
function ECharts_injectStyle (ssrContext) {
  __webpack_require__("ykZO")
}
var ECharts_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ECharts___vue_template_functional__ = false
/* styles */
var ECharts___vue_styles__ = ECharts_injectStyle
/* scopeId */
var ECharts___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ECharts___vue_module_identifier__ = null
var ECharts_Component = ECharts_normalizeComponent(
  ECharts,
  components_ECharts,
  ECharts___vue_template_functional__,
  ECharts___vue_styles__,
  ECharts___vue_scopeId__,
  ECharts___vue_module_identifier__
)

/* harmony default export */ var vue_echarts_components_ECharts = (ECharts_Component.exports);

// EXTERNAL MODULE: ./node_modules/echarts/index.js
var node_modules_echarts = __webpack_require__("XLwt");
var node_modules_echarts_default = /*#__PURE__*/__webpack_require__.n(node_modules_echarts);

// EXTERNAL MODULE: ./node_modules/echarts/lib/chart/bar.js
var chart_bar = __webpack_require__("GbHy");
var bar_default = /*#__PURE__*/__webpack_require__.n(chart_bar);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/productPrice/graphOptions.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var graphOptions = ({
  props: {
    name: {
      type: String,
      required: true
    },
    min: {
      type: Number,
      default: function _default() {
        return 1;
      }
    },
    max: {
      type: Number,
      default: function _default() {
        return 7;
      }
    },
    countryOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    createOptions: {
      type: Object,
      default: function _default() {
        return null;
      }
    },
    checkOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      createData: '',
      checks: [],
      selected: []
    };
  },

  computed: {
    filtedCreateOptions: function filtedCreateOptions() {
      var createOptions = this.createOptions.options(this.createData) || [];
      return createOptions;
    }
  },
  created: function created() {
    this.checks = [].concat(toConsumableArray_default()(this.checkOptions.options || []));
    this.selected = [].concat(toConsumableArray_default()(this.checkOptions.values || []));
  },

  watch: {
    'checkOptions': function checkOptions() {
      this.checks = [].concat(toConsumableArray_default()(this.checkOptions.options || []));
      this.selected = [].concat(toConsumableArray_default()(this.checkOptions.values || []));
    }
  },
  methods: {
    isDisabled: function isDisabled(data) {
      return this.selected.length <= this.min && this.selected.includes(data.value) || this.selected.length >= this.max && !this.selected.includes(data.value);
    },
    checkData: function checkData(value) {
      var checker = this.createOptions.checkData || function () {
        return true;
      };
      if (value && !checker(value)) {
        this.createData = '';
      }
    },
    addData: function addData() {
      var _this = this;

      this.$emit('create', this.createData);
      this.selectData(this.countryOptions.find(function (option) {
        return option.title === _this.createData;
      }) || { title: '無', value: '無', country: { iso_name: '', chinese_name: '' } });
      this.createData = '';
    },
    selectData: function selectData(data) {
      var selected = [].concat(toConsumableArray_default()(this.selected));
      if (selected.includes(data.value)) {
        selected.splice(selected.indexOf(data.value), 1);
        if (this.createOptions) {
          this.$emit('remove', data.title);
        }
      } else {
        selected.push(data.value);
      }
      this.$emit('select', selected);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53cec6a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/productPrice/graphOptions.vue
var graphOptions_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-price-graph-option-page"},[(_vm.createOptions)?_c('div',{staticClass:"create-container input-group col-block"},[_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"create-title"},[_vm._v(_vm._s(_vm.createOptions.title))]),_vm._v(" "),_c('div',{style:({ height: '5px' })}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.createData),expression:"createData"}],attrs:{"type":"text","list":'graph-option-list-' + _vm.name},domProps:{"value":(_vm.createData)},on:{"change":function (e) { return _vm.checkData(_vm.createData); },"input":function($event){if($event.target.composing){ return; }_vm.createData=$event.target.value}}}),_vm._v(" "),(_vm.filtedCreateOptions.length)?_c('datalist',{attrs:{"id":'graph-option-list-' + _vm.name}},_vm._l((_vm.filtedCreateOptions),function(option,index){return _c('option',{key:index,domProps:{"value":option.title}})}),0):_vm._e(),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('button',{staticClass:"white-button",attrs:{"type":"button","name":"button"},on:{"click":function (e) { return _vm.addData(); }}},[_c('span',[_vm._v("加入")])]),_vm._v(" "),_c('div',{style:({ height: '10px' })})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"check-container"},_vm._l((_vm.checks),function(data,index){return _c('label',{key:index,staticClass:"data-block row-block",class:{ disabled: _vm.isDisabled(data) },attrs:{"for":'graph-option-check-' + data.value},on:{"click":function (e) { return !_vm.isDisabled(data) && _vm.selectData(data); }}},[_c('img',{attrs:{"src":__webpack_require__("TEyu")("./checkbox-" + (_vm.selected.includes(data.value) ? 'true' : 'false') + '.svg')}}),_vm._v(" "),_c('div',{style:({ width: '8px' })}),_vm._v(" "),_c('div',{staticClass:"data-title",style:({ flex: 1 }),attrs:{"title":data.title}},[_vm._v(_vm._s(data.title.replace(/\(.+\)$/, '')))])])}),0)])}
var graphOptions_staticRenderFns = []
var graphOptions_esExports = { render: graphOptions_render, staticRenderFns: graphOptions_staticRenderFns }
/* harmony default export */ var productPrice_graphOptions = (graphOptions_esExports);
// CONCATENATED MODULE: ./src/components/productPrice/graphOptions.vue
var graphOptions_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var graphOptions___vue_template_functional__ = false
/* styles */
var graphOptions___vue_styles__ = null
/* scopeId */
var graphOptions___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var graphOptions___vue_module_identifier__ = null
var graphOptions_Component = graphOptions_normalizeComponent(
  graphOptions,
  productPrice_graphOptions,
  graphOptions___vue_template_functional__,
  graphOptions___vue_styles__,
  graphOptions___vue_scopeId__,
  graphOptions___vue_module_identifier__
)

/* harmony default export */ var components_productPrice_graphOptions = (graphOptions_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/productPrice/graph.vue








//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ var graph = ({
  components: {
    vueCharts: vue_echarts_components_ECharts,
    graphOptions: components_productPrice_graphOptions,
    customFilter: components_tool_customFilter
  },
  mixins: [mixins_userPermission, toastMethods["a" /* default */]],
  props: {
    datas: {
      type: Array,
      default: function _default() {
        return null;
      }
    },
    filterOptions: {
      type: Object,
      required: true
    },
    conditions: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      echarts: node_modules_echarts_default.a,
      fontSize: '14',
      filtedDatas: [],
      options: {},
      filterConditions: {}
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['countrys']), {
    // static
    colors: function colors() {
      return [['#36A2DA', '#3966A6', '#9CCECB', '#85B84F', '#3A9171', '#29463C', '#FFB700', '#FF7D0D', '#ED92BF', '#CC292E', '#DABE7F', '#6A0E1C', '#B38039', '#C37FE6'], ['#85B84F', '#FFB700', '#ED92BF', '#FF7D0D', '#36A2DA', '#29463C', '#CC292E', '#C37FE6', '#3A9171', '#9CCECB', '#6A0E1C', '#DABE7F', '#3966A6', '#B38039']];
    },
    xAxisOptions: function xAxisOptions() {
      var _this = this;

      return [{ title: '市場所在國家', value: 'marketCountry' }, { title: '包裝類型', value: 'packingMethod' }, { title: '市場類型', value: 'marketKind' }, { title: '產地', value: 'country' }].filter(function (option) {
        return _this.filterConditions['zAxis'] !== option.value;
      });
    },
    yAxisCheckOptions: function yAxisCheckOptions() {
      return [{ title: '單價價格', value: 'single' }, { title: '總價價格', value: 'all' }];
    },
    zAxisOptions: function zAxisOptions() {
      var _this2 = this;

      return [{ title: '市場所在國家', value: 'marketCountry' }, { title: '包裝類型', value: 'packingMethod' }, { title: '市場類型', value: 'marketKind' }, { title: '產地', value: 'country' }].filter(function (option) {
        return _this2.filterConditions['xAxis'] !== option.value;
      });
    },
    otherCheckOptions: function otherCheckOptions() {
      return [{ title: '重量計價', value: 'price_by_weight', icon: __webpack_require__("AFvp") }, { title: '數量計價', value: 'price_by_count', icon: __webpack_require__("ECQw") }];
    },
    countryOptions: function countryOptions() {
      return this.countrys.map(function (_ref) {
        var _ref2 = slicedToArray_default()(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        return {
          title: value.chinese_name + '(' + value.iso_name + ')',
          value: key,
          country: value
        };
      });
    },
    marketCountryCheckOptions: function marketCountryCheckOptions() {
      var _this3 = this;

      return this.countryOptions.filter(function (option) {
        return _this3.options.marketCountry.includes(option.title);
      });
    },
    countryCheckOptions: function countryCheckOptions() {
      var _this4 = this;

      return [{ title: '無', value: '無', country: { iso_name: '', chinese_name: '' } }].concat(this.countryOptions).filter(function (option) {
        return _this4.options.country.includes(option.title);
      });
    },
    packingMethodCheckOptions: function packingMethodCheckOptions() {
      return [{ title: '散裝', value: 'bulk', style: { color: '#EF6577' } }, { title: '有包裝', value: 'packed', style: { color: '#3967A6' } }, { title: '截切', value: 'cut', style: { color: '#3967A6' } }];
    },
    marketKindCheckOptions: function marketKindCheckOptions() {
      return [{ title: '傳統市場', value: 'traditional_market' }, { title: '批發市場', value: 'wholesale_market' }, { title: '超市', value: 'supermarket' }, { title: '量販店', value: 'hyper_market' }, { title: '便利商店', value: 'convenience_store' }, { title: '蔬果專賣店', value: 'vegetable_and_fruit_store' }, { title: '農夫(假日)市集', value: 'farmers_market' }];
    },
    xAxisGraphOptions: function xAxisGraphOptions() {
      var _this5 = this;

      var checkOptionTitles = this[this.filterConditions['xAxis'] + 'CheckOptions'].map(function (option) {
        return option.title;
      });
      var dataKeyMap = {
        country: 'country',
        id: 'id',
        marketCountry: 'market_country',
        marketKind: 'market_kind',
        packingMethod: 'packing_method',
        price: 'price',
        pricingMethod: 'pricing_method'
      };
      var dataValues = this.datas.map(function (data) {
        return data[dataKeyMap[_this5.filterConditions['xAxis']]];
      });
      return {
        createOptions: ['marketCountry', 'country'].includes(this.filterConditions['xAxis']) ? {
          title: '國家 (可選擇1-7個國家)',
          options: function options(value) {
            return (['country'].includes(_this5.filterConditions['xAxis']) && !_this5.options.country.includes('無') ? [{ title: '無', value: '無', country: { iso_name: '', chinese_name: '' } }] : []).concat(_this5.countryOptions.filter(function (option) {
              return dataValues.includes(option.value) && !checkOptionTitles.includes(option.title);
            })).filter(function (option) {
              return option.country.iso_name.toLowerCase().startsWith((value || '').toLowerCase()) || option.country.chinese_name.startsWith(value);
            }).filter(function (_, index) {
              return value || index < 99999;
            });
          },
          checkData: function checkData(value) {
            return _this5.countryOptions.map(function (option) {
              return option.title;
            }).includes(value) || value === '無';
          }
        } : null,
        checkOptions: {
          options: this[this.filterConditions['xAxis'] + 'CheckOptions'],
          values: this.filterConditions[this.filterConditions['xAxis']]
        }
      };
    },
    zAxisGraphOptions: function zAxisGraphOptions() {
      var _this6 = this;

      var checkOptionTitles = this[this.filterConditions['zAxis'] + 'CheckOptions'].map(function (option) {
        return option.title;
      });
      var dataKeyMap = {
        country: 'country',
        id: 'id',
        marketCountry: 'market_country',
        marketKind: 'market_kind',
        packingMethod: 'packing_method',
        price: 'price',
        pricingMethod: 'pricing_method'
      };
      var dataValues = this.datas.map(function (data) {
        return data[dataKeyMap[_this6.filterConditions['zAxis']]];
      });
      return {
        createOptions: ['marketCountry', 'country'].includes(this.filterConditions['zAxis']) ? {
          title: '國家 (可選擇1-7個國家)',
          options: function options(value) {
            return (['country'].includes(_this6.filterConditions['zAxis']) && !_this6.options.country.includes('無') ? [{ title: '無', value: '無', country: { iso_name: '', chinese_name: '' } }] : []).concat(_this6.countryOptions.filter(function (option) {
              return dataValues.includes(option.value) && !checkOptionTitles.includes(option.title);
            })).filter(function (option) {
              return option.country.iso_name.toLowerCase().startsWith((value || '').toLowerCase()) || option.country.chinese_name.startsWith(value);
            }).filter(function (_, index) {
              return value || index < 99999;
            });
          },
          checkData: function checkData(value) {
            return _this6.countryOptions.map(function (option) {
              return option.title;
            }).includes(value) || value === '無';
          }
        } : null,
        checkOptions: {
          options: this[this.filterConditions['zAxis'] + 'CheckOptions'],
          values: this.filterConditions[this.filterConditions['zAxis']]
        }
      };
    },
    zAxisLegends: function zAxisLegends() {
      var _this7 = this;

      var legendDatas = this[this.filterConditions['zAxis'] + 'CheckOptions'].filter(function (option) {
        return _this7.filterConditions[_this7.filterConditions['zAxis']].includes(option.value);
      });
      return legendDatas.map(function (data, index) {
        return extends_default()({}, data, {
          title: data.title.replace(/\(.+\)$/, ''),
          color: _this7.colors[1][index]
        });
      });
    },
    otherLegends: function otherLegends() {
      var _this8 = this;

      var legendDatas = this['otherCheckOptions'].filter(function (option) {
        return _this8.filterConditions['other'].includes(option.value);
      });
      return legendDatas.map(function (data, index) {
        return extends_default()({}, data);
      });
    },
    chartOptions: function chartOptions() {
      var _this9 = this;

      var datas = this.datas.map(function (data) {
        return extends_default()({}, data, {
          country: data.country || '無'
        });
      });
      var maxPrice = 0;
      var dataOffsetLength = function dataOffsetLength(length) {
        if (length >= 250) return 7;
        if (length >= 600) return 9;
        if (length >= 1000) return 11;
        return 5;
      };
      var yAxisMap = {
        single: ['bulk'],
        all: ['packed', 'cut']
      };
      var dataKeyMap = {
        country: 'country',
        id: 'id',
        marketCountry: 'market_country',
        marketKind: 'market_kind',
        packingMethod: 'packing_method',
        price: 'price',
        pricingMethod: 'pricing_method'
      };
      var filtedDatas = [];
      var dateRange = [this.filterConditions['range'].start ? new Date(this.filterConditions['range'].start) : null, this.filterConditions['range'].end ? new Date(this.filterConditions['range'].end) : null];
      var seriesGenerator = function seriesGenerator(symbol, color) {
        var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        return {
          type: 'scatter',
          symbolSize: Math.sqrt(200),
          symbol: symbol,
          symbolOffset: [offset * 5 + '&', 0],
          itemStyle: {
            color: color,
            opacity: 1,
            borderColor: '#777777',
            borderWidth: 1
          },
          data: []
        };
      };
      var seriesMap = this.zAxisLegends.reduce(function (s, legend) {
        return extends_default()({}, s, defineProperty_default()({}, legend.value, {
          price_by_weight: [seriesGenerator('circle', legend.color, 0), seriesGenerator('circle', legend.color, 1.5), seriesGenerator('circle', legend.color, -1.5), seriesGenerator('circle', legend.color, 2.5), seriesGenerator('circle', legend.color, -2.5), seriesGenerator('circle', legend.color, 3.5), seriesGenerator('circle', legend.color, -3.5), seriesGenerator('circle', legend.color, 4.5), seriesGenerator('circle', legend.color, -4.5), seriesGenerator('circle', legend.color, 5.5), seriesGenerator('circle', legend.color, -5.5)],
          price_by_count: [seriesGenerator('triangle', legend.color, 0), seriesGenerator('triangle', legend.color, 1.5), seriesGenerator('triangle', legend.color, -1.5), seriesGenerator('triangle', legend.color, 2.5), seriesGenerator('triangle', legend.color, -2.5), seriesGenerator('triangle', legend.color, 3.5), seriesGenerator('triangle', legend.color, -3.5), seriesGenerator('triangle', legend.color, 4.5), seriesGenerator('triangle', legend.color, -4.5), seriesGenerator('triangle', legend.color, 5.5), seriesGenerator('triangle', legend.color, -5.5)]
        }));
      }, {});
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(datas), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var data = _step.value;

          if (Array.prototype.concat.apply([], this.filterConditions['yAxis'].map(function (value) {
            return yAxisMap[value];
          })).includes(data.packing_method) && this.filterConditions['other'].includes(data.pricing_method)) {
            var seriesKey = dataKeyMap[this.filterConditions['zAxis']];
            if (seriesMap[data[seriesKey]]) {
              var valueKey = dataKeyMap[this.filterConditions['xAxis']];
              var dataDate = data.date ? new Date(data.date) : null;
              if (this.filterConditions[this.filterConditions['xAxis']].includes(data[valueKey]) && (!dateRange[0] || dataDate > dateRange[0]) && (!dateRange[1] || dataDate < dateRange[1])) {
                maxPrice = Math.max(maxPrice, data.price);
                var graphData = [data[valueKey], data.price, data.id];
                var generators = seriesMap[data[seriesKey]][data.pricing_method];
                var length = Math.min(dataOffsetLength(filtedDatas.length || this.datas.length), generators.length);
                generators[Math.floor(Math.random() * length)].data.push(graphData);
                filtedDatas.push(graphData);
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.filtedDatas = filtedDatas;
      var yAxisValueLength = Math.max(3, (maxPrice.toFixed(0) + '0').length);
      var xAxisLabelMap = this[this.filterConditions['xAxis'] + 'CheckOptions'].reduce(function (s, option) {
        return extends_default()({}, s, defineProperty_default()({}, option.value, option.title.replace(/\(.+\)$/, '')));
      }, {});
      return {
        xAxis: {
          type: 'category',
          // splitLine: {
          //   lineStyle: {
          //     type: 'dashed'
          //   }
          // },
          axisLabel: {
            formatter: function formatter(value) {
              return xAxisLabelMap[value];
            },
            interval: 0,
            fontSize: this.fontSize
          },
          axisTick: {
            alignWithLabel: true
          },
          name: this.xAxisOptions.find(function (option) {
            return option.value === _this9.filterConditions['xAxis'];
          }).title,
          nameLocation: 'middle',
          nameGap: 40,
          nameTextStyle: {
            fontSize: this.fontSize
          },
          data: this.filterConditions[this.filterConditions['xAxis']]
        },
        yAxis: {
          splitLine: {
            lineStyle: {
              type: 'dashed'
            }
          },
          axisLabel: {
            fontSize: this.fontSize
          },
          name: '價格 (美元)',
          nameLocation: 'middle',
          nameGap: yAxisValueLength * 10,
          nameTextStyle: {
            fontSize: this.fontSize
          }
        },
        grid: {
          top: 30,
          left: 30 + yAxisValueLength * 10,
          right: 10,
          bottom: 80
        },
        tooltip: {
          trigger: 'axis',
          showContent: false,
          axisPointer: {
            type: 'shadow',
            shadowStyle: {
              color: '#9BC737',
              opacity: 0.1
            }
          }
        },
        series: Array.prototype.concat.apply([], values_default()(seriesMap).map(function (wcMap) {
          return Array.prototype.concat.apply([], values_default()(wcMap));
        }))
      };
    },

    // global
    dateFormat: function dateFormat() {
      return util["b" /* dateFormat */];
    }
  }),
  watch: {
    'datas': function datas() {
      this.initCondition();
    }
  },
  created: function created() {
    this.initCondition();
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setModalAction']), {
    initCondition: function initCondition() {
      this.options = {
        marketCountry: [],
        country: []
      };
      this.filterConditions = {
        xAxis: 'packingMethod',
        yAxis: ['single', 'all'],
        zAxis: 'marketKind',
        other: ['price_by_weight', 'price_by_count'],
        range: {
          start: '',
          end: ''
        },
        marketCountry: [],
        country: [],
        packingMethod: ['bulk', 'packed', 'cut'],
        marketKind: ['traditional_market', 'wholesale_market', 'supermarket', 'hyper_market', 'convenience_store', 'vegetable_and_fruit_store', 'farmers_market']
      };
    },
    getFilterTitle: function getFilterTitle(value) {
      var _this10 = this;

      if (!this.conditions.filters[value]) {
        return '';
      }
      return this.filterOptions.filters.find(function (filter) {
        return filter.value === value;
      }).options.find(function (option) {
        return option.value === _this10.conditions.filters[value];
      }).title;
    },
    chartOnClick: function chartOnClick(param) {
      var value = param.data[1];
      var xAxis = param.data[0];
      var filtedValues = this.filtedDatas.map(function (data) {
        return data[1];
      });
      var interval = (Math.max.apply(null, filtedValues) - Math.min.apply(null, filtedValues)) / 10;
      var ids = this.filtedDatas.filter(function (data) {
        return data[1] <= value + interval && data[1] >= value - interval && data[0] === xAxis;
      }).map(function (data) {
        return data[2];
      });
      this.setModalAction({
        action: 'graphData',
        width: '820px',
        height: '90%',
        customStyles: {
          padding: '0px',
          margin: '20px auto',
          borderRadius: '0'
        },
        param: {
          ids: ids,
          defaultID: param.data[2],
          options: {
            country: this.countryOptions,
            packingMethod: this.packingMethodCheckOptions,
            marketKind: this.marketKindCheckOptions,
            quantity: [{ title: '公克', value: 'gram', type: '重量' }, { title: '公斤', value: 'kilogram', type: '重量' }, { title: '磅', value: 'pound', type: '重量' }, { title: '個', value: 'number', type: '數量' }, { title: '包裝', value: 'package', type: '數量' }]
          }
        }
      });
    },
    downloadGraph: function downloadGraph() {
      var _this11 = this;

      var download = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var url, title;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Object(util["e" /* html2DataUrl */])(_this11.$refs.chartField, 'png', 0.3);

              case 2:
                url = _context.sent;

                if (!download) {
                  _context.next = 11;
                  break;
                }

                title = '';

                title = title + _this11.getFilterTitle('crop_name') + '的零售價格分析.png';
                _context.next = 8;
                return _this11.sendGraphAccessLog();

              case 8:
                Object(util["c" /* downloadFile */])(title, url, '_blank');
                _context.next = 12;
                break;

              case 11:
                return _context.abrupt('return', url);

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this11);
      }))();
    },
    sendGraphAccessLog: function sendGraphAccessLog() {
      var _this12 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var config, type, paramInfos, data;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                config = _this12.$ls.get('userInfo');
                type = 'product_prices';
                paramInfos = {
                  x: {
                    value: _this12.xAxisOptions.find(function (option) {
                      return option.value === _this12.filterConditions.xAxis;
                    }).title,
                    selected: _this12.filterConditions[_this12.filterConditions.xAxis].map(function (condition) {
                      return _this12[_this12.filterConditions.xAxis + 'CheckOptions'].find(function (option) {
                        return option.value === condition;
                      }).title;
                    })
                  },
                  y: {
                    value: '價格',
                    selected: _this12.filterConditions.yAxis.map(function (condition) {
                      return _this12.yAxisCheckOptions.find(function (option) {
                        return option.value === condition;
                      }).title;
                    })
                  },
                  z: {
                    value: _this12.zAxisOptions.find(function (option) {
                      return option.value === _this12.filterConditions.zAxis;
                    }).title,
                    selected: _this12.filterConditions[_this12.filterConditions.zAxis].map(function (condition) {
                      return _this12[_this12.filterConditions.zAxis + 'CheckOptions'].find(function (option) {
                        return option.value === condition;
                      }).title;
                    })
                  }
                };
                data = {
                  crop_name: _this12.getFilterTitle('crop_name'),
                  chart_params_info: entries_default()(paramInfos).map(function (_ref3) {
                    var _ref4 = slicedToArray_default()(_ref3, 2),
                        title = _ref4[0],
                        info = _ref4[1];

                    return title + ' = ' + info.value + ' (' + info.selected.join('、') + ')';
                  }).join(', ')
                };
                _context2.next = 7;
                return Object(src_api["I" /* postAccessLog */])(type, data, config);

              case 7:
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](0);

                _this12.addToast('error', !_context2.t0.response ? _context2.t0.message : _context2.t0.response.data.message || _context2.t0.response.data.errors.join('<br>'));

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this12, [[0, 9]]);
      }))();
    },
    downloadData: function downloadData() {
      var _this13 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var config, conditions, data, url;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                config = _this13.$ls.get('userInfo');
                conditions = _this13.conditions.filters;
                // let image = await this.downloadGraph(false)

                data = extends_default()({}, config, conditions);
                url = api_config["a" /* API_ROOT */] + 'product_prices/export.zip';

                url = url + '?' + entries_default()(data).map(function (_ref5) {
                  var _ref6 = slicedToArray_default()(_ref5, 2),
                      key = _ref6[0],
                      value = _ref6[1];

                  return value ? key + '=' + value : '';
                }).filter(function (x) {
                  return x;
                }).join('&');
                Object(util["c" /* downloadFile */])(null, url, '_target');

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this13);
      }))();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d41b26ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/productPrice/graph.vue
var graph_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.datas)?_c('div',{staticClass:"product-price-graph-page col-block"},[_c('div',{staticClass:"option-container row-block"},[_c('div',{staticClass:"data-block row-block"},[(_vm.conditions.filters.crop_name)?[_c('div',[_c('b',[_vm._v("作物(產品)：")]),_vm._v(_vm._s(_vm.getFilterTitle('crop_name')))]),_vm._v(" "),_c('div',{style:({ width: '50px' })})]:_vm._e()],2),_vm._v(" "),_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"option-block row-block"},[_c('div',{staticClass:"option row-block input-group"},[_c('div',{staticClass:"option-title"},[_vm._v("字體")]),_vm._v(" "),_c('div',{style:({ width: '8.5px' })}),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.fontSize),expression:"fontSize"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.fontSize=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"14"}},[_vm._v("小")]),_vm._v(" "),_c('option',{attrs:{"value":"16"}},[_vm._v("中")]),_vm._v(" "),_c('option',{attrs:{"value":"20"}},[_vm._v("大")])])])]),_vm._v(" "),_c('div',{style:({ width: '15px' })}),_vm._v(" "),_c('div',{staticClass:"button-block row-block"},[(_vm.rolePermission(['advance', 'admin']))?[_c('button',{staticClass:"main-button option-button update",attrs:{"type":"button","name":"button"},on:{"click":function (e) { return _vm.downloadData(); }}},[_c('span',[_vm._v("原始數據下載")])]),_vm._v(" "),_c('div',{style:({ width: '15px' })})]:_vm._e(),_vm._v(" "),_c('button',{staticClass:"main-button option-button update",attrs:{"type":"button","name":"button"},on:{"click":function (e) { return _vm.downloadGraph(); }}},[_c('span',[_vm._v("另存圖檔")])])],2)]),_vm._v(" "),_c('div',{staticClass:"content-container",style:({ flex: 1 })},[_c('div',{staticClass:"graph-block row-block stretch"},[_c('div',{staticClass:"options-container col-block",style:({ width: '210px' })},[_c('div',{staticClass:"options-block col-block",style:({ flex: 1, height: 0 })},[_c('div',{style:({ height: 0, width: '100%' })},[_c('div',{staticClass:"options col-block"},[_c('div',{staticClass:"filter-container col-block"},[_c('div',{staticClass:"filter-title-container row-block"},[_c('div',{staticClass:"filter-title"},[_vm._v("X軸")]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '5px' })}),_vm._v(" "),_c('div',{staticClass:"filter-forms input-group col-block"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterConditions['xAxis']),expression:"filterConditions['xAxis']"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filterConditions, 'xAxis', $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.xAxisOptions),function(option,index){return _c('option',{key:index,domProps:{"value":option.value}},[_vm._v(_vm._s(option.title))])}),0)]),_vm._v(" "),_c('div',{style:({ height: '15px' })}),_vm._v(" "),_c('div',{staticClass:"filter-options"},[_c('graphOptions',{attrs:{"name":'xAxis',"countryOptions":_vm.countryOptions,"createOptions":_vm.xAxisGraphOptions.createOptions,"checkOptions":_vm.xAxisGraphOptions.checkOptions},on:{"create":function (value) { return (_vm.options[_vm.filterConditions['xAxis']] || []).push(value); },"remove":function (value) { return (_vm.options[_vm.filterConditions['xAxis']] || []).splice((_vm.options[_vm.filterConditions['xAxis']] || []).indexOf(value), 1); },"select":function (value) { return _vm.filterConditions[_vm.filterConditions['xAxis']] = value; }}})],1)]),_vm._v(" "),_c('div',{style:({ height: '15px' })}),_vm._v(" "),_c('div',{staticClass:"filter-container col-block"},[_c('div',{staticClass:"filter-title-container row-block"},[_c('div',{staticClass:"filter-title"},[_vm._v("Y軸")]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '5px' })}),_vm._v(" "),_c('div',{staticClass:"filter-forms input-group col-block"},[_c('div',{staticClass:"data-lists col-block"},[_c('div',{style:({ height: '7px' })}),_vm._v(" "),_vm._l((_vm.yAxisCheckOptions),function(data,index){return _c('label',{key:index,staticClass:"data-block row-block",attrs:{"for":'yAxis-select-' + data.value}},[_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"},{name:"model",rawName:"v-model",value:(_vm.filterConditions['yAxis']),expression:"filterConditions['yAxis']"}],attrs:{"type":"checkbox","id":'yAxis-select-' + data.value},domProps:{"value":data.value,"checked":Array.isArray(_vm.filterConditions['yAxis'])?_vm._i(_vm.filterConditions['yAxis'],data.value)>-1:(_vm.filterConditions['yAxis'])},on:{"change":function($event){var $$a=_vm.filterConditions['yAxis'],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=data.value,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.filterConditions, 'yAxis', $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.filterConditions, 'yAxis', $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.filterConditions, 'yAxis', $$c)}}}}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("TEyu")("./checkbox-" + (_vm.filterConditions['yAxis'].includes(data.value) ? 'true' : 'false') + '.svg')}}),_vm._v(" "),_c('div',{style:({ width: '8px' })}),_vm._v(" "),_c('div',{staticClass:"data-title",style:({ flex: 1 }),attrs:{"title":data.title}},[_vm._v(_vm._s(data.title))])])})],2)])]),_vm._v(" "),_c('div',{style:({ height: '15px' })}),_vm._v(" "),_c('div',{staticClass:"filter-container col-block"},[_c('div',{staticClass:"filter-title-container row-block"},[_c('div',{staticClass:"filter-title"},[_vm._v("Z軸")]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '5px' })}),_vm._v(" "),_c('div',{staticClass:"filter-forms input-group col-block"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterConditions['zAxis']),expression:"filterConditions['zAxis']"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filterConditions, 'zAxis', $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.zAxisOptions),function(option,index){return _c('option',{key:index,domProps:{"value":option.value}},[_vm._v(_vm._s(option.title))])}),0)]),_vm._v(" "),_c('div',{style:({ height: '15px' })}),_vm._v(" "),_c('div',{staticClass:"filter-options"},[_c('graphOptions',{attrs:{"name":'zAxis',"countryOptions":_vm.countryOptions,"createOptions":_vm.zAxisGraphOptions.createOptions,"checkOptions":_vm.zAxisGraphOptions.checkOptions},on:{"create":function (value) { return (_vm.options[_vm.filterConditions['zAxis']] || []).push(value); },"remove":function (value) { return (_vm.options[_vm.filterConditions['zAxis']] || []).splice((_vm.options[_vm.filterConditions['zAxis']] || []).indexOf(value), 1); },"select":function (value) { return _vm.filterConditions[_vm.filterConditions['zAxis']] = value; }}})],1)]),_vm._v(" "),_c('div',{style:({ height: '15px' })}),_vm._v(" "),_c('div',{staticClass:"filter-container col-block"},[_c('div',{staticClass:"filter-title-container row-block"},[_c('div',{staticClass:"filter-title"},[_vm._v("計價方式")]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '5px' })}),_vm._v(" "),_c('div',{staticClass:"filter-forms input-group col-block"},[_c('div',{staticClass:"data-lists col-block"},[_c('div',{style:({ height: '7px' })}),_vm._v(" "),_vm._l((_vm.otherCheckOptions),function(data,index){return _c('label',{key:index,staticClass:"data-block row-block",attrs:{"for":'other-select-' + data.value}},[_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"},{name:"model",rawName:"v-model",value:(_vm.filterConditions['other']),expression:"filterConditions['other']"}],attrs:{"type":"checkbox","id":'other-select-' + data.value},domProps:{"value":data.value,"checked":Array.isArray(_vm.filterConditions['other'])?_vm._i(_vm.filterConditions['other'],data.value)>-1:(_vm.filterConditions['other'])},on:{"change":function($event){var $$a=_vm.filterConditions['other'],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=data.value,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.filterConditions, 'other', $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.filterConditions, 'other', $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.filterConditions, 'other', $$c)}}}}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("TEyu")("./checkbox-" + (_vm.filterConditions['other'].includes(data.value) ? 'true' : 'false') + '.svg')}}),_vm._v(" "),_c('div',{style:({ width: '8px' })}),_vm._v(" "),_c('div',{staticClass:"data-title",style:({ flex: 1 }),attrs:{"title":data.title}},[_vm._v(_vm._s(data.title))])])})],2)])]),_vm._v(" "),_c('div',{style:({ height: '15px' })}),_vm._v(" "),_c('div',{staticClass:"filter-container col-block"},[_c('div',{staticClass:"filter-title-container row-block"},[_c('div',{staticClass:"filter-title"},[_vm._v("日期起始與結束")]),_vm._v(" "),_c('div',{style:({ flex: 1 })}),_vm._v(" "),(_vm.filterConditions['range'].start || _vm.filterConditions['range'].end)?_c('a',{staticClass:"filter-reset link",on:{"click":function (e) { return _vm.filterConditions['range'] = { start: '', end: '' }; }}},[_vm._v(_vm._s('重設'))]):_vm._e()]),_vm._v(" "),_c('div',{style:({ height: '5px' })}),_vm._v(" "),_c('div',{staticClass:"filter-forms input-group col-block"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterConditions['range'].start),expression:"filterConditions['range'].start"}],style:(_vm.filterConditions['range'].start ? {} : { color: '#777777' }),attrs:{"type":"date","placeholder":'請選擇起始日'},domProps:{"value":(_vm.filterConditions['range'].start)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filterConditions['range'], "start", $event.target.value)}}}),_vm._v(" "),_c('span',{style:({ opacity: 0, height: '5px' })},[_vm._v("~")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterConditions['range'].end),expression:"filterConditions['range'].end"}],style:(_vm.filterConditions['range'].end ? {} : { color: '#777777' }),attrs:{"type":"date","placeholder":'請選擇結束日'},domProps:{"value":(_vm.filterConditions['range'].end)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filterConditions['range'], "end", $event.target.value)}}})])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])])]),_vm._v(" "),_c('div',{staticClass:"chart-container",style:({ flex: 1 })},[_c('div',{staticClass:"chart-block"},[_c('div',{ref:"chartField",staticClass:"chart-field",style:({ '--chart-font-size': _vm.fontSize + 'px' })},[_c('div',{staticClass:"chart-block col-block"},[_c('div',{staticClass:"main-chart-container row-block stretch"},[_c('div',{staticClass:"main-chart-block col-block",style:({ flex: 1 })},[_c('div',{staticClass:"data-block col-block"},[_c('b',[_vm._v(_vm._s([[_vm.filterConditions['range'].start, _vm.filterConditions['range'].end].filter(function (x) { return x; }).join('~'), _vm.getFilterTitle('crop_name') + '的零售價格分析'].filter(function (x) { return x; }).join(' ')))])]),_vm._v(" "),_c('div',{staticClass:"chart-block"},[_c('vueCharts',{ref:"chart",attrs:{"options":_vm.chartOptions,"autoresize":true},on:{"click":function (param) { return _vm.chartOnClick(param); }}})],1)]),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('div',{staticClass:"legend-container col-block",style:({ width: '170px' })},[_c('div',{style:({ height: '35px' })}),_vm._v(" "),_c('div',{staticClass:"zAxis-container col-block"},[_c('div',{staticClass:"axis-title"},[_c('b',[_vm._v("Z軸：")]),_vm._v(_vm._s(_vm.zAxisOptions.find(function (option) { return option.value === _vm.filterConditions['zAxis']; }).title))]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"axis-legend-container col-block"},_vm._l((_vm.zAxisLegends),function(legend,index){return _c('div',{key:index,staticClass:"axis-legend row-block"},[_c('div',{staticClass:"legend-icon",style:({ background: legend.color })}),_vm._v(" "),_c('div',{style:({ width: '8.5px' })}),_vm._v(" "),_c('div',{staticClass:"legend-title"},[_vm._v(_vm._s(legend.title))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])}),0)]),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"other-container col-block"},[_vm._m(0),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"axis-legend-container col-block"},_vm._l((_vm.otherLegends),function(legend,index){return _c('div',{key:index,staticClass:"axis-legend row-block"},[_c('div',{staticClass:"legend-icon"},[_c('img',{attrs:{"src":legend.icon,"alt":""}})]),_vm._v(" "),_c('div',{style:({ width: '8.5px' })}),_vm._v(" "),_c('div',{staticClass:"legend-title"},[_vm._v(_vm._s(legend.title))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])}),0)]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ width: '10px' })})]),_vm._v(" "),_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"description-block row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_vm._m(1)])])])])])])])]):_vm._e()}
var graph_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"axis-title"},[_c('b',[_vm._v("計價方式")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-block"},[_c('div',{staticClass:"content"},[_vm._v("資料來源：本平台資料庫")]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("農業部農業試驗所")])])}]
var graph_esExports = { render: graph_render, staticRenderFns: graph_staticRenderFns }
/* harmony default export */ var productPrice_graph = (graph_esExports);
// CONCATENATED MODULE: ./src/components/productPrice/graph.vue
function graph_injectStyle (ssrContext) {
  __webpack_require__("hxho")
}
var graph_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var graph___vue_template_functional__ = false
/* styles */
var graph___vue_styles__ = graph_injectStyle
/* scopeId */
var graph___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var graph___vue_module_identifier__ = null
var graph_Component = graph_normalizeComponent(
  graph,
  productPrice_graph,
  graph___vue_template_functional__,
  graph___vue_styles__,
  graph___vue_scopeId__,
  graph___vue_module_identifier__
)

/* harmony default export */ var components_productPrice_graph = (graph_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/productPrice/tutorial.vue
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var productPrice_tutorial = ({
  components: {
    tutorialMain: src_components_tutorial_main
  },
  computed: {
    // static
    renderItem: function renderItem() {
      return {
        '零售價格分析與指標': true,
        '零售價格分析操作教學說明': true
      };
    },
    display: function display() {
      return {
        '零售價格分析與指標': false,
        '零售價格分析操作教學說明': true
      };
    },
    toggle: function toggle() {
      return {
        '零售價格分析與指標': null
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e6c7b3d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/productPrice/tutorial.vue
var productPrice_tutorial_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-price-tutorial-page col-block",style:({ height: '100%', width: '100%', 'min-width': '1350px' })},[_c('tutorialMain',{attrs:{"params":{
      renderItem: _vm.renderItem,
      display: _vm.display,
      toggle: _vm.toggle
    }}})],1)}
var productPrice_tutorial_staticRenderFns = []
var productPrice_tutorial_esExports = { render: productPrice_tutorial_render, staticRenderFns: productPrice_tutorial_staticRenderFns }
/* harmony default export */ var components_productPrice_tutorial = (productPrice_tutorial_esExports);
// CONCATENATED MODULE: ./src/components/productPrice/tutorial.vue
var productPrice_tutorial_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var productPrice_tutorial___vue_template_functional__ = false
/* styles */
var productPrice_tutorial___vue_styles__ = null
/* scopeId */
var productPrice_tutorial___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var productPrice_tutorial___vue_module_identifier__ = null
var productPrice_tutorial_Component = productPrice_tutorial_normalizeComponent(
  productPrice_tutorial,
  components_productPrice_tutorial,
  productPrice_tutorial___vue_template_functional__,
  productPrice_tutorial___vue_styles__,
  productPrice_tutorial___vue_scopeId__,
  productPrice_tutorial___vue_module_identifier__
)

/* harmony default export */ var src_components_productPrice_tutorial = (productPrice_tutorial_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/tool/tabButtons.vue
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var tabButtons = ({
  props: {
    state: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      d_state: null
    };
  },

  watch: {
    state: function state() {
      this.d_state = this.state;
    }
  },
  computed: {
    c_state: function c_state() {
      return this.d_state || this.state;
    }
  },
  methods: {
    setFilterState: function setFilterState(state) {
      this.$emit('change', state);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fbfaed1a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/tabButtons.vue
var tabButtons_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.options.length > 0)?_c('ul',{staticClass:"custom",attrs:{"id":"tab-buttons"}},_vm._l((_vm.options),function(option,index){return _c('li',{key:index},[_c('button',{staticClass:"default-shadow",class:{ active: _vm.c_state === option.value },on:{"click":function($event){_vm.setFilterState(option.value)}}},[_c('div',[_c('span',[_vm._v(_vm._s(option.title))])])])])}),0):_vm._e()}
var tabButtons_staticRenderFns = []
var tabButtons_esExports = { render: tabButtons_render, staticRenderFns: tabButtons_staticRenderFns }
/* harmony default export */ var tool_tabButtons = (tabButtons_esExports);
// CONCATENATED MODULE: ./src/components/tool/tabButtons.vue
function tabButtons_injectStyle (ssrContext) {
  __webpack_require__("usg8")
}
var tabButtons_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tabButtons___vue_template_functional__ = false
/* styles */
var tabButtons___vue_styles__ = tabButtons_injectStyle
/* scopeId */
var tabButtons___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tabButtons___vue_module_identifier__ = null
var tabButtons_Component = tabButtons_normalizeComponent(
  tabButtons,
  tool_tabButtons,
  tabButtons___vue_template_functional__,
  tabButtons___vue_styles__,
  tabButtons___vue_scopeId__,
  tabButtons___vue_module_identifier__
)

/* harmony default export */ var components_tool_tabButtons = (tabButtons_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/productPrice/panel.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var panel = ({
  components: {
    productPriceTable: components_productPrice_table,
    productPriceGraph: components_productPrice_graph,
    productPriceTutorial: src_components_productPrice_tutorial,
    tabButtons: components_tool_tabButtons
  },
  mixins: [mixins_userPermission],
  props: {
    minHeight: {
      type: String,
      default: function _default() {
        return null;
      }
    },
    datas: {
      type: Array,
      required: true
    },
    filterOptions: {
      type: Object,
      required: true
    },
    conditions: {
      type: Object,
      required: true
    },
    update: {
      type: Number,
      required: true
    }
  },
  data: function data() {
    return {
      state: 'graph',
      tableDatas: [],
      selectedDatas: []
    };
  },

  computed: {
    tabOptions: function tabOptions() {
      return [{
        title: '統計圖呈現',
        value: 'graph'
      }].concat(toConsumableArray_default()(this.rolePermission(['advance', 'admin']) ? [{
        title: '上傳紀錄',
        value: 'table'
      }] : []));
    }
  },
  watch: {
    'datas': function datas() {
      this.state = 'graph';
    },
    'state': function state(nv) {
      this.$emit('changeState', nv);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29ae773a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/productPrice/panel.vue
var panel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-price-panel-page row-block",style:({ height: _vm.minHeight || '100%' })},[(_vm.datas.length)?_c('div',{staticClass:"main-container col-block",class:[_vm.state]},[_c('div',{staticClass:"tab-block"},[_c('tabButtons',{attrs:{"state":_vm.state,"options":_vm.tabOptions},on:{"change":function (s) { return _vm.state = s; }}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.state === 'graph'),expression:"state === 'graph'"}],staticClass:"main-block",style:({ flex: 1 })},[_c('productPriceGraph',{attrs:{"datas":_vm.datas,"filterOptions":_vm.filterOptions,"conditions":_vm.conditions}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.state === 'table'),expression:"state === 'table'"}],staticClass:"main-field",style:({ flex: 1, 'min-width': '1330px' })},[_c('div',{staticClass:"main-block"},[(_vm.rolePermission(['advance', 'admin']))?_c('productPriceTable',{attrs:{"update":_vm.update}}):_vm._e()],1)])]):_c('div',{staticClass:"tutorial-container container-block"},[_c('productPriceTutorial')],1)])}
var panel_staticRenderFns = []
var panel_esExports = { render: panel_render, staticRenderFns: panel_staticRenderFns }
/* harmony default export */ var productPrice_panel = (panel_esExports);
// CONCATENATED MODULE: ./src/components/productPrice/panel.vue
var panel_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var panel___vue_template_functional__ = false
/* styles */
var panel___vue_styles__ = null
/* scopeId */
var panel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var panel___vue_module_identifier__ = null
var panel_Component = panel_normalizeComponent(
  panel,
  productPrice_panel,
  panel___vue_template_functional__,
  panel___vue_styles__,
  panel___vue_scopeId__,
  panel___vue_module_identifier__
)

/* harmony default export */ var components_productPrice_panel = (panel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/main/productPrice.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var main_productPrice = ({
  components: {
    productPriceFilter: src_components_productPrice_filter,
    productPricePanel: components_productPrice_panel
  },
  mixins: [mixins_routeLoading, toastMethods["a" /* default */]],
  props: {
    minHeight: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      datas: [],
      products: [],
      init: {
        filters: {
          kind: '',
          crop_name: ''
        }
      },
      conditions: {
        filters: {}
      },
      onSearch: false,
      tabState: 'table',
      update: 0
    };
  },

  computed: {
    // static
    kindOptions: function kindOptions() {
      return [{ title: '蔬菜', value: 'vegetable' }, { title: '水果', value: 'fruit' }];
    },
    productOptions: function productOptions() {
      return this.products.map(function (product) {
        return {
          title: product.name,
          value: product.name,
          kind: product.kind
        };
      });
    },
    filterOptions: function filterOptions() {
      return [{
        title: '產品類別',
        value: 'kind',
        type: 'select',
        options: this.kindOptions,
        placeholder: function placeholder() {
          return '水果、蔬菜...';
        }
      }, {
        title: '作物(產品)',
        value: 'crop_name',
        type: 'select',
        options: this.productOptions,
        optionDisplay: function optionDisplay(result) {
          return function (option) {
            return option.kind === result.kind;
          };
        },
        placeholder: function placeholder() {
          return '請選擇產品';
        }
      }];
    }
  },
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setModalAction']), {
    fetchData: function fetchData() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.fetchProducts();

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    fetchProducts: function fetchProducts() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var config, response, products;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                config = _this2.$ls.get('userInfo');
                _context2.next = 4;
                return Object(src_api["v" /* getProductPriceGraphProducts */])(config);

              case 4:
                response = _context2.sent;
                products = response.data.data;

                _this2.products = products;
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](0);
                throw _context2.t0;

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 9]]);
      }))();
    },
    fetchDatas: function fetchDatas() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var config, conditions, response, datas;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.onSearch = true;
                _context3.prev = 1;
                config = _this3.$ls.get('userInfo');
                conditions = _this3.conditions.filters;
                _context3.next = 6;
                return Object(src_api["w" /* getProductPriceResults */])(conditions, config);

              case 6:
                response = _context3.sent;
                datas = response.data.data;

                _this3.datas = datas;
                _context3.next = 15;
                break;

              case 11:
                _context3.prev = 11;
                _context3.t0 = _context3['catch'](1);

                _this3.datas = [];
                if (_context3.t0.response.status === 429) {
                  _this3.addToast('error', '您的操作過於頻繁，請稍後再繼續。');
                }

              case 15:
                _this3.onSearch = false;

              case 16:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[1, 11]]);
      }))();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9e6170fc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/main/productPrice.vue
var productPrice_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-price-page row-block",style:({ minHeight: _vm.minHeight })},[_c('div',{staticClass:"filter-container",style:({ width: '250px' })},[_c('productPriceFilter',{attrs:{"minHeight":_vm.minHeight,"disabled":false,"title":'農產品零售價格分析',"filters":{
        init: _vm.init.filters,
        options: _vm.filterOptions
      }},on:{"changeFilters":function (c) { _vm.conditions.filters = c; _vm.fetchDatas() },"updateList":function () { return _vm.update = _vm.update + 1; }}})],1),_vm._v(" "),_c('div',{staticClass:"panel-container",style:({ flex: 1 })},[(_vm.onSearch)?_c('div',{staticClass:"mask center-block"},[_c('img',{attrs:{"src":__webpack_require__("5xS/"),"alt":""}})]):_vm._e(),_vm._v(" "),_c('productPricePanel',{attrs:{"minHeight":_vm.minHeight,"datas":_vm.datas,"filterOptions":{
        filters: _vm.filterOptions
      },"conditions":_vm.conditions,"update":_vm.update},on:{"changeState":function (s) { return _vm.tabState = s; }}})],1)])}
var productPrice_staticRenderFns = []
var productPrice_esExports = { render: productPrice_render, staticRenderFns: productPrice_staticRenderFns }
/* harmony default export */ var pages_main_productPrice = (productPrice_esExports);
// CONCATENATED MODULE: ./src/pages/main/productPrice.vue
var productPrice_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var productPrice___vue_template_functional__ = false
/* styles */
var productPrice___vue_styles__ = null
/* scopeId */
var productPrice___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var productPrice___vue_module_identifier__ = null
var productPrice_Component = productPrice_normalizeComponent(
  main_productPrice,
  pages_main_productPrice,
  productPrice___vue_template_functional__,
  productPrice___vue_styles__,
  productPrice___vue_scopeId__,
  productPrice___vue_module_identifier__
)

/* harmony default export */ var src_pages_main_productPrice = (productPrice_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/report/filter.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var report_filter = ({
  components: {
    customFilter: components_tool_customFilter
  },
  props: {
    minHeight: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    filters: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      init: {},
      conditions: {
        filters: {}
      }
    };
  },
  created: function created() {
    this.init = this.filters.init;
  },

  watch: {
    'filters': function filters() {
      this.init = this.filters.init;
    }
  },
  methods: {
    filtersOnChange: function filtersOnChange(conditions) {
      // const init = !Object.values(this.conditions.filters).every(x => x)
      this.conditions.filters = conditions;
      this.updateFilter(false);
    },
    updateFilter: function updateFilter() {
      var search = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      this.$emit('changeFilters', JSON.parse(stringify_default()(value || this.conditions.filters)), search);
    },
    clearFilter: function clearFilter() {
      var _this = this;

      this.init = {};
      setTimeout(function () {
        return _this.updateFilter(true, {});
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3562c9ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/report/filter.vue
var report_filter_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"report-filter-page col-block default-shadow",style:({ height: _vm.minHeight })},[(_vm.disabled)?_c('div',{staticClass:"mask"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"title-container center-block"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"filter-container"},[_c('customFilter',{attrs:{"init":_vm.init,"filters":_vm.filters.options},on:{"change":function (conditions) { return _vm.filtersOnChange(conditions); },"pressEnter":function () { return _vm.updateFilter(); }}}),_vm._v(" "),_c('div',{staticClass:"button col-block"},[_c('button',{staticClass:"main-button",attrs:{"type":"button","name":"button"},on:{"click":function (e) { return _vm.updateFilter(); }}},[_c('span',[_vm._v("搜尋")])]),_vm._v(" "),_c('div',{style:({ height: '15px' })}),_vm._v(" "),_c('button',{staticClass:"white-button",attrs:{"type":"button","name":"button"},on:{"click":function (e) { return _vm.clearFilter(); }}},[_c('span',[_vm._v("清除")])])]),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"tutorial-link",on:{"click":function (e) { return _vm.$router.push({ name: 'tutorial', query: { to: '分析報告與操作說明' } }); }}},[_vm._v("•"),_c('span',{staticClass:"link"},[_vm._v("分析報告與操作說明")])])],1),_vm._v(" "),_c('div',{staticClass:"other-container col-block",style:({ flex: 1 })},[_c('div',{style:({ flex: 1 })})])])}
var report_filter_staticRenderFns = []
var report_filter_esExports = { render: report_filter_render, staticRenderFns: report_filter_staticRenderFns }
/* harmony default export */ var components_report_filter = (report_filter_esExports);
// CONCATENATED MODULE: ./src/components/report/filter.vue
var report_filter_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var report_filter___vue_template_functional__ = false
/* styles */
var report_filter___vue_styles__ = null
/* scopeId */
var report_filter___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var report_filter___vue_module_identifier__ = null
var report_filter_Component = report_filter_normalizeComponent(
  report_filter,
  components_report_filter,
  report_filter___vue_template_functional__,
  report_filter___vue_styles__,
  report_filter___vue_scopeId__,
  report_filter___vue_module_identifier__
)

/* harmony default export */ var src_components_report_filter = (report_filter_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/main/report.vue








//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var main_report = ({
  components: {
    reportFilter: src_components_report_filter,
    pageButtons: components_tool_pageButtons
  },
  mixins: [mixins_routeLoading, toastMethods["a" /* default */]],
  props: {
    minHeight: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      reports: [],
      productByCategorys: [],
      init: {},
      filters: {},
      onSearch: false,
      pageData: {
        selectedPage: 1,
        display: 12,
        total: null,
        buttonRange: 7
      },
      sort: {
        value: ['publish_time'],
        order: ['desc']
      },
      reportBlock: {
        width: 300,
        fillCount: 0
      }
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['countrys']), {
    categoryOptions: function categoryOptions() {
      return [].concat(toConsumableArray_default()(keys_default()(this.productByCategorys).map(function (category) {
        return { title: category, value: category };
      })), [{ title: '其他', value: '其他' }]);
    },
    productOptions: function productOptions() {
      return [].concat(toConsumableArray_default()(Array.prototype.concat.apply([], entries_default()(this.productByCategorys).map(function (_ref) {
        var _ref2 = slicedToArray_default()(_ref, 2),
            category = _ref2[0],
            products = _ref2[1];

        return entries_default()(products).map(function (_ref3) {
          var _ref4 = slicedToArray_default()(_ref3, 2),
              code = _ref4[0],
              product = _ref4[1];

          return { title: product.chinese_name + '(' + code + ')', value: code, type: product.product_type, category: category };
        });
      }))), [{ title: '其他', value: '其他', type: '其他', category: '其他' }]);
    },
    moduleOptions: function moduleOptions() {
      return [{ title: '市場吸引力', value: 'market_attractiveness' }, { title: '市場競爭力', value: 'market_competitiveness' }, { title: '零售價格分析', value: 'product_prices' }, { title: '其他', value: 'others' }];
    },
    yearOptions: function yearOptions() {
      var year = new Date().getFullYear();
      return [{ title: '無', value: '無' }].concat(toConsumableArray_default()(new Array(year - 2000).fill('').map(function (_, i) {
        return { title: year - i + '', value: year - i + '' };
      })));
    },
    countryOptions: function countryOptions() {
      return this.countrys.map(function (_ref5) {
        var _ref6 = slicedToArray_default()(_ref5, 2),
            key = _ref6[0],
            value = _ref6[1];

        return {
          title: value.chinese_name + '(' + value.iso_name + ')',
          value: key,
          country: value
        };
      });
    },

    // static
    filterOptions: function filterOptions() {
      var _this = this;

      return [{
        title: '標題關鍵字',
        value: 'title',
        type: 'input',
        options: this.kindOptions,
        placeholder: function placeholder() {
          return '如：產業報告...等';
        }
      }, {
        title: '產品類別',
        value: 'category',
        type: 'select',
        options: this.categoryOptions,
        placeholder: function placeholder() {
          return '水果、蔬菜、農業機械...等';
        },
        onChange: function onChange(value, conditions) {
          setTimeout(function () {
            _this.init = extends_default()({}, _this.init, conditions, {
              product_code: ''
            });
          });
        }
      }, {
        title: '產品名稱',
        value: 'product_code',
        type: 'select',
        options: this.productOptions,
        optionDisplay: function optionDisplay(result) {
          return function (option) {
            return option.category === result.category;
          };
        },
        placeholder: function placeholder() {
          return '請選擇產品';
        }
      }, {
        title: '國家',
        value: 'countries',
        type: 'datalist',
        lists: function lists(value) {
          return _this.countryOptions.map(function (option) {
            return option.title;
          });
        },
        options: this.countryOptions,
        placeholder: function placeholder() {
          return '請選擇國家';
        },
        onChange: function onChange(value) {
          if (value && !_this.countryOptions.some(function (option) {
            return option.title === value;
          })) {
            _this.init = extends_default()({}, _this.init, _this.filters, {
              countries: ''
            });
          }
        }
      }, {
        title: '分析模組',
        value: 'module',
        type: 'select',
        options: this.moduleOptions,
        placeholder: function placeholder() {
          return '請選擇分析模組';
        }
      }, {
        title: '年份',
        value: 'year',
        type: 'select',
        options: this.yearOptions,
        placeholder: function placeholder() {
          return '請選擇年份';
        }
      }];
    },

    // global
    htmlDecode: function htmlDecode() {
      return util["f" /* htmlDecode */];
    }
  }),
  beforeMount: function beforeMount() {
    window.addEventListener('resize', this.onWindowResize);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onWindowResize);
  },

  watch: {
    'reports.length': function reportsLength() {
      this.onWindowResize();
    }
  },
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setLoadingAction', 'setModalAction']), {
    fetchData: function fetchData() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.fetchProductByCategorys();

              case 2:
                _context.next = 4;
                return _this2.fetchReports();

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    fetchProductByCategorys: function fetchProductByCategorys() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var config, response, productByCategorys;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                config = _this3.$ls.get('userInfo');
                _context2.next = 4;
                return Object(src_api["r" /* getProductByCategorys */])(config);

              case 4:
                response = _context2.sent;
                productByCategorys = response.data;

                _this3.productByCategorys = productByCategorys;
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](0);
                throw _context2.t0;

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[0, 9]]);
      }))();
    },
    fetchReports: function fetchReports(filters) {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var config, data, response, reports;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                config = _this4.$ls.get('userInfo');

                filters = filters || _this4.filters || {};
                data = extends_default()({}, entries_default()(filters).filter(function (kv) {
                  return kv[1];
                }).reduce(function (s, kv) {
                  return extends_default()({}, s, defineProperty_default()({}, kv[0], kv[1]));
                }, {}), {
                  year: filters.year === '無' ? '' : filters.year || null,
                  product_code: filters.product_code === '其他' ? '' : filters.product_code || null,
                  countries: (_this4.countryOptions.find(function (option) {
                    return option.title === filters.countries;
                  }) || {}).value || null
                });

                _this4.pageData.selectedPage && (data.page = _this4.pageData.selectedPage);
                _this4.pageData.display && (data.item_per_page = _this4.pageData.display);
                _this4.sort.value[0] && (data.order_by = _this4.sort.value[0]);
                _this4.sort.order[0] && (data.order_method = _this4.sort.order[0].replace(/^-/, ''));
                _context3.next = 10;
                return Object(src_api["C" /* getReports */])(data, config);

              case 10:
                response = _context3.sent;
                reports = response.data.data.elements;

                _this4.pageData.total = response.data.data.items_count;
                _this4.reports = reports;
                _context3.next = 19;
                break;

              case 16:
                _context3.prev = 16;
                _context3.t0 = _context3['catch'](0);
                throw _context3.t0;

              case 19:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4, [[0, 16]]);
      }))();
    },
    searchDatas: function searchDatas(init) {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this5.onSearch = true;
                if (init) {
                  _this5.init = init;
                  _this5.filter = init;
                }
                _context4.next = 4;
                return _this5.fetchReports(init);

              case 4:
                _this5.onSearch = false;

              case 5:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    },
    reportDetail: function reportDetail(report) {
      this.setModalAction({
        action: 'reportDetail',
        width: '900px',
        customStyles: {
          padding: '20px',
          margin: '20px auto',
          borderRadius: '0'
        },
        param: {
          data: report,
          func: {
            getReportTags: this.getReportTags,
            setFilter: this.setFilter
          }
        }
      });
    },
    getDateCompare: function getDateCompare(date) {
      var value = new Date() - date;
      var compare = 0;
      var list = [{ title: '分鐘', value: 60 * 1000 }, { title: '小時', value: 60 * 60 * 1000 }, { title: '天', value: 24 * 60 * 60 * 1000 }, { title: '週', value: 7 * 24 * 60 * 60 * 1000 }, { title: '個月', value: 30 * 24 * 60 * 60 * 1000 }, { title: '', value: 9 * 30 * 24 * 60 * 60 * 1000 }];
      while (compare < list.length) {
        if (value < list[compare].value) {
          return (compare ? Math.floor(value / list[compare - 1].value) + list[compare - 1].title : '0分鐘') + '前';
        }
        compare++;
      }
      return Object(util["b" /* dateFormat */])(date, 'yyyy/MM/dd hh:mm');
    },
    getReportTags: function getReportTags(report) {
      var _this6 = this;

      var tags = [];
      var product = this.productOptions.find(function (option) {
        return option.title === report.product_name || option.value === report.product_code;
      });
      if (product) {
        tags.push({
          title: product.title,
          filter: {
            category: product.category,
            product_code: product.value
          }
        });
      }
      if (report.countries && report.countries.length) {
        tags = [].concat(toConsumableArray_default()(tags), toConsumableArray_default()(report.countries.map(function (country) {
          return _this6.countryOptions.find(function (option) {
            return option.value === country;
          });
        }).filter(function (x) {
          return x;
        }).map(function (option) {
          return {
            title: option.country.chinese_name,
            filter: {
              countries: option.title
            }
          };
        })));
      }
      var _module = this.moduleOptions.find(function (option) {
        return option.value === report.module;
      });
      if (_module) {
        tags.push({
          title: _module.title,
          filter: {
            module: _module.value
          }
        });
      }
      var year = this.yearOptions.find(function (option) {
        return option.value + '' === report.year + '';
      });
      if (year) {
        tags.push({
          title: year.title,
          filter: {
            year: year.value
          }
        });
      }
      return tags;
    },
    setFilter: function setFilter(filter) {
      this.filter = extends_default()({}, filter);
      this.searchDatas(this.filter);
    },
    onWindowResize: function onWindowResize() {
      var containerWidth = this.$refs['report-main'].offsetWidth;
      var reportBlockWidth = this.reportBlock.width + 25;
      var reportCount = Math.floor(containerWidth / reportBlockWidth);
      var fillCount = reportCount - (this.reports.length - Math.floor(this.reports.length / reportCount) * reportCount);
      this.reportBlock.fillCount = fillCount;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7358df6a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/main/report.vue
var report_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"report-page row-block",style:({ minHeight: _vm.minHeight })},[_c('div',{staticClass:"filter-container",style:({ width: '250px' })},[_c('reportFilter',{attrs:{"minHeight":_vm.minHeight,"disabled":false,"title":'分析報告搜尋',"filters":{
        init: _vm.init,
        options: _vm.filterOptions
      }},on:{"changeFilters":function (c, search) { _vm.filters = c; search && _vm.searchDatas(c) }}})],1),_vm._v(" "),_c('div',{staticClass:"main-container row-block",style:({ flex: 1, height: _vm.minHeight })},[(_vm.onSearch)?_c('div',{staticClass:"mask center-block",style:({ height: '100%', width: '100%', 'min-width': '1000px' })},[_c('img',{attrs:{"src":__webpack_require__("5xS/"),"alt":""}})]):_vm._e(),_vm._v(" "),_c('div',{ref:"report-main",staticClass:"main-block col-block",style:({ height: '100%', width: '100%', 'min-width': '1000px' })},[_c('div',{staticClass:"report-container col-block",style:({ flex: 1, height: 0 })},[_c('div',{staticClass:"report-field-container row-block stretch"},_vm._l((_vm.reports.concat((new Array(_vm.reportBlock.fillCount)).fill({}))),function(report,index){return _c('div',{key:index,staticClass:"report-field"},[(report.id)?_c('div',{staticClass:"report-block default-shadow col-block",style:({ width: _vm.reportBlock.width + 'px' })},[_c('div',{staticClass:"cover-container"},[_c('div',{staticClass:"cover-block center-block",on:{"click":function (e) { return _vm.reportDetail(report); }}},[_c('img',{attrs:{"src":report.cover_photo_url || __webpack_require__("hp+x"),"alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"content-container col-block"},[_c('div',{staticClass:"date"},[_vm._v(_vm._s('發表時間：' + _vm.getDateCompare(new Date(report.publish_time))))]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v(_vm._s(report.title.substring(0, 25) + (report.title.length > 25 ? '...' : '')))]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._v(_vm._s(report.content ? _vm.htmlDecode((report.content).replace(/\<.+?\>/g, '')).substring(0, 55) + (_vm.htmlDecode((report.content).replace(/\<.+?\>/g, '')).length > 55 ? '...' : '') : '沒有文字內容'))]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"option row-block"},[_c('div',{staticClass:"detail",on:{"click":function (e) { return _vm.reportDetail(report); }}},[_vm._v("更多內容")]),_vm._v(" "),_c('div',{staticClass:"comment row-block"},[_c('img',{attrs:{"src":__webpack_require__("v3Qp"),"alt":""}}),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('div',{staticClass:"count"},[_vm._v(_vm._s(report.comments_count))])])]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"tags row-block"},_vm._l((_vm.getReportTags(report)),function(tag,tindex){return _c('div',{key:tindex,staticClass:"tag-field"},[_c('div',{staticClass:"tag-block"},[_c('div',{staticClass:"tag-title",on:{"click":function (e) { return _vm.setFilter(tag.filter); }}},[_vm._v(_vm._s(tag.title + ','))])])])}),0),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]):_c('div',{staticClass:"report-block empty",style:({ width: _vm.reportBlock.width + 'px' })})])}),0),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{staticClass:"page-container center-block"},[(_vm.pageData.total)?_c('pageButtons',{attrs:{"default":_vm.pageData.selectedPage,"display":_vm.pageData.display,"total":_vm.pageData.total,"buttonRange":_vm.pageData.buttonRange},on:{"selectPage":function (page) { _vm.pageData.selectedPage = page; _vm.searchDatas() }}}):_vm._e()],1)])])])}
var report_staticRenderFns = []
var report_esExports = { render: report_render, staticRenderFns: report_staticRenderFns }
/* harmony default export */ var pages_main_report = (report_esExports);
// CONCATENATED MODULE: ./src/pages/main/report.vue
var report_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var report___vue_template_functional__ = false
/* styles */
var report___vue_styles__ = null
/* scopeId */
var report___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var report___vue_module_identifier__ = null
var report_Component = report_normalizeComponent(
  main_report,
  pages_main_report,
  report___vue_template_functional__,
  report___vue_styles__,
  report___vue_scopeId__,
  report___vue_module_identifier__
)

/* harmony default export */ var src_pages_main_report = (report_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/loading.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var dialog_loading = ({});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2abe38ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/loading.vue
var dialog_loading_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-dialog"},[_c('div',{staticClass:"img-box"},[_c('img',{attrs:{"src":__webpack_require__("F7NO")}})])])}
var dialog_loading_staticRenderFns = []
var dialog_loading_esExports = { render: dialog_loading_render, staticRenderFns: dialog_loading_staticRenderFns }
/* harmony default export */ var components_dialog_loading = (dialog_loading_esExports);
// CONCATENATED MODULE: ./src/components/dialog/loading.vue
var dialog_loading_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var dialog_loading___vue_template_functional__ = false
/* styles */
var dialog_loading___vue_styles__ = null
/* scopeId */
var dialog_loading___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var dialog_loading___vue_module_identifier__ = null
var dialog_loading_Component = dialog_loading_normalizeComponent(
  dialog_loading,
  components_dialog_loading,
  dialog_loading___vue_template_functional__,
  dialog_loading___vue_styles__,
  dialog_loading___vue_scopeId__,
  dialog_loading___vue_module_identifier__
)

/* harmony default export */ var src_components_dialog_loading = (dialog_loading_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/container.vue

//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var container = ({
  components: {
    dialogLoading: src_components_dialog_loading
  },
  props: {
    width: {
      type: String,
      default: function _default() {
        return '400px';
      }
    },
    height: {
      type: String,
      default: function _default() {
        return 'auto';
      }
    },
    customStyles: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['isDialogLoading']), {
    containerStyle: function containerStyle() {
      return extends_default()({}, this.customStyles, { height: this.height, width: this.width });
    }
  }),
  methods: {
    closeModal: function closeModal(e) {
      if (!['modal-mask', 'modal-wrapper'].includes(e.target.className)) {
        return;
      }
      this.$emit('hide');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0883ce04","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/container.vue
var container_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask",on:{"click":_vm.closeModal}},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-container",style:(_vm.containerStyle)},[_vm._t("default"),_vm._v(" "),(_vm.isDialogLoading)?_c('dialogLoading'):_vm._e()],2)])])])}
var container_staticRenderFns = []
var container_esExports = { render: container_render, staticRenderFns: container_staticRenderFns }
/* harmony default export */ var dialog_container = (container_esExports);
// CONCATENATED MODULE: ./src/components/dialog/container.vue
function container_injectStyle (ssrContext) {
  __webpack_require__("pBN0")
}
var container_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var container___vue_template_functional__ = false
/* styles */
var container___vue_styles__ = container_injectStyle
/* scopeId */
var container___vue_scopeId__ = "data-v-0883ce04"
/* moduleIdentifier (server only) */
var container___vue_module_identifier__ = null
var container_Component = container_normalizeComponent(
  container,
  dialog_container,
  container___vue_template_functional__,
  container___vue_styles__,
  container___vue_scopeId__,
  container___vue_module_identifier__
)

/* harmony default export */ var components_dialog_container = (container_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/toast.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var dialog_toast = ({
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21713a2d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/toast.vue
var dialog_toast_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-toast",class:[_vm.param.type]},[_c('div',{staticClass:"content-block row-block"},[_c('img',{attrs:{"src":{
      success: __webpack_require__("ct0j"),
      error: __webpack_require__("fc/Z")
    }[_vm.param.type]}}),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('div',{staticClass:"content",class:[_vm.param.type],style:({ flex: 1 }),domProps:{"innerHTML":_vm._s(_vm.param.content)}})]),_vm._v(" "),_c('div',{staticClass:"button-row"},_vm._l((_vm.param.buttons || []),function(button,index){return _c('button',{key:index,class:[button.type + '-button'],style:(button.style || {}),on:{"click":function($event){_vm.$emit('changeModal', {}, button.result)}}},[_c('span',[_vm._v(_vm._s(button.title))])])}),0)])}
var dialog_toast_staticRenderFns = []
var dialog_toast_esExports = { render: dialog_toast_render, staticRenderFns: dialog_toast_staticRenderFns }
/* harmony default export */ var components_dialog_toast = (dialog_toast_esExports);
// CONCATENATED MODULE: ./src/components/dialog/toast.vue
var dialog_toast_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var dialog_toast___vue_template_functional__ = false
/* styles */
var dialog_toast___vue_styles__ = null
/* scopeId */
var dialog_toast___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var dialog_toast___vue_module_identifier__ = null
var dialog_toast_Component = dialog_toast_normalizeComponent(
  dialog_toast,
  components_dialog_toast,
  dialog_toast___vue_template_functional__,
  dialog_toast___vue_styles__,
  dialog_toast___vue_scopeId__,
  dialog_toast___vue_module_identifier__
)

/* harmony default export */ var src_components_dialog_toast = (dialog_toast_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/tool/analysisTable.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var analysisTable = ({
  components: {
    borCor: components_tool_borCor
  },
  props: {
    dataType: {
      type: String,
      required: true
    },
    datas: {
      type: Array,
      required: true
    },
    option: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      default: function _default() {
        return 'table';
      }
    },
    init: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    onSelected: {
      type: Function,
      default: null
    }
  },
  data: function data() {
    return {
      selected: []
    };
  },

  computed: {
    tableDatas: function tableDatas() {
      var tableDatas = this.datas;
      return tableDatas;
    },

    // global
    toPriceString: function toPriceString() {
      return util["m" /* toPriceString */];
    }
  },
  created: function created() {
    this.selected = this.init;
  },

  watch: {
    'init': function init() {
      this.selected = this.init;
    },
    'selected': function selected() {
      this.onSelected(this.selected);
    }
  },
  methods: {
    tableSortBy: function tableSortBy(value) {
      var position = this.sort.value.indexOf(value);
      if (position === 0) {
        var order = this.sort.order[position] === '-asc' ? '-desc' : '-asc';
        this.sort.order.splice(position, 1);
        this.sort.order.unshift(order);
      } else {
        var _order = position !== -1 ? this.sort.order[position] === '-asc' ? '-desc' : '-asc' : undefined;
        position = position !== -1 ? position : 2;
        this.sort.value.splice(position, 1);
        this.sort.order.splice(position, 1);
        this.sort.value.unshift(value);
        this.sort.order.unshift(_order || '-asc');
      }
      this.$emit('onSort', this.sort);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d35c6bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/analysisTable.vue
var analysisTable_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"analysis-table-container"}},[_c('table',{staticClass:"analysis-table-line sticky",class:[_vm.type, { 'bottom-line': !_vm.tableDatas.length }, { fixed: false }]},[_c('thead',[_c('tr',{staticClass:"none-line",class:[{ country: 'country', year: 'year' }[_vm.dataType], { long: _vm.option.index.width === 88 }]},[(_vm.onSelected)?_c('th',{staticClass:"selected",attrs:{"width":'auto'}},[_c('div',{staticClass:"col-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('label',{attrs:{"for":'select-all-' + _vm.dataType}},[_c('div',{domProps:{"innerHTML":_vm._s('選擇')}}),_vm._v(" "),_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"},{name:"model",rawName:"v-model",value:([].concat( _vm.selected ).length),expression:"[...selected].length"}],attrs:{"type":"checkbox","id":'select-all-' + _vm.dataType},domProps:{"checked":Array.isArray([].concat( _vm.selected ).length)?_vm._i([].concat( _vm.selected ).length,null)>-1:([].concat( _vm.selected ).length)},on:{"change":[function($event){var $$a=[].concat( _vm.selected ).length,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set([].concat( _vm.selected ), "length", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set([].concat( _vm.selected ), "length", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set([].concat( _vm.selected ), "length", $$c)}},function (e) { return _vm.selected = e.target.checked ? _vm.tableDatas : []; }]}}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("TEyu")("./checkbox-" + ([].concat( _vm.selected ).length ? [].concat( _vm.selected ).length < _vm.tableDatas.length ? 'minus' : 'true' : 'false') + '.svg')}})]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]):_vm._e(),_vm._v(" "),(_vm.dataType === 'country')?_c('th',{style:({ width: _vm.option.index.width + 'px', minWidth: _vm.option.index.width + 'px', maxWidth: _vm.option.index.width + 'px' })},[_c('div',{staticClass:"row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',[_vm._v("排名")]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]):_vm._e(),_vm._v(" "),_c('th',{style:({ width: { country: _vm.option.country.width, year: _vm.option.year.width }[_vm.dataType] + 'px', minWidth: { country: _vm.option.country.width, year: _vm.option.year.width }[_vm.dataType] + 'px', maxWidth: { country: _vm.option.country.width, year: _vm.option.year.width }[_vm.dataType] + 'px' })},[_c('div',{staticClass:"row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',[_vm._v(_vm._s({ country: _vm.option.country.title, year: _vm.option.year.title }[_vm.dataType]))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_vm._l((_vm.option.contents),function(content,index){return _c('th',{key:index,style:({ 'z-index': _vm.option.contents.length - index }),attrs:{"width":'auto'}},[_c('div',{staticClass:"row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(content.title.join('<br>'))}}),_vm._v(" "),(content.description || content.alert)?[_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('div',{staticClass:"info-icon-container"},[_c('img',{staticClass:"info-icon",attrs:{"src":__webpack_require__("ia3f")}}),_vm._v(" "),_c('div',{staticClass:"info-container"},[_c('span',{staticClass:"info-bor-cor"}),_vm._v(" "),_c('div',{staticClass:"info-block col-block default-shadow"},[(content.description)?_c('div',{staticClass:"description"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(content.description.title + ':'))]),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._v(_vm._s(content.description.content))])]):_vm._e(),_vm._v(" "),(content.description && content.alert)?_c('div',{style:({ height: '5px' })}):_vm._e(),_vm._v(" "),(content.alert)?_c('div',{staticClass:"alert"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(content.alert.title))]),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._v(_vm._s(content.alert.content))])]):_vm._e()])])])]:_vm._e(),_vm._v(" "),_c('div',{style:({ flex: 1 })})],2)])}),_vm._v(" "),(_vm.option.contents.length)?_c('th',{style:({ width: '120px', minWidth: '120px', maxWidth: '120px' }),attrs:{"width":'auto'}},[_c('div',{staticClass:"row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('center',{domProps:{"innerHTML":_vm._s({
                country: [
                  '分數總計'
                ],
                year: [
                  '標準化總分之',
                  '世界總排名'
                ]
              }[_vm.dataType].join('<br>'))}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})],1)]):_vm._e()],2)]),_vm._v(" "),_c('tbody',[_vm._l((_vm.tableDatas),function(data,dindex){return [_c('tr',{key:dindex * 2,staticClass:"none-line",class:[{ country: 'country', year: 'year' }[_vm.dataType], { long: _vm.option.index.width === 88 }]},[(_vm.onSelected)?_c('td',{staticClass:"selected",attrs:{"rowspan":"2"}},[_c('label',{attrs:{"for":'selected' + _vm.dataType + dindex}},[_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"},{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],attrs:{"type":"checkbox","id":'selected' + _vm.dataType + dindex},domProps:{"value":data,"checked":Array.isArray(_vm.selected)?_vm._i(_vm.selected,data)>-1:(_vm.selected)},on:{"change":function($event){var $$a=_vm.selected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=data,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selected=$$c}}}}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("TEyu")("./checkbox-" + (_vm.selected.includes(data) ? 'true' : 'false') + '.svg')}})])]):_vm._e(),_vm._v(" "),(_vm.dataType === 'country')?_c('td',{staticClass:"table-content ranking",class:{ description: data.display_description },attrs:{"rowspan":"2"}},[_c('div',{staticClass:"col-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.selected.includes(data) ? dindex + 1 : '--'))]),_vm._v(" "),(data.display_description)?_c('div',{staticClass:"description"},[(data.display_description)?_c('borCor',{attrs:{"width":'180px',"type":!dindex ? 'bottom' : 'top',"background":'#FFFCEF',"border":'transparent',"blockStyle":{
                    'padding': '10px',
                    'font-size': '12px',
                    'font-weight': '400',
                    'text-align': 'left',
                    'line-height': '18px'
                  }}},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('div',{staticClass:"img-container center-block"},[_c('img',{attrs:{"src":__webpack_require__("ka30"),"alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"content",attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(data.display_description)}})])]):_vm._e()],1):_vm._e(),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]):_vm._e(),_vm._v(" "),_c('td',{attrs:{"rowspan":"2"}},[_c('div',{staticClass:"table-content",class:[{ country: 'country', year: 'year' }[_vm.dataType]],domProps:{"innerHTML":_vm._s({
                country: [
                  data[_vm.option.country.name],
                  data[_vm.option.country.subName]
                ],
                year: [
                  data[_vm.option.year.name]
                ]
              }[_vm.dataType].join('<br>'))},on:{"click":function (e) { return _vm.$emit({ country: 'countryOnClick', year: 'yearOnClick' }[_vm.dataType], data); }}}),_vm._v(" "),(_vm.dataType === 'country' && data.hasReport)?_c('div',{staticClass:"report-icon",on:{"click":function (e) { return _vm.$emit('reportOnClick', data); }}},[_c('img',{attrs:{"src":__webpack_require__("C0KS"),"alt":""}})]):_vm._e()]),_vm._v(" "),_vm._l((_vm.option.contents),function(content,oindex){return _c('td',{key:oindex},[_c('span',{staticClass:"table-content"},[_vm._v(_vm._s((content.display || (function (x) { return x; }))(data[content.value]) || 'n/a'))])])}),_vm._v(" "),(_vm.option.contents.length)?_c('td',{staticClass:"table-content total",attrs:{"rowspan":"2"}},[_c('div',[_vm._v(_vm._s({ country: _vm.toPriceString(data['display_total_standardization'].toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: data['total_standardization_order'] }[_vm.dataType]))])]):_vm._e()],2),_vm._v(" "),_c('tr',{key:dindex * 2 + 1,staticClass:"none-line",class:[{ country: 'country', year: 'year' }[_vm.dataType]]},_vm._l((_vm.option.contents),function(content,oindex){return _c('td',{key:oindex},[_c('span',{staticClass:"table-content"},[_vm._v(_vm._s((content.subDisplay || (function (x) { return x; }))({ country: data.display_standardization[content.value], year: data.standardization[content.value + '_order'] }[_vm.dataType]) || { country: 0, year: 'n/a' }[_vm.dataType]))])])}),0)]})],2)])])}
var analysisTable_staticRenderFns = []
var analysisTable_esExports = { render: analysisTable_render, staticRenderFns: analysisTable_staticRenderFns }
/* harmony default export */ var tool_analysisTable = (analysisTable_esExports);
// CONCATENATED MODULE: ./src/components/tool/analysisTable.vue
function analysisTable_injectStyle (ssrContext) {
  __webpack_require__("MpsS")
}
var analysisTable_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var analysisTable___vue_template_functional__ = false
/* styles */
var analysisTable___vue_styles__ = analysisTable_injectStyle
/* scopeId */
var analysisTable___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var analysisTable___vue_module_identifier__ = null
var analysisTable_Component = analysisTable_normalizeComponent(
  analysisTable,
  tool_analysisTable,
  analysisTable___vue_template_functional__,
  analysisTable___vue_styles__,
  analysisTable___vue_scopeId__,
  analysisTable___vue_module_identifier__
)

/* harmony default export */ var components_tool_analysisTable = (analysisTable_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/analysis/table.vue










//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var analysis_table = ({
  components: {
    analysisTable: components_tool_analysisTable
  },
  mixins: [mixins_userPermission, toastMethods["a" /* default */]],
  props: {
    dataType: {
      type: String,
      required: true
    },
    country: {
      Type: Object,
      default: function _default() {
        return null;
      }
    },
    curSelectedDatas: {
      type: Array,
      required: true
    },
    datas: {
      type: Array,
      required: true
    },
    reportCountrys: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    state: {
      type: String,
      required: true
    },
    filterOptions: {
      type: Object,
      required: true
    },
    conditions: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      selectedDatas: null
    };
  },
  created: function created() {
    this.selectedDatas = this.tableDatas;
  },

  computed: {
    analysisType: function analysisType() {
      return this.$route.name;
    },
    tableDatas: function tableDatas() {
      var _this = this;

      var tableDatas = this.datas;
      tableDatas = {
        country: {
          competitiveness: Object(util["j" /* sortData */])(Object(util["j" /* sortData */])(tableDatas.filter(function (data) {
            return data.addition.partner_import_country_value !== null;
          }), function (data) {
            return data.addition.partner_import_country_value;
          }, 'desc').slice(0, 5), 'total_standardization_order'),
          attraction: Object(util["j" /* sortData */])(tableDatas, 'total_standardization_order').slice(0, 20),
          toolcompetitiveness: Object(util["j" /* sortData */])(Object(util["j" /* sortData */])(tableDatas.filter(function (data) {
            return data.addition.partner_import_country_value !== null;
          }), function (data) {
            return data.addition.partner_import_country_value;
          }, 'desc').slice(0, 5), 'total_standardization_order'),
          toolattraction: Object(util["j" /* sortData */])(tableDatas, 'total_standardization_order').slice(0, 20)
        },
        year: {
          competitiveness: tableDatas,
          attraction: tableDatas,
          toolcompetitiveness: tableDatas,
          toolattraction: tableDatas
        }
      }[this.dataType][this.analysisType];
      if (['country'].includes(this.dataType)) {
        if (['competitiveness', 'toolcompetitiveness'].includes(this.analysisType)) {
          var taiwan = this.datas.find(function (data) {
            return data.country_name === '台灣';
          });
          if (taiwan) {
            var datas = Object(util["j" /* sortData */])(this.datas.filter(function (data) {
              return data.addition.partner_import_country_value !== null;
            }), [function (data) {
              return data.addition.partner_import_country_value;
            }, function (data) {
              return data.country_name === '台灣' ? 0 : 1;
            }], 'desc');
            taiwan.display_description = '<b>' + this.getFilterTitle('country').replace(/\(.*\)$/, '') + '</b> 進口該品項之進口值，' + (taiwan.addition.partner_import_country_value !== 0 ? taiwan.addition.partner_import_country_value ? '台灣排在第<b>' + (datas.indexOf(taiwan) + 1) + '</b>名' : '沒有來自台灣' : '台灣為０') + '。(排名與數值皆根據ITC提供之資料，若需詳細數值可參考其他網站)';
            !tableDatas.includes(taiwan) && tableDatas.push(taiwan);
          }
        }
        tableDatas = tableDatas.map(function (data) {
          var standardization = _this.tableOption.contents.reduce(function (s, c) {
            return extends_default()({}, s, defineProperty_default()({}, c.value, _this.getStandardizationPoint(tableDatas, data, c)));
          }, {});
          data.display_standardization = standardization;
          data.display_total_standardization = values_default()(standardization).reduce(function (s, c) {
            return s + c;
          }, 0);
          data.hasReport = _this.reportCountrys.includes({ competitiveness: data.country_code, attraction: data.partner_code, toolcompetitiveness: data.country_code, toolattraction: data.partner_code }[_this.analysisType]);
          return data;
        });
      } else if (this.dataType === 'year') {
        tableDatas = tableDatas.map(function (data) {
          data.display_standardization = {};
          data.display_total_standardization = 0;
          return data;
        });
      }
      tableDatas = Object(util["j" /* sortData */])(tableDatas, [function (data) {
        return (_this.selectedDatas || []).includes(data) ? 1 : -1;
      }, { country: 'display_total_standardization', year: 'year' }[this.dataType]], ['desc', 'desc'], true);
      this.$emit('allDatas', tableDatas);
      return tableDatas;
    },

    // static
    tableOption: function tableOption() {
      var _this2 = this;

      return {
        competitiveness: {
          maskWidth: 491.5,
          index: {
            width: 88
          },
          country: {
            title: '競爭國家',
            name: 'country_name',
            subName: 'country_iso_name',
            width: 330
          },
          year: {
            title: '數據年份',
            name: 'year',
            width: 330
          },
          contents: [{
            title: ['產量(公噸)'],
            value: 'production_quantity',
            standardization: {
              type: 'positive'
            },
            display: function display(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[_this2.dataType] : 'n/a';
            },
            subDisplay: function subDisplay(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[_this2.dataType] : 'n/a';
            }
          }, {
            title: ['單位面積產量', '(百克/公頃)'],
            value: 'yield',
            standardization: {
              type: 'positive'
            },
            display: function display(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[_this2.dataType] : 'n/a';
            },
            subDisplay: function subDisplay(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[_this2.dataType] : 'n/a';
            }
          }, {
            title: ['生產者價格', '(美元/公噸)'],
            value: 'producer_price',
            standardization: {
              type: 'negative'
            },
            display: function display(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[_this2.dataType] : 'n/a';
            },
            subDisplay: function subDisplay(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[_this2.dataType] : 'n/a';
            }
          }, {
            title: ['進口單價', '(美元/公斤)'],
            description: {
              title: '進口單價計算公式',
              content: '目標市場國進口競爭國之產品進口值 / 目標市場國進口競爭國之產品進口量'
            },
            value: 'import_price',
            standardization: {
              type: 'negative'
            },
            display: function display(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[_this2.dataType] : 'n/a';
            },
            subDisplay: function subDisplay(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[_this2.dataType] : 'n/a';
            }
          }, {
            title: ['RCA'],
            description: {
              title: '顯示性比較利益RCA公式',
              content: '(競爭國出口產品至目標市場國總出口值/全球出口產品至目標市場總出口值)/(競爭國出口水果(蔬菜)至目標市場總出口值/全球出口水果(蔬菜)至目標市場總出口值)'
            },
            value: 'RCA',
            standardization: {
              type: 'positive'
            },
            display: function display(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[_this2.dataType] : 'n/a';
            },
            subDisplay: function subDisplay(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[_this2.dataType] : 'n/a';
            }
          }, {
            title: ['TII'],
            description: {
              title: '貿易密集度TII公式',
              content: '(目標市場進口競爭國之產品總進口值/目標市場國進口全球之產品總進口值)/[競爭國出口全球之產品總出口值/(產品全球總出口值-目標市場國出口全球之產品總出口值)]'
            },
            value: 'TII',
            standardization: {
              type: 'positive'
            },
            display: function display(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[_this2.dataType] : 'n/a';
            },
            subDisplay: function subDisplay(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[_this2.dataType] : 'n/a';
            }
          }, {
            title: ['市場距離', '(公里)'],
            value: 'distance',
            standardization: {
              type: 'negative'
            },
            display: function display(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[_this2.dataType] : 'n/a';
            },
            subDisplay: function subDisplay(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[_this2.dataType] : 'n/a';
            }
          }]
        },
        attraction: {
          maskWidth: 491.5,
          index: {
            width: 28
          },
          country: {
            title: '國家',
            name: 'partner_name',
            subName: 'partner_iso_name',
            width: 330
          },
          year: {
            title: '數據年份',
            name: 'year',
            width: 330
          },
          contents: [{
            title: ['產量(公噸)'],
            value: 'production_quantity',
            standardization: {
              type: 'negative'
            },
            display: function display(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[_this2.dataType] : 'n/a';
            },
            subDisplay: function subDisplay(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[_this2.dataType] : 'n/a';
            }
          }, {
            title: ['出口值', '(千美元)'],
            value: 'export_value',
            standardization: {
              type: 'negative'
            },
            display: function display(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[_this2.dataType] : 'n/a';
            },
            subDisplay: function subDisplay(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[_this2.dataType] : 'n/a';
            }
          }, {
            title: ['進口值', '(千美元)'],
            value: 'import_value',
            standardization: {
              type: 'positive'
            },
            display: function display(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[_this2.dataType] : 'n/a';
            },
            subDisplay: function subDisplay(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[_this2.dataType] : 'n/a';
            }
          }, {
            title: ['市場規模', '(千美元)'],
            description: {
              title: '市場規模計算公式',
              content: '(目標市場國之產品產量 * 目標市場國之產品生產者價格) + 目標市場國之產品總進口值 - 目標市場國之產品總出口值'
            },
            value: 'market_size',
            standardization: {
              type: 'positive'
            },
            display: function display(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[_this2.dataType] : 'n/a';
            },
            subDisplay: function subDisplay(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[_this2.dataType] : 'n/a';
            }
          }, {
            title: ['進口市場', '成長趨勢(%)'],
            description: {
              title: '進口市場成長趨勢計算公式',
              content: '(目標市場國 本年度之產品總進口值 - 目標市場國 去年度之產品總進口值) / 目標市場國 去年度之產品總進口值'
            },
            value: 'import_market_growth_trend',
            standardization: {
              type: 'positive'
            },
            display: function display(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[_this2.dataType] : 'n/a';
            },
            subDisplay: function subDisplay(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[_this2.dataType] : 'n/a';
            }
          }, {
            title: ['TSI'],
            description: {
              title: '貿易專業化指數TSI的公式',
              content: '(目標市場國之產品總出口值 - 目標市場國之產品總進口值) / (目標市場國之產品總出口值 + 目標市場國之產品總進口值)'
            },
            value: 'TSI',
            standardization: {
              type: 'negative',
              max: 1,
              min: -1
            },
            display: function display(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[_this2.dataType] : 'n/a';
            },
            subDisplay: function subDisplay(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[_this2.dataType] : 'n/a';
            }
          }, {
            title: ['市場距離', '(公里)'],
            value: 'distance',
            standardization: {
              type: 'negative'
            },
            display: function display(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[_this2.dataType] : 'n/a';
            },
            subDisplay: function subDisplay(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[_this2.dataType] : 'n/a';
            }
          }, {
            title: ['全球貿易市場', '佔有率(%)'],
            description: {
              title: '全球貿易市場佔有率計算公式',
              content: '目標市場國之產品進口值 / 全球之產品進口值'
            },
            value: 'market_share',
            standardization: {
              type: 'positive'
            },
            display: function display(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[_this2.dataType] : 'n/a';
            },
            subDisplay: function subDisplay(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[_this2.dataType] : 'n/a';
            }
          }, {
            title: ['平均每人', 'GDP(美元)'],
            value: 'GDP',
            standardization: {
              type: 'positive'
            },
            display: function display(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[_this2.dataType] : 'n/a';
            },
            subDisplay: function subDisplay(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[_this2.dataType] : 'n/a';
            }
          }, {
            title: ['人口數'],
            value: 'total_population',
            standardization: {
              type: 'positive'
            },
            display: function display(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[_this2.dataType] : 'n/a';
            },
            subDisplay: function subDisplay(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[_this2.dataType] : 'n/a';
            }
          }, {
            title: ['市場成長', '相對強度(%)'],
            description: {
              title: '市場成長相對強度計算公式',
              content: '[(今年目標市場國之產品進口值-5年前目標市場國之產品進口值)/(5年前目標市場國之產品進口值)] - [(今年全球之產品進口值-5年前全球之產品進口值)/(5年前全球之產品進口值)]'
            },
            value: 'market_growth_intensity',
            standardization: {
              type: 'positive',
              max: 15,
              min: -15
            },
            display: function display(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[_this2.dataType] : 'n/a';
            },
            subDisplay: function subDisplay(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[_this2.dataType] : 'n/a';
            }
          }, {
            title: ['進口市場', '表現(%)'],
            description: {
              title: '進口市場表現計算公式',
              content: '(目標市場國之產品進口值/全球之產品進口值) - (台灣之產品出口至目標市場國之出口值/台灣之產品總出口值)'
            },
            value: 'market_performance',
            standardization: {
              type: 'positive',
              max: 5,
              min: 0
            },
            display: function display(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[_this2.dataType] : 'n/a';
            },
            subDisplay: function subDisplay(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[_this2.dataType] : 'n/a';
            }
          }, {
            title: ['市場開放', '程度(%)'],
            alert: {
              title: '注意！',
              content: '因ITC關稅資料僅有最新年度之資料，並無歷年資料，因此各年度均以最新年度之關稅率作為分析數據之依據。'
            },
            value: 'market_openness',
            standardization: {
              type: 'positive',
              max: 5,
              min: 30
            },
            display: function display(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[_this2.dataType] : 'n/a';
            },
            subDisplay: function subDisplay(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[_this2.dataType] : 'n/a';
            }
          }, {
            title: ['市場相對', '優惠關稅(%)'],
            description: {
              title: '市場相對優惠關稅',
              content: '目標市場國前五大進口國產品之平均關稅率 - 台灣至目標市場國之產品關稅率'
            },
            alert: {
              title: '注意！',
              content: '因ITC關稅資料僅有最新年度之資料，並無歷年資料，因此各年度均以最新年度之關稅率作為分析數據之依據。'
            },
            value: 'market_preferential_tariff',
            standardization: {
              type: 'positive',
              max: 10,
              min: -10
            },
            display: function display(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[_this2.dataType] : 'n/a';
            },
            subDisplay: function subDisplay(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[_this2.dataType] : 'n/a';
            }
          }]
        },
        toolcompetitiveness: {
          maskWidth: 491.5,
          index: {
            width: 88
          },
          country: {
            title: '競爭國家',
            name: 'country_name',
            subName: 'country_iso_name',
            width: 330
          },
          year: {
            title: '數據年份',
            name: 'year',
            width: 330
          },
          contents: [{
            title: ['進口單價 (美元)'],
            description: {
              title: '進口單價計算公式',
              content: '目標市場國進口競爭國之產品進口值 / 目標市場國進口競爭國之產品進口量'
            },
            value: 'import_price',
            standardization: {
              type: 'negative'
            },
            display: function display(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[_this2.dataType] : 'n/a';
            },
            subDisplay: function subDisplay(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[_this2.dataType] : 'n/a';
            }
          }, {
            title: ['RCA'],
            description: {
              title: '顯示性比較利益RCA公式',
              content: '(競爭國出口產品至目標市場國總出口值/全球出口產品至目標市場總出口值)/(競爭國出口水果(蔬菜)至目標市場總出口值/全球出口水果(蔬菜)至目標市場總出口值)'
            },
            value: 'RCA',
            standardization: {
              type: 'positive'
            },
            display: function display(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[_this2.dataType] : 'n/a';
            },
            subDisplay: function subDisplay(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[_this2.dataType] : 'n/a';
            }
          }, {
            title: ['TII'],
            description: {
              title: '貿易密集度TII公式',
              content: '(目標市場進口競爭國之產品總進口值/目標市場國進口全球之產品總進口值)/[競爭國出口全球之產品總出口值/(產品全球總出口值-目標市場國出口全球之產品總出口值)]'
            },
            value: 'TII',
            standardization: {
              type: 'positive'
            },
            display: function display(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[_this2.dataType] : 'n/a';
            },
            subDisplay: function subDisplay(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[_this2.dataType] : 'n/a';
            }
          }]
        },
        toolattraction: {
          maskWidth: 491.5,
          index: {
            width: 28
          },
          country: {
            title: '國家',
            name: 'partner_name',
            subName: 'partner_iso_name',
            width: 330
          },
          year: {
            title: '數據年份',
            name: 'year',
            width: 330
          },
          contents: [{
            title: ['出口值', '(千美元)'],
            value: 'export_value',
            standardization: {
              type: 'negative'
            },
            display: function display(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[_this2.dataType] : 'n/a';
            },
            subDisplay: function subDisplay(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[_this2.dataType] : 'n/a';
            }
          }, {
            title: ['進口值', '(千美元)'],
            value: 'import_value',
            standardization: {
              type: 'positive'
            },
            display: function display(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[_this2.dataType] : 'n/a';
            },
            subDisplay: function subDisplay(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[_this2.dataType] : 'n/a';
            }
          }, {
            title: ['進口市場', '成長趨勢(%)'],
            description: {
              title: '進口市場成長趨勢計算公式',
              content: '(目標市場國 本年度之產品總進口值 - 目標市場國 去年度之產品總進口值) / 目標市場國 去年度之產品總進口值'
            },
            value: 'import_market_growth_trend',
            standardization: {
              type: 'positive'
            },
            display: function display(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[_this2.dataType] : 'n/a';
            },
            subDisplay: function subDisplay(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[_this2.dataType] : 'n/a';
            }
          }, {
            title: ['TSI'],
            description: {
              title: '貿易專業化指數TSI的公式',
              content: '(目標市場國之產品總出口值 - 目標市場國之產品總進口值) / (目標市場國之產品總出口值 + 目標市場國之產品總進口值)'
            },
            value: 'TSI',
            standardization: {
              type: 'negative',
              max: 1,
              min: -1
            },
            display: function display(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[_this2.dataType] : 'n/a';
            },
            subDisplay: function subDisplay(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[_this2.dataType] : 'n/a';
            }
          }, {
            title: ['全球貿易市場', '佔有率(%)'],
            description: {
              title: '全球貿易市場佔有率計算公式',
              content: '目標市場國之產品進口值 / 全球之產品進口值'
            },
            value: 'market_share',
            standardization: {
              type: 'positive'
            },
            display: function display(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[_this2.dataType] : 'n/a';
            },
            subDisplay: function subDisplay(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[_this2.dataType] : 'n/a';
            }
          }, {
            title: ['平均每人', 'GDP(美元)'],
            value: 'GDP',
            standardization: {
              type: 'positive'
            },
            display: function display(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[_this2.dataType] : 'n/a';
            },
            subDisplay: function subDisplay(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[_this2.dataType] : 'n/a';
            }
          }, {
            title: ['GNI', '(美元)'],
            value: 'GNI',
            standardization: {
              type: 'positive'
            },
            display: function display(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[_this2.dataType] : 'n/a';
            },
            subDisplay: function subDisplay(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[_this2.dataType] : 'n/a';
            }
          }, {
            title: ['農業人口', '比率(%)'],
            value: 'agricultural_population_proportion',
            standardization: {
              type: 'positive'
            },
            display: function display(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[_this2.dataType] : 'n/a';
            },
            subDisplay: function subDisplay(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[_this2.dataType] : 'n/a';
            }
          }, {
            title: ['農業人', '口比率', '趨勢(%)'],
            description: {
              title: '農業人口比率趨勢計算公式',
              content: ''
            },
            value: 'agricultural_population_proportion_trend',
            standardization: {
              type: 'positive'
            },
            display: function display(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[_this2.dataType] : 'n/a';
            },
            subDisplay: function subDisplay(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[_this2.dataType] : 'n/a';
            }
          }, {
            title: ['耕地面積', '(平方公里)'],
            value: 'cultivated_area',
            standardization: {
              type: 'positive'
            },
            display: function display(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[_this2.dataType] : 'n/a';
            },
            subDisplay: function subDisplay(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[_this2.dataType] : 'n/a';
            }
          }, {
            title: ['平均農業人口', '耕地面積', '(平方公里/人)'],
            description: {
              title: '平均農業人耕地面積口計算公式',
              content: ''
            },
            value: 'average_agricultural_population_cultivated_area',
            standardization: {
              type: 'positive'
            },
            display: function display(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[_this2.dataType] : 'n/a';
            },
            subDisplay: function subDisplay(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[_this2.dataType] : 'n/a';
            }
          }, {
            title: ['市場成長', '相對強度(%)'],
            description: {
              title: '市場成長相對強度計算公式',
              content: '[(今年目標市場國之產品進口值-5年前目標市場國之產品進口值)/(5年前目標市場國之產品進口值)] - [(今年全球之產品進口值-5年前全球之產品進口值)/(5年前全球之產品進口值)]'
            },
            value: 'market_growth_intensity',
            standardization: {
              type: 'positive',
              max: 15,
              min: -15
            },
            display: function display(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[_this2.dataType] : 'n/a';
            },
            subDisplay: function subDisplay(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[_this2.dataType] : 'n/a';
            }
          }, {
            title: ['進口市場', '表現(%)'],
            description: {
              title: '進口市場表現計算公式',
              content: '(目標市場國之產品進口值/全球之產品進口值) - (台灣之產品出口至目標市場國之出口值/台灣之產品總出口值)'
            },
            value: 'market_performance',
            standardization: {
              type: 'positive',
              max: 5,
              min: 0
            },
            display: function display(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[_this2.dataType] : 'n/a';
            },
            subDisplay: function subDisplay(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[_this2.dataType] : 'n/a';
            }
          }, {
            title: ['市場開放', '程度(%)'],
            alert: {
              title: '注意！',
              content: '因ITC關稅資料僅有最新年度之資料，並無歷年資料，因此各年度均以最新年度之關稅率作為分析數據之依據。'
            },
            value: 'market_openness',
            standardization: {
              type: 'positive',
              max: 5,
              min: 30
            },
            display: function display(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[_this2.dataType] : 'n/a';
            },
            subDisplay: function subDisplay(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[_this2.dataType] : 'n/a';
            }
          }, {
            title: ['市場相對', '優惠關稅(%)'],
            description: {
              title: '市場相對優惠關稅',
              content: '目標市場國前五大進口國產品之平均關稅率 - 台灣至目標市場國之產品關稅率'
            },
            alert: {
              title: '注意！',
              content: '因ITC關稅資料僅有最新年度之資料，並無歷年資料，因此各年度均以最新年度之關稅率作為分析數據之依據。'
            },
            value: 'market_preferential_tariff',
            standardization: {
              type: 'positive',
              max: 10,
              min: -10
            },
            display: function display(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[_this2.dataType] : 'n/a';
            },
            subDisplay: function subDisplay(value) {
              return value || value === 0 ? { country: Object(util["m" /* toPriceString */])(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[_this2.dataType] : 'n/a';
            }
          }]
        }
      }[this.analysisType];
    }
  },
  watch: {
    'datas': function datas() {
      this.selectedDatas = [].concat(toConsumableArray_default()(this.tableDatas));
    },
    'tableDatas': function tableDatas() {
      var _this3 = this;

      this.$emit('dataChange', this.tableDatas.filter(function (data) {
        return _this3.selectedDatas.includes(data);
      }));
    },
    'curSelectedDatas': function curSelectedDatas(nv) {
      if (nv.length !== this.selectedDatas.length) {
        this.selectedDatas = [].concat(toConsumableArray_default()(nv));
      }
    },
    'selectedDatas': function selectedDatas() {
      var _this4 = this;

      this.$emit('dataChange', this.tableDatas.filter(function (data) {
        return _this4.selectedDatas.includes(data);
      }));
    }
  },
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setModalAction']), {
    onSelected: function onSelected(selected) {
      this.selectedDatas = selected;
    },
    countryOnClick: function countryOnClick(data, tab) {
      this.setModalAction({
        action: 'analysis',
        width: '1400px',
        height: 'calc(100% - 40px)',
        customStyles: {
          padding: '0px',
          margin: '20px auto',
          borderRadius: '0'
        },
        param: {
          country: data,
          tab: tab,
          filterOptions: this.filterOptions,
          conditions: this.conditions
        }
      });
    },
    reportOnClick: function reportOnClick(data) {
      this.countryOnClick(data, 'report');
    },
    getFilterTitle: function getFilterTitle(value) {
      var _this5 = this;

      if (!this.conditions.filters[value]) {
        return '';
      }
      return this.filterOptions.filters.find(function (filter) {
        return filter.value === value;
      }).options.find(function (option) {
        return option.value === _this5.conditions.filters[value];
      }).title;
    },
    getCountryTitle: function getCountryTitle() {
      if (!this.country) {
        return '';
      }
      return { competitiveness: this.country.country_name, attraction: this.country.partner_name, toolcompetitiveness: this.country.country_name, toolattraction: this.country.partner_name }[this.analysisType];
    },
    getStandardizationPoint: function getStandardizationPoint(allData, data, option) {
      var max = option.standardization.max || Math.max.apply(null, allData.map(function (data) {
        return data[option.value];
      }).filter(function (value) {
        return value || value === 0;
      }));
      var min = option.standardization.min || Math.min.apply(null, allData.map(function (data) {
        return data[option.value];
      }).filter(function (value) {
        return value || value === 0;
      }));
      var value = data[option.value] > Math.max(max, min) ? Math.max(max, min) : data[option.value] < Math.min(max, min) ? Math.min(max, min) : data[option.value];
      return (!data[option.value] && data[option.value] !== 0 ? 0 : option.standardization.type === 'positive' ? 1 + (max === min ? 0 : 4 * ((value - min) / (max - min))) : option.standardization.type === 'negative' ? 5 - (max === min ? 0 : 4 * ((value - min) / (max - min))) : 0) * (this.conditions.weightings[option.value].active ? this.conditions.weightings[option.value].value : 0);
    },
    downloadData: function downloadData() {
      var _this6 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var dataOptions, csvContents, extraContents, alertContents, headerContents, _loop, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, data, url, title;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dataOptions = {
                  competitiveness: extends_default()({}, {
                    country: {
                      '競爭國家': 'country_name'
                    },
                    year: {
                      '數據年份': 'year'
                    }
                  }[_this6.dataType], {
                    '產量(公噸)': 'production_quantity',
                    '單位面積產量(百克/公頃)': 'yield',
                    '生產者價格(美元)': 'producer_price',
                    '進口單價(美元/公斤)': 'import_price',
                    'RCA': 'RCA',
                    'TII': 'TII',
                    '市場距離(公里)': 'distance',
                    '產量標準化分數': ['standardization', 'production_quantity'],
                    '單位面積產量標準化分數': ['standardization', 'yield'],
                    '生產者價格標準化分數': ['standardization', 'producer_price'],
                    '進口單價標準化分數': ['standardization', 'import_price'],
                    'RCA標準化分數': ['standardization', 'RCA'],
                    'TII標準化分數': ['standardization', 'TII'],
                    '市場距離標準化分數': ['standardization', 'distance'],
                    '標準化分數總計': 'total_standardization',
                    '標準化分數之世界排名': 'total_standardization_order',
                    '目標市場國進口競爭國之產品進口值(千美元)': ['addition', 'partner_import_country_value'],
                    '目標市場國進口競爭國之產品進口量': ['addition', 'partner_import_country_quantity'],
                    '目標市場國進口競爭國之產品進口量單位': ['addition', 'partner_import_country_quantity_unit'],
                    '目標市場國進口世界之產品進口值(千美元)': ['addition', 'partner_import_world_value'],
                    '競爭國出口世界之產品出口值(千美元)': ['addition', 'country_export_world_value'],
                    '世界之產品出口值(千美元)': ['addition', 'world_export_world_value'],
                    '目標市場國出口世界之產品出口值(千美元)': ['addition', 'partner_export_world_value'],
                    '競爭國出口目標市場國之產品出口值(千美元)': ['addition', 'country_export_partner_value'],
                    '世界出口目標市場國之產品出口值(千美元)': ['addition', 'world_export_partner_value'],
                    '競爭國出口目標市場國之水果/蔬菜出口值(千美元)': ['addition', 'class_country_export_partner_value'],
                    '世界出口目標市場國之水果/蔬菜出口值(千美元)': ['addition', 'class_world_export_partner_value'],
                    '競爭國出口目標市場國之產品出口量': ['addition', 'country_export_partner_quantity'],
                    '競爭國出口目標市場國之產品出口量單位': ['addition', 'country_export_partner_quantity_unit'],
                    '目標市場國出口世界之產品出口量': ['addition', 'partner_export_world_quantity'],
                    '目標市場國出口世界之產品出口量單位': ['addition', 'partner_export_world_quantity_unit'],
                    '世界出口目標市場國之產品出口量(公噸)': ['addition', 'world_export_partner_quantity'],
                    '競爭國出口世界之產品出口量': ['addition', 'country_export_world_quantity'],
                    '競爭國出口世界之產品出口量單位': ['addition', 'country_export_world_quantity_unit'],
                    '目標市場國進口世界之產品進口量': ['addition', 'partner_import_world_quantity'],
                    '目標市場國進口世界之產品進口量單位': ['addition', 'partner_import_world_quantity_unit'],
                    '世界出口目標市場國之水果/蔬菜總出口量(公噸)': ['addition', 'class_world_export_partner_quantity'],
                    '競爭國出口目標市場國之水果/蔬菜總出口量': ['addition', 'class_country_export_partner_quantity'],
                    '競爭國出口目標市場國之水果/蔬菜總出口量單位': ['addition', 'class_country_export_partner_quantity_unit']
                  }),
                  attraction: extends_default()({}, {
                    country: {
                      '市場國家': 'partner_name'
                    },
                    year: {
                      '數據年份': 'year'
                    }
                  }[_this6.dataType], {
                    '產量(公噸)': 'production_quantity',
                    '出口值(千美元)': 'export_value',
                    '進口值(千美元)': 'import_value',
                    '市場規模(千美元)': 'market_size',
                    '進口市場成長趨勢(%)': 'import_market_growth_trend',
                    'TSI': 'TSI',
                    '市場距離(公里)': 'distance',
                    '佔全球貿易市場佔有率(%)': 'market_share',
                    '平均每人GDP(美元)': 'GDP',
                    '人口數': 'total_population',
                    '市場成長相對強度(%)': 'market_growth_intensity',
                    '進口市場表現(%)': 'market_performance',
                    '市場開放程度(%)': 'market_openness',
                    '市場相對優惠關稅(%)': 'market_preferential_tariff',
                    '產量標準化分數': ['standardization', 'production_quantity'],
                    '出口值標準化分數': ['standardization', 'export_value'],
                    '進口值標準化分數': ['standardization', 'import_value'],
                    '市場規模標準化分數': ['standardization', 'market_size'],
                    '進口市場成長趨勢標準化分數': ['standardization', 'import_market_growth_trend'],
                    'TSI標準化分數': ['standardization', 'TSI'],
                    '市場距離標準化分數': ['standardization', 'distance'],
                    '佔全球貿易市場佔有率標準化分數': ['standardization', 'market_share'],
                    '平均每人GDP標準化分數': ['standardization', 'GDP'],
                    '人口數標準化分數': ['standardization', 'total_population'],
                    '市場成長相對強度標準化分數': ['standardization', 'market_growth_intensity'],
                    '進口市場表現標準化分數': ['standardization', 'market_performance'],
                    '市場開放程度標準化分數': ['standardization', 'market_openness'],
                    '市場相對優惠關稅標準化分數': ['standardization', 'market_preferential_tariff'],
                    '標準化分數總計': 'total_standardization',
                    '標準化分數之世界排名': 'total_standardization_order',
                    '目標市場國之產品產量(公噸)': 'production_quantity',
                    '目標市場國之產品生產者價格(美元)': ['addition', 'producer_price'],
                    '目標市場國之產品進口值(千美元)': ['addition', 'partner_import_world_value'],
                    '目標市場國之產品出口值(千美元)': ['addition', 'partner_export_world_value'],
                    '目標市場國之產品前一年進口值(千美元)': ['addition', 'last_year_import_value'],
                    '世界之產品進口值(千美元)': ['addition', 'world_import_world_value'],
                    '目標市場國之產品五年前進口值(千美元)': ['addition', 'last_5_year_partner_import_world_value'],
                    '世界之產品五年前進口值(千美元)': ['addition', 'last_5_year_world_import_world_value'],
                    '台灣出口目標市場國之產品出口值(千美元)': ['addition', 'taiwan_export_partner_value'],
                    '台灣之產品出口值(千美元)': ['addition', 'taiwan_export_world_value'],
                    '目標市場國之產品第一大進口國關稅(%)': ['addition', 'top_5_tariff', 0, function (data) {
                      return data ? data.chinese_name + ':' + data.tariff : 'n/a';
                    }],
                    '目標市場國之產品第二大進口國關稅(%)': ['addition', 'top_5_tariff', 1, function (data) {
                      return data ? data.chinese_name + ':' + data.tariff : 'n/a';
                    }],
                    '目標市場國之產品第三大進口國關稅(%)': ['addition', 'top_5_tariff', 2, function (data) {
                      return data ? data.chinese_name + ':' + data.tariff : 'n/a';
                    }],
                    '目標市場國之產品第四大進口國關稅(%)': ['addition', 'top_5_tariff', 3, function (data) {
                      return data ? data.chinese_name + ':' + data.tariff : 'n/a';
                    }],
                    '目標市場國之產品第五大進口國關稅(%)': ['addition', 'top_5_tariff', 4, function (data) {
                      return data ? data.chinese_name + ':' + data.tariff : 'n/a';
                    }],
                    '目標市場國對台灣之產品關稅': ['addition', 'partner_taiwan_tariff'],
                    '目標市場國之產品出口量': ['addition', 'partner_export_world_quantity'],
                    '目標市場國之產品出口量單位': ['addition', 'partner_export_world_quantity_unit'],
                    '目標市場國之產品進口量': ['addition', 'partner_import_world_quantity'],
                    '目標市場國之產品進口量單位': ['addition', 'partner_import_world_quantity_unit'],
                    '世界之產品進口量(公噸)': ['addition', 'world_import_world_quantity'],
                    '世界之產品出口值(千美元)': ['addition', 'world_export_world_value'],
                    '世界之產品出口量(公噸)': ['addition', 'world_export_world_quantity']
                  }),
                  toolcompetitiveness: extends_default()({}, {
                    country: {
                      '競爭國家': 'country_name'
                    },
                    year: {
                      '數據年份': 'year'
                    }
                  }[_this6.dataType], {
                    '產量(公噸)': 'production_quantity',
                    '進口單價(美元/公斤)': 'import_price',
                    'RCA': 'RCA',
                    'TII': 'TII',
                    '進口單價標準化分數': ['standardization', 'import_price'],
                    'RCA標準化分數': ['standardization', 'RCA'],
                    'TII標準化分數': ['standardization', 'TII'],
                    '標準化分數總計': 'total_standardization',
                    '標準化分數之世界排名': 'total_standardization_order',
                    '目標市場國進口競爭國之產品進口值(千美元)': ['addition', 'partner_import_country_value'],
                    '目標市場國進口競爭國之產品進口量': ['addition', 'partner_import_country_quantity'],
                    '目標市場國進口競爭國之產品進口量單位': ['addition', 'partner_import_country_quantity_unit'],
                    '目標市場國進口世界之產品進口值(千美元)': ['addition', 'partner_import_world_value'],
                    '競爭國出口世界之產品出口值(千美元)': ['addition', 'country_export_world_value'],
                    '世界之產品出口值(千美元)': ['addition', 'world_export_world_value'],
                    '目標市場國出口世界之產品出口值(千美元)': ['addition', 'partner_export_world_value'],
                    '競爭國出口目標市場國之產品出口值(千美元)': ['addition', 'country_export_partner_value'],
                    '世界出口目標市場國之產品出口值(千美元)': ['addition', 'world_export_partner_value'],
                    '競爭國出口目標市場國之農機分類出口值(千美元)': ['addition', 'class_country_export_partner_value'],
                    '世界出口目標市場國之農機分類出口值(千美元)': ['addition', 'class_world_export_partner_value'],
                    '競爭國出口目標市場國之產品出口量': ['addition', 'country_export_partner_quantity'],
                    '競爭國出口目標市場國之產品出口量單位': ['addition', 'country_export_partner_quantity_unit'],
                    '目標市場國出口世界之產品出口量': ['addition', 'partner_export_world_quantity'],
                    '目標市場國出口世界之產品出口量單位': ['addition', 'partner_export_world_quantity_unit'],
                    '世界出口目標市場國之產品出口量(公噸)': ['addition', 'world_export_partner_quantity'],
                    '競爭國出口世界之產品出口量': ['addition', 'country_export_world_quantity'],
                    '競爭國出口世界之產品出口量單位': ['addition', 'country_export_world_quantity_unit'],
                    '目標市場國進口世界之產品進口量': ['addition', 'partner_import_world_quantity'],
                    '目標市場國進口世界之產品進口量單位': ['addition', 'partner_import_world_quantity_unit'],
                    '世界之產品出口量 (公噸)': ['addition', 'world_export_world_quantity'],
                    '世界出口目標市場國之農機分類總出口量(公噸)': ['addition', 'class_world_export_partner_quantity'],
                    '競爭國出口目標市場國之農機分類總出口量': ['addition', 'class_country_export_partner_quantity'],
                    '競爭國出口目標市場國之農機分類總出口量單位': ['addition', 'class_country_export_partner_quantity_unit']
                  }),
                  toolattraction: extends_default()({}, {
                    country: {
                      '市場國家': 'partner_name'
                    },
                    year: {
                      '數據年份': 'year'
                    }
                  }[_this6.dataType], {
                    '出口值(千美元)': 'export_value',
                    '進口值(千美元)': 'import_value',
                    '進口市場成長趨勢(%)': 'import_market_growth_trend',
                    'TSI': 'TSI',
                    '佔全球貿易市場佔有率(%)': 'market_share',
                    '平均每人GDP(美元)': 'GDP',
                    'GNI(美元)': 'GNI',
                    '農業人口比率(%)': 'agricultural_population_proportion',
                    '農業人口比率趨勢': 'agricultural_population_proportion_trend',
                    '耕地面積(平方公里)': 'cultivated_area',
                    '平均農業人口耕地面積(平方公里/人)': 'average_agricultural_population_cultivated_area',
                    '市場成長相對強度(%)': 'market_growth_intensity',
                    '進口市場表現(%)': 'market_performance',
                    '市場開放程度(%)': 'market_openness',
                    '市場相對優惠關稅(%)': 'market_preferential_tariff',
                    '出口值標準化分數': ['standardization', 'export_value'],
                    '進口值標準化分數': ['standardization', 'import_value'],
                    '進口市場成長趨勢標準化分數': ['standardization', 'import_market_growth_trend'],
                    'TSI標準化分數': ['standardization', 'TSI'],
                    '佔全球貿易市場佔有率標準化分數': ['standardization', 'market_share'],
                    '平均每人GDP標準化分數': ['standardization', 'GDP'],
                    'GNI標準化分數': ['standardization', 'GNI'],
                    '農業人口比率標準化分數': ['standardization', 'agricultural_population_proportion'],
                    '農業人口比率趨勢標準化分數': ['standardization', 'agricultural_population_proportion_trend'],
                    '耕地面積標準化分數': ['standardization', 'cultivated_area'],
                    '平均農業人口耕地面積標準化分數': ['standardization', 'average_agricultural_population_cultivated_area'],
                    '市場成長相對強度標準化分數': ['standardization', 'market_growth_intensity'],
                    '進口市場表現標準化分數': ['standardization', 'market_performance'],
                    '市場開放程度標準化分數': ['standardization', 'market_openness'],
                    '市場相對優惠關稅標準化分數': ['standardization', 'market_preferential_tariff'],
                    '標準化分數總計': 'total_standardization',
                    '標準化分數之世界排名': 'total_standardization_order',
                    '目標市場國之產品進口值(千美元)': ['addition', 'partner_import_world_value'],
                    '目標市場國之產品出口值(千美元)': ['addition', 'partner_export_world_value'],
                    '目標市場國之產品前一年進口值(千美元)': ['addition', 'last_year_import_value'],
                    '世界之產品進口值(千美元)': ['addition', 'world_import_world_value'],
                    '前一年農業人口比率 (%)': ['addition', 'last_year_agricultural_population_proportion'],
                    '人口數': 'total_population',
                    '目標市場國之產品五年前進口值(千美元)': ['addition', 'last_5_year_partner_import_world_value'],
                    '世界之產品五年前進口值(千美元)': ['addition', 'last_5_year_world_import_world_value'],
                    '台灣出口目標市場國之產品出口值(千美元)': ['addition', 'taiwan_export_partner_value'],
                    '台灣之產品出口值(千美元)': ['addition', 'taiwan_export_world_value'],
                    '目標市場國之產品第一大進口國關稅(%)': ['addition', 'top_5_tariff', 0, function (data) {
                      return data ? data.chinese_name + ':' + data.tariff : 'n/a';
                    }],
                    '目標市場國之產品第二大進口國關稅(%)': ['addition', 'top_5_tariff', 1, function (data) {
                      return data ? data.chinese_name + ':' + data.tariff : 'n/a';
                    }],
                    '目標市場國之產品第三大進口國關稅(%)': ['addition', 'top_5_tariff', 2, function (data) {
                      return data ? data.chinese_name + ':' + data.tariff : 'n/a';
                    }],
                    '目標市場國之產品第四大進口國關稅(%)': ['addition', 'top_5_tariff', 3, function (data) {
                      return data ? data.chinese_name + ':' + data.tariff : 'n/a';
                    }],
                    '目標市場國之產品第五大進口國關稅(%)': ['addition', 'top_5_tariff', 4, function (data) {
                      return data ? data.chinese_name + ':' + data.tariff : 'n/a';
                    }],
                    '目標市場國對台灣之產品關稅': ['addition', 'partner_taiwan_tariff'],
                    '目標市場國之產品出口量': ['addition', 'partner_export_world_quantity'],
                    '目標市場國之產品出口量單位': ['addition', 'partner_export_world_quantity_unit'],
                    '目標市場國之產品進口量': ['addition', 'partner_import_world_quantity'],
                    '目標市場國之產品進口量單位': ['addition', 'partner_import_world_quantity_unit'],
                    '世界之產品進口量(公噸)': ['addition', 'world_import_world_quantity'],
                    '世界之產品出口值(千美元)': ['addition', 'world_export_world_value'],
                    '世界之產品出口量(公噸)': ['addition', 'world_export_world_quantity']
                  })
                }[_this6.analysisType];
                csvContents = [];
                extraContents = [];

                _this6.conditions.filters.product && extraContents.push('品項：' + _this6.getFilterTitle('product'));
                _this6.conditions.filters.country && extraContents.push('目標市場：' + _this6.getFilterTitle('country'));
                if (_this6.dataType === 'country') {
                  _this6.conditions.filters.year && extraContents.push('數據年份：' + _this6.getFilterTitle('year'));
                } else if (_this6.dataType === 'year') {
                  _this6.country && extraContents.push({
                    competitiveness: '競爭國家：' + _this6.country.country_name,
                    attraction: '市場國家：' + _this6.country.partner_name,
                    toolcompetitiveness: '競爭國家：' + _this6.country.country_name,
                    toolattraction: '市場國家：' + _this6.country.partner_name
                  }[_this6.analysisType]);
                }
                extraContents = [extraContents.join(', ')];
                csvContents.push(extraContents);
                alertContents = [];

                alertContents.push('原始資料與分析資料比較範圍不同會影響標準化分數數值，可能會造成排名略有差異。');
                csvContents.push(alertContents);
                headerContents = keys_default()(dataOptions);

                csvContents.push(headerContents);

                _loop = function _loop(data) {
                  csvContents.push(values_default()(dataOptions).map(function (value) {
                    var paths = value.join ? value : [value];
                    var content = data;
                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                      for (var _iterator2 = get_iterator_default()(paths), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var path = _step2.value;

                        content = path instanceof Function ? path(content) : content[path];
                        if (!content) break;
                      }
                    } catch (err) {
                      _didIteratorError2 = true;
                      _iteratorError2 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                          _iterator2.return();
                        }
                      } finally {
                        if (_didIteratorError2) {
                          throw _iteratorError2;
                        }
                      }
                    }

                    return content || content === 0 ? content : 'n/a';
                  }));
                };

                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 17;
                for (_iterator = get_iterator_default()(Object(util["j" /* sortData */])(_this6.datas, { country: 'total_standardization', year: 'year' }[_this6.dataType], 'desc')); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  data = _step.value;

                  _loop(data);
                }
                _context.next = 25;
                break;

              case 21:
                _context.prev = 21;
                _context.t0 = _context['catch'](17);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 25:
                _context.prev = 25;
                _context.prev = 26;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 28:
                _context.prev = 28;

                if (!_didIteratorError) {
                  _context.next = 31;
                  break;
                }

                throw _iteratorError;

              case 31:
                return _context.finish(28);

              case 32:
                return _context.finish(25);

              case 33:
                url = 'data:application/csv;charset=utf-8,%EF%BB%BF' + encodeURIComponent(csvContents.map(function (x) {
                  return '"' + x.join('","') + '"';
                }).join('\r\n') + '\r\n');
                title = '';

                title = title + {
                  country: {
                    competitiveness: _this6.getFilterTitle('year') + '年' + _this6.getFilterTitle('product') + '在' + _this6.getFilterTitle('country') + '的市場競爭力',
                    attraction: _this6.getFilterTitle('year') + '年' + _this6.getFilterTitle('product') + '各國市場吸引力',
                    toolcompetitiveness: _this6.getFilterTitle('year') + '年' + _this6.getFilterTitle('product') + '在' + _this6.getFilterTitle('country') + '的農業機械市場競爭力',
                    toolattraction: _this6.getFilterTitle('year') + '年' + _this6.getFilterTitle('product') + '各國農業機械市場吸引力'
                  },
                  year: {
                    competitiveness: _this6.getCountryTitle() + '的' + _this6.getFilterTitle('product') + '在' + _this6.getFilterTitle('country') + '市場的歷年市場競爭力',
                    attraction: _this6.getFilterTitle('product') + '在' + _this6.getCountryTitle() + '的歷年市場吸引力',
                    toolcompetitiveness: _this6.getCountryTitle() + '的' + _this6.getFilterTitle('product') + '在' + _this6.getFilterTitle('country') + '市場的歷年農業機械市場競爭力',
                    toolattraction: _this6.getFilterTitle('product') + '在' + _this6.getCountryTitle() + '的歷年農業機械市場吸引力'
                  }
                }[_this6.dataType][_this6.analysisType];
                title = title + '原始數據.csv';
                _context.next = 39;
                return _this6.sendDataAccessLog();

              case 39:
                Object(util["c" /* downloadFile */])(title, url, '_target');

              case 40:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this6, [[17, 21, 25, 33], [26,, 28, 32]]);
      }))();
    },
    sendDataAccessLog: function sendDataAccessLog() {
      var _this7 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var config, type, selectedDatas, paramDatas, data;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                config = _this7.$ls.get('userInfo');
                type = {
                  country: {
                    competitiveness: 'market_competitiveness',
                    attraction: 'market_attractiveness',
                    toolcompetitiveness: 'market_competitiveness',
                    toolattraction: 'market_attractiveness'
                  },
                  year: {
                    competitiveness: 'single_country_market_competitiveness',
                    attraction: 'single_country_market_attractiveness',
                    toolcompetitiveness: 'single_country_market_competitiveness',
                    toolattraction: 'single_country_market_attractiveness'
                  }
                }[_this7.dataType][_this7.analysisType];
                selectedDatas = _this7.selectedDatas.map(function (data) {
                  return {
                    country: {
                      competitiveness: data.country_name,
                      attraction: data.partner_name,
                      toolcompetitiveness: data.country_name,
                      toolattraction: data.partner_name
                    },
                    year: {
                      competitiveness: data.year,
                      attraction: data.year,
                      toolcompetitiveness: data.year,
                      toolattraction: data.year
                    }
                  }[_this7.dataType][_this7.analysisType];
                });
                paramDatas = {
                  country: _this7.dataType === 'country' ? {
                    competitiveness: {
                      access_file_type: 'advanced_data_sheet',
                      partner: _this7.conditions.filters.country,
                      year: _this7.conditions.filters.year,
                      product_code: _this7.conditions.filters.product
                    },
                    attraction: {
                      access_file_type: 'advanced_data_sheet',
                      year: _this7.conditions.filters.year,
                      product_code: _this7.conditions.filters.product
                    },
                    toolcompetitiveness: {
                      access_file_type: 'advanced_data_sheet',
                      partner: _this7.conditions.filters.country,
                      year: _this7.conditions.filters.year,
                      product_code: _this7.conditions.filters.product
                    },
                    toolattraction: {
                      access_file_type: 'advanced_data_sheet',
                      year: _this7.conditions.filters.year,
                      product_code: _this7.conditions.filters.product
                    }
                  } : {},
                  year: _this7.dataType === 'year' ? {
                    competitiveness: {
                      access_file_type: 'advanced_data_sheet',
                      partner: _this7.conditions.filters.country,
                      product_code: _this7.conditions.filters.product,
                      country: _this7.country.country_code
                    },
                    attraction: {
                      access_file_type: 'advanced_data_sheet',
                      partner: _this7.country.partner_code,
                      product_code: _this7.conditions.filters.product
                    },
                    toolcompetitiveness: {
                      access_file_type: 'advanced_data_sheet',
                      partner: _this7.conditions.filters.country,
                      product_code: _this7.conditions.filters.product,
                      country: _this7.country.country_code
                    },
                    toolattraction: {
                      access_file_type: 'advanced_data_sheet',
                      partner: _this7.country.partner_code,
                      product_code: _this7.conditions.filters.product
                    }
                  } : {}
                }[_this7.dataType][_this7.analysisType];
                data = extends_default()({}, paramDatas, {
                  chart_params_info: selectedDatas.join(', ')
                });
                _context2.next = 8;
                return Object(src_api["I" /* postAccessLog */])(type, data, config);

              case 8:
                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](0);

                _this7.addToast('error', !_context2.t0.response ? _context2.t0.message : _context2.t0.response.data.message || _context2.t0.response.data.errors.join('<br>'));

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this7, [[0, 10]]);
      }))();
    },
    exportTable: function exportTable() {
      var _this8 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var csvContents, extraContents, headerContents, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, content, weighting, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, _ref, _ref2, index, data, contents, _iteratorNormalCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, _content, url, title;

        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                csvContents = [];
                extraContents = [];

                _this8.conditions.filters.product && extraContents.push('品項：' + _this8.getFilterTitle('product'));
                _this8.conditions.filters.country && extraContents.push('目標市場：' + _this8.getFilterTitle('country'));
                if (_this8.dataType === 'country') {
                  _this8.conditions.filters.year && extraContents.push('數據年份：' + _this8.getFilterTitle('year'));
                } else if (_this8.dataType === 'year') {
                  _this8.country && extraContents.push({
                    competitiveness: '競爭國家：' + _this8.country.country_name,
                    attraction: '市場國家：' + _this8.country.partner_name,
                    toolcompetitiveness: '競爭國家：' + _this8.country.country_name,
                    toolattraction: '市場國家：' + _this8.country.partner_name
                  }[_this8.analysisType]);
                }
                extraContents = [extraContents.join(', ')];
                csvContents.push(extraContents);
                headerContents = [];

                headerContents.push({
                  country: _this8.tableOption.country.title,
                  year: _this8.tableOption.year.title
                }[_this8.dataType]);
                _iteratorNormalCompletion3 = true;
                _didIteratorError3 = false;
                _iteratorError3 = undefined;
                _context3.prev = 12;
                for (_iterator3 = get_iterator_default()(_this8.tableOption.contents); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                  content = _step3.value;

                  headerContents.push(content.title.join(''));
                  weighting = _this8.conditions.weightings[content.value].active ? _this8.conditions.weightings[content.value].value : 0;

                  headerContents.push(content.title.join('').replace(/\(.+\)/, '') + { country: '標準化分數(加權=' + weighting + ')', year: '之年度世界排名' }[_this8.dataType]);
                }
                _context3.next = 20;
                break;

              case 16:
                _context3.prev = 16;
                _context3.t0 = _context3['catch'](12);
                _didIteratorError3 = true;
                _iteratorError3 = _context3.t0;

              case 20:
                _context3.prev = 20;
                _context3.prev = 21;

                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }

              case 23:
                _context3.prev = 23;

                if (!_didIteratorError3) {
                  _context3.next = 26;
                  break;
                }

                throw _iteratorError3;

              case 26:
                return _context3.finish(23);

              case 27:
                return _context3.finish(20);

              case 28:
                if (_this8.dataType === 'country') {
                  headerContents.push('標準化分數總計');
                  headerContents.push('標準化總分之世界排名');
                } else if (_this8.dataType === 'year') {
                  headerContents.push('標準化總分之世界排名');
                }
                csvContents.push(headerContents);
                _iteratorNormalCompletion4 = true;
                _didIteratorError4 = false;
                _iteratorError4 = undefined;
                _context3.prev = 33;
                _iterator4 = get_iterator_default()(entries_default()(_this8.tableDatas));

              case 35:
                if (_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done) {
                  _context3.next = 67;
                  break;
                }

                _ref = _step4.value;
                _ref2 = slicedToArray_default()(_ref, 2);
                index = _ref2[0];
                data = _ref2[1];

                if (!_this8.selectedDatas.includes(data)) {
                  _context3.next = 64;
                  break;
                }

                contents = [];

                contents.push({
                  country: data[_this8.tableOption.country.name] + '(' + data[_this8.tableOption.country.subName] + ')',
                  year: data[_this8.tableOption.year.name]
                }[_this8.dataType]);
                _iteratorNormalCompletion5 = true;
                _didIteratorError5 = false;
                _iteratorError5 = undefined;
                _context3.prev = 46;
                for (_iterator5 = get_iterator_default()(_this8.tableOption.contents); !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                  _content = _step5.value;

                  contents.push(data[_content.value] || data[_content.value] === 0 ? data[_content.value].toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : 'n/a');
                  contents.push({ country: (data.display_standardization[_content.value] || 0).toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, ''), year: data.standardization[_content.value + '_order'] }[_this8.dataType]);
                }
                _context3.next = 54;
                break;

              case 50:
                _context3.prev = 50;
                _context3.t1 = _context3['catch'](46);
                _didIteratorError5 = true;
                _iteratorError5 = _context3.t1;

              case 54:
                _context3.prev = 54;
                _context3.prev = 55;

                if (!_iteratorNormalCompletion5 && _iterator5.return) {
                  _iterator5.return();
                }

              case 57:
                _context3.prev = 57;

                if (!_didIteratorError5) {
                  _context3.next = 60;
                  break;
                }

                throw _iteratorError5;

              case 60:
                return _context3.finish(57);

              case 61:
                return _context3.finish(54);

              case 62:
                if (_this8.dataType === 'country') {
                  contents.push(data.display_total_standardization || 0);
                  contents.push(index - -1);
                } else if (_this8.dataType === 'year') {
                  contents.push(data.total_standardization_order || 'n/a');
                }
                csvContents.push(contents);

              case 64:
                _iteratorNormalCompletion4 = true;
                _context3.next = 35;
                break;

              case 67:
                _context3.next = 73;
                break;

              case 69:
                _context3.prev = 69;
                _context3.t2 = _context3['catch'](33);
                _didIteratorError4 = true;
                _iteratorError4 = _context3.t2;

              case 73:
                _context3.prev = 73;
                _context3.prev = 74;

                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                  _iterator4.return();
                }

              case 76:
                _context3.prev = 76;

                if (!_didIteratorError4) {
                  _context3.next = 79;
                  break;
                }

                throw _iteratorError4;

              case 79:
                return _context3.finish(76);

              case 80:
                return _context3.finish(73);

              case 81:
                url = 'data:application/csv;charset=utf-8,%EF%BB%BF' + encodeURIComponent(csvContents.map(function (x) {
                  return '"' + x.join('","') + '"';
                }).join('\r\n') + '\r\n');
                title = '';

                title = title + {
                  country: {
                    competitiveness: _this8.getFilterTitle('year') + '年' + _this8.getFilterTitle('product') + '在' + _this8.getFilterTitle('country') + '的市場競爭力',
                    attraction: _this8.getFilterTitle('year') + '年' + _this8.getFilterTitle('product') + '各國市場吸引力',
                    toolcompetitiveness: _this8.getFilterTitle('year') + '年' + _this8.getFilterTitle('product') + '在' + _this8.getFilterTitle('country') + '的農業機械市場競爭力',
                    toolattraction: _this8.getFilterTitle('year') + '年' + _this8.getFilterTitle('product') + '各國農業機械市場吸引力'
                  },
                  year: {
                    competitiveness: _this8.getCountryTitle() + '的' + _this8.getFilterTitle('product') + '在' + _this8.getFilterTitle('country') + '市場的歷年市場競爭力',
                    attraction: _this8.getFilterTitle('product') + '在' + _this8.getCountryTitle() + '的歷年市場吸引力',
                    toolcompetitiveness: _this8.getCountryTitle() + '的' + _this8.getFilterTitle('product') + '在' + _this8.getFilterTitle('country') + '市場的歷年農業機械市場競爭力',
                    toolattraction: _this8.getFilterTitle('product') + '在' + _this8.getCountryTitle() + '的歷年農業機械市場吸引力'
                  }
                }[_this8.dataType][_this8.analysisType];
                title = title + '分析表.csv';
                _context3.next = 87;
                return _this8.sendTableAccessLog();

              case 87:
                Object(util["c" /* downloadFile */])(title, url, '_target');

              case 88:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this8, [[12, 16, 20, 28], [21,, 23, 27], [33, 69, 73, 81], [46, 50, 54, 62], [55,, 57, 61], [74,, 76, 80]]);
      }))();
    },
    sendTableAccessLog: function sendTableAccessLog() {
      var _this9 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var config, type, selectedDatas, paramDatas, paramInfos, data;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                config = _this9.$ls.get('userInfo');
                type = {
                  country: {
                    competitiveness: 'market_competitiveness',
                    attraction: 'market_attractiveness',
                    toolcompetitiveness: 'market_competitiveness',
                    toolattraction: 'market_attractiveness'
                  },
                  year: {
                    competitiveness: 'single_country_market_competitiveness',
                    attraction: 'single_country_market_attractiveness',
                    toolcompetitiveness: 'single_country_market_competitiveness',
                    toolattraction: 'single_country_market_attractiveness'
                  }
                }[_this9.dataType][_this9.analysisType];
                selectedDatas = _this9.selectedDatas.map(function (data) {
                  return {
                    country: {
                      competitiveness: data.country_name,
                      attraction: data.partner_name,
                      toolcompetitiveness: data.country_name,
                      toolattraction: data.partner_name
                    },
                    year: {
                      competitiveness: data.year,
                      attraction: data.year,
                      toolcompetitiveness: data.year,
                      toolattraction: data.year
                    }
                  }[_this9.dataType][_this9.analysisType];
                });
                paramDatas = {
                  country: _this9.dataType === 'country' ? {
                    competitiveness: {
                      access_file_type: 'normal_data_sheet',
                      partner: _this9.conditions.filters.country,
                      year: _this9.conditions.filters.year,
                      product_code: _this9.conditions.filters.product
                    },
                    attraction: {
                      access_file_type: 'normal_data_sheet',
                      year: _this9.conditions.filters.year,
                      product_code: _this9.conditions.filters.product
                    },
                    toolcompetitiveness: {
                      access_file_type: 'normal_data_sheet',
                      partner: _this9.conditions.filters.country,
                      year: _this9.conditions.filters.year,
                      product_code: _this9.conditions.filters.product
                    },
                    toolattraction: {
                      access_file_type: 'normal_data_sheet',
                      year: _this9.conditions.filters.year,
                      product_code: _this9.conditions.filters.product
                    }
                  } : {},
                  year: _this9.dataType === 'year' ? {
                    competitiveness: {
                      access_file_type: 'normal_data_sheet',
                      partner: _this9.conditions.filters.country,
                      product_code: _this9.conditions.filters.product,
                      country: _this9.country.country_code
                    },
                    attraction: {
                      access_file_type: 'normal_data_sheet',
                      partner: _this9.country.partner_code,
                      product_code: _this9.conditions.filters.product
                    },
                    toolcompetitiveness: {
                      access_file_type: 'normal_data_sheet',
                      partner: _this9.conditions.filters.country,
                      product_code: _this9.conditions.filters.product,
                      country: _this9.country.country_code
                    },
                    toolattraction: {
                      access_file_type: 'normal_data_sheet',
                      partner: _this9.country.partner_code,
                      product_code: _this9.conditions.filters.product
                    }
                  } : {}
                }[_this9.dataType][_this9.analysisType];
                paramInfos = entries_default()(_this9.conditions.weightings).map(function (_ref3) {
                  var _ref4 = slicedToArray_default()(_ref3, 2),
                      value = _ref4[0],
                      condition = _ref4[1];

                  return [condition.title, condition.active ? condition.value : 0];
                });
                data = extends_default()({}, paramDatas, {
                  chart_params_info: selectedDatas.join(', '),
                  weighted_index_info: paramInfos.map(function (info) {
                    return info.join(' = ');
                  }).join(', ')
                });
                _context4.next = 9;
                return Object(src_api["I" /* postAccessLog */])(type, data, config);

              case 9:
                _context4.next = 14;
                break;

              case 11:
                _context4.prev = 11;
                _context4.t0 = _context4['catch'](0);

                _this9.addToast('error', !_context4.t0.response ? _context4.t0.message : _context4.t0.response.data.message || _context4.t0.response.data.errors.join('<br>'));

              case 14:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this9, [[0, 11]]);
      }))();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-182bd981","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/analysis/table.vue
var analysis_table_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"analysis-table-page col-block"},[_c('div',{staticClass:"option-container row-block"},[_c('div',{staticClass:"data-block row-block"},[(_vm.conditions.filters.product)?[_c('div',[_c('b',[_vm._v("品項：")]),_vm._v(_vm._s(_vm.getFilterTitle('product')))]),_vm._v(" "),_c('div',{style:({ width: '50px' })})]:_vm._e(),_vm._v(" "),(_vm.conditions.filters.country)?[_c('div',[_c('b',[_vm._v("目標市場：")]),_vm._v(_vm._s(_vm.getFilterTitle('country')))]),_vm._v(" "),_c('div',{style:({ width: '50px' })})]:_vm._e(),_vm._v(" "),(_vm.dataType === 'country' && _vm.conditions.filters.year)?[_c('div',[_c('b',[_vm._v("數據年份：")]),_vm._v(_vm._s(_vm.getFilterTitle('year')))]),_vm._v(" "),_c('div',{style:({ width: '50px' })})]:_vm._e(),_vm._v(" "),(_vm.dataType === 'year' && _vm.country)?[_c('div',[_c('b',[_vm._v(_vm._s({ competitiveness: '競爭國家', attraction: '市場國家', toolcompetitiveness: '競爭國家', toolattraction: '市場國家' }[_vm.analysisType])+"：")]),_vm._v(_vm._s({ competitiveness: _vm.country.country_name, attraction: _vm.country.partner_name, toolcompetitiveness: _vm.country.country_name, toolattraction: _vm.country.partner_name }[_vm.analysisType]))]),_vm._v(" "),_c('div',{style:({ width: '50px' })})]:_vm._e(),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{style:({ width: '50px' })}),_vm._v(" "),_c('div',{staticClass:"row-block"},[_c('b',[_vm._v(_vm._s({ country: '標準化分數', year: '該指標標準化分數之年度世界排名' }[_vm.dataType]))]),_vm._v(" "),_c('div',{staticClass:"block",class:[{ country: 'blue', year: 'yellow' }[_vm.dataType]]})])],2),_vm._v(" "),_c('div',{staticClass:"button-block row-block"},[(_vm.rolePermission(['advance', 'admin']))?[_c('button',{staticClass:"main-button option-button update",attrs:{"type":"button","name":"button"},on:{"click":function (e) { return _vm.downloadData(); }}},[_c('span',[_vm._v("原始數據下載")])]),_vm._v(" "),_c('div',{style:({ width: '15px' })})]:_vm._e(),_vm._v(" "),_c('button',{staticClass:"main-button option-button update",attrs:{"type":"button","name":"button"},on:{"click":function (e) { return _vm.exportTable(); }}},[_c('span',[_vm._v("匯出表格")])])],2)]),_vm._v(" "),_c('div',{staticClass:"content-container",style:({ flex: 1 })},[_c('div',{staticClass:"table-block"},[_c('analysisTable',{attrs:{"dataType":_vm.dataType,"datas":_vm.tableDatas || [],"option":_vm.tableOption,"init":_vm.selectedDatas,"onSelected":function (selected) { return _vm.onSelected(selected); }},on:{"countryOnClick":function (data) { return _vm.countryOnClick(data); },"reportOnClick":function (data) { return _vm.reportOnClick(data); }}})],1)])])}
var analysis_table_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row-block"},[_c('b',[_vm._v("原始數值")]),_vm._v(" "),_c('div',{staticClass:"block white"})])}]
var analysis_table_esExports = { render: analysis_table_render, staticRenderFns: analysis_table_staticRenderFns }
/* harmony default export */ var components_analysis_table = (analysis_table_esExports);
// CONCATENATED MODULE: ./src/components/analysis/table.vue
var analysis_table_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var analysis_table___vue_template_functional__ = false
/* styles */
var analysis_table___vue_styles__ = null
/* scopeId */
var analysis_table___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var analysis_table___vue_module_identifier__ = null
var analysis_table_Component = analysis_table_normalizeComponent(
  analysis_table,
  components_analysis_table,
  analysis_table___vue_template_functional__,
  analysis_table___vue_styles__,
  analysis_table___vue_scopeId__,
  analysis_table___vue_module_identifier__
)

/* harmony default export */ var src_components_analysis_table = (analysis_table_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/analysis/graph.vue





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var analysis_graph = ({
  components: {
    vueCharts: vue_echarts_components_ECharts,
    customFilter: components_tool_customFilter
  },
  mixins: [toastMethods["a" /* default */]],
  props: {
    dataType: {
      type: String,
      required: true
    },
    country: {
      Type: Object,
      default: function _default() {
        return null;
      }
    },
    tableDatas: {
      type: Array,
      required: true
    },
    curSelectedDatas: {
      type: Array,
      required: true
    },
    state: {
      type: String,
      required: true
    },
    filterOptions: {
      type: Object,
      required: true
    },
    conditions: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      echarts: node_modules_echarts_default.a,
      fontSize: '14',
      optionTab: 'graph',
      selectedDatas: [],
      graphInit: null,
      graphType: null,
      displayGraphType: null,
      filterConditions: {}
    };
  },

  computed: {
    graphDatas: function graphDatas() {
      var graphDatas = this.selectedDatas;
      return graphDatas;
    },
    analysisType: function analysisType() {
      return this.$route.name;
    },

    // static
    colors: function colors() {
      return [['#36A2DA', '#3966A6', '#9CCECB', '#85B84F', '#3A9171', '#29463C', '#FFB700', '#FF7D0D', '#ED92BF', '#CC292E', '#DABE7F', '#6A0E1C', '#B38039', '#C37FE6'], ['#85B84F', '#FFB700', '#ED92BF', '#FF7D0D', '#36A2DA', '#29463C', '#CC292E', '#C37FE6', '#3A9171', '#9CCECB', '#6A0E1C', '#DABE7F', '#3966A6', '#B38039']];
    },
    filterDescription: function filterDescription() {
      var _this = this;

      return {
        bar: function bar() {
          return {
            competitiveness: ['若要修改圖面呈現之國家/年份數據，請回到數據結果勾選操作'],
            attraction: ['若要修改圖面呈現之國家/年份數據，請回到數據結果勾選操作'],
            toolcompetitiveness: ['若要修改圖面呈現之國家/年份數據，請回到數據結果勾選操作'],
            toolattraction: ['若要修改圖面呈現之國家/年份數據，請回到數據結果勾選操作']
          }[_this.analysisType];
        },
        scatter: function scatter() {
          return {
            competitiveness: ['若要修改圖面呈現之國家/年份數據，請回到數據結果勾選操作'],
            attraction: ['若要修改圖面呈現之國家/年份數據，請回到數據結果勾選操作'],
            toolcompetitiveness: ['若要修改圖面呈現之國家/年份數據，請回到數據結果勾選操作'],
            toolattraction: ['若要修改圖面呈現之國家/年份數據，請回到數據結果勾選操作']
          }[_this.analysisType];
        },
        bubble: function bubble() {
          return {
            competitiveness: ['若要修改圖面呈現之國家/年份數據，請回到數據結果勾選操作'],
            attraction: ['若要修改圖面呈現之國家/年份數據，請回到數據結果勾選操作'],
            toolcompetitiveness: ['若要修改圖面呈現之國家/年份數據，請回到數據結果勾選操作'],
            toolattraction: ['若要修改圖面呈現之國家/年份數據，請回到數據結果勾選操作']
          }[_this.analysisType];
        },
        radar: function radar() {
          return {
            country: {
              competitiveness: ['雷達圖最多提供5個國家疊圖，', '若超過國家，顯示前5國家，', '若需調整其他年度，請回到', '「數據結果」頁面勾選。'],
              attraction: ['雷達圖最多提供5個國家疊圖，', '若超過國家，顯示前5國家，', '若需調整其他年度，請回到', '「數據結果」頁面勾選。'],
              toolcompetitiveness: ['雷達圖最多提供5個國家疊圖，', '若超過國家，顯示前5國家，', '若需調整其他年度，請回到', '「數據結果」頁面勾選。'],
              toolattraction: ['雷達圖最多提供5個國家疊圖，', '若超過國家，顯示前5國家，', '若需調整其他年度，請回到', '「數據結果」頁面勾選。']
            },
            year: {
              competitiveness: ['雷達圖最多提供5個年度疊圖，', '若超過則顯示前5個年度，', '若需調整其他年度，請回到', '「數據結果」頁面勾選。'],
              attraction: ['雷達圖最多提供5個年度疊圖，', '若超過則顯示前5個年度，', '若需調整其他年度，請回到', '「數據結果」頁面勾選。'],
              toolcompetitiveness: ['雷達圖最多提供5個國家疊圖，', '若超過國家，顯示前5國家，', '若需調整其他年度，請回到', '「數據結果」頁面勾選。'],
              toolattraction: ['雷達圖最多提供5個國家疊圖，', '若超過國家，顯示前5國家，', '若需調整其他年度，請回到', '「數據結果」頁面勾選。']
            }
          }[_this.dataType][_this.analysisType];
        }
      }[this.graphType]();
    },
    typeOptions: function typeOptions() {
      return [{
        title: '統計圖類型',
        value: 'type',
        type: 'select',
        options: [{
          title: 'XY散佈圖',
          value: 'scatter'
        }, {
          title: '泡泡圖',
          value: 'bubble'
        }, {
          title: '累計長條圖',
          value: 'bar'
        }, {
          title: '雷達圖',
          value: 'radar'
        }]
      }];
    },
    graphOptions: function graphOptions() {
      var _this2 = this;

      return {
        bar: function bar() {
          return {
            competitiveness: [{
              title: 'X軸',
              value: 'xAxis',
              type: 'select',
              options: [{
                country: { title: '國家', value: 'country_name' },
                year: { title: '數據年分', value: 'year' }
              }[_this2.dataType]]
            }, {
              title: 'Y軸',
              value: 'yAxis',
              type: 'multiple',
              options: [{ title: '產量', value: 'production_quantity' }, { title: '單位面積產量', value: 'yield' }, { title: '生產者價格', value: 'producer_price' }, { title: '進口單價', value: 'import_price' }, { title: 'RCA', value: 'RCA' }, { title: 'TII', value: 'TII' }, { title: '市場距離', value: 'distance' }]
            }],
            attraction: [{
              title: 'X軸',
              value: 'xAxis',
              type: 'select',
              options: [{
                country: { title: '國家', value: 'partner_name' },
                year: { title: '數據年分', value: 'year' }
              }[_this2.dataType]]
            }, {
              title: 'Y軸',
              value: 'yAxis',
              type: 'multiple',
              options: [{ title: '產量', value: 'production_quantity' }, { title: '出口值', value: 'export_value' }, { title: '進口值', value: 'import_value' }, { title: '市場規模', value: 'market_size' }, { title: '進口市場成長趨勢', value: 'import_market_growth_trend' }, { title: 'TSI', value: 'TSI' }, { title: '市場距離', value: 'distance' }, { title: '佔全球貿易市場佔有率', value: 'market_share' }, { title: '平均每人GDP', value: 'GDP' }, { title: '人口數', value: 'total_population' }, { title: '市場成長相對強度', value: 'market_growth_intensity' }, { title: '進口市場表現', value: 'market_performance' }, { title: '市場開放程度', value: 'market_openness' }, { title: '市場相對優惠關稅', value: 'market_preferential_tariff' }]
            }],
            toolcompetitiveness: [{
              title: 'X軸',
              value: 'xAxis',
              type: 'select',
              options: [{
                country: { title: '國家', value: 'country_name' },
                year: { title: '數據年分', value: 'year' }
              }[_this2.dataType]]
            }, {
              title: 'Y軸',
              value: 'yAxis',
              type: 'multiple',
              options: [{ title: '進口單價', value: 'import_price' }, { title: 'RCA', value: 'RCA' }, { title: 'TII', value: 'TII' }]
            }],
            toolattraction: [{
              title: 'X軸',
              value: 'xAxis',
              type: 'select',
              options: [{
                country: { title: '國家', value: 'partner_name' },
                year: { title: '數據年分', value: 'year' }
              }[_this2.dataType]]
            }, {
              title: 'Y軸',
              value: 'yAxis',
              type: 'multiple',
              options: [{ title: '出口值', value: 'export_value' }, { title: '進口值', value: 'import_value' }, { title: '進口市場成長趨勢', value: 'import_market_growth_trend' }, { title: 'TSI', value: 'TSI' }, { title: '佔全球貿易市場佔有率', value: 'market_share' }, { title: '平均每人GDP', value: 'GDP' }, { title: 'GNI', value: 'GNI' }, { title: '農業人口比率', value: 'agricultural_population_proportion' }, { title: '農業人口比率趨勢', value: 'agricultural_population_proportion_trend' }, { title: '耕地面積', value: 'cultivated_area' }, { title: '平均農業人口耕地面積', value: 'average_agricultural_population_cultivated_area' }, { title: '市場成長相對強度', value: 'market_growth_intensity' }, { title: '進口市場表現', value: 'market_performance' }, { title: '市場開放程度', value: 'market_openness' }, { title: '市場相對優惠關稅', value: 'market_preferential_tariff' }]
            }]
          }[_this2.analysisType];
        },
        scatter: function scatter() {
          return {
            competitiveness: [{
              title: 'X軸',
              value: 'xAxis',
              type: 'select',
              options: [{ title: '產量', value: 'production_quantity' }, { title: '單位面積產量', value: 'yield' }, { title: '生產者價格', value: 'producer_price' }, { title: '進口單價', value: 'import_price' }, { title: 'RCA', value: 'RCA' }, { title: 'TII', value: 'TII' }, { title: '市場距離', value: 'distance' }].filter(function (option) {
                return option.value !== _this2.filterConditions.yAxis;
              })
            }, {
              title: 'Y軸',
              value: 'yAxis',
              type: 'select',
              options: [{ title: '產量', value: 'production_quantity' }, { title: '單位面積產量', value: 'yield' }, { title: '生產者價格', value: 'producer_price' }, { title: '進口單價', value: 'import_price' }, { title: 'RCA', value: 'RCA' }, { title: 'TII', value: 'TII' }, { title: '市場距離', value: 'distance' }].filter(function (option) {
                return option.value !== _this2.filterConditions.xAxis;
              })
            }],
            attraction: [{
              title: 'X軸',
              value: 'xAxis',
              type: 'select',
              options: [{ title: '產量', value: 'production_quantity' }, { title: '出口值', value: 'export_value' }, { title: '進口值', value: 'import_value' }, { title: '市場規模', value: 'market_size' }, { title: '進口市場成長趨勢', value: 'import_market_growth_trend' }, { title: 'TSI', value: 'TSI' }, { title: '市場距離', value: 'distance' }, { title: '佔全球貿易市場佔有率', value: 'market_share' }, { title: '平均每人GDP', value: 'GDP' }, { title: '人口數', value: 'total_population' }, { title: '市場成長相對強度', value: 'market_growth_intensity' }, { title: '進口市場表現', value: 'market_performance' }, { title: '市場開放程度', value: 'market_openness' }, { title: '市場相對優惠關稅', value: 'market_preferential_tariff' }].filter(function (option) {
                return option.value !== _this2.filterConditions.yAxis;
              })
            }, {
              title: 'Y軸',
              value: 'yAxis',
              type: 'select',
              options: [{ title: '產量', value: 'production_quantity' }, { title: '出口值', value: 'export_value' }, { title: '進口值', value: 'import_value' }, { title: '市場規模', value: 'market_size' }, { title: '進口市場成長趨勢', value: 'import_market_growth_trend' }, { title: 'TSI', value: 'TSI' }, { title: '市場距離', value: 'distance' }, { title: '佔全球貿易市場佔有率', value: 'market_share' }, { title: '平均每人GDP', value: 'GDP' }, { title: '人口數', value: 'total_population' }, { title: '市場成長相對強度', value: 'market_growth_intensity' }, { title: '進口市場表現', value: 'market_performance' }, { title: '市場開放程度', value: 'market_openness' }, { title: '市場相對優惠關稅', value: 'market_preferential_tariff' }].filter(function (option) {
                return option.value !== _this2.filterConditions.xAxis;
              })
            }],
            toolcompetitiveness: [{
              title: 'X軸',
              value: 'xAxis',
              type: 'select',
              options: [{ title: '進口單價', value: 'import_price' }, { title: 'RCA', value: 'RCA' }, { title: 'TII', value: 'TII' }].filter(function (option) {
                return option.value !== _this2.filterConditions.yAxis;
              })
            }, {
              title: 'Y軸',
              value: 'yAxis',
              type: 'select',
              options: [{ title: '進口單價', value: 'import_price' }, { title: 'RCA', value: 'RCA' }, { title: 'TII', value: 'TII' }].filter(function (option) {
                return option.value !== _this2.filterConditions.xAxis;
              })
            }],
            toolattraction: [{
              title: 'X軸',
              value: 'xAxis',
              type: 'select',
              options: [{ title: '出口值', value: 'export_value' }, { title: '進口值', value: 'import_value' }, { title: '進口市場成長趨勢', value: 'import_market_growth_trend' }, { title: 'TSI', value: 'TSI' }, { title: '佔全球貿易市場佔有率', value: 'market_share' }, { title: '平均每人GDP', value: 'GDP' }, { title: 'GNI', value: 'GNI' }, { title: '農業人口比率', value: 'agricultural_population_proportion' }, { title: '農業人口比率趨勢', value: 'agricultural_population_proportion_trend' }, { title: '耕地面積', value: 'cultivated_area' }, { title: '平均農業人口耕地面積', value: 'average_agricultural_population_cultivated_area' }, { title: '市場成長相對強度', value: 'market_growth_intensity' }, { title: '進口市場表現', value: 'market_performance' }, { title: '市場開放程度', value: 'market_openness' }, { title: '市場相對優惠關稅', value: 'market_preferential_tariff' }].filter(function (option) {
                return option.value !== _this2.filterConditions.yAxis;
              })
            }, {
              title: 'Y軸',
              value: 'yAxis',
              type: 'select',
              options: [{ title: '出口值', value: 'export_value' }, { title: '進口值', value: 'import_value' }, { title: '進口市場成長趨勢', value: 'import_market_growth_trend' }, { title: 'TSI', value: 'TSI' }, { title: '佔全球貿易市場佔有率', value: 'market_share' }, { title: '平均每人GDP', value: 'GDP' }, { title: 'GNI', value: 'GNI' }, { title: '農業人口比率', value: 'agricultural_population_proportion' }, { title: '農業人口比率趨勢', value: 'agricultural_population_proportion_trend' }, { title: '耕地面積', value: 'cultivated_area' }, { title: '平均農業人口耕地面積', value: 'average_agricultural_population_cultivated_area' }, { title: '市場成長相對強度', value: 'market_growth_intensity' }, { title: '進口市場表現', value: 'market_performance' }, { title: '市場開放程度', value: 'market_openness' }, { title: '市場相對優惠關稅', value: 'market_preferential_tariff' }].filter(function (option) {
                return option.value !== _this2.filterConditions.xAxis;
              })
            }]
          }[_this2.analysisType];
        },
        bubble: function bubble() {
          return {
            competitiveness: [{
              title: 'X軸',
              value: 'xAxis',
              type: 'select',
              options: [{ title: '產量', value: 'production_quantity' }, { title: '單位面積產量', value: 'yield' }, { title: '生產者價格', value: 'producer_price' }, { title: '進口單價', value: 'import_price' }, { title: 'RCA', value: 'RCA' }, { title: 'TII', value: 'TII' }, { title: '市場距離', value: 'distance' }].filter(function (option) {
                return ![_this2.filterConditions.yAxis, _this2.filterConditions.point].includes(option.value);
              })
            }, {
              title: 'Y軸',
              value: 'yAxis',
              type: 'select',
              options: [{ title: '產量', value: 'production_quantity' }, { title: '單位面積產量', value: 'yield' }, { title: '生產者價格', value: 'producer_price' }, { title: '進口單價', value: 'import_price' }, { title: 'RCA', value: 'RCA' }, { title: 'TII', value: 'TII' }, { title: '市場距離', value: 'distance' }].filter(function (option) {
                return ![_this2.filterConditions.xAxis, _this2.filterConditions.point].includes(option.value);
              })
            }, {
              title: 'Z軸',
              value: 'point',
              type: 'select',
              options: [{ title: '產量', value: 'production_quantity', description: '公噸' }, { title: '單位面積產量', value: 'yield', description: '百克/公頃' }, { title: '生產者價格', value: 'producer_price', description: '美元/公噸' }, { title: '進口單價', value: 'import_price', description: '美元/公斤' }, { title: 'RCA', value: 'RCA', description: '' }, { title: 'TII', value: 'TII', description: '' }, { title: '市場距離', value: 'distance', description: '公里' }].filter(function (option) {
                return ![_this2.filterConditions.xAxis, _this2.filterConditions.yAxis].includes(option.value);
              })
            }],
            attraction: [{
              title: 'X軸',
              value: 'xAxis',
              type: 'select',
              options: [{ title: '產量', value: 'production_quantity' }, { title: '出口值', value: 'export_value' }, { title: '進口值', value: 'import_value' }, { title: '市場規模', value: 'market_size' }, { title: '進口市場成長趨勢', value: 'import_market_growth_trend' }, { title: 'TSI', value: 'TSI' }, { title: '市場距離', value: 'distance' }, { title: '佔全球貿易市場佔有率', value: 'market_share' }, { title: '平均每人GDP', value: 'GDP' }, { title: '人口數', value: 'total_population' }, { title: '市場成長相對強度', value: 'market_growth_intensity' }, { title: '進口市場表現', value: 'market_performance' }, { title: '市場開放程度', value: 'market_openness' }, { title: '市場相對優惠關稅', value: 'market_preferential_tariff' }].filter(function (option) {
                return ![_this2.filterConditions.yAxis, _this2.filterConditions.point].includes(option.value);
              })
            }, {
              title: 'Y軸',
              value: 'yAxis',
              type: 'select',
              options: [{ title: '產量', value: 'production_quantity' }, { title: '出口值', value: 'export_value' }, { title: '進口值', value: 'import_value' }, { title: '市場規模', value: 'market_size' }, { title: '進口市場成長趨勢', value: 'import_market_growth_trend' }, { title: 'TSI', value: 'TSI' }, { title: '市場距離', value: 'distance' }, { title: '佔全球貿易市場佔有率', value: 'market_share' }, { title: '平均每人GDP', value: 'GDP' }, { title: '人口數', value: 'total_population' }, { title: '市場成長相對強度', value: 'market_growth_intensity' }, { title: '進口市場表現', value: 'market_performance' }, { title: '市場開放程度', value: 'market_openness' }, { title: '市場相對優惠關稅', value: 'market_preferential_tariff' }].filter(function (option) {
                return ![_this2.filterConditions.xAxis, _this2.filterConditions.point].includes(option.value);
              })
            }, {
              title: 'Z軸',
              value: 'point',
              type: 'select',
              options: [{ title: '產量', value: 'production_quantity', description: '公噸' }, { title: '出口值', value: 'export_value', description: '千美元' }, { title: '進口值', value: 'import_value', description: '千美元' }, { title: '市場規模', value: 'market_size', description: '千美元' }, { title: '進口市場成長趨勢', value: 'import_market_growth_trend', description: '%' }, { title: 'TSI', value: 'TSI', description: '' }, { title: '市場距離', value: 'distance', description: '公里' }, { title: '佔全球貿易市場佔有率', value: 'market_share', description: '%' }, { title: '平均每人GDP', value: 'GDP', description: '美元' }, { title: '人口數', value: 'total_population', description: '' }, { title: '市場成長相對強度', value: 'market_growth_intensity', description: '%' }, { title: '進口市場表現', value: 'market_performance', description: '%' }, { title: '市場開放程度', value: 'market_openness', description: '%' }, { title: '市場相對優惠關稅', value: 'market_preferential_tariff', description: '%' }].filter(function (option) {
                return ![_this2.filterConditions.xAxis, _this2.filterConditions.yAxis].includes(option.value);
              })
            }],
            toolcompetitiveness: [{
              title: 'X軸',
              value: 'xAxis',
              type: 'select',
              options: [{ title: '進口單價', value: 'import_price' }, { title: 'RCA', value: 'RCA' }, { title: 'TII', value: 'TII' }].filter(function (option) {
                return ![_this2.filterConditions.yAxis, _this2.filterConditions.point].includes(option.value);
              })
            }, {
              title: 'Y軸',
              value: 'yAxis',
              type: 'select',
              options: [{ title: '進口單價', value: 'import_price' }, { title: 'RCA', value: 'RCA' }, { title: 'TII', value: 'TII' }].filter(function (option) {
                return ![_this2.filterConditions.xAxis, _this2.filterConditions.point].includes(option.value);
              })
            }, {
              title: 'Z軸',
              value: 'point',
              type: 'select',
              options: [{ title: '進口單價', value: 'import_price', description: '美元/公斤' }, { title: 'RCA', value: 'RCA', description: '' }, { title: 'TII', value: 'TII', description: '' }].filter(function (option) {
                return ![_this2.filterConditions.xAxis, _this2.filterConditions.yAxis].includes(option.value);
              })
            }],
            toolattraction: [{
              title: 'X軸',
              value: 'xAxis',
              type: 'select',
              options: [{ title: '出口值', value: 'export_value' }, { title: '進口值', value: 'import_value' }, { title: '進口市場成長趨勢', value: 'import_market_growth_trend' }, { title: 'TSI', value: 'TSI' }, { title: '佔全球貿易市場佔有率', value: 'market_share' }, { title: '平均每人GDP', value: 'GDP' }, { title: 'GNI', value: 'GNI' }, { title: '農業人口比率', value: 'agricultural_population_proportion' }, { title: '農業人口比率趨勢', value: 'agricultural_population_proportion_trend' }, { title: '耕地面積', value: 'cultivated_area' }, { title: '平均農業人口耕地面積', value: 'average_agricultural_population_cultivated_area' }, { title: '市場成長相對強度', value: 'market_growth_intensity' }, { title: '進口市場表現', value: 'market_performance' }, { title: '市場開放程度', value: 'market_openness' }, { title: '市場相對優惠關稅', value: 'market_preferential_tariff' }].filter(function (option) {
                return ![_this2.filterConditions.yAxis, _this2.filterConditions.point].includes(option.value);
              })
            }, {
              title: 'Y軸',
              value: 'yAxis',
              type: 'select',
              options: [{ title: '出口值', value: 'export_value' }, { title: '進口值', value: 'import_value' }, { title: '進口市場成長趨勢', value: 'import_market_growth_trend' }, { title: 'TSI', value: 'TSI' }, { title: '佔全球貿易市場佔有率', value: 'market_share' }, { title: '平均每人GDP', value: 'GDP' }, { title: 'GNI', value: 'GNI' }, { title: '農業人口比率', value: 'agricultural_population_proportion' }, { title: '農業人口比率趨勢', value: 'agricultural_population_proportion_trend' }, { title: '耕地面積', value: 'cultivated_area' }, { title: '平均農業人口耕地面積', value: 'average_agricultural_population_cultivated_area' }, { title: '市場成長相對強度', value: 'market_growth_intensity' }, { title: '進口市場表現', value: 'market_performance' }, { title: '市場開放程度', value: 'market_openness' }, { title: '市場相對優惠關稅', value: 'market_preferential_tariff' }].filter(function (option) {
                return ![_this2.filterConditions.xAxis, _this2.filterConditions.point].includes(option.value);
              })
            }, {
              title: 'Z軸',
              value: 'point',
              type: 'select',
              options: [{ title: '出口值', value: 'export_value', description: '千美元' }, { title: '進口值', value: 'import_value', description: '千美元' }, { title: '進口市場成長趨勢', value: 'import_market_growth_trend', description: '%' }, { title: 'TSI', value: 'TSI', description: '' }, { title: '佔全球貿易市場佔有率', value: 'market_share', description: '%' }, { title: '平均每人GDP', value: 'GDP', description: '美元' }, { title: 'GNI', value: 'GNI', description: '美元' }, { title: '農業人口比率', value: 'agricultural_population_proportion', description: '%' }, { title: '農業人口比率趨勢', value: 'agricultural_population_proportion_trend', description: '%' }, { title: '耕地面積', value: 'cultivated_area', description: '平方公里' }, { title: '平均農業人口耕地面積', value: 'average_agricultural_population_cultivated_area', description: '平方公里/人' }, { title: '市場成長相對強度', value: 'market_growth_intensity', description: '%' }, { title: '進口市場表現', value: 'market_performance', description: '%' }, { title: '市場開放程度', value: 'market_openness', description: '%' }, { title: '市場相對優惠關稅', value: 'market_preferential_tariff', description: '%' }].filter(function (option) {
                return ![_this2.filterConditions.xAxis, _this2.filterConditions.yAxis].includes(option.value);
              })
            }]
          }[_this2.analysisType];
        },
        radar: function radar() {
          return {
            competitiveness: [{
              title: '維度（可選擇3-8項維度）',
              value: 'dimension',
              type: 'multiple',
              range: [3, 8],
              options: [{ title: '產量', value: 'production_quantity' }, { title: '單位面積產量', value: 'yield' }, { title: '生產者價格', value: 'producer_price' }, { title: '進口單價', value: 'import_price' }, { title: 'RCA', value: 'RCA' }, { title: 'TII', value: 'TII' }, { title: '市場距離', value: 'distance' }]
            }],
            attraction: [{
              title: '維度（可選擇3-8項維度）',
              value: 'dimension',
              type: 'multiple',
              range: [3, 8],
              options: [{ title: '產量', value: 'production_quantity' }, { title: '出口值', value: 'export_value' }, { title: '進口值', value: 'import_value' }, { title: '市場規模', value: 'market_size' }, { title: '進口市場成長趨勢', value: 'import_market_growth_trend' }, { title: 'TSI', value: 'TSI' }, { title: '市場距離', value: 'distance' }, { title: '佔全球貿易市場佔有率', value: 'market_share' }, { title: '平均每人GDP', value: 'GDP' }, { title: '人口數', value: 'total_population' }, { title: '市場成長相對強度', value: 'market_growth_intensity' }, { title: '進口市場表現', value: 'market_performance' }, { title: '市場開放程度', value: 'market_openness' }, { title: '市場相對優惠關稅', value: 'market_preferential_tariff' }]
            }],
            toolcompetitiveness: [{
              title: '維度（可選擇3-8項維度）',
              value: 'dimension',
              type: 'multiple',
              range: [3, 8],
              options: [{ title: '進口單價', value: 'import_price' }, { title: 'RCA', value: 'RCA' }, { title: 'TII', value: 'TII' }]
            }],
            toolattraction: [{
              title: '維度（可選擇3-8項維度）',
              value: 'dimension',
              type: 'multiple',
              range: [3, 8],
              options: [{ title: '出口值', value: 'export_value' }, { title: '進口值', value: 'import_value' }, { title: '進口市場成長趨勢', value: 'import_market_growth_trend' }, { title: 'TSI', value: 'TSI' }, { title: '佔全球貿易市場佔有率', value: 'market_share' }, { title: '平均每人GDP', value: 'GDP' }, { title: 'GNI', value: 'GNI' }, { title: '農業人口比率', value: 'agricultural_population_proportion' }, { title: '農業人口比率趨勢', value: 'agricultural_population_proportion_trend' }, { title: '耕地面積', value: 'cultivated_area' }, { title: '平均農業人口耕地面積', value: 'average_agricultural_population_cultivated_area' }, { title: '市場成長相對強度', value: 'market_growth_intensity' }, { title: '進口市場表現', value: 'market_performance' }, { title: '市場開放程度', value: 'market_openness' }, { title: '市場相對優惠關稅', value: 'market_preferential_tariff' }]
            }]
          }[_this2.analysisType];
        }
      }[this.graphType]();
    },
    chartOptions: function chartOptions() {
      var _this3 = this;

      return {
        bar: function bar() {
          var datas = {
            competitiveness: function competitiveness() {
              var _datas = {
                country: [].concat(toConsumableArray_default()(_this3.graphDatas)),
                year: [].concat(toConsumableArray_default()(_this3.graphDatas)).reverse()
              }[_this3.dataType];
              return _datas;
            },
            attraction: function attraction() {
              var _datas = {
                country: [].concat(toConsumableArray_default()(_this3.graphDatas)),
                year: [].concat(toConsumableArray_default()(_this3.graphDatas)).reverse()
              }[_this3.dataType];
              return _datas;
            },
            toolcompetitiveness: function toolcompetitiveness() {
              var _datas = {
                country: [].concat(toConsumableArray_default()(_this3.graphDatas)),
                year: [].concat(toConsumableArray_default()(_this3.graphDatas)).reverse()
              }[_this3.dataType];
              return _datas;
            },
            toolattraction: function toolattraction() {
              var _datas = {
                country: [].concat(toConsumableArray_default()(_this3.graphDatas)),
                year: [].concat(toConsumableArray_default()(_this3.graphDatas)).reverse()
              }[_this3.dataType];
              return _datas;
            }
          }[_this3.analysisType]();
          var columnMap = {
            competitiveness: {
              production_quantity: {
                title: '產量',
                display: function display(data) {
                  return data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : '';
                }
              },
              yield: {
                title: '單位面積產量',
                display: function display(data) {
                  return data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : '';
                }
              },
              producer_price: {
                title: '生產者價格',
                display: function display(data) {
                  return data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : '';
                }
              },
              import_price: {
                title: '進口單價',
                display: function display(data) {
                  return data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : '';
                }
              },
              RCA: {
                title: 'RCA',
                display: function display(data) {
                  return data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : '';
                }
              },
              TII: {
                title: 'TII',
                display: function display(data) {
                  return data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : '';
                }
              },
              distance: {
                title: '市場距離',
                display: function display(data) {
                  return data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : '';
                }
              }
            },
            attraction: {
              production_quantity: {
                title: '產量',
                display: function display(data) {
                  return data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : '';
                }
              },
              export_value: {
                title: '出口值',
                display: function display(data) {
                  return data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : '';
                }
              },
              import_value: {
                title: '進口值',
                display: function display(data) {
                  return data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : '';
                }
              },
              market_size: {
                title: '市場規模',
                display: function display(data) {
                  return data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : '';
                }
              },
              import_market_growth_trend: {
                title: '進口市場成長趨勢',
                display: function display(data) {
                  return data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : '';
                }
              },
              TSI: {
                title: 'TSI',
                display: function display(data) {
                  return data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : '';
                }
              },
              distance: {
                title: '市場距離',
                display: function display(data) {
                  return data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : '';
                }
              },
              market_share: {
                title: '佔全球貿易市場佔有率',
                display: function display(data) {
                  return data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : '';
                }
              },
              GDP: {
                title: '平均每人GDP',
                display: function display(data) {
                  return data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : '';
                }
              },
              total_population: {
                title: '人口數',
                display: function display(data) {
                  return data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : '';
                }
              },
              market_growth_intensity: {
                title: '市場成長相對強度',
                display: function display(data) {
                  return data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : '';
                }
              },
              market_performance: {
                title: '進口市場表現',
                display: function display(data) {
                  return data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : '';
                }
              },
              market_openness: {
                title: '市場開放程度',
                display: function display(data) {
                  return data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : '';
                }
              },
              market_preferential_tariff: {
                title: '市場相對優惠關稅',
                display: function display(data) {
                  return data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : '';
                }
              }
            },
            toolcompetitiveness: {
              import_price: {
                title: '進口單價',
                display: function display(data) {
                  return data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : '';
                }
              },
              RCA: {
                title: 'RCA',
                display: function display(data) {
                  return data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : '';
                }
              },
              TII: {
                title: 'TII',
                display: function display(data) {
                  return data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : '';
                }
              }
            },
            toolattraction: {
              export_value: {
                title: '出口值',
                display: function display(data) {
                  return data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : '';
                }
              },
              import_value: {
                title: '進口值',
                display: function display(data) {
                  return data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : '';
                }
              },
              import_market_growth_trend: {
                title: '進口市場成長趨勢',
                display: function display(data) {
                  return data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : '';
                }
              },
              TSI: {
                title: 'TSI',
                display: function display(data) {
                  return data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : '';
                }
              },
              market_share: {
                title: '佔全球貿易市場佔有率',
                display: function display(data) {
                  return data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : '';
                }
              },
              GDP: {
                title: '平均每人GDP',
                display: function display(data) {
                  return data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : '';
                }
              },
              GNI: {
                title: 'GNI',
                display: function display(data) {
                  return data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : '';
                }
              },
              agricultural_population_proportion: {
                title: '農業人口比率',
                display: function display(data) {
                  return data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : '';
                }
              },
              agricultural_population_proportion_trend: {
                title: '農業人口比率趨勢',
                display: function display(data) {
                  return data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : '';
                }
              },
              cultivated_area: {
                title: '耕地面積',
                display: function display(data) {
                  return data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : '';
                }
              },
              average_agricultural_population_cultivated_area: {
                title: '平均農業人口耕地面積',
                display: function display(data) {
                  return data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : '';
                }
              },
              market_growth_intensity: {
                title: '市場成長相對強度',
                display: function display(data) {
                  return data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : '';
                }
              },
              market_performance: {
                title: '進口市場表現',
                display: function display(data) {
                  return data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : '';
                }
              },
              market_openness: {
                title: '市場開放程度',
                display: function display(data) {
                  return data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : '';
                }
              },
              market_preferential_tariff: {
                title: '市場相對優惠關稅',
                display: function display(data) {
                  return data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : '';
                }
              }
            }
          }[_this3.analysisType];
          var graphChartOptions = {
            color: _this3.colors[1],
            legend: {
              type: 'scroll',
              orient: 'vertical',
              right: 10,
              top: 20,
              bottom: 10,
              data: (_this3.filterConditions.yAxis || []).filter(function (value) {
                return _this3.conditions.weightings[value];
              }).map(function (value) {
                return (columnMap[value] || {}).title + ' (' + (_this3.conditions.weightings[value].active ? _this3.conditions.weightings[value].value : 0) + ')';
              }),
              textStyle: {
                fontSize: _this3.fontSize
              }
            },
            xAxis: {
              type: 'category',
              data: datas.map(function (data) {
                return {
                  country: data[_this3.filterConditions.xAxis],
                  year: data[_this3.filterConditions.xAxis] + '年'
                }[_this3.dataType];
              }),
              nameTextStyle: {
                fontSize: _this3.fontSize
              },
              axisLabel: {
                rotate: {
                  country: { competitiveness: -70, attraction: -70, toolcompetitiveness: -70, toolattraction: -70 },
                  year: { competitiveness: -70, attraction: -70, toolcompetitiveness: -70, toolattraction: -70 }
                }[_this3.dataType][_this3.analysisType],
                fontSize: _this3.fontSize
              }
            },
            yAxis: {
              type: 'value',
              name: '標準化分數總計',
              nameLocation: 'middle',
              nameGap: 40,
              nameTextStyle: {
                fontSize: _this3.fontSize
              },
              axisLabel: {
                fontSize: _this3.fontSize
              }
            },
            grid: {
              top: 30,
              left: 50,
              right: { competitiveness: 150, attraction: 200, toolcompetitiveness: 150, toolattraction: 200 }[_this3.analysisType] + (_this3.fontSize / 14 - 0.9) * 180,
              containLabel: true
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow'
              },
              textStyle: {
                fontSize: _this3.fontSize
              }
            },
            series: _this3.filterConditions.yAxis.filter(function (value) {
              return _this3.conditions.weightings[value];
            }).map(function (value) {
              return {
                name: (columnMap[value] || {}).title + ' (' + (_this3.conditions.weightings[value].active ? _this3.conditions.weightings[value].value : 0) + ')',
                type: 'bar',
                stack: 'default',
                barCategoryGap: '60%',
                data: datas.map(function (data) {
                  return (columnMap[value] || {}).display({ country: data.display_standardization[value], year: data.standardization[value] }[_this3.dataType]) || 0;
                })
              };
            })
          };
          return graphChartOptions;
        },
        scatter: function scatter() {
          var datas = {
            competitiveness: function competitiveness() {
              var _datas = {
                country: [].concat(toConsumableArray_default()(_this3.graphDatas)),
                year: [].concat(toConsumableArray_default()(_this3.graphDatas)).reverse()
              }[_this3.dataType];
              return _datas;
            },
            attraction: function attraction() {
              var _datas = {
                country: [].concat(toConsumableArray_default()(_this3.graphDatas)),
                year: [].concat(toConsumableArray_default()(_this3.graphDatas)).reverse()
              }[_this3.dataType];
              return _datas;
            },
            toolcompetitiveness: function toolcompetitiveness() {
              var _datas = {
                country: [].concat(toConsumableArray_default()(_this3.graphDatas)),
                year: [].concat(toConsumableArray_default()(_this3.graphDatas)).reverse()
              }[_this3.dataType];
              return _datas;
            },
            toolattraction: function toolattraction() {
              var _datas = {
                country: [].concat(toConsumableArray_default()(_this3.graphDatas)),
                year: [].concat(toConsumableArray_default()(_this3.graphDatas)).reverse()
              }[_this3.dataType];
              return _datas;
            }
          }[_this3.analysisType]();
          var columnMap = {
            competitiveness: {
              production_quantity: {
                title: '產量',
                description: '公噸'
              },
              yield: {
                title: '單位面積產量',
                description: '百克/公頃'
              },
              producer_price: {
                title: '生產者價格',
                description: '美元/公噸'
              },
              import_price: {
                title: '進口單價',
                description: '美元/公斤'
              },
              RCA: {
                title: 'RCA',
                description: ''
              },
              TII: {
                title: 'TII',
                description: ''
              },
              distance: {
                title: '市場距離',
                description: '公里'
              }
            },
            attraction: {
              production_quantity: {
                title: '產量',
                description: '公噸'
              },
              export_value: {
                title: '出口值',
                description: '千美元'
              },
              import_value: {
                title: '進口值',
                description: '千美元'
              },
              market_size: {
                title: '市場規模',
                description: '千美元'
              },
              import_market_growth_trend: {
                title: '進口市場成長趨勢',
                description: '%'
              },
              TSI: {
                title: 'TSI',
                description: ''
              },
              distance: {
                title: '市場距離',
                description: '公里'
              },
              market_share: {
                title: '佔全球貿易市場佔有率',
                description: '%'
              },
              GDP: {
                title: '平均每人GDP',
                description: '美元'
              },
              total_population: {
                title: '人口數',
                description: ''
              },
              market_growth_intensity: {
                title: '市場成長相對強度',
                description: '%'
              },
              market_performance: {
                title: '進口市場表現',
                description: '%'
              },
              market_openness: {
                title: '市場開放程度',
                description: '%'
              },
              market_preferential_tariff: {
                title: '市場相對優惠關稅',
                description: '%'
              }
            },
            toolcompetitiveness: {
              import_price: {
                title: '進口單價',
                description: '美元/公斤'
              },
              RCA: {
                title: 'RCA',
                description: ''
              },
              TII: {
                title: 'TII',
                description: ''
              }
            },
            toolattraction: {
              export_value: {
                title: '出口值',
                description: '千美元'
              },
              import_value: {
                title: '進口值',
                description: '千美元'
              },
              import_market_growth_trend: {
                title: '進口市場成長趨勢',
                description: '%'
              },
              TSI: {
                title: 'TSI',
                description: ''
              },
              market_share: {
                title: '佔全球貿易市場佔有率',
                description: '%'
              },
              GDP: {
                title: '平均每人GDP',
                description: '美元'
              },
              GNI: {
                title: 'GNI',
                description: '美元'
              },
              agricultural_population_proportion: {
                title: '農業人口比率',
                description: '%'
              },
              agricultural_population_proportion_trend: {
                title: '農業人口比率趨勢',
                description: '%'
              },
              cultivated_area: {
                title: '耕地面積',
                description: '平方公里'
              },
              average_agricultural_population_cultivated_area: {
                title: '平均農業人口耕地面積',
                description: '平方公里/人'
              },
              market_growth_intensity: {
                title: '市場成長相對強度',
                description: '%'
              },
              market_performance: {
                title: '進口市場表現',
                description: '%'
              },
              market_openness: {
                title: '市場開放程度',
                description: '%'
              },
              market_preferential_tariff: {
                title: '市場相對優惠關稅',
                description: '%'
              }
            }
          }[_this3.analysisType];
          var yAxisValueLength = Math.max(3, ((Math.max.apply(null, datas.map(function (data) {
            return data[_this3.filterConditions.yAxis];
          })).toFixed(0) || 999) + '0').length);
          var graphChartOptions = {
            color: _this3.colors[1],
            xAxis: {
              splitLine: {
                lineStyle: {
                  type: 'dashed'
                }
              },
              name: (columnMap[_this3.filterConditions.xAxis] || {}).title + ((columnMap[_this3.filterConditions.xAxis] || {}).description ? '(' + (columnMap[_this3.filterConditions.xAxis] || {}).description + ')' : '') + (['country'].includes(_this3.dataType) ? ' ( 加權=' + (_this3.conditions.weightings[_this3.filterConditions.xAxis] ? _this3.conditions.weightings[_this3.filterConditions.xAxis].active ? _this3.conditions.weightings[_this3.filterConditions.xAxis].value : 0 : 0) + ' )' : ''),
              nameLocation: 'middle',
              nameGap: 40,
              nameTextStyle: {
                fontSize: _this3.fontSize
              },
              axisLabel: {
                fontSize: _this3.fontSize
              }
            },
            yAxis: {
              splitLine: {
                lineStyle: {
                  type: 'dashed'
                }
              },
              name: (columnMap[_this3.filterConditions.yAxis] || {}).title + ((columnMap[_this3.filterConditions.yAxis] || {}).description ? '(' + (columnMap[_this3.filterConditions.yAxis] || {}).description + ')' : '') + (['country'].includes(_this3.dataType) ? ' ( 加權=' + (_this3.conditions.weightings[_this3.filterConditions.yAxis] ? _this3.conditions.weightings[_this3.filterConditions.yAxis].active ? _this3.conditions.weightings[_this3.filterConditions.yAxis].value : 0 : 0) + ' )' : ''),
              nameLocation: 'middle',
              nameGap: yAxisValueLength * 10 * (_this3.fontSize / 14),
              nameTextStyle: {
                fontSize: _this3.fontSize
              },
              axisLabel: {
                fontSize: _this3.fontSize
              },
              scale: true
            },
            grid: {
              top: 80,
              left: 40 + yAxisValueLength * 10 * (_this3.fontSize / 14),
              right: 80,
              bottom: 120
            },
            series: datas.map(function (data) {
              return {
                type: 'scatter',
                symbolSize: function symbolSize(data) {
                  return Math.sqrt(data[2]);
                },
                label: {
                  normal: {
                    show: true,
                    formatter: function formatter(param) {
                      return param.data[3];
                    },
                    textShadowBlur: 2,
                    textShadowColor: 'rgba(0, 0, 0, 0.2)',
                    textShadowOffsetX: 1,
                    textShadowOffsetY: 1,
                    textStyle: {
                      fontSize: _this3.fontSize
                    },
                    position: 'bottom'
                  },
                  emphasis: {
                    show: true,
                    formatter: function formatter(param) {
                      return param.data[3];
                    },
                    backgroundColor: 'white',
                    borderRadius: 999999999999999,
                    borderColor: '#cccccc',
                    borderWidth: 1,
                    padding: [5, 10],
                    shadowBlur: 6,
                    shadowColor: 'rgba(0, 0, 0, 0.2)',
                    shadowOffsetX: 3,
                    shadowOffsetY: 3,
                    textShadowColor: 'rgba(0, 0, 0, 0)',
                    position: 'bottom'
                  }
                },
                itemStyle: {
                  normal: {
                    shadowBlur: 6,
                    shadowColor: 'rgba(0, 0, 0, 0.2)',
                    shadowOffsetX: 3,
                    shadowOffsetY: 3,
                    opacity: 0.8
                  },
                  emphasis: {
                    opacity: 1
                  }
                },
                data: [data].map(function (data) {
                  return [data[_this3.filterConditions.xAxis] || 0, data[_this3.filterConditions.yAxis] || 0, 200, {
                    country: {
                      competitiveness: data.country_name,
                      attraction: data.partner_name,
                      toolcompetitiveness: data.country_name,
                      toolattraction: data.partner_name
                    },
                    year: {
                      competitiveness: data.year + '年',
                      attraction: data.year + '年',
                      toolcompetitiveness: data.year + '年',
                      toolattraction: data.year + '年'
                    }
                  }[_this3.dataType][_this3.analysisType]];
                })
              };
            })
          };
          return graphChartOptions;
        },
        bubble: function bubble() {
          var datas = {
            competitiveness: function competitiveness() {
              var _datas = {
                country: [].concat(toConsumableArray_default()(_this3.graphDatas)),
                year: [].concat(toConsumableArray_default()(_this3.graphDatas)).reverse()
              }[_this3.dataType];
              return _datas;
            },
            attraction: function attraction() {
              var _datas = {
                country: [].concat(toConsumableArray_default()(_this3.graphDatas)),
                year: [].concat(toConsumableArray_default()(_this3.graphDatas)).reverse()
              }[_this3.dataType];
              return _datas;
            },
            toolcompetitiveness: function toolcompetitiveness() {
              var _datas = {
                country: [].concat(toConsumableArray_default()(_this3.graphDatas)),
                year: [].concat(toConsumableArray_default()(_this3.graphDatas)).reverse()
              }[_this3.dataType];
              return _datas;
            },
            toolattraction: function toolattraction() {
              var _datas = {
                country: [].concat(toConsumableArray_default()(_this3.graphDatas)),
                year: [].concat(toConsumableArray_default()(_this3.graphDatas)).reverse()
              }[_this3.dataType];
              return _datas;
            }
          }[_this3.analysisType]();
          var columnMap = {
            competitiveness: {
              production_quantity: {
                title: '產量',
                description: '公噸',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              yield: {
                title: '單位面積產量',
                description: '百克/公頃',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              producer_price: {
                title: '生產者價格',
                description: '美元/公噸',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              import_price: {
                title: '進口單價',
                description: '美元/公斤',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              RCA: {
                title: 'RCA',
                description: '',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              TII: {
                title: 'TII',
                description: '',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              distance: {
                title: '市場距離',
                description: '公里',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              }
            },
            attraction: {
              production_quantity: {
                title: '產量',
                description: '公噸',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              export_value: {
                title: '出口值',
                description: '千美元',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              import_value: {
                title: '進口值',
                description: '千美元',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              market_size: {
                title: '市場規模',
                description: '千美元',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              import_market_growth_trend: {
                title: '進口市場成長趨勢',
                description: '%',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              TSI: {
                title: 'TSI',
                description: '',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              distance: {
                title: '市場距離',
                description: '公里',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              market_share: {
                title: '佔全球貿易市場佔有率',
                description: '%',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              GDP: {
                title: '平均每人GDP',
                description: '美元',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              total_population: {
                title: '人口數',
                description: '',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              market_growth_intensity: {
                title: '市場成長相對強度',
                description: '%',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              market_performance: {
                title: '進口市場表現',
                description: '%',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              market_openness: {
                title: '市場開放程度',
                description: '%',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              market_preferential_tariff: {
                title: '市場相對優惠關稅',
                description: '%',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              }
            },
            toolcompetitiveness: {
              import_price: {
                title: '進口單價',
                description: '美元/公斤',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              RCA: {
                title: 'RCA',
                description: '',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              TII: {
                title: 'TII',
                description: '',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              }
            },
            toolattraction: {
              export_value: {
                title: '出口值',
                description: '千美元',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              import_value: {
                title: '進口值',
                description: '千美元',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              import_market_growth_trend: {
                title: '進口市場成長趨勢',
                description: '%',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              TSI: {
                title: 'TSI',
                description: '',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              market_share: {
                title: '佔全球貿易市場佔有率',
                description: '%',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              GDP: {
                title: '平均每人GDP',
                description: '美元',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              GNI: {
                title: 'GNI',
                description: '美元',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              agricultural_population_proportion: {
                title: '農業人口比率',
                description: '%',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              agricultural_population_proportion_trend: {
                title: '農業人口比率趨勢',
                description: '%',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              cultivated_area: {
                title: '耕地面積',
                description: '平方公里',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              average_agricultural_population_cultivated_area: {
                title: '平均農業人口耕地面積',
                description: '平方公里/人',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              market_growth_intensity: {
                title: '市場成長相對強度',
                description: '%',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              market_performance: {
                title: '進口市場表現',
                description: '%',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              market_openness: {
                title: '市場開放程度',
                description: '%',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              market_preferential_tariff: {
                title: '市場相對優惠關稅',
                description: '%',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              }
            }
          }[_this3.analysisType];
          // let sizeScale = 5000 / Math.min.apply(null, datas.map(data => Math.abs(data[this.filterConditions.point])).filter(data => data))
          var max = Math.max.apply(null, datas.map(function (data) {
            return Math.abs(data[_this3.filterConditions.point]);
          }).filter(function (data) {
            return data || data === 0;
          }));
          var min = Math.min.apply(null, datas.map(function (data) {
            return Math.abs(data[_this3.filterConditions.point]);
          }).filter(function (data) {
            return data || data === 0;
          }));
          var yAxisValueLength = Math.max(3, ((Math.max.apply(null, datas.map(function (data) {
            return data[_this3.filterConditions.yAxis];
          })).toFixed(0) || 999) + '0').length);
          var graphChartOptions = {
            color: _this3.colors[1],
            xAxis: {
              splitLine: {
                lineStyle: {
                  type: 'dashed'
                }
              },
              name: (columnMap[_this3.filterConditions.xAxis] || {}).title + ((columnMap[_this3.filterConditions.xAxis] || {}).description ? '(' + (columnMap[_this3.filterConditions.xAxis] || {}).description + ')' : '') + (['country'].includes(_this3.dataType) ? ' ( 加權=' + (_this3.conditions.weightings[_this3.filterConditions.xAxis] ? _this3.conditions.weightings[_this3.filterConditions.xAxis].active ? _this3.conditions.weightings[_this3.filterConditions.xAxis].value : 0 : 0) + ' )' : ''),
              nameLocation: 'middle',
              nameGap: 40,
              nameTextStyle: {
                fontSize: _this3.fontSize
              },
              axisLabel: {
                fontSize: _this3.fontSize
              }
            },
            yAxis: {
              splitLine: {
                lineStyle: {
                  type: 'dashed'
                }
              },
              name: (columnMap[_this3.filterConditions.yAxis] || {}).title + ((columnMap[_this3.filterConditions.yAxis] || {}).description ? '(' + (columnMap[_this3.filterConditions.yAxis] || {}).description + ')' : '') + (['country'].includes(_this3.dataType) ? ' ( 加權=' + (_this3.conditions.weightings[_this3.filterConditions.yAxis] ? _this3.conditions.weightings[_this3.filterConditions.yAxis].active ? _this3.conditions.weightings[_this3.filterConditions.xAxis].value : 0 : 0) + ' )' : ''),
              nameLocation: 'middle',
              nameGap: yAxisValueLength * 10 * (_this3.fontSize / 14),
              nameTextStyle: {
                fontSize: _this3.fontSize
              },
              axisLabel: {
                fontSize: _this3.fontSize
              },
              scale: true
            },
            grid: {
              top: 80,
              left: Math.max(120, 40 + yAxisValueLength * 10 * (_this3.fontSize / 14)),
              right: 80,
              bottom: 120
            },
            series: [].concat(toConsumableArray_default()(datas)).sort(function (a, b) {
              return Math.abs(b[_this3.filterConditions.point]) - Math.abs(a[_this3.filterConditions.point]);
            }).map(function (data) {
              return {
                type: 'scatter',
                symbolSize: function symbolSize(data) {
                  var size = max - min ? (Math.abs(data[2]) - min) / (max - min) : 0.0001;
                  return 100 * Math.sqrt(Math.sqrt(size)) + 10;
                },
                label: {
                  normal: {
                    show: true,
                    formatter: function formatter(param) {
                      return param.data[3] + '\n' + ((columnMap[_this3.filterConditions.point] || {}).display(param.data[2]) || 0);
                    },
                    textShadowBlur: 2,
                    textShadowColor: 'rgba(0, 0, 0, 0.2)',
                    textShadowOffsetX: 1,
                    textShadowOffsetY: 1,
                    textStyle: {
                      fontSize: _this3.fontSize
                    },
                    position: 'bottom'
                  },
                  emphasis: {
                    show: true,
                    formatter: function formatter(param) {
                      return param.data[3] + '\n' + ((columnMap[_this3.filterConditions.point] || {}).display(param.data[2]) || 0);
                    },
                    backgroundColor: 'white',
                    borderRadius: 999999999999999,
                    borderColor: '#cccccc',
                    borderWidth: 1,
                    padding: [5, 10],
                    shadowBlur: 6,
                    shadowColor: 'rgba(0, 0, 0, 0.2)',
                    shadowOffsetX: 3,
                    shadowOffsetY: 3,
                    textShadowColor: 'rgba(0, 0, 0, 0)',
                    position: 'bottom'
                  }
                },
                itemStyle: {
                  normal: {
                    shadowBlur: 6,
                    shadowColor: 'rgba(0, 0, 0, 0.2)',
                    shadowOffsetX: 3,
                    shadowOffsetY: 3,
                    opacity: 0.6,
                    color: function color(param) {
                      return !param.data[2] ? '#999999' : param.data[2] < 0 ? '#999999' : _this3.colors[1][param.seriesIndex % _this3.colors[1].length];
                    }
                  },
                  emphasis: {
                    opacity: 1
                  }
                },
                data: [data].map(function (data) {
                  return [data[_this3.filterConditions.xAxis] || 0, data[_this3.filterConditions.yAxis] || 0, data[_this3.filterConditions.point] || 0, {
                    country: {
                      competitiveness: data.country_name,
                      attraction: data.partner_name,
                      toolcompetitiveness: data.country_name,
                      toolattraction: data.partner_name
                    },
                    year: {
                      competitiveness: data.year + '年',
                      attraction: data.year + '年',
                      toolcompetitiveness: data.year + '年',
                      toolattraction: data.year + '年'
                    }
                  }[_this3.dataType][_this3.analysisType]];
                })
              };
            })
          };
          return graphChartOptions;
        },
        radar: function radar() {
          var datas = {
            competitiveness: function competitiveness() {
              var _datas = {
                country: [].concat(toConsumableArray_default()(_this3.graphDatas)),
                year: [].concat(toConsumableArray_default()(_this3.graphDatas)).reverse()
              }[_this3.dataType].slice(0, 5);
              return _datas;
            },
            attraction: function attraction() {
              var _datas = {
                country: [].concat(toConsumableArray_default()(_this3.graphDatas)),
                year: [].concat(toConsumableArray_default()(_this3.graphDatas)).reverse()
              }[_this3.dataType].slice(0, 5);
              return _datas;
            },
            toolcompetitiveness: function toolcompetitiveness() {
              var _datas = {
                country: [].concat(toConsumableArray_default()(_this3.graphDatas)),
                year: [].concat(toConsumableArray_default()(_this3.graphDatas)).reverse()
              }[_this3.dataType].slice(0, 5);
              return _datas;
            },
            toolattraction: function toolattraction() {
              var _datas = {
                country: [].concat(toConsumableArray_default()(_this3.graphDatas)),
                year: [].concat(toConsumableArray_default()(_this3.graphDatas)).reverse()
              }[_this3.dataType].slice(0, 5);
              return _datas;
            }
          }[_this3.analysisType]();
          var columnMap = {
            competitiveness: {
              production_quantity: {
                title: '產量',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              yield: {
                title: '單位面積產量',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              producer_price: {
                title: '生產者價格',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              import_price: {
                title: '進口單價',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              RCA: {
                title: 'RCA',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              TII: {
                title: 'TII',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              distance: {
                title: '市場距離',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              }
            },
            attraction: {
              production_quantity: {
                title: '產量',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              export_value: {
                title: '出口值',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              import_value: {
                title: '進口值',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              market_size: {
                title: '市場規模',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              import_market_growth_trend: {
                title: '進口市場成長趨勢',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              TSI: {
                title: 'TSI',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              distance: {
                title: '市場距離',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              market_share: {
                title: '佔全球貿易市場佔有率',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              GDP: {
                title: '平均每人GDP',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              total_population: {
                title: '人口數',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              market_growth_intensity: {
                title: '市場成長相對強度',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              market_performance: {
                title: '進口市場表現',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              market_openness: {
                title: '市場開放程度',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              market_preferential_tariff: {
                title: '市場相對優惠關稅',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              }
            },
            toolcompetitiveness: {
              import_price: {
                title: '進口單價',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              RCA: {
                title: 'RCA',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              TII: {
                title: 'TII',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              }
            },
            toolattraction: {
              export_value: {
                title: '出口值',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              import_value: {
                title: '進口值',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              import_market_growth_trend: {
                title: '進口市場成長趨勢',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              TSI: {
                title: 'TSI',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              market_share: {
                title: '佔全球貿易市場佔有率',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              GDP: {
                title: '平均每人GDP',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              GNI: {
                title: 'GNI',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              agricultural_population_proportion: {
                title: '農業人口比率',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              agricultural_population_proportion_trend: {
                title: '農業人口比率趨勢',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              cultivated_area: {
                title: '耕地面積',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              average_agricultural_population_cultivated_area: {
                title: '平均農業人口耕地面積',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              market_growth_intensity: {
                title: '市場成長相對強度',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              market_performance: {
                title: '進口市場表現',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              market_openness: {
                title: '市場開放程度',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              },
              market_preferential_tariff: {
                title: '市場相對優惠關稅',
                display: function display(data) {
                  return data ? Object(util["m" /* toPriceString */])(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : '';
                }
              }
            }
          }[_this3.analysisType];
          var graphChartOptions = {
            color: _this3.colors[1],
            tooltip: {
              trigger: 'axis'
            },
            legend: {
              type: 'scroll',
              orient: 'vertical',
              right: 10,
              top: 20,
              bottom: 10,
              data: datas.map(function (data) {
                return {
                  country: {
                    competitiveness: data.country_name,
                    attraction: data.partner_name,
                    toolcompetitiveness: data.country_name,
                    toolattraction: data.partner_name
                  },
                  year: {
                    competitiveness: data.year + '年',
                    attraction: data.year + '年',
                    toolcompetitiveness: data.year + '年',
                    toolattraction: data.year + '年'
                  }
                }[_this3.dataType][_this3.analysisType];
              }),
              textStyle: {
                fontSize: _this3.fontSize
              }
            },
            radar: {
              name: {
                textStyle: {
                  color: '#555555',
                  fontSize: _this3.fontSize,
                  padding: [3, 5]
                }
              },
              indicator: _this3.filterConditions.dimension.filter(function (value) {
                return _this3.conditions.weightings[value];
              }).map(function (value) {
                return {
                  name: (columnMap[value] || {}).title,
                  max: 5 * _this3.conditions.weightings[value].value
                };
              }),
              center: ['45%', '50%'],
              radius: '70%'
            },
            series: [{
              type: 'radar',
              symbolSize: 10,
              tooltip: {
                trigger: 'item'
              },
              itemStyle: {
                normal: {
                  areaStyle: {
                    type: 'default',
                    opacity: 0.3
                  }
                },
                emphasis: {
                  areaStyle: {
                    type: 'default',
                    opacity: 0.9
                  }
                }
              },
              data: datas.map(function (data) {
                return {
                  country: {
                    competitiveness: {
                      name: data.country_name,
                      value: _this3.filterConditions.dimension.filter(function (value) {
                        return _this3.conditions.weightings[value];
                      }).map(function (value) {
                        return (columnMap[value] || {}).display({ country: data.display_standardization[value], year: data.standardization[value] }[_this3.dataType]) || '0';
                      })
                    },
                    attraction: {
                      name: data.partner_name,
                      value: _this3.filterConditions.dimension.filter(function (value) {
                        return _this3.conditions.weightings[value];
                      }).map(function (value) {
                        return (columnMap[value] || {}).display({ country: data.display_standardization[value], year: data.standardization[value] }[_this3.dataType]) || '0';
                      })
                    },
                    toolcompetitiveness: {
                      name: data.country_name,
                      value: _this3.filterConditions.dimension.filter(function (value) {
                        return _this3.conditions.weightings[value];
                      }).map(function (value) {
                        return (columnMap[value] || {}).display({ country: data.display_standardization[value], year: data.standardization[value] }[_this3.dataType]) || '0';
                      })
                    },
                    toolattraction: {
                      name: data.partner_name,
                      value: _this3.filterConditions.dimension.filter(function (value) {
                        return _this3.conditions.weightings[value];
                      }).map(function (value) {
                        return (columnMap[value] || {}).display({ country: data.display_standardization[value], year: data.standardization[value] }[_this3.dataType]) || '0';
                      })
                    }
                  },
                  year: {
                    competitiveness: {
                      name: data.year + '年',
                      value: _this3.filterConditions.dimension.filter(function (value) {
                        return _this3.conditions.weightings[value];
                      }).map(function (value) {
                        return (columnMap[value] || {}).display({ country: data.display_standardization[value], year: data.standardization[value] }[_this3.dataType]) || '0';
                      })
                    },
                    attraction: {
                      name: data.year + '年',
                      value: _this3.filterConditions.dimension.filter(function (value) {
                        return _this3.conditions.weightings[value];
                      }).map(function (value) {
                        return (columnMap[value] || {}).display({ country: data.display_standardization[value], year: data.standardization[value] }[_this3.dataType]) || '0';
                      })
                    },
                    toolcompetitiveness: {
                      name: data.year + '年',
                      value: _this3.filterConditions.dimension.filter(function (value) {
                        return _this3.conditions.weightings[value];
                      }).map(function (value) {
                        return (columnMap[value] || {}).display({ country: data.display_standardization[value], year: data.standardization[value] }[_this3.dataType]) || '0';
                      })
                    },
                    toolattraction: {
                      name: data.year + '年',
                      value: _this3.filterConditions.dimension.filter(function (value) {
                        return _this3.conditions.weightings[value];
                      }).map(function (value) {
                        return (columnMap[value] || {}).display({ country: data.display_standardization[value], year: data.standardization[value] }[_this3.dataType]) || '0';
                      })
                    }
                  }
                }[_this3.dataType][_this3.analysisType];
              })
            }]
          };
          return graphChartOptions;
        }
      }[this.displayGraphType || this.graphType]();
    },

    // global
    nco: function nco() {
      return util["i" /* nco */];
    }
  },
  created: function created() {
    this.graphType = 'scatter';
    this.selectedDatas = [].concat(toConsumableArray_default()(this.curSelectedDatas));
  },

  watch: {
    'graphType': function graphType(nv, ov) {
      var _this4 = this;

      this.graphInit = {
        bar: function bar() {
          return {
            competitiveness: {
              xAxis: {
                country: 'country_name',
                year: 'year'
              }[_this4.dataType],
              yAxis: ['production_quantity', 'yield', 'producer_price', 'import_price', 'RCA', 'TII', 'distance']
            },
            attraction: {
              xAxis: {
                country: 'partner_name',
                year: 'year'
              }[_this4.dataType],
              yAxis: ['production_quantity', 'export_value', 'import_value', 'market_size', 'import_market_growth_trend', 'TSI', 'distance', 'market_share', 'GDP', 'total_population', 'market_growth_intensity', 'market_performance', 'market_openness', 'market_preferential_tariff']
            },
            toolcompetitiveness: {
              xAxis: {
                country: 'country_name',
                year: 'year'
              }[_this4.dataType],
              yAxis: ['import_price', 'RCA', 'TII']
            },
            toolattraction: {
              xAxis: {
                country: 'partner_name',
                year: 'year'
              }[_this4.dataType],
              yAxis: ['export_value', 'import_value', 'import_market_growth_trend', 'TSI', 'market_share', 'GDP', 'GNI', 'agricultural_population_proportion', 'agricultural_population_proportion_trend', 'cultivated_area', 'average_agricultural_population_cultivated_area', 'market_growth_intensity', 'market_performance', 'market_openness', 'market_preferential_tariff']
            }
          }[_this4.analysisType];
        },
        scatter: function scatter() {
          return {
            competitiveness: {
              point: 'country_name',
              xAxis: 'production_quantity',
              yAxis: 'yield'
            },
            attraction: {
              point: 'partner_name',
              xAxis: 'production_quantity',
              yAxis: 'export_value'
            },
            toolcompetitiveness: {
              point: 'import_price',
              xAxis: 'TII',
              yAxis: 'import_price'
            },
            toolattraction: {
              point: 'partner_name',
              xAxis: 'import_value',
              yAxis: 'export_value'
            }
          }[_this4.analysisType];
        },
        bubble: function bubble() {
          return {
            competitiveness: {
              point: 'production_quantity',
              xAxis: 'RCA',
              yAxis: 'RCA'
            },
            attraction: {
              point: 'production_quantity',
              xAxis: 'export_value',
              yAxis: 'import_value'
            },
            toolcompetitiveness: {
              point: 'import_price',
              xAxis: 'TII',
              yAxis: 'import_price'
            },
            toolattraction: {
              point: 'import_market_growth_trend',
              xAxis: 'import_value',
              yAxis: 'export_value'
            }
          }[_this4.analysisType];
        },
        radar: function radar() {
          return {
            competitiveness: {
              dimension: ['production_quantity', 'yield', 'producer_price', 'import_price', 'RCA']
            },
            attraction: {
              dimension: ['production_quantity', 'export_value', 'import_value', 'market_size', 'import_market_growth_trend']
            },
            toolcompetitiveness: {
              dimension: ['import_price', 'RCA', 'TII']
            },
            toolattraction: {
              dimension: ['export_value', 'import_value', 'import_market_growth_trend', 'TSI', 'market_share']
            }
          }[_this4.analysisType];
        }
      }[nv]();
    },
    'curSelectedDatas': function curSelectedDatas(nv) {
      this.selectedDatas = [].concat(toConsumableArray_default()(nv));
    },
    'selectedDatas': function selectedDatas(nv, ov) {
      var _this5 = this;

      if (nv.length !== ov.length) {
        this.$emit('dataChange', this.tableDatas.filter(function (data) {
          return _this5.selectedDatas.includes(data);
        }));
      }
    }
  },
  methods: {
    getFilterTitle: function getFilterTitle(value) {
      var _this6 = this;

      if (!this.conditions.filters[value]) {
        return '';
      }
      return this.filterOptions.filters.find(function (filter) {
        return filter.value === value;
      }).options.find(function (option) {
        return option.value === _this6.conditions.filters[value];
      }).title;
    },
    getCountryTitle: function getCountryTitle() {
      if (!this.country) {
        return '';
      }
      return { competitiveness: this.country.country_name, attraction: this.country.partner_name, toolcompetitiveness: this.country.country_name, toolattraction: this.country.partner_name }[this.analysisType];
    },
    downloadGraph: function downloadGraph() {
      var _this7 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var url, title;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Object(util["e" /* html2DataUrl */])(_this7.$refs.chartField, 'png', 0.3);

              case 2:
                url = _context.sent;
                title = '';

                title = title + {
                  country: {
                    competitiveness: _this7.getFilterTitle('year') + '年' + _this7.getFilterTitle('product') + '在' + _this7.getFilterTitle('country') + '的市場競爭力',
                    attraction: _this7.getFilterTitle('year') + '年' + _this7.getFilterTitle('product') + '各國市場吸引力',
                    toolcompetitiveness: _this7.getFilterTitle('year') + '年' + _this7.getFilterTitle('product') + '在' + _this7.getFilterTitle('country') + '的農業機械市場競爭力',
                    toolattraction: _this7.getFilterTitle('year') + '年' + _this7.getFilterTitle('product') + '各國農業機械市場吸引力'
                  },
                  year: {
                    competitiveness: _this7.getCountryTitle() + '的' + _this7.getFilterTitle('product') + '在' + _this7.getFilterTitle('country') + '市場的歷年市場競爭力',
                    attraction: _this7.getFilterTitle('product') + '在' + _this7.getCountryTitle() + '的歷年市場吸引力',
                    toolcompetitiveness: _this7.getCountryTitle() + '的' + _this7.getFilterTitle('product') + '在' + _this7.getFilterTitle('country') + '市場的歷年農業機械市場競爭力',
                    toolattraction: _this7.getFilterTitle('product') + '在' + _this7.getCountryTitle() + '的歷年農業機械市場吸引力'
                  }
                }[_this7.dataType][_this7.analysisType];
                title = title + _this7.typeOptions[0].options.find(function (option) {
                  return option.value === _this7.graphType;
                }).title + '.png';
                _context.next = 8;
                return _this7.sendGraphAccessLog();

              case 8:
                Object(util["c" /* downloadFile */])(title, url, '_blank');

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this7);
      }))();
    },
    sendGraphAccessLog: function sendGraphAccessLog() {
      var _this8 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var config, accessFileTypeMap, type, selectedDatas, paramDatas, paramInfos, data;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                config = _this8.$ls.get('userInfo');
                accessFileTypeMap = {
                  scatter: 'xy_scatter_diagram',
                  bubble: 'bubble_chart',
                  bar: 'cumulative_bar_graph',
                  radar: 'radar_chart'
                };
                type = {
                  country: {
                    competitiveness: 'market_competitiveness',
                    attraction: 'market_attractiveness',
                    toolcompetitiveness: 'market_competitiveness',
                    toolattraction: 'market_attractiveness'
                  },
                  year: {
                    competitiveness: 'single_country_market_competitiveness',
                    attraction: 'single_country_market_attractiveness',
                    toolcompetitiveness: 'single_country_market_competitiveness',
                    toolattraction: 'single_country_market_attractiveness'
                  }
                }[_this8.dataType][_this8.analysisType];
                selectedDatas = _this8.selectedDatas.map(function (data) {
                  return {
                    country: {
                      competitiveness: data.country_name,
                      attraction: data.partner_name,
                      toolcompetitiveness: data.country_name,
                      toolattraction: data.partner_name
                    },
                    year: {
                      competitiveness: data.year,
                      attraction: data.year,
                      toolcompetitiveness: data.year,
                      toolattraction: data.year
                    }
                  }[_this8.dataType][_this8.analysisType];
                });
                paramDatas = {
                  country: _this8.dataType === 'country' ? {
                    competitiveness: {
                      access_file_type: accessFileTypeMap[_this8.graphType],
                      partner: _this8.conditions.filters.country,
                      year: _this8.conditions.filters.year,
                      product_code: _this8.conditions.filters.product
                    },
                    attraction: {
                      access_file_type: accessFileTypeMap[_this8.graphType],
                      year: _this8.conditions.filters.year,
                      product_code: _this8.conditions.filters.product
                    },
                    toolcompetitiveness: {
                      access_file_type: accessFileTypeMap[_this8.graphType],
                      partner: _this8.conditions.filters.country,
                      year: _this8.conditions.filters.year,
                      product_code: _this8.conditions.filters.product
                    },
                    toolattraction: {
                      access_file_type: accessFileTypeMap[_this8.graphType],
                      year: _this8.conditions.filters.year,
                      product_code: _this8.conditions.filters.product
                    }
                  } : {},
                  year: _this8.dataType === 'year' ? {
                    competitiveness: {
                      access_file_type: accessFileTypeMap[_this8.graphType],
                      partner: _this8.conditions.filters.country,
                      product_code: _this8.conditions.filters.product,
                      country: _this8.country.country_code
                    },
                    attraction: {
                      access_file_type: accessFileTypeMap[_this8.graphType],
                      partner: _this8.country.partner_code,
                      product_code: _this8.conditions.filters.product
                    },
                    toolcompetitiveness: {
                      access_file_type: accessFileTypeMap[_this8.graphType],
                      partner: _this8.conditions.filters.country,
                      product_code: _this8.conditions.filters.product,
                      country: _this8.country.country_code
                    },
                    toolattraction: {
                      access_file_type: accessFileTypeMap[_this8.graphType],
                      partner: _this8.country.partner_code,
                      product_code: _this8.conditions.filters.product
                    }
                  } : {}
                }[_this8.dataType][_this8.analysisType];
                paramInfos = {
                  scatter: _this8.graphType === 'scatter' ? [['x', _this8.conditions.weightings[_this8.filterConditions.xAxis].title, _this8.conditions.weightings[_this8.filterConditions.xAxis].active ? _this8.conditions.weightings[_this8.filterConditions.xAxis].value : 0], ['y', _this8.conditions.weightings[_this8.filterConditions.yAxis].title, _this8.conditions.weightings[_this8.filterConditions.yAxis].active ? _this8.conditions.weightings[_this8.filterConditions.yAxis].value : 0]] : [],
                  bubble: _this8.graphType === 'bubble' ? [['x', _this8.conditions.weightings[_this8.filterConditions.xAxis].title, _this8.conditions.weightings[_this8.filterConditions.xAxis].active ? _this8.conditions.weightings[_this8.filterConditions.xAxis].value : 0], ['y', _this8.conditions.weightings[_this8.filterConditions.yAxis].title, _this8.conditions.weightings[_this8.filterConditions.yAxis].active ? _this8.conditions.weightings[_this8.filterConditions.yAxis].value : 0], ['z', _this8.conditions.weightings[_this8.filterConditions.point].title, _this8.conditions.weightings[_this8.filterConditions.point].active ? _this8.conditions.weightings[_this8.filterConditions.point].value : 0]] : [],
                  bar: _this8.graphType === 'bar' ? (_this8.filterConditions.yAxis || []).map(function (value) {
                    return [_this8.conditions.weightings[value].title, _this8.conditions.weightings[value].active ? _this8.conditions.weightings[value].value : 0];
                  }) : [],
                  radar: _this8.graphType === 'radar' ? (_this8.filterConditions.dimension || []).map(function (value) {
                    return [_this8.conditions.weightings[value].title, _this8.conditions.weightings[value].active ? _this8.conditions.weightings[value].value : 0];
                  }) : []
                }[_this8.graphType];
                data = extends_default()({}, paramDatas, {
                  chart_params_info: selectedDatas.join(', '),
                  weighted_index_info: paramInfos.map(function (info) {
                    return info.join(' = ');
                  }).join(', ')
                });
                _context2.next = 10;
                return Object(src_api["I" /* postAccessLog */])(type, data, config);

              case 10:
                _context2.next = 15;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2['catch'](0);

                _this8.addToast('error', !_context2.t0.response ? _context2.t0.message : _context2.t0.response.data.message || _context2.t0.response.data.errors.join('<br>'));

              case 15:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this8, [[0, 12]]);
      }))();
    },
    filterOnChange: function filterOnChange(conditions) {
      if (stringify_default()(conditions) !== stringify_default()(this.filterConditions)) {
        this.filterConditions = conditions;
        this.displayGraphType = this.graphType;
        this.graphInit = conditions;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b6909ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/analysis/graph.vue
var analysis_graph_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"analysis-graph-page col-block"},[_c('div',{staticClass:"option-container row-block"},[_c('div',{staticClass:"data-block row-block"},[(_vm.conditions.filters.product)?[_c('div',[_c('b',[_vm._v("品項：")]),_vm._v(_vm._s(_vm.getFilterTitle('product')))]),_vm._v(" "),_c('div',{style:({ width: '50px' })})]:_vm._e(),_vm._v(" "),(_vm.conditions.filters.country)?[_c('div',[_c('b',[_vm._v("目標市場：")]),_vm._v(_vm._s(_vm.getFilterTitle('country')))]),_vm._v(" "),_c('div',{style:({ width: '50px' })})]:_vm._e(),_vm._v(" "),(_vm.dataType === 'country' && _vm.conditions.filters.year)?[_c('div',[_c('b',[_vm._v("數據年份：")]),_vm._v(_vm._s(_vm.getFilterTitle('year')))]),_vm._v(" "),_c('div',{style:({ width: '50px' })})]:_vm._e(),_vm._v(" "),(_vm.dataType === 'year' && _vm.country)?[_c('div',[_c('b',[_vm._v(_vm._s({ competitiveness: '競爭國家', attraction: '市場國家', toolcompetitiveness: '競爭國家', toolattraction: '市場國家' }[_vm.analysisType])+"：")]),_vm._v(_vm._s(_vm.getCountryTitle()))]),_vm._v(" "),_c('div',{style:({ width: '50px' })})]:_vm._e()],2),_vm._v(" "),_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"option-block row-block"},[_c('div',{staticClass:"option row-block input-group"},[_c('div',{staticClass:"option-title"},[_vm._v("字體")]),_vm._v(" "),_c('div',{style:({ width: '8.5px' })}),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.fontSize),expression:"fontSize"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.fontSize=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"14"}},[_vm._v("小")]),_vm._v(" "),_c('option',{attrs:{"value":"16"}},[_vm._v("中")]),_vm._v(" "),_c('option',{attrs:{"value":"20"}},[_vm._v("大")])])])]),_vm._v(" "),_c('div',{style:({ width: '15px' })}),_vm._v(" "),_c('div',{staticClass:"button-block row-block"},[_c('button',{staticClass:"main-button option-button update",attrs:{"type":"button","name":"button"},on:{"click":function (e) { return _vm.downloadGraph(); }}},[_c('span',[_vm._v("另存圖檔")])])])]),_vm._v(" "),_c('div',{staticClass:"content-container",style:({ flex: 1 })},[_c('div',{staticClass:"graph-block row-block stretch"},[_c('div',{staticClass:"options-container col-block",style:({ width: '210px' })},[(_vm.graphType)?_c('div',{staticClass:"main-options-block"},[_c('customFilter',{attrs:{"init":{ type: _vm.graphType },"filters":_vm.typeOptions},on:{"change":function (conditions) { return _vm.graphType = conditions.type; }}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"option-tabs row-block"},[_c('div',{staticClass:"tab-container",class:{ active: _vm.optionTab === 'graph' },on:{"click":function (e) { return _vm.optionTab = 'graph'; }}},[_c('div',{staticClass:"tab-block center-block"},[_vm._v("可調參數")])]),_vm._v(" "),_c('div',{staticClass:"tab-container",class:{ active: _vm.optionTab === 'data' },on:{"click":function (e) { return _vm.optionTab = 'data'; }}},[_c('div',{staticClass:"tab-block center-block"},[_vm._v("數據選擇")])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),(_vm.graphInit)?_c('div',{staticClass:"sub-options-container",style:({ flex: 1, height: 0 })},[_c('div',{staticClass:"sub-options-block",class:[_vm.optionTab]},[_c('customFilter',{directives:[{name:"show",rawName:"v-show",value:(_vm.optionTab === 'graph'),expression:"optionTab === 'graph'"}],attrs:{"init":_vm.graphInit,"filters":_vm.graphOptions},on:{"change":function (conditions) { return _vm.filterOnChange(conditions); }}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.optionTab === 'data'),expression:"optionTab === 'data'"}],staticClass:"data-select-block col-block",style:({ height: '100%' })},[_c('div',{staticClass:"title-container row-block"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s({ country: '國家', year: '年份' }[_vm.dataType]))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '15px' })}),_vm._v(" "),_c('div',{staticClass:"data-lists-container col-block",style:({ flex: 1, height: 0 })},[_c('div',{staticClass:"data-lists col-block"},[_vm._l((_vm.tableDatas),function(data,index){return _c('label',{key:index,staticClass:"data-block row-block",attrs:{"for":'select_' + {
                      country: {
                        competitiveness: data.country_code,
                        attraction: data.partner_code,
                        toolcompetitiveness: data.country_code,
                        toolattraction: data.partner_code
                      },
                      year: {
                        competitiveness: data.year,
                        attraction: data.year,
                        toolcompetitiveness: data.year,
                        toolattraction: data.year
                      }
                    }[_vm.dataType][_vm.analysisType]}},[_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"},{name:"model",rawName:"v-model",value:(_vm.selectedDatas),expression:"selectedDatas"}],attrs:{"type":"checkbox","id":'select_' + {
                        country: {
                          competitiveness: data.country_code,
                          attraction: data.partner_code,
                          toolcompetitiveness: data.country_code,
                          toolattraction: data.partner_code
                        },
                        year: {
                          competitiveness: data.year,
                          attraction: data.year,
                          toolcompetitiveness: data.year,
                          toolattraction: data.year
                        }
                      }[_vm.dataType][_vm.analysisType]},domProps:{"value":data,"checked":Array.isArray(_vm.selectedDatas)?_vm._i(_vm.selectedDatas,data)>-1:(_vm.selectedDatas)},on:{"change":function($event){var $$a=_vm.selectedDatas,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=data,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectedDatas=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectedDatas=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectedDatas=$$c}}}}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("TEyu")("./checkbox-" + (_vm.selectedDatas.includes(data) ? 'true' : 'false') + '.svg')}}),_vm._v(" "),_c('div',{style:({ width: '8px' })}),_vm._v(" "),_c('div',{staticClass:"data-title",style:({ flex: 1 }),attrs:{"title":{
                        country: {
                          competitiveness: data.country_name,
                          attraction: data.partner_name,
                          toolcompetitiveness: data.country_name,
                          toolattraction: data.partner_name
                        },
                        year: {
                          competitiveness: data.year,
                          attraction: data.year,
                          toolcompetitiveness: data.year,
                          toolattraction: data.year
                        }
                      }[_vm.dataType][_vm.analysisType]},domProps:{"innerHTML":_vm._s({
                        country: {
                          competitiveness: data.country_name,
                          attraction: data.partner_name,
                          toolcompetitiveness: data.country_name,
                          toolattraction: data.partner_name
                        },
                        year: {
                          competitiveness: data.year,
                          attraction: data.year,
                          toolcompetitiveness: data.year,
                          toolattraction: data.year
                        }
                      }[_vm.dataType][_vm.analysisType])}})])}),_vm._v(" "),_c('div',{style:({ flex: 1 })})],2)])])],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"chart-container",style:({ flex: 1 })},[_c('div',{staticClass:"chart-block"},[_c('div',{ref:"chartField",staticClass:"chart-field",style:({ '--chart-font-size': _vm.fontSize + 'px' })},[_c('div',{staticClass:"chart-block col-block"},[_c('div',{staticClass:"data-block col-block"},[_c('div',{staticClass:"row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',[_c('b',{domProps:{"innerHTML":_vm._s({
                      country: {
                        competitiveness: [
                          _vm.getFilterTitle('year') + '年 ' + _vm.getFilterTitle('product'),
                          '在 ' + _vm.getFilterTitle('country') + ' 的市場競爭力'
                        ],
                        attraction: [
                          _vm.getFilterTitle('year') + '年 ' + _vm.getFilterTitle('product'),
                          '各國市場吸引力'
                        ],
                        toolcompetitiveness: [
                          _vm.getFilterTitle('year') + '年 ' + _vm.getFilterTitle('product'),
                          '在 ' + _vm.getFilterTitle('country') + ' 的農業機械市場競爭力'
                        ],
                        toolattraction: [
                          _vm.getFilterTitle('year') + '年 ' + _vm.getFilterTitle('product'),
                          '各國農業機械市場吸引力'
                        ]
                      },
                      year: {
                        competitiveness: [
                          _vm.getCountryTitle() + ' 的 ' + _vm.getFilterTitle('product'),
                          '在 ' + _vm.getFilterTitle('country') + ' 市場的歷年市場競爭力'
                        ],
                        attraction: [
                          _vm.getFilterTitle('product'),
                          '在 ' + _vm.getCountryTitle() + ' 的歷年市場吸引力'
                        ],
                        toolcompetitiveness: [
                          _vm.getCountryTitle() + ' 的 ' + _vm.getFilterTitle('product'),
                          '在 ' + _vm.getFilterTitle('country') + ' 市場的歷年農業機械市場競爭力'
                        ],
                        toolattraction: [
                          _vm.getFilterTitle('product'),
                          '在 ' + _vm.getCountryTitle() + ' 的歷年農業機械市場吸引力'
                        ]
                      }
                    }[_vm.dataType][_vm.analysisType].join('<br>'))}})]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{staticClass:"row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),(_vm.filterConditions.point)?_c('div',{style:({ 'text-align': 'left' }),domProps:{"innerHTML":_vm._s('<b>Z軸：</b>' + _vm.nco(function () { return _vm.graphOptions.find(function (option) { return option.value === 'point'; }).options.find(function (option) { return option.value === _vm.filterConditions.point; }).title + (_vm.graphOptions.find(function (option) { return option.value === 'point'; }).options.find(function (option) { return option.value === _vm.filterConditions.point; }).description ? ' (' + _vm.graphOptions.find(function (option) { return option.value === 'point'; }).options.find(function (option) { return option.value === _vm.filterConditions.point; }).description + ')' : '') + (['country'].includes(_vm.dataType) ? '<br><b style=\'opacity:0\'>Z軸：</b>( 加權=' + (_vm.conditions.weightings[_vm.filterConditions.point] ? _vm.conditions.weightings[_vm.filterConditions.point].active ? _vm.conditions.weightings[_vm.filterConditions.point].value : 0 : 0) + ' )' : ''); }, ''))}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"chart-block"},[(_vm.graphType && _vm.graphInit && _vm.state === 'graph')?_c('vueCharts',{ref:"chart",attrs:{"options":_vm.chartOptions,"autoresize":true}}):_vm._e()],1),_vm._v(" "),_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"description-block row-block",style:({ 'font-size': _vm.fontSize + 'px' })},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_vm._m(0)])])])])])])])])}
var analysis_graph_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-block"},[_c('div',{staticClass:"content"},[_vm._v("資料來源：世界銀行、國際貿易中心、FAOSTAT")]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("農業部農業試驗所")])])}]
var analysis_graph_esExports = { render: analysis_graph_render, staticRenderFns: analysis_graph_staticRenderFns }
/* harmony default export */ var components_analysis_graph = (analysis_graph_esExports);
// CONCATENATED MODULE: ./src/components/analysis/graph.vue
function analysis_graph_injectStyle (ssrContext) {
  __webpack_require__("fwQm")
}
var analysis_graph_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var analysis_graph___vue_template_functional__ = false
/* styles */
var analysis_graph___vue_styles__ = analysis_graph_injectStyle
/* scopeId */
var analysis_graph___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var analysis_graph___vue_module_identifier__ = null
var analysis_graph_Component = analysis_graph_normalizeComponent(
  analysis_graph,
  components_analysis_graph,
  analysis_graph___vue_template_functional__,
  analysis_graph___vue_styles__,
  analysis_graph___vue_scopeId__,
  analysis_graph___vue_module_identifier__
)

/* harmony default export */ var src_components_analysis_graph = (analysis_graph_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/report/comment.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var report_comment = ({
  mixins: [mixins_routeLoading, toastMethods["a" /* default */], mixins_userPermission],
  props: {
    reportID: {
      type: Number,
      required: true
    }
  },
  data: function data() {
    return {
      comments: [],
      now: new Date(),
      comment: '',
      currentAlert: null
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['user']), {
    // global
    dateFormat: function dateFormat() {
      return util["b" /* dateFormat */];
    }
  }),
  watch: {
    'reportID': function reportID() {
      this.fetchData();
    }
  },
  methods: {
    fetchData: function fetchData() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.fetchComments();

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    fetchComments: function fetchComments() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var config, reportID, response, comments;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                config = _this2.$ls.get('userInfo');
                reportID = _this2.reportID;
                _context2.next = 5;
                return Object(src_api["A" /* getReportComments */])(reportID, config);

              case 5:
                response = _context2.sent;
                comments = response.data.data;

                _this2.comments = comments.reverse();
                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](0);
                throw _context2.t0;

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 10]]);
      }))();
    },
    sendComment: function sendComment() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var config, reportID, data;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                config = _this3.$ls.get('userInfo');
                reportID = _this3.reportID;
                data = {
                  content: _this3.comment
                };
                _context3.next = 6;
                return Object(src_api["Q" /* postReportComment */])(reportID, data, config);

              case 6:
                _this3.comment = '';
                _context3.next = 9;
                return _this3.fetchComments();

              case 9:
                _context3.next = 14;
                break;

              case 11:
                _context3.prev = 11;
                _context3.t0 = _context3['catch'](0);

                _this3.addToast('error', !_context3.t0.response ? _context3.t0.message : _context3.t0.response.data.message || _context3.t0.response.data.errors.join('<br>'));

              case 14:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 11]]);
      }))();
    },
    deleteComment: function deleteComment(comment) {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var config, reportID, id;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                config = _this4.$ls.get('userInfo');
                reportID = _this4.reportID;
                id = comment.id;
                _context4.next = 6;
                return Object(src_api["d" /* deleteReportComment */])(id, reportID, config);

              case 6:
                _context4.next = 8;
                return _this4.fetchComments();

              case 8:
                _this4.currentAlert = null;
                _context4.next = 14;
                break;

              case 11:
                _context4.prev = 11;
                _context4.t0 = _context4['catch'](0);

                _this4.addToast('error', !_context4.t0.response ? _context4.t0.message : _context4.t0.response.data.message || _context4.t0.response.data.errors.join('<br>'));

              case 14:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[0, 11]]);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5880a68b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/report/comment.vue
var comment_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"report-comment-page"},[_c('div',{staticClass:"comment-container col-block"},[(_vm.rolePermission(['advance', 'admin']))?_c('div',{staticClass:"comment-field row-block"},[_c('div',{staticClass:"comment-block col-block",style:({ flex: 1 })},[_c('div',{staticClass:"title-container row-block"},[_c('div',{style:({ 'min-width': '10px' })}),_vm._v(" "),_c('div',{staticClass:"title-block row-block ellipsis"},[_c('div',{staticClass:"time ellipsis"},[_vm._v(_vm._s(_vm.dateFormat(new Date(_vm.now), 'yyyy/MM/dd hh:mm')))]),_vm._v(" "),_c('div',{style:({ 'min-width': '3px' })}),_vm._v(" "),_c('div',{staticClass:"user"},[_vm._v(_vm._s(_vm.user.name))])]),_vm._v(" "),_c('div',{style:({ flex: 1, 'min-width': '20px' })}),_vm._v(" "),_c('div',{staticClass:"alert-block ellipsis"},[_vm._v("請注意自身發言，勿發表冒犯或不法言論，管理員有權刪除留言。")])]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"form-container input-group"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.comment),expression:"comment"}],attrs:{"rows":"4","placeholder":"請輸入留言文字。"},domProps:{"value":(_vm.comment)},on:{"input":function($event){if($event.target.composing){ return; }_vm.comment=$event.target.value}}})])]),_vm._v(" "),_c('div',{style:({ width: '10px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block",style:({ width: '73px' })},[_c('button',{staticClass:"main-button option-button",attrs:{"type":"button","name":"button","disabled":!_vm.comment},on:{"click":function (e) { return _vm.sendComment(); }}},[_c('span',[_vm._v("留言")])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]):_vm._e(),_vm._v(" "),_vm._l((_vm.comments),function(comment,index){return _c('div',{key:index,staticClass:"comment-field row-block"},[(_vm.rolePermission(['advance', 'admin']) && comment.id)?_c('div',{staticClass:"alert-container col-block",class:{ active: _vm.currentAlert === comment }},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),(_vm.currentAlert === comment)?[_c('div',{staticClass:"alert-title row-block"},[_c('img',{attrs:{"src":__webpack_require__("oNTV"),"alt":""}}),_vm._v(" "),_c('div',{style:({ width: '15px' })}),_vm._v(" "),_c('div',{staticClass:"alert-text"},[_vm._v("此動作不可復原，確認是否刪除留言?")])]),_vm._v(" "),_c('div',{style:({ height: '12px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('button',{staticClass:"gray-button",on:{"click":function (e) { return _vm.currentAlert = null; }}},[_c('span',[_vm._v("取消")])]),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('button',{staticClass:"error-button",on:{"click":function (e) { return _vm.deleteComment(comment); }}},[_c('span',[_vm._v("刪除")])])])]:_vm._e(),_vm._v(" "),_c('div',{style:({ flex: 1 })})],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"comment-block col-block",style:({ flex: 1 })},[_c('div',{staticClass:"title-container row-block"},[_c('div',{style:({ width: '10px' })}),_vm._v(" "),_c('div',{staticClass:"title-block row-block"},[_c('div',{staticClass:"time"},[_vm._v(_vm._s(_vm.dateFormat(new Date(comment.created_at), 'yyyy/MM/dd hh:mm')))]),_vm._v(" "),_c('div',{style:({ width: '3px' })}),_vm._v(" "),_c('div',{staticClass:"user"},[_vm._v(_vm._s(comment.user_name))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"form-container input-group"},[_c('div',{staticClass:"content"},[_vm._v(_vm._s(comment.content))])])]),_vm._v(" "),_c('div',{style:({ width: '10px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block",style:({ width: '73px' })},[(_vm.rolePermission(['advance', 'admin']) && comment.id)?_c('button',{staticClass:"alert-button option-button center-block",attrs:{"type":"button","name":"button"},on:{"click":function (e) { return _vm.currentAlert = comment; }}},[_c('img',{attrs:{"src":__webpack_require__("xuiG"),"alt":""}})]):_vm._e(),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])})],2)])}
var comment_staticRenderFns = []
var comment_esExports = { render: comment_render, staticRenderFns: comment_staticRenderFns }
/* harmony default export */ var components_report_comment = (comment_esExports);
// CONCATENATED MODULE: ./src/components/report/comment.vue
var comment_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var comment___vue_template_functional__ = false
/* styles */
var comment___vue_styles__ = null
/* scopeId */
var comment___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var comment___vue_module_identifier__ = null
var comment_Component = comment_normalizeComponent(
  report_comment,
  components_report_comment,
  comment___vue_template_functional__,
  comment___vue_styles__,
  comment___vue_scopeId__,
  comment___vue_module_identifier__
)

/* harmony default export */ var src_components_report_comment = (comment_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/report/detail.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var detail = ({
  components: {
    comment: src_components_report_comment
  },
  mixins: [mixins_routeLoading, mixins_userPermission],
  props: {
    reportID: {
      type: Number,
      required: true
    },
    func: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      report: {}
    };
  },

  computed: {
    // global
    dateFormat: function dateFormat() {
      return util["b" /* dateFormat */];
    },
    convertFileSize: function convertFileSize() {
      return util["a" /* convertFileSize */];
    }
  },
  watch: {
    'reportID': function reportID() {
      this.fetchData();
    }
  },
  methods: {
    fetchData: function fetchData() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.fetchDatas();

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    fetchDatas: function fetchDatas() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var config, id, response, report;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                config = _this2.$ls.get('userInfo');
                id = _this2.reportID;
                _context2.next = 5;
                return Object(src_api["z" /* getReport */])(id, config);

              case 5:
                response = _context2.sent;
                report = response.data.data;

                _this2.report = report;
                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](0);
                throw _context2.t0;

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 10]]);
      }))();
    },
    setFilter: function setFilter(tag) {
      this.$emit('setFilter', tag);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a9f9cd6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/report/detail.vue
var detail_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"report-detail-page container-block col-block"},[_c('div',{staticClass:"title-container"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.report.title))])]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"date-container"},[_c('span',[_c('b',[_vm._v("發表時間：")]),_vm._v(_vm._s(_vm.dateFormat(new Date(_vm.report.publish_time), 'yyyy/MM/dd hh:mm')))])]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"cover-container row-block"},[_c('div',{staticClass:"cover-block center-block"},[_c('img',{attrs:{"src":(_vm.report.cover_photo || {}).url || __webpack_require__("hp+x"),"alt":""}})]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"content-container ql-container ql-snow"},[_c('div',{staticClass:"content ql-editor",domProps:{"innerHTML":_vm._s(_vm.report.content || '沒有文字內容')}})]),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"tag-container row-block"},[_c('div',{staticClass:"title"},[_vm._v("標籤：")]),_vm._v(" "),_c('div',{staticClass:"tags row-block",style:({ flex: 1 })},_vm._l((_vm.func.getReportTags(_vm.report)),function(tag,tindex){return _c('div',{key:tindex,staticClass:"tag-field"},[_c('div',{staticClass:"tag-block"},[_c('div',{staticClass:"tag-title",on:{"click":function (e) { return _vm.setFilter(tag); }}},[_vm._v(_vm._s(tag.title + ','))])])])}),0)]),_vm._v(" "),(_vm.report.external_link)?[_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"link-container row-block"},[_c('div',{staticClass:"title"},[_vm._v("連結：")]),_vm._v(" "),_c('div',{staticClass:"link",style:({ flex: 1 })},[_c('a',{staticClass:"link",attrs:{"href":_vm.report.external_link,"target":"_blank"}},[_vm._v(_vm._s(_vm.report.external_link))])])])]:_vm._e(),_vm._v(" "),((_vm.report.attachments || []).length)?[_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"attachment-container row-block"},[_c('div',{staticClass:"title"},[_vm._v("附件：")]),_vm._v(" "),_c('div',{staticClass:"attachments col-block",style:({ flex: 1, width: 0 })},_vm._l((_vm.report.attachments),function(attachment,tindex){return _c('div',{key:tindex,staticClass:"attachment row-block"},[(_vm.rolePermission(['advance', 'admin']))?_c('a',{staticClass:"attachment-title link row-block",attrs:{"href":attachment.url,"target":"_blank"}},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(attachment.name))]),_vm._v(" "),_c('div',{style:({ width: '3px' })}),_vm._v(" "),_c('div',{staticClass:"size"},[_vm._v(_vm._s('(' + _vm.convertFileSize(attachment.file_size) + ')'))])]):_c('div',{staticClass:"attachment-title row-block"},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(attachment.name))]),_vm._v(" "),_c('div',{style:({ width: '3px' })}),_vm._v(" "),_c('div',{staticClass:"size"},[_vm._v(_vm._s('(無權限下載)'))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])}),0)])]:_vm._e(),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),(_vm.report.id)?[_c('comment',{attrs:{"reportID":_vm.reportID}})]:_vm._e(),_vm._v(" "),_c('div',{style:({ flex: 1 })})],2)}
var detail_staticRenderFns = []
var detail_esExports = { render: detail_render, staticRenderFns: detail_staticRenderFns }
/* harmony default export */ var report_detail = (detail_esExports);
// CONCATENATED MODULE: ./src/components/report/detail.vue
var detail_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var detail___vue_template_functional__ = false
/* styles */
var detail___vue_styles__ = null
/* scopeId */
var detail___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var detail___vue_module_identifier__ = null
var detail_Component = detail_normalizeComponent(
  detail,
  report_detail,
  detail___vue_template_functional__,
  detail___vue_styles__,
  detail___vue_scopeId__,
  detail___vue_module_identifier__
)

/* harmony default export */ var components_report_detail = (detail_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/analysis/report.vue






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var analysis_report = ({
  components: {
    reportDetail: components_report_detail,
    pageButtons: components_tool_pageButtons
  },
  mixins: [mixins_routeLoading],
  props: {
    dataType: {
      type: String,
      required: true
    },
    country: {
      Type: Object,
      default: function _default() {
        return null;
      }
    },
    state: {
      type: String,
      required: true
    },
    filterOptions: {
      type: Object,
      required: true
    },
    conditions: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      reports: [],
      currentReportID: null,
      productByCategorys: [],
      onSearch: false,
      pageData: {
        selectedPage: 1,
        display: 12,
        total: null,
        buttonRange: 7
      },
      sort: {
        value: [],
        order: []
      }
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['countrys']), {
    analysisType: function analysisType() {
      return this.$route.name;
    },

    // static
    productOptions: function productOptions() {
      return [].concat(toConsumableArray_default()(Array.prototype.concat.apply([], entries_default()(this.productByCategorys).map(function (_ref) {
        var _ref2 = slicedToArray_default()(_ref, 2),
            category = _ref2[0],
            products = _ref2[1];

        return entries_default()(products).map(function (_ref3) {
          var _ref4 = slicedToArray_default()(_ref3, 2),
              code = _ref4[0],
              product = _ref4[1];

          return { title: product.chinese_name, value: code, type: product.product_type, category: category };
        });
      }))), [{ title: '其他', value: '其他', type: '其他', category: '其他' }]);
    },
    moduleOptions: function moduleOptions() {
      return [{ title: '市場吸引力', value: 'market_attractiveness' }, { title: '市場競爭力', value: 'market_competitiveness' }, { title: '零售價格分析', value: 'product_prices' }, { title: '其他', value: 'others' }];
    },
    yearOptions: function yearOptions() {
      var year = new Date().getFullYear();
      return [{ title: '無', value: '無' }].concat(toConsumableArray_default()(new Array(year - 2000).fill('').map(function (_, i) {
        return { title: year - i + '', value: year - i + '' };
      })));
    },
    countryOptions: function countryOptions() {
      return this.countrys.map(function (_ref5) {
        var _ref6 = slicedToArray_default()(_ref5, 2),
            key = _ref6[0],
            value = _ref6[1];

        return {
          title: value.chinese_name + '(' + value.iso_name + ')',
          value: key,
          country: value
        };
      });
    },
    tableOptions: function tableOptions() {
      var _this = this;

      return [{
        title: '發表時間',
        value: 'publish_time',
        width: '150px',
        display: function display(value) {
          return value ? Object(util["b" /* dateFormat */])(new Date(value), 'yyyy/MM/dd hh:mm') : '';
        }
      }, {
        title: '報告標題',
        value: 'title',
        style: function style() {
          return {
            'color': '#3967A6',
            'text-decoration': 'underline',
            'cursor': 'pointer'
          };
        },
        func: function func(report) {
          return _this.selectReport(report);
        }
      }];
    }
  }),
  methods: {
    fetchData: function fetchData() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.fetchProductByCategorys();

              case 2:
                _context.next = 4;
                return _this2.fetchReports();

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    fetchProductByCategorys: function fetchProductByCategorys() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var config, response, productByCategorys;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                config = _this3.$ls.get('userInfo');
                _context2.next = 4;
                return Object(src_api["r" /* getProductByCategorys */])(config);

              case 4:
                response = _context2.sent;
                productByCategorys = response.data;

                _this3.productByCategorys = productByCategorys;
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](0);
                throw _context2.t0;

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[0, 9]]);
      }))();
    },
    fetchReports: function fetchReports(filters) {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var config, data, response, reports;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                config = _this4.$ls.get('userInfo');

                filters = filters || _this4.filters || {};
                data = {
                  product_code: _this4.conditions.filters['product'],
                  countries: { competitiveness: _this4.country.country_code, attraction: _this4.country.partner_code, toolcompetitiveness: _this4.country.country_code, toolattraction: _this4.country.partner_code }[_this4.analysisType]
                };

                _this4.pageData.selectedPage && (data.page = _this4.pageData.selectedPage);
                _this4.pageData.display && (data.item_per_page = _this4.pageData.display);
                _this4.sort.value[0] && (data.order_by = _this4.sort.value[0]);
                _this4.sort.order[0] && (data.order_method = _this4.sort.order[0].replace(/^-/, ''));
                _context3.next = 10;
                return Object(src_api["C" /* getReports */])(data, config);

              case 10:
                response = _context3.sent;
                reports = response.data.data.elements;

                _this4.pageData.total = response.data.data.items_count;
                _this4.reports = reports;
                _context3.next = 19;
                break;

              case 16:
                _context3.prev = 16;
                _context3.t0 = _context3['catch'](0);
                throw _context3.t0;

              case 19:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4, [[0, 16]]);
      }))();
    },
    searchDatas: function searchDatas(init) {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this5.onSearch = true;
                _context4.next = 3;
                return _this5.fetchReports(init);

              case 3:
                _this5.onSearch = false;

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    },
    getFilterTitle: function getFilterTitle(value) {
      var _this6 = this;

      if (!this.conditions.filters[value]) {
        return '';
      }
      return this.filterOptions.filters.find(function (filter) {
        return filter.value === value;
      }).options.find(function (option) {
        return option.value === _this6.conditions.filters[value];
      }).title;
    },
    getCountryTitle: function getCountryTitle() {
      if (!this.country) {
        return '';
      }
      return { competitiveness: this.country.country_name, attraction: this.country.partner_name, toolcompetitiveness: this.country.country_name, toolattraction: this.country.partner_name }[this.analysisType];
    },
    selectReport: function selectReport(report) {
      var _this7 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this7.currentReportID = report.id;

              case 1:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this7);
      }))();
    },
    getReportTags: function getReportTags(report) {
      var _this8 = this;

      var tags = [];
      var product = this.productOptions.find(function (option) {
        return option.title === report.product_name || option.value === report.product_code;
      });
      if (product) {
        tags.push({
          title: product.title,
          filter: {
            category: product.category,
            product_code: product.value
          }
        });
      }
      if (report.countries && report.countries.length) {
        tags = [].concat(toConsumableArray_default()(tags), toConsumableArray_default()(report.countries.map(function (country) {
          return _this8.countryOptions.find(function (option) {
            return option.value === country;
          });
        }).filter(function (x) {
          return x;
        }).map(function (option) {
          return {
            title: option.country.chinese_name,
            filter: {
              countries: option.title
            }
          };
        })));
      }
      var _module = this.moduleOptions.find(function (option) {
        return option.value === report.module;
      });
      if (_module) {
        tags.push({
          title: _module.title,
          filter: {
            module: _module.value
          }
        });
      }
      var year = this.yearOptions.find(function (option) {
        return option.value + '' === report.year + '';
      });
      if (year) {
        tags.push({
          title: year.title,
          filter: {
            year: year.value
          }
        });
      }
      return tags;
    },
    tableSortBy: function tableSortBy(value) {
      var position = this.sort.value.indexOf(value);
      if (position === 0) {
        var order = this.sort.order[position] === '-asc' ? '-desc' : '-asc';
        this.sort.order.splice(position, 1);
        this.sort.order.unshift(order);
      } else {
        var _order = position !== -1 ? this.sort.order[position] === '-asc' ? '-desc' : '-asc' : undefined;
        position = position !== -1 ? position : 0;
        this.sort.value.splice(position, 1);
        this.sort.order.splice(position, 1);
        this.sort.value.unshift(value);
        this.sort.order.unshift(_order || '-asc');
      }
      this.searchDatas();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20aa47b9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/analysis/report.vue
var analysis_report_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"analysis-report-page col-block"},[_c('div',{staticClass:"option-container row-block"},[_c('div',{staticClass:"data-block row-block"},[(_vm.conditions.filters.product)?[_c('div',[_c('b',[_vm._v("品項：")]),_vm._v(_vm._s(_vm.getFilterTitle('product')))]),_vm._v(" "),_c('div',{style:({ width: '50px' })})]:_vm._e(),_vm._v(" "),(_vm.conditions.filters.country)?[_c('div',[_c('b',[_vm._v("目標市場：")]),_vm._v(_vm._s(_vm.getFilterTitle('country')))]),_vm._v(" "),_c('div',{style:({ width: '50px' })})]:_vm._e(),_vm._v(" "),(_vm.dataType === 'country' && _vm.conditions.filters.year)?[_c('div',[_c('b',[_vm._v("數據年份：")]),_vm._v(_vm._s(_vm.getFilterTitle('year')))]),_vm._v(" "),_c('div',{style:({ width: '50px' })})]:_vm._e(),_vm._v(" "),(_vm.dataType === 'year' && _vm.country)?[_c('div',[_c('b',[_vm._v(_vm._s({ competitiveness: '競爭國家', attraction: '市場國家', toolcompetitiveness: '競爭國家', toolattraction: '市場國家' }[_vm.analysisType])+"：")]),_vm._v(_vm._s(_vm.getCountryTitle()))]),_vm._v(" "),_c('div',{style:({ width: '50px' })})]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"button-block row-block"})]),_vm._v(" "),_c('div',{staticClass:"content-container",style:({ flex: 1 })},[_c('div',{staticClass:"report-block row-block stretch"},[_c('div',{staticClass:"list-container col-block",style:({ width: '400px' })},[_c('div',{staticClass:"table-container col-block",style:({ height: '50px' })},[_c('div',{staticClass:"thead default-shadow"},[_c('div',{staticClass:"tr row-block"},_vm._l((_vm.tableOptions),function(option,index){return _c('div',{key:index,staticClass:"th row-block",class:option.class,style:(option.width ? { width: option.width } : { flex: 1 }),on:{"click":function (e) { return option.sort !== false && _vm.tableSortBy(option.value); }}},[_c('span',[_vm._v(_vm._s(option.title))]),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),(option.sort !== false)?_c('i',{class:['fa', 'fa-sort' + (_vm.sort.order[_vm.sort.value.indexOf(option.value)] || '')],attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "),_c('div',{style:({ flex: 1 })})])}),0)])]),_vm._v(" "),_c('div',{staticClass:"table-container col-block sub-shadow",style:({ flex: 1 })},[_c('div',{staticClass:"tbody",style:({ flex: 1 })},[_c('div',{style:({ height: 0 })},_vm._l((_vm.reports),function(report,cindex){return _c('div',{key:cindex,staticClass:"tr row-block"},[_c('div',{staticClass:"container-block row-block"},_vm._l((_vm.tableOptions),function(option,index){return _c('div',{key:index,staticClass:"td row-block",class:option.class,style:(option.width ? { width: option.width } : { flex: 1 })},[_c('span',{style:((option.style || (function () {}))(report[option.value])),attrs:{"title":(option.display || (function (x) { return x; }))(report[option.value], cindex)},on:{"click":function (e) { return (option.func || (function () {}))(report); }}},[_vm._v(_vm._s((option.display || (function (x) { return x; }))(report[option.value], cindex) || '--'))])])}),0)])}),0)])]),_vm._v(" "),_c('div',{staticClass:"page-container center-block"},[(_vm.pageData.total)?_c('pageButtons',{attrs:{"default":_vm.pageData.selectedPage,"display":_vm.pageData.display,"total":_vm.pageData.total,"buttonRange":_vm.pageData.buttonRange},on:{"selectPage":function (page) { _vm.pageData.selectedPage = page; _vm.searchDatas() }}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"report-container",style:({ flex: 1 })},[(_vm.currentReportID)?_c('div',{staticClass:"report-detail-container"},[_c('reportDetail',{attrs:{"reportID":_vm.currentReportID,"func":{
              getReportTags: this.getReportTags
            }},on:{"setFilter":function () {}}})],1):_vm._e()])])])])}
var analysis_report_staticRenderFns = []
var analysis_report_esExports = { render: analysis_report_render, staticRenderFns: analysis_report_staticRenderFns }
/* harmony default export */ var components_analysis_report = (analysis_report_esExports);
// CONCATENATED MODULE: ./src/components/analysis/report.vue
var analysis_report_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var analysis_report___vue_template_functional__ = false
/* styles */
var analysis_report___vue_styles__ = null
/* scopeId */
var analysis_report___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var analysis_report___vue_module_identifier__ = null
var analysis_report_Component = analysis_report_normalizeComponent(
  analysis_report,
  components_analysis_report,
  analysis_report___vue_template_functional__,
  analysis_report___vue_styles__,
  analysis_report___vue_scopeId__,
  analysis_report___vue_module_identifier__
)

/* harmony default export */ var src_components_analysis_report = (analysis_report_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/tool/googleMap.vue


//
//
//
//
//
//

/* eslint-disable */
var _google = null;
var _MarkerClusterer = null;
setTimeout(function () {
  _google = google;
  _MarkerClusterer = MarkerClusterer;
}, 3000);
/* eslint-enable */

/* harmony default export */ var googleMap = ({
  props: {
    countryName: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    mapOption: {
      type: Object,
      default: function _default() {
        return null;
      }
    },
    mapEvents: {
      type: Array,
      default: function _default() {
        return ['center_changed'];
      }
    },
    markerOptions: {
      type: Array,
      default: function _default() {
        return null;
      }
    },
    markerEvents: {
      type: Array,
      default: function _default() {
        return ['click'];
      }
    }
  },
  data: function data() {
    return {
      country: null,
      mapObj: {
        geocoder: null,
        map: null,
        markers: null,
        clusterer: null
      }
    };
  },
  mounted: function mounted() {
    this.getCountry();
  },

  watch: {
    'mapOption': function mapOption(nv, ov) {
      if (stringify_default()(nv) !== stringify_default()(ov)) {
        this.init();
      }
    },
    'markerOptions': function markerOptions(nv, ov) {
      if (stringify_default()(nv) !== stringify_default()(ov)) {
        this.init();
      }
    },
    'mapEvents': function mapEvents(nv, ov) {
      if (stringify_default()(nv) !== stringify_default()(ov)) {
        this.setEventListener();
      }
    },
    'markerEvents': function markerEvents(nv, ov) {
      if (stringify_default()(nv) !== stringify_default()(ov)) {
        this.setEventListener();
      }
    }
  },
  methods: {
    getCountry: function getCountry() {
      var _this = this;

      this.mapObj.geocoder = new _google.maps.Geocoder();
      this.mapObj.geocoder.geocode({ address: this.countryName }, function (results, status) {
        if (status === 'OK') {
          if (results[0]) {
            _this.country = results[0];
          }
        }
        _this.init();
      });
    },
    init: function init() {
      if (this.initMap()) {
        this.setEventListener();
      }
    },
    initMap: function initMap() {
      var _this2 = this;

      try {
        var center = this.country ? { lat: this.country.geometry.location.lat(), lng: this.country.geometry.location.lng() } : null;
        this.mapObj.map = new _google.maps.Map(this.$refs['map'], extends_default()({
          zoom: 8,
          center: center || (this.markerOptions[0] ? this.markerOptions[0].position : { lat: 0, lng: 0 })
        }, this.mapOption || {}));
        this.mapObj.markers = this.markerOptions.map(function (markerOption) {
          return new _google.maps.Marker(extends_default()({
            map: _this2.map
          }, markerOption || {}));
        });
        this.mapObj.clusterer = new _MarkerClusterer(this.mapObj.map, this.mapObj.markers, {
          imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m'
        });
        return true;
      } catch (error) {
        return false;
      }
    },
    setEventListener: function setEventListener() {
      var _this3 = this;

      this.mapEvents.forEach(function (event) {
        _this3.mapObj.map.addListener(event, function () {
          _this3.$emit('mapEvent', event, _this3.mapObj.map);
        });
      });
      this.markerEvents.forEach(function (event) {
        _this3.mapObj.markers.forEach(function (marker) {
          marker.addListener(event, function () {
            _this3.$emit('markerEvent', event, marker, _this3.mapObj.map);
          });
        });
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1927d5a7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/googleMap.vue
var googleMap_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"google-map"}},[_c('div',{ref:"map"})])}
var googleMap_staticRenderFns = []
var googleMap_esExports = { render: googleMap_render, staticRenderFns: googleMap_staticRenderFns }
/* harmony default export */ var tool_googleMap = (googleMap_esExports);
// CONCATENATED MODULE: ./src/components/tool/googleMap.vue
function googleMap_injectStyle (ssrContext) {
  __webpack_require__("km+N")
}
var googleMap_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var googleMap___vue_template_functional__ = false
/* styles */
var googleMap___vue_styles__ = googleMap_injectStyle
/* scopeId */
var googleMap___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var googleMap___vue_module_identifier__ = null
var googleMap_Component = googleMap_normalizeComponent(
  googleMap,
  tool_googleMap,
  googleMap___vue_template_functional__,
  googleMap___vue_styles__,
  googleMap___vue_scopeId__,
  googleMap___vue_module_identifier__
)

/* harmony default export */ var components_tool_googleMap = (googleMap_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/analysis/weather.vue






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ var weather = ({
  components: {
    vueCharts: vue_echarts_components_ECharts,
    googleMap: components_tool_googleMap
  },
  mixins: [mixins_routeLoading, toastMethods["a" /* default */]],
  props: {
    dataType: {
      type: String,
      required: true
    },
    country: {
      Type: Object,
      default: function _default() {
        return null;
      }
    },
    state: {
      type: String,
      required: true
    },
    filterOptions: {
      type: Object,
      required: true
    },
    conditions: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      echarts: node_modules_echarts_default.a,
      fontSize: '14',
      optionTab: 'graph',
      conditionCache: {
        date: null,
        month: null
      },
      filterConditions: {
        type: 'date',
        start: '',
        end: ''
      },
      graphConditions: {
        type: 'date',
        start: '',
        end: ''
      },
      today: new Date(),
      // stations
      stations: null,
      curStation: null,
      summarys: null
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['source']), {
    analysisType: function analysisType() {
      return this.$route.name;
    },
    countryName: function countryName() {
      if (!this.country) {
        return '';
      }
      return { competitiveness: this.country.country_iso_name, attraction: this.country.partner_iso_name, toolcompetitiveness: this.country.country_iso_name, toolattraction: this.country.partner_iso_name }[this.analysisType];
    },
    startMin: function startMin() {
      if (this.filterConditions.end) {
        var end = new Date(this.filterConditions.end);
        if (this.filterConditions.type === 'date') end.setDate(end.getDate() - 89);
        if (this.filterConditions.type === 'month') end.setMonth(end.getMonth() - 59);
        var format = {
          date: 'yyyy-MM-dd',
          month: 'yyyy-MM'
        }[this.filterConditions.type];
        return Object(util["b" /* dateFormat */])(end, format);
      } else {
        return null;
      }
    },
    endMax: function endMax() {
      if (this.filterConditions.start) {
        var start = new Date(this.filterConditions.start);
        if (this.filterConditions.type === 'date') start.setDate(start.getDate() + 89);
        if (this.filterConditions.type === 'month') start.setMonth(start.getMonth() + 59);
        var format = {
          date: 'yyyy-MM-dd',
          month: 'yyyy-MM'
        }[this.filterConditions.type];
        return Object(util["b" /* dateFormat */])(start, format);
      } else {
        return null;
      }
    },
    startDefaultMax: function startDefaultMax() {
      // let date = new Date((this.source['NOAA Daily Summaries'] + '').replace(/(?!^)(?=(\d{2})+$)/g, '-').replace('-', ''))
      // let month = new Date((this.source['NOAA Monthly Summaries'] + '').replace(/(?!^)(?=(\d{2})+$)/g, '-').replace('-', ''))
      // let result = date < month ? date : month
      var result = new Date((this.source['NOAA'] + '').replace(/(?!^)(?=(\d{2})+$)/g, '-').replace('-', ''));
      var format = {
        date: 'yyyy-MM-dd',
        month: 'yyyy-MM'
      }[this.filterConditions.type];
      if (this.filterConditions.type === 'date') {
        result.setDate(result.getDate() - 1);
      } else if (this.filterConditions.type === 'month') {
        result.setMonth(result.getMonth() - 1);
      }
      return Object(util["b" /* dateFormat */])(result, format);
    },
    startDefaultMin: function startDefaultMin() {
      var result = new Date((this.source['NOAA'] + '').replace(/(?!^)(?=(\d{2})+$)/g, '-').replace('-', ''));
      var minYear = result.getFullYear() - 5;
      return {
        date: minYear + '-01-01',
        month: minYear + '-01'
      }[this.filterConditions.type];
    },
    endDefaultMax: function endDefaultMax() {
      // let date = new Date((this.source['NOAA Daily Summaries'] + '').replace(/(?!^)(?=(\d{2})+$)/g, '-').replace('-', ''))
      // let month = new Date((this.source['NOAA Monthly Summaries'] + '').replace(/(?!^)(?=(\d{2})+$)/g, '-').replace('-', ''))
      // let result = date < month ? date : month
      var result = new Date((this.source['NOAA'] + '').replace(/(?!^)(?=(\d{2})+$)/g, '-').replace('-', ''));
      var format = {
        date: 'yyyy-MM-dd',
        month: 'yyyy-MM'
      }[this.filterConditions.type];
      return Object(util["b" /* dateFormat */])(result, format);
    },
    endDefaultMin: function endDefaultMin() {
      var result = new Date((this.source['NOAA'] + '').replace(/(?!^)(?=(\d{2})+$)/g, '-').replace('-', ''));
      var minYear = result.getFullYear() - 5;
      return {
        date: minYear + '-01-02',
        month: minYear + '-02'
      }[this.filterConditions.type];
    },

    // static
    chartOptions: function chartOptions() {
      var _this = this;

      var summarys = Object(util["j" /* sortData */])(this.summarys || [], 'date');
      var data = {
        date: [],
        tmin: [],
        tavg: [],
        tmax: [],
        prcp: []
      };
      var range = {
        temp: {
          max: Number.MIN_VALUE,
          min: Number.MAX_VALUE
        },
        prcp: {
          max: Number.MIN_VALUE,
          min: Number.MAX_VALUE
        }
      };
      var fixed = {
        date: 1,
        month: 2
      }[this.graphConditions.type];
      summarys.forEach(function (summary) {
        data.date.push(summary.date);
        data.tmin.push(summary.TMIN_value ? summary.TMIN_value.toFixed(fixed).replace(/0+$/, '').replace(/\.$/, '') : null);
        data.tavg.push(summary.TAVG_value ? summary.TAVG_value.toFixed(fixed).replace(/0+$/, '').replace(/\.$/, '') : null);
        data.tmax.push(summary.TMAX_value ? summary.TMAX_value.toFixed(fixed).replace(/0+$/, '').replace(/\.$/, '') : null);
        data.prcp.push(summary.PRCP_value ? summary.PRCP_value.toFixed(fixed).replace(/0+$/, '').replace(/\.$/, '') : null);
        range.temp.max = Math.max(range.temp.max, summary.TMIN_value || Number.MIN_VALUE, summary.TAVG_value || Number.MIN_VALUE, summary.TMAX_value || Number.MIN_VALUE);
        range.temp.min = Math.min(range.temp.min, summary.TMIN_value || Number.MAX_VALUE, summary.TAVG_value || Number.MAX_VALUE, summary.TMAX_value || Number.MAX_VALUE);
        range.prcp.max = Math.max(range.prcp.max, summary.PRCP_value || Number.MIN_VALUE);
        range.prcp.min = Math.min(range.prcp.min, summary.PRCP_value || Number.MAX_VALUE, 0);
      });
      var prcpScale = {
        date: 2,
        month: 10
      }[this.graphConditions.type];
      var interval = function () {
        var interval = Object(util["k" /* toDivideNumber */])(Object(util["k" /* toDivideNumber */])(Math.max(range.temp.max, range.prcp.max / prcpScale) - Math.min(range.temp.min, range.prcp.min / prcpScale), 7) / 7, 5);
        return summarys.length ? {
          temp: interval,
          prcp: interval * prcpScale
        } : {
          temp: 5,
          prcp: 5 * prcpScale
        };
      }();
      var yAxis = summarys.length ? {
        temp: {
          max: Object(util["k" /* toDivideNumber */])(Math.max(range.temp.max, range.prcp.max / prcpScale), interval.temp),
          min: Object(util["k" /* toDivideNumber */])(Math.min(range.temp.min, range.prcp.min / prcpScale, 0), interval.temp, true)
        },
        prcp: {
          max: Object(util["k" /* toDivideNumber */])(Math.max(range.temp.max * prcpScale, range.prcp.max), interval.prcp),
          min: Object(util["k" /* toDivideNumber */])(Math.min(range.temp.min * prcpScale, range.prcp.min), interval.prcp, true)
        }
      } : {
        temp: {
          max: 30,
          min: 0
        },
        prcp: {
          max: 30 * prcpScale,
          min: 0
        }
      };
      yAxis = extends_default()({}, yAxis, {
        prcp: {
          max: yAxis.prcp.max - yAxis.prcp.min,
          min: 0
        }
      });
      var symbolSize = summarys.length ? Math.min(450 / summarys.length, 13) : 1;
      return {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            },
            label: {
              fontSize: this.fontSize
            }
          },
          textStyle: {
            fontSize: this.fontSize
          }
        },
        color: ['#CC292E', '#999999', '#36A2DA', '#9CCECB'],
        legend: {
          data: ['最高溫度', '平均温度', '最低溫度', '累積雨量'],
          textStyle: {
            fontSize: this.fontSize
          }
        },
        xAxis: [{
          type: 'category',
          data: data.date,
          nameTextStyle: {
            fontSize: this.fontSize
          },
          axisLabel: {
            rotate: -45,
            fontSize: this.fontSize,
            formatter: function formatter(value) {
              var format = {
                date: 'yyyy-MM-dd',
                month: 'yyyy-MM'
              }[_this.graphConditions.type];
              return Object(util["b" /* dateFormat */])(new Date(value), format);
            }
          },
          axisTick: {
            show: false
          },
          axisPointer: {
            type: 'shadow',
            shadowStyle: {
              color: '#9BC737',
              opacity: 0.1
            }
          }
        }],
        yAxis: [{
          type: 'value',
          name: '雨量 (mm)',
          nameLocation: 'middle',
          nameGap: 50,
          nameTextStyle: {
            fontSize: this.fontSize
          },
          min: yAxis.prcp.min,
          max: yAxis.prcp.max,
          interval: interval.prcp,
          axisTick: {
            show: false
          },
          axisLabel: {
            formatter: '{value}',
            fontSize: this.fontSize
          }
        }, {
          type: 'value',
          name: '氣溫 (°C)',
          nameLocation: 'middle',
          nameGap: 50,
          nameTextStyle: {
            fontSize: this.fontSize
          },
          min: yAxis.temp.min,
          max: yAxis.temp.max,
          interval: interval.temp,
          axisTick: {
            show: false
          },
          axisLabel: {
            formatter: '{value}',
            fontSize: this.fontSize
          }
        }],
        grid: {
          top: 50,
          left: 100,
          right: 100,
          bottom: 100
        },
        series: [{
          name: '最高溫度',
          type: 'line',
          yAxisIndex: 1,
          symbol: 'circle',
          symbolSize: symbolSize,
          data: data.tmax
        }, {
          name: '平均温度',
          type: 'line',
          yAxisIndex: 1,
          symbolSize: symbolSize,
          lineStyle: {
            type: 'dashed'
          },
          data: data.tavg
        }, {
          name: '最低溫度',
          type: 'line',
          yAxisIndex: 1,
          symbol: 'circle',
          symbolSize: symbolSize,
          data: data.tmin
        }, {
          name: '累積雨量',
          type: 'bar',
          yAxisIndex: 0,
          barWidth: '80%',
          data: data.prcp
        }]
      };
    },

    // global
    dateFormat: function dateFormat() {
      return util["b" /* dateFormat */];
    }
  }),
  watch: {
    'curStation': function curStation() {
      if (this.curStation) {
        this.getStationSummarys(!this.summarys);
      }
    },
    'filterConditions.start': function filterConditionsStart() {
      if (this.filterConditions.start && Object(util["h" /* isValidDate */])(new Date(this.filterConditions.start)) && new Date(this.filterConditions.start) >= new Date(this.startDefaultMin) && new Date(this.filterConditions.start) <= new Date(this.startDefaultMax)) {
        var start = this.filterConditions.start;
        var end = this.filterConditions.end;
        var startMin = new Date(start);
        var format = {
          date: 'yyyy-MM-dd',
          month: 'yyyy-MM'
        }[this.filterConditions.type];
        if (this.filterConditions.type === 'date') {
          startMin.setDate(startMin.getDate() + 1);
        } else if (this.filterConditions.type === 'month') {
          startMin.setMonth(startMin.getMonth() + 1);
        }
        startMin = Object(util["b" /* dateFormat */])(startMin, format);
        this.filterConditions = extends_default()({}, this.filterConditions, {
          end: !end ? startMin : new Date(end) < new Date(start) ? startMin : new Date(end) > new Date(this.endMax) ? this.endMax : end
        });
      }
    },
    'filterConditions.end': function filterConditionsEnd() {
      if (this.filterConditions.end && Object(util["h" /* isValidDate */])(new Date(this.filterConditions.end)) && new Date(this.filterConditions.end) >= new Date(this.endDefaultMin) && new Date(this.filterConditions.end) <= new Date(this.endDefaultMax)) {
        var start = this.filterConditions.start;
        var end = this.filterConditions.end;
        var endMax = new Date(end);
        var format = {
          date: 'yyyy-MM-dd',
          month: 'yyyy-MM'
        }[this.filterConditions.type];
        if (this.filterConditions.type === 'date') {
          endMax.setDate(endMax.getDate() - 1);
        } else if (this.filterConditions.type === 'month') {
          endMax.setMonth(endMax.getMonth() - 1);
        }
        endMax = Object(util["b" /* dateFormat */])(endMax, format);
        this.filterConditions = extends_default()({}, this.filterConditions, {
          start: !start ? endMax : new Date(start) > new Date(end) ? endMax : new Date(start) < new Date(this.startMin) ? this.startMin : start
        });
      }
    }
  },
  methods: {
    fetchData: function fetchData() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.fetchStations();

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    fetchStations: function fetchStations() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var config, country, response, stations;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                config = _this3.$ls.get('userInfo');
                country = { competitiveness: _this3.country.country_code, attraction: _this3.country.partner_code, toolcompetitiveness: _this3.country.country_code, toolattraction: _this3.country.partner_code }[_this3.analysisType];
                _context2.next = 5;
                return Object(src_api["F" /* getStations */])(country, config);

              case 5:
                response = _context2.sent;
                stations = response.data;

                _this3.stations = stations;
                _this3.curStation = _this3.stations[0];
                _context2.next = 14;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2['catch'](0);
                throw _context2.t0;

              case 14:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[0, 11]]);
      }))();
    },
    getStationSummarys: function getStationSummarys() {
      var _this4 = this;

      var init = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var config, stationID, type, format, defautStart, defaultEnd, data, response, summarys, start, key;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!init) {
                  _context3.next = 3;
                  break;
                }

                _this4.summarys = [];
                return _context3.abrupt('return');

              case 3:
                _context3.prev = 3;
                config = _this4.$ls.get('userInfo');
                stationID = _this4.curStation.id;
                type = {
                  date: 'daily_summaries',
                  month: 'monthly_summaries'
                }[_this4.filterConditions.type];
                format = {
                  date: 'yyyy-MM-dd',
                  month: 'yyyy-MM'
                }[_this4.filterConditions.type];
                defautStart = new Date();
                defaultEnd = new Date();

                defautStart.setDate(defautStart.getDate() - 30);
                data = init ? {
                  start_date: Object(util["b" /* dateFormat */])(new Date(defautStart), format),
                  end_date: Object(util["b" /* dateFormat */])(new Date(defaultEnd), format)
                } : {
                  start_date: _this4.filterConditions.start ? Object(util["b" /* dateFormat */])(new Date(_this4.filterConditions.start), format) : null,
                  end_date: _this4.filterConditions.end ? Object(util["b" /* dateFormat */])(new Date(_this4.filterConditions.end), format) : null
                };
                _context3.next = 14;
                return Object(src_api["E" /* getStationSummarys */])(stationID, type, data, config);

              case 14:
                response = _context3.sent;
                summarys = response.data;

                if (!summarys.length) {
                  _context3.next = 28;
                  break;
                }

                summarys = summarys.reduce(function (s, c) {
                  return extends_default()({}, s, defineProperty_default()({}, c.date, c));
                }, {});
                start = new Date(data.start_date);

              case 19:
                if (false) {
                  _context3.next = 28;
                  break;
                }

                key = Object(util["b" /* dateFormat */])(start, format);

                summarys[key] = summarys[key] || { date: key };
                if (_this4.filterConditions.type === 'date') start.setDate(start.getDate() + 1);
                if (_this4.filterConditions.type === 'month') start.setMonth(start.getMonth() + 1);

                if (!(key === data.end_date)) {
                  _context3.next = 26;
                  break;
                }

                return _context3.abrupt('break', 28);

              case 26:
                _context3.next = 19;
                break;

              case 28:
                _this4.summarys = values_default()(summarys);
                return _context3.abrupt('return', true);

              case 32:
                _context3.prev = 32;
                _context3.t0 = _context3['catch'](3);

              case 34:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4, [[3, 32]]);
      }))();
    },
    getFilterTitle: function getFilterTitle(value) {
      var _this5 = this;

      if (!this.conditions.filters[value]) {
        return '';
      }
      return this.filterOptions.filters.find(function (filter) {
        return filter.value === value;
      }).options.find(function (option) {
        return option.value === _this5.conditions.filters[value];
      }).title;
    },
    getCountryTitle: function getCountryTitle() {
      if (!this.country) {
        return '';
      }
      return { competitiveness: this.country.country_name, attraction: this.country.partner_name, toolcompetitiveness: this.country.country_name, toolattraction: this.country.partner_name }[this.analysisType];
    },
    getDateRange: function getDateRange() {
      var isHtml = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.graphConditions.start && this.graphConditions.end) {
        var defautStart = new Date();
        var defaultEnd = new Date();
        defautStart.setDate(defautStart.getDate() - 30);
        var format = {
          date: 'yyyy年 MM月 dd日',
          month: 'yyyy年 MM月'
        }[this.graphConditions.type];
        var start = this.graphConditions.start || defautStart;
        var end = this.graphConditions.end || defaultEnd;
        return Object(util["b" /* dateFormat */])(new Date(start), format) + ' ~ ' + Object(util["b" /* dateFormat */])(new Date(end), format);
      } else {
        return isHtml ? '<span style="opacity:0;">_</span>' : '';
      }
    },
    downloadGraph: function downloadGraph() {
      var _this6 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var url, title;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return Object(util["e" /* html2DataUrl */])(_this6.$refs.chartField, 'png', 0.3);

              case 2:
                url = _context4.sent;
                title = '';

                title = _this6.getCountryTitle() + ' ' + (_this6.curStation || {}).name + ' ' + _this6.getDateRange().replace(/ /g, '') + ' 之氣溫與降雨量統計圖';
                // await this.sendGraphAccessLog()
                Object(util["c" /* downloadFile */])(title, url, '_blank');

              case 6:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this6);
      }))();
    },
    downloadData: function downloadData() {
      var _this7 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        var csvContents, extraContents, headerContents, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, data, contents, url, title;

        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                csvContents = [];
                extraContents = [];

                extraContents.push(_this7.getCountryTitle() + ' ' + (_this7.curStation || {}).name + '之氣溫與降雨量資料表, 資料來源：NOAA 美國國家海洋暨大氣總署');
                extraContents = [extraContents.join(', ')];
                csvContents.push(extraContents);
                headerContents = [{
                  date: '日期',
                  month: '月'
                }[_this7.filterConditions.type], '最高溫度(°C)', '平均溫度(°C)', '最低溫度(°C)', '累積雨量(mm)'];

                csvContents.push(headerContents);
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context5.prev = 10;
                for (_iterator = get_iterator_default()(_this7.summarys); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  data = _step.value;
                  contents = [data.date, data.TMAX_value, data.TAVG_value, data.TMIN_value, data.PRCP_value];

                  csvContents.push(contents);
                }
                _context5.next = 18;
                break;

              case 14:
                _context5.prev = 14;
                _context5.t0 = _context5['catch'](10);
                _didIteratorError = true;
                _iteratorError = _context5.t0;

              case 18:
                _context5.prev = 18;
                _context5.prev = 19;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 21:
                _context5.prev = 21;

                if (!_didIteratorError) {
                  _context5.next = 24;
                  break;
                }

                throw _iteratorError;

              case 24:
                return _context5.finish(21);

              case 25:
                return _context5.finish(18);

              case 26:
                url = 'data:application/csv;charset=utf-8,%EF%BB%BF' + encodeURIComponent(csvContents.map(function (x) {
                  return '"' + x.join('","') + '"';
                }).join('\r\n') + '\r\n');
                title = '';

                title = _this7.getCountryTitle() + ' ' + (_this7.curStation || {}).name + ' ' + _this7.getDateRange().replace(/ /g, '') + ' 之氣候數據.csv';
                // await this.sendTableAccessLog()
                Object(util["c" /* downloadFile */])(title, url, '_target');

              case 30:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this7, [[10, 14, 18, 26], [19,, 21, 25]]);
      }))();
    },
    sendGraphAccessLog: function sendGraphAccessLog() {
      var _this8 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
        var config, accessFileType, type, paramDatas, data;
        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                config = _this8.$ls.get('userInfo');
                accessFileType = 'station';
                type = {
                  country: {
                    competitiveness: 'market_competitiveness',
                    attraction: 'market_attractiveness',
                    toolcompetitiveness: 'market_competitiveness',
                    toolattraction: 'market_attractiveness'
                  },
                  year: {
                    competitiveness: 'single_country_market_competitiveness',
                    attraction: 'single_country_market_attractiveness',
                    toolcompetitiveness: 'single_country_market_competitiveness',
                    toolattraction: 'single_country_market_attractiveness'
                  }
                }[_this8.dataType][_this8.analysisType];
                paramDatas = {
                  country: _this8.dataType === 'country' ? {
                    competitiveness: {
                      access_file_type: accessFileType,
                      partner: _this8.conditions.filters.country,
                      year: _this8.conditions.filters.year,
                      product_code: _this8.conditions.filters.product
                    },
                    attraction: {
                      access_file_type: accessFileType,
                      year: _this8.conditions.filters.year,
                      product_code: _this8.conditions.filters.product
                    },
                    toolcompetitiveness: {
                      access_file_type: accessFileType,
                      partner: _this8.conditions.filters.country,
                      year: _this8.conditions.filters.year,
                      product_code: _this8.conditions.filters.product
                    },
                    toolattraction: {
                      access_file_type: accessFileType,
                      year: _this8.conditions.filters.year,
                      product_code: _this8.conditions.filters.product
                    }
                  } : {},
                  year: _this8.dataType === 'year' ? {
                    competitiveness: {
                      access_file_type: accessFileType,
                      partner: _this8.conditions.filters.country,
                      product_code: _this8.conditions.filters.product,
                      country: _this8.country.country_code
                    },
                    attraction: {
                      access_file_type: accessFileType,
                      partner: _this8.country.partner_code,
                      product_code: _this8.conditions.filters.product
                    },
                    toolcompetitiveness: {
                      access_file_type: accessFileType,
                      partner: _this8.conditions.filters.country,
                      product_code: _this8.conditions.filters.product,
                      country: _this8.country.country_code
                    },
                    toolattraction: {
                      access_file_type: accessFileType,
                      partner: _this8.country.partner_code,
                      product_code: _this8.conditions.filters.product
                    }
                  } : {}
                }[_this8.dataType][_this8.analysisType];
                data = extends_default()({}, paramDatas);
                _context6.next = 8;
                return Object(src_api["I" /* postAccessLog */])(type, data, config);

              case 8:
                _context6.next = 13;
                break;

              case 10:
                _context6.prev = 10;
                _context6.t0 = _context6['catch'](0);

                _this8.addToast('error', !_context6.t0.response ? _context6.t0.message : _context6.t0.response.data.message || _context6.t0.response.data.errors.join('<br>'));

              case 13:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this8, [[0, 10]]);
      }))();
    },
    filterOnChange: function filterOnChange() {
      var _this9 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7() {
        var start, end, _start, _end;

        return regenerator_default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!(_this9.filterConditions.start && Object(util["h" /* isValidDate */])(new Date(_this9.filterConditions.start)) && _this9.filterConditions.end && Object(util["h" /* isValidDate */])(new Date(_this9.filterConditions.end)))) {
                  _context7.next = 37;
                  break;
                }

                if (!(_this9.filterConditions.type === 'date')) {
                  _context7.next = 20;
                  break;
                }

                start = new Date(_this9.filterConditions.start);

                start = start < new Date(_this9.startDefaultMin) ? new Date(_this9.startDefaultMin) : start > new Date(_this9.startDefaultMax) ? new Date(_this9.startDefaultMax) : start;
                _this9.filterConditions.start = Object(util["b" /* dateFormat */])(start, 'yyyy-MM-dd');
                end = new Date(_this9.filterConditions.end);

                end = end < new Date(_this9.endDefaultMin) ? new Date(_this9.endDefaultMin) : end > new Date(_this9.endDefaultMax) ? new Date(_this9.endDefaultMax) : end;
                _this9.filterConditions.end = Object(util["b" /* dateFormat */])(end, 'yyyy-MM-dd');
                start.setDate(start.getDate() + 90);

                if (!(start <= end)) {
                  _context7.next = 13;
                  break;
                }

                _this9.addToast('error', '您選擇的日期區間超過90日，請縮小範圍。');
                _context7.next = 18;
                break;

              case 13:
                _context7.next = 15;
                return _this9.getStationSummarys();

              case 15:
                if (!_context7.sent) {
                  _context7.next = 18;
                  break;
                }

                _this9.conditionCache['date'] = extends_default()({}, _this9.filterConditions);
                _this9.graphConditions = extends_default()({}, _this9.filterConditions);

              case 18:
                _context7.next = 37;
                break;

              case 20:
                if (!(_this9.filterConditions.type === 'month')) {
                  _context7.next = 37;
                  break;
                }

                _start = new Date(_this9.filterConditions.start);

                _start = _start < new Date(_this9.startDefaultMin) ? new Date(_this9.startDefaultMin) : _start > new Date(_this9.startDefaultMax) ? new Date(_this9.startDefaultMax) : _start;
                _this9.filterConditions.start = Object(util["b" /* dateFormat */])(_start, 'yyyy-MM');
                _end = new Date(_this9.filterConditions.end);

                _end = _end < new Date(_this9.endDefaultMin) ? new Date(_this9.endDefaultMin) : _end > new Date(_this9.endDefaultMax) ? new Date(_this9.endDefaultMax) : _end;
                _this9.filterConditions.end = Object(util["b" /* dateFormat */])(_end, 'yyyy-MM');
                _start.setMonth(_start.getMonth() + 60);

                if (!(_start <= _end)) {
                  _context7.next = 32;
                  break;
                }

                _this9.addToast('error', '您選擇的月區間超過60個月，請縮小範圍。');
                _context7.next = 37;
                break;

              case 32:
                _context7.next = 34;
                return _this9.getStationSummarys();

              case 34:
                if (!_context7.sent) {
                  _context7.next = 37;
                  break;
                }

                _this9.conditionCache['month'] = extends_default()({}, _this9.filterConditions);
                _this9.graphConditions = extends_default()({}, _this9.filterConditions);

              case 37:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this9);
      }))();
    },
    switchType: function switchType(type) {
      var _this10 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee8() {
        var cache;
        return regenerator_default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                cache = _this10.conditionCache[type] || {};

                _this10.filterConditions = {
                  type: type,
                  start: cache.start || '',
                  end: cache.end || ''
                };

                if (!cache.type) {
                  _context8.next = 5;
                  break;
                }

                _context8.next = 5;
                return _this10.filterOnChange();

              case 5:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this10);
      }))();
    },

    // google map
    markerEvent: function markerEvent(event, marker, map) {
      if (event === 'click') {
        var position = marker.getPosition();
        var station = this.stations.find(function (station) {
          return station.latitude === position.lat() && station.longitude === position.lng();
        });
        this.curStation = station || this.curStation;
        map.setCenter(map.getCenter());
        map.setZoom(map.getZoom());
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52fd1224","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/analysis/weather.vue
var weather_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"analysis-weather-page col-block"},[_c('div',{staticClass:"map-container col-block"},[_c('div',{staticClass:"map-title-container"},[_c('div',{staticClass:"map-title"},[_vm._v(_vm._s('' + _vm.getCountryTitle() + ' 天氣觀測站點一覽'))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),(!_vm.stations || _vm.stations.length)?_c('div',{staticClass:"map-main-container row-block"},[_c('div',{staticClass:"map-main-block row-block",style:({ flex: 1, 'max-width': '1020px' })},[_c('div',{staticClass:"gmap-container",style:({ flex: 1, 'max-width': '600px', height: '400px' })},[(_vm.stations)?_c('googleMap',{attrs:{"countryName":_vm.countryName,"mapOption":{
              zoom: 4,
              zoomControl: false,
              streetViewControl: false,
              scaleControl: false,
              rotateControl: false,
              panControl: false,
              mapTypeControl: false,
              fullscreenControl: false
            },"markerOptions":_vm.stations.map(function (station) { return ({
              position: { lat: station.latitude, lng: station.longitude },
              icon: __webpack_require__("Z1H5")
            }); })},on:{"markerEvent":function (event, marker, map) { return _vm.markerEvent(event, marker, map); }}}):_vm._e()],1),_vm._v(" "),_c('div',[_c('div',{style:({ width: '20px' })})]),_vm._v(" "),_c('div',{staticClass:"map-info-container col-block",style:({ width: '400px' })},[_c('div',{staticClass:"info-table col-block"},[_c('div',{staticClass:"info-table-title row-block"},[_vm._v("觀測站點詳細資訊")]),_vm._v(" "),(_vm.curStation)?_c('div',{staticClass:"info-table-content-container col-block"},[_c('div',{staticClass:"info-table-content row-block"},[_c('div',{staticClass:"content-title row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('span',[_vm._v("站點名稱")])]),_vm._v(" "),_c('div',{staticClass:"content-content row-block"},[_vm._v(_vm._s(_vm.curStation.name))])]),_vm._v(" "),_c('div',{staticClass:"info-table-content row-block"},[_c('div',{staticClass:"content-title row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('span',[_vm._v("NOAA ID")])]),_vm._v(" "),_c('div',{staticClass:"content-content row-block"},[_c('a',{staticClass:"link",attrs:{"href":'https://www.ncdc.noaa.gov/cdo-web/datasets/GHCND/stations/' + _vm.curStation.id + '/detail',"target":"_blank"}},[_vm._v(_vm._s(_vm.curStation.id))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"info-table-content row-block"},[_c('div',{staticClass:"content-title row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('span',[_vm._v("經緯度")])]),_vm._v(" "),_c('div',{staticClass:"content-content row-block"},[_vm._v(_vm._s(Math.abs(_vm.curStation.latitude) + '° ' + (_vm.curStation.latitude >= 0 ? 'N' : 'S') + '，' + Math.abs(_vm.curStation.longitude) + '° ' + (_vm.curStation.longitude >= 0 ? 'E' : 'W')))])]),_vm._v(" "),_c('div',{staticClass:"info-table-content row-block"},[_c('div',{staticClass:"content-title row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('span',[_vm._v("海拔高度")])]),_vm._v(" "),_c('div',{staticClass:"content-content row-block"},[_vm._v(_vm._s(_vm.curStation.elevation + ' ' + { MILLIMETERS: 'mm', CENTIMETERS: 'cm', METERS: 'm', KILOMETERS: 'km' }[_vm.curStation.elevationUnit]))])])]):_vm._e()]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"source-container row-block"},[_c('div',{style:({ width: '15px' })}),_vm._v(" "),_c('div',{staticClass:"source"},[_vm._v("資料來源：NOAA 美國國家海洋暨大氣總署")]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])])]):_c('div',{staticClass:"map-title-container"},[_c('div',{staticClass:"map-title empty"},[_vm._v(_vm._s('沒有資料呈現，因為NOAA未收錄[' + _vm.getCountryTitle() + '] 2001~2020年 氣溫與雨量資料。'))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),(!_vm.stations || _vm.stations.length)?[_c('hr'),_vm._v(" "),_c('div',{staticClass:"graph-container row-block stretch"},[_c('div',{staticClass:"options-container col-block",style:({ width: '230px' })},[_c('div',{style:({ height: '15px' })}),_vm._v(" "),_c('div',{staticClass:"option-tabs row-block"},[_c('div',{staticClass:"tab-container",class:{ active: _vm.optionTab === 'graph' },on:{"click":function (e) { return _vm.optionTab = 'graph'; }}},[_c('div',{staticClass:"tab-block center-block"},[_vm._v("可調參數")])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{staticClass:"sub-options-container",style:({ flex: 1, height: 0 })},[(false)?_c('div',{staticClass:"mask"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"sub-options-block col-block",class:[_vm.optionTab]},[_c('div',{staticClass:"interval-container col-block"},[_c('div',{staticClass:"sub-option-title"},[_vm._v("統計圖區間")]),_vm._v(" "),_c('div',{style:({ height: '5px' })}),_vm._v(" "),_c('div',{staticClass:"interval-block row-block"},[_c('div',{staticClass:"interval center-block",class:{ active: _vm.filterConditions.type === 'date' },on:{"click":function (e) { return _vm.switchType('date'); }}},[_vm._v("日資料")]),_vm._v(" "),_c('div',{staticClass:"hr"}),_vm._v(" "),_c('div',{staticClass:"interval center-block",class:{ active: _vm.filterConditions.type === 'month' },on:{"click":function (e) { return _vm.switchType('month'); }}},[_vm._v("月資料")])])]),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"time-container col-block"},[_c('div',{staticClass:"sub-option-title"},[_vm._v("日期起始與結束")]),_vm._v(" "),_c('div',{style:({ height: '5px' })}),_vm._v(" "),_c('div',{staticClass:"time-block col-block input-group"},[((_vm.filterConditions.type)==='checkbox')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterConditions.start),expression:"filterConditions.start"}],attrs:{"placeholder":'請選擇起始' + { date: '日', month: '月' }[_vm.filterConditions.type],"max":_vm.startDefaultMax,"min":_vm.startDefaultMin,"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.filterConditions.start)?_vm._i(_vm.filterConditions.start,null)>-1:(_vm.filterConditions.start)},on:{"change":function($event){var $$a=_vm.filterConditions.start,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.filterConditions, "start", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.filterConditions, "start", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.filterConditions, "start", $$c)}}}}):((_vm.filterConditions.type)==='radio')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterConditions.start),expression:"filterConditions.start"}],attrs:{"placeholder":'請選擇起始' + { date: '日', month: '月' }[_vm.filterConditions.type],"max":_vm.startDefaultMax,"min":_vm.startDefaultMin,"type":"radio"},domProps:{"checked":_vm._q(_vm.filterConditions.start,null)},on:{"change":function($event){_vm.$set(_vm.filterConditions, "start", null)}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterConditions.start),expression:"filterConditions.start"}],attrs:{"placeholder":'請選擇起始' + { date: '日', month: '月' }[_vm.filterConditions.type],"max":_vm.startDefaultMax,"min":_vm.startDefaultMin,"type":_vm.filterConditions.type},domProps:{"value":(_vm.filterConditions.start)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filterConditions, "start", $event.target.value)}}}),_vm._v(" "),_c('div',{style:({ height: '5px' })}),_vm._v(" "),((_vm.filterConditions.type)==='checkbox')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterConditions.end),expression:"filterConditions.end"}],attrs:{"placeholder":'請選擇結束' + { date: '日', month: '月' }[_vm.filterConditions.type],"max":_vm.endDefaultMax,"min":_vm.endDefaultMin,"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.filterConditions.end)?_vm._i(_vm.filterConditions.end,null)>-1:(_vm.filterConditions.end)},on:{"change":function($event){var $$a=_vm.filterConditions.end,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.filterConditions, "end", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.filterConditions, "end", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.filterConditions, "end", $$c)}}}}):((_vm.filterConditions.type)==='radio')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterConditions.end),expression:"filterConditions.end"}],attrs:{"placeholder":'請選擇結束' + { date: '日', month: '月' }[_vm.filterConditions.type],"max":_vm.endDefaultMax,"min":_vm.endDefaultMin,"type":"radio"},domProps:{"checked":_vm._q(_vm.filterConditions.end,null)},on:{"change":function($event){_vm.$set(_vm.filterConditions, "end", null)}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterConditions.end),expression:"filterConditions.end"}],attrs:{"placeholder":'請選擇結束' + { date: '日', month: '月' }[_vm.filterConditions.type],"max":_vm.endDefaultMax,"min":_vm.endDefaultMin,"type":_vm.filterConditions.type},domProps:{"value":(_vm.filterConditions.end)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filterConditions, "end", $event.target.value)}}})])]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"description-container col-block"},[_c('div',{staticClass:"description-block col-block",domProps:{"innerHTML":_vm._s([
                '<span>日資料選取區間，最大選擇資料筆數為90日；月資料選取區間，最大選擇資料筆數為60個月。</span>',
                '',
                '<span>平台收集之數據為過去5年歷史資料，目前更新到' + _vm.dateFormat(new Date((this.source['NOAA'] + '').replace(/(?!^)(?=(\d{2})+$)/g, '-').replace('-', '')), 'yyyy/MM/dd') + '，若需即時數據，請拜訪<a class=\'link\' href=\'https://www.ncdc.noaa.gov/cdo-web/search\' target=\'_blank\'>NOAA</a>或其他氣候數據平台。</span>' ].join('<br>'))}})]),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"button-container col-block"},[_c('button',{staticClass:"main-button",attrs:{"type":"button","name":"button"},on:{"click":function (e) { return _vm.filterOnChange(); }}},[_c('span',[_vm._v("繪圖")])])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])]),_vm._v(" "),_c('div',[_c('div',{style:({ width: '20px' })})]),_vm._v(" "),_c('div',{staticClass:"graph-chart-container col-blcok",style:({ flex: 1, width: 0 })},[_c('div',{staticClass:"graph-chart-field col-block",style:({ height: '100%' })},[_c('div',{staticClass:"option-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"option-block row-block"},[_c('div',{staticClass:"option row-block input-group"},[_c('div',{staticClass:"option-title"},[_vm._v("字體")]),_vm._v(" "),_c('div',{style:({ width: '8.5px' })}),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.fontSize),expression:"fontSize"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.fontSize=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"14"}},[_vm._v("小")]),_vm._v(" "),_c('option',{attrs:{"value":"16"}},[_vm._v("中")]),_vm._v(" "),_c('option',{attrs:{"value":"20"}},[_vm._v("大")])])])]),_vm._v(" "),_c('div',{style:({ width: '15px' })}),_vm._v(" "),_c('div',{staticClass:"button-block row-block"},[_c('button',{staticClass:"main-button option-button update",attrs:{"type":"button","name":"button","disabled":false},on:{"click":function (e) { return _vm.downloadData(); }}},[_c('span',[_vm._v("氣候數據下載")])]),_vm._v(" "),_c('div',{style:({ width: '15px' })}),_vm._v(" "),_c('button',{staticClass:"main-button option-button update",attrs:{"type":"button","name":"button","disabled":false},on:{"click":function (e) { return _vm.downloadGraph(); }}},[_c('span',[_vm._v("另存圖檔")])])])]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"graph-chart-block",style:({ flex: 1 })},[_c('div',{ref:"chartField",staticClass:"chart-field",style:({ '--chart-font-size': _vm.fontSize + 'px' })},[((_vm.summarys && _vm.summarys.length) || (!_vm.graphConditions.start || !_vm.graphConditions.end))?_c('div',{staticClass:"chart-block col-block"},[_c('div',{staticClass:"data-block col-block"},[_c('div',{staticClass:"row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',[_c('b',{domProps:{"innerHTML":_vm._s([
                        _vm.getCountryTitle() + ' ' + (_vm.curStation || {}).name + ' 之氣溫與降雨量統計圖',
                        _vm.getDateRange(true) ].join('<br>'))}})]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{staticClass:"row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"chart-block"},[(_vm.state === 'station')?_c('vueCharts',{ref:"chart",attrs:{"options":_vm.chartOptions,"autoresize":true}}):_vm._e()],1),_vm._v(" "),_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"description-block row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_vm._m(0)])]):(_vm.summarys)?_c('div',{staticClass:"chart-empty"},[_vm._v(_vm._s('沒有資料呈現，因為NOAA未收錄[' + (_vm.curStation || {}).name + ']\n' + _vm.getDateRange() + ' 氣溫與雨量資料'))]):_c('div',{staticClass:"chart-empty"},[_vm._v(_vm._s('沒有資料呈現，因為NOAA未收錄[' + (_vm.curStation || {}).name + ']\n2001~2020年 氣溫與雨量資料'))])])])])])])]:_vm._e()],2)}
var weather_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-block"},[_c('div',{staticClass:"content"},[_vm._v("資料來源：NOAA 美國國家海洋暨大氣總署")]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("農業部農業試驗所")])])}]
var weather_esExports = { render: weather_render, staticRenderFns: weather_staticRenderFns }
/* harmony default export */ var analysis_weather = (weather_esExports);
// CONCATENATED MODULE: ./src/components/analysis/weather.vue
function weather_injectStyle (ssrContext) {
  __webpack_require__("6uzY")
}
var weather_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var weather___vue_template_functional__ = false
/* styles */
var weather___vue_styles__ = weather_injectStyle
/* scopeId */
var weather___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var weather___vue_module_identifier__ = null
var weather_Component = weather_normalizeComponent(
  weather,
  analysis_weather,
  weather___vue_template_functional__,
  weather___vue_styles__,
  weather___vue_scopeId__,
  weather___vue_module_identifier__
)

/* harmony default export */ var components_analysis_weather = (weather_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/analysis/station.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var station = ({
  components: {
    analysisWeather: components_analysis_weather
  },
  props: {
    dataType: {
      type: String,
      required: true
    },
    country: {
      Type: Object,
      default: function _default() {
        return null;
      }
    },
    state: {
      type: String,
      required: true
    },
    filterOptions: {
      type: Object,
      required: true
    },
    conditions: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      tab: 'weather'
    };
  },

  computed: {
    analysisType: function analysisType() {
      return this.$route.name;
    },

    // static
    tabOptions: function tabOptions() {
      return [{
        title: '天氣',
        value: 'weather'
      }];
    }
  },
  methods: {
    getFilterTitle: function getFilterTitle(value) {
      var _this = this;

      if (!this.conditions.filters[value]) {
        return '';
      }
      return this.filterOptions.filters.find(function (filter) {
        return filter.value === value;
      }).options.find(function (option) {
        return option.value === _this.conditions.filters[value];
      }).title;
    },
    getCountryTitle: function getCountryTitle() {
      if (!this.country) {
        return '';
      }
      return { competitiveness: this.country.country_name, attraction: this.country.partner_name, toolcompetitiveness: this.country.country_name, toolattraction: this.country.partner_name }[this.analysisType];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24c77a04","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/analysis/station.vue
var station_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"analysis-station-page col-block"},[_c('div',{staticClass:"option-container row-block"},[_c('div',{staticClass:"data-block row-block"},[(_vm.conditions.filters.product)?[_c('div',[_c('b',[_vm._v("品項：")]),_vm._v(_vm._s(_vm.getFilterTitle('product')))]),_vm._v(" "),_c('div',{style:({ width: '50px' })})]:_vm._e(),_vm._v(" "),(_vm.conditions.filters.country)?[_c('div',[_c('b',[_vm._v("目標市場：")]),_vm._v(_vm._s(_vm.getFilterTitle('country')))]),_vm._v(" "),_c('div',{style:({ width: '50px' })})]:_vm._e(),_vm._v(" "),(_vm.dataType === 'country' && _vm.conditions.filters.year)?[_c('div',[_c('b',[_vm._v("數據年份：")]),_vm._v(_vm._s(_vm.getFilterTitle('year')))]),_vm._v(" "),_c('div',{style:({ width: '50px' })})]:_vm._e(),_vm._v(" "),(_vm.dataType === 'year' && _vm.country)?[_c('div',[_c('b',[_vm._v(_vm._s({ competitiveness: '競爭國家', attraction: '市場國家', toolcompetitiveness: '競爭國家', toolattraction: '市場國家' }[_vm.analysisType])+"：")]),_vm._v(_vm._s(_vm.getCountryTitle()))]),_vm._v(" "),_c('div',{style:({ width: '50px' })})]:_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"content-container row-block",style:({ flex: 1 })},[_c('div',{staticClass:"content-tab-container col-block",style:({ width: '48px' })},[_vm._l((_vm.tabOptions),function(option,index){return _c('div',{key:index,staticClass:"content-tab-block center-block",class:{ active: _vm.tab === option.value }},[_vm._v(_vm._s(option.title))])}),_vm._v(" "),_c('div',{style:({ flex: 1 })})],2),_vm._v(" "),_c('div',{staticClass:"main-container",style:({ flex: 1 })},[_c('analysisWeather',{directives:[{name:"show",rawName:"v-show",value:(_vm.tab === 'weather'),expression:"tab === 'weather'"}],attrs:{"dataType":_vm.dataType,"country":_vm.country,"state":_vm.state,"filterOptions":_vm.filterOptions,"conditions":_vm.conditions}})],1)])])}
var station_staticRenderFns = []
var station_esExports = { render: station_render, staticRenderFns: station_staticRenderFns }
/* harmony default export */ var analysis_station = (station_esExports);
// CONCATENATED MODULE: ./src/components/analysis/station.vue
var station_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var station___vue_template_functional__ = false
/* styles */
var station___vue_styles__ = null
/* scopeId */
var station___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var station___vue_module_identifier__ = null
var station_Component = station_normalizeComponent(
  station,
  analysis_station,
  station___vue_template_functional__,
  station___vue_styles__,
  station___vue_scopeId__,
  station___vue_module_identifier__
)

/* harmony default export */ var components_analysis_station = (station_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/analysis/tutorial.vue
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var analysis_tutorial = ({
  components: {
    tutorialMain: src_components_tutorial_main
  },
  computed: {
    analysisType: function analysisType() {
      return this.$route.name;
    },
    tutorialType: function tutorialType() {
      return {
        competitiveness: 'normal',
        attraction: 'normal',
        toolcompetitiveness: 'tool',
        toolattraction: 'tool'
      }[this.analysisType];
    },

    // static
    renderItem: function renderItem() {
      return {
        competitiveness: {
          '市場競爭力分析': true,
          '市場競爭力操作教學說明': true
        },
        attraction: {
          '市場吸引力分析': true,
          '市場吸引力操作教學說明': true
        },
        toolcompetitiveness: {
          '市場競爭力分析': true,
          '市場競爭力操作教學說明': true
        },
        toolattraction: {
          '市場吸引力分析': true,
          '市場吸引力操作教學說明': true
        }
      }[this.analysisType];
    },
    display: function display() {
      return {
        competitiveness: {
          '市場競爭力分析': false,
          '市場競爭力操作教學說明': true
        },
        attraction: {
          '市場吸引力分析': false,
          '市場吸引力操作教學說明': true
        },
        toolcompetitiveness: {
          '市場競爭力分析': false,
          '市場競爭力操作教學說明': true
        },
        toolattraction: {
          '市場吸引力分析': false,
          '市場吸引力操作教學說明': true
        }
      }[this.analysisType];
    },
    toggle: function toggle() {
      return {
        competitiveness: {},
        attraction: {},
        toolcompetitiveness: {},
        toolattraction: {}
      }[this.analysisType];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-683e1f70","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/analysis/tutorial.vue
var analysis_tutorial_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"analysis-tutorial-page col-block",style:({ height: '100%', width: '100%', 'min-width': '1350px' })},[_c('tutorialMain',{attrs:{"type":_vm.tutorialType,"params":{
      renderItem: _vm.renderItem,
      display: _vm.display,
      toggle: _vm.toggle
    }}})],1)}
var analysis_tutorial_staticRenderFns = []
var analysis_tutorial_esExports = { render: analysis_tutorial_render, staticRenderFns: analysis_tutorial_staticRenderFns }
/* harmony default export */ var components_analysis_tutorial = (analysis_tutorial_esExports);
// CONCATENATED MODULE: ./src/components/analysis/tutorial.vue
var analysis_tutorial_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var analysis_tutorial___vue_template_functional__ = false
/* styles */
var analysis_tutorial___vue_styles__ = null
/* scopeId */
var analysis_tutorial___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var analysis_tutorial___vue_module_identifier__ = null
var analysis_tutorial_Component = analysis_tutorial_normalizeComponent(
  analysis_tutorial,
  components_analysis_tutorial,
  analysis_tutorial___vue_template_functional__,
  analysis_tutorial___vue_styles__,
  analysis_tutorial___vue_scopeId__,
  analysis_tutorial___vue_module_identifier__
)

/* harmony default export */ var src_components_analysis_tutorial = (analysis_tutorial_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/analysis/panel.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var analysis_panel = ({
  components: {
    analysisTable: src_components_analysis_table,
    analysisGraph: src_components_analysis_graph,
    analysisReport: src_components_analysis_report,
    analysisStation: components_analysis_station,
    analysisTutorial: src_components_analysis_tutorial,
    tabButtons: components_tool_tabButtons
  },
  props: {
    dataType: {
      type: String,
      required: true
    },
    country: {
      Type: Object,
      default: function _default() {
        return null;
      }
    },
    minHeight: {
      type: String,
      default: function _default() {
        return null;
      }
    },
    datas: {
      type: Array,
      required: true
    },
    tab: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    reportCountrys: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    filterOptions: {
      type: Object,
      required: true
    },
    conditions: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      state: this.tab || 'table',
      tableDatas: [],
      selectedDatas: [],
      isComponentLoaded: {
        station: false
      }
    };
  },

  computed: {
    // static
    tabOptions: function tabOptions() {
      return [{
        title: '數據結果',
        value: 'table'
      }, {
        title: '統計圖呈現',
        value: 'graph'
      }].concat(toConsumableArray_default()(['year'].includes(this.dataType) && this.country.hasReport ? [{
        title: '分析報告',
        value: 'report'
      }] : []), toConsumableArray_default()(['year'].includes(this.dataType) ? [{
        title: '國家概況',
        value: 'station'
      }] : []));
    }
  },
  watch: {
    'state': function state(nv) {
      this.isComponentLoaded[nv] = true;
      this.$emit('changeState', nv);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ae7cdd8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/analysis/panel.vue
var analysis_panel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"analysis-panel-page col-block",style:({ height: _vm.minHeight || '100%' })},[(_vm.datas.length)?_c('div',{staticClass:"main-container container-block col-block"},[_c('div',{staticClass:"tab-block"},[_c('tabButtons',{attrs:{"state":_vm.state,"options":_vm.tabOptions},on:{"change":function (s) { return _vm.state = s; }}})],1),_vm._v(" "),_c('div',{staticClass:"main-block",style:({ flex: 1 })},[_c('analysisTable',{directives:[{name:"show",rawName:"v-show",value:(_vm.state === 'table'),expression:"state === 'table'"}],attrs:{"dataType":_vm.dataType,"country":_vm.country,"datas":_vm.datas,"curSelectedDatas":_vm.selectedDatas,"reportCountrys":_vm.reportCountrys || [],"state":_vm.state,"filterOptions":_vm.filterOptions,"conditions":_vm.conditions},on:{"allDatas":function (datas) { return _vm.tableDatas = datas; },"dataChange":function (datas) { return _vm.selectedDatas = datas; }}}),_vm._v(" "),_c('analysisGraph',{directives:[{name:"show",rawName:"v-show",value:(_vm.state === 'graph'),expression:"state === 'graph'"}],attrs:{"dataType":_vm.dataType,"country":_vm.country,"tableDatas":_vm.tableDatas,"curSelectedDatas":_vm.selectedDatas,"state":_vm.state,"filterOptions":_vm.filterOptions,"conditions":_vm.conditions},on:{"dataChange":function (datas) { return _vm.selectedDatas = datas; }}}),_vm._v(" "),(['year'].includes(_vm.dataType) && _vm.country.hasReport)?_c('analysisReport',{directives:[{name:"show",rawName:"v-show",value:(_vm.state === 'report'),expression:"state === 'report'"}],attrs:{"dataType":_vm.dataType,"country":_vm.country,"state":_vm.state,"filterOptions":_vm.filterOptions,"conditions":_vm.conditions}}):_vm._e(),_vm._v(" "),(['year'].includes(_vm.dataType) && (_vm.state === 'station' || _vm.isComponentLoaded.station))?_c('analysisStation',{directives:[{name:"show",rawName:"v-show",value:(_vm.state === 'station'),expression:"state === 'station'"}],attrs:{"dataType":_vm.dataType,"country":_vm.country,"state":_vm.state,"filterOptions":_vm.filterOptions,"conditions":_vm.conditions}}):_vm._e()],1)]):(['country'].includes(_vm.dataType))?_c('div',{staticClass:"tutorial-container container-block"},[_c('analysisTutorial')],1):_vm._e()])}
var analysis_panel_staticRenderFns = []
var analysis_panel_esExports = { render: analysis_panel_render, staticRenderFns: analysis_panel_staticRenderFns }
/* harmony default export */ var components_analysis_panel = (analysis_panel_esExports);
// CONCATENATED MODULE: ./src/components/analysis/panel.vue
var analysis_panel_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var analysis_panel___vue_template_functional__ = false
/* styles */
var analysis_panel___vue_styles__ = null
/* scopeId */
var analysis_panel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var analysis_panel___vue_module_identifier__ = null
var analysis_panel_Component = analysis_panel_normalizeComponent(
  analysis_panel,
  components_analysis_panel,
  analysis_panel___vue_template_functional__,
  analysis_panel___vue_styles__,
  analysis_panel___vue_scopeId__,
  analysis_panel___vue_module_identifier__
)

/* harmony default export */ var src_components_analysis_panel = (analysis_panel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/analysis.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var analysis = ({
  components: {
    analysisPanel: src_components_analysis_panel
  },
  mixins: [mixins_routeLoading, toastMethods["a" /* default */]],
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      datas: [],
      onSearch: false
    };
  },

  computed: {
    analysisType: function analysisType() {
      return this.$route.name;
    }
  },
  methods: {
    fetchData: function fetchData() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.fetchDatas();

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    fetchDatas: function fetchDatas() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var api, config, country, conditions, response, datas;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                api = {
                  competitiveness: src_api["n" /* getCompetitivenessDatas */],
                  attraction: src_api["m" /* getAttractionDatas */],
                  toolcompetitiveness: src_api["n" /* getCompetitivenessDatas */],
                  toolattraction: src_api["m" /* getAttractionDatas */]
                }[_this2.analysisType];
                config = _this2.$ls.get('userInfo');
                country = {
                  competitiveness: _this2.param.country.country_code,
                  attraction: _this2.param.country.partner_code,
                  toolcompetitiveness: _this2.param.country.country_code,
                  toolattraction: _this2.param.country.partner_code
                }[_this2.analysisType];
                conditions = {
                  competitiveness: {
                    product: _this2.param.conditions.filters.product,
                    country: country,
                    partner: _this2.param.conditions.filters.country
                  },
                  attraction: {
                    product: _this2.param.conditions.filters.product,
                    partner: country
                  },
                  toolcompetitiveness: {
                    product: _this2.param.conditions.filters.product,
                    country: country,
                    partner: _this2.param.conditions.filters.country
                  },
                  toolattraction: {
                    product: _this2.param.conditions.filters.product,
                    partner: country
                  }
                }[_this2.analysisType];
                _context2.next = 7;
                return api(conditions, config);

              case 7:
                response = _context2.sent;
                datas = response.data;

                _this2.datas = datas;
                _context2.next = 15;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2['catch'](0);

                _this2.datas = [];

              case 15:
                _this2.onSearch = false;

              case 16:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 12]]);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28238206","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/analysis.vue
var analysis_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"analysis-dailog container-block col-block"},[_c('div',{staticClass:"title-container row-block default-shadow"},[_c('div',{staticClass:"row-block",style:({ width: '35px' })}),_vm._v(" "),_c('div',{staticClass:"title",domProps:{"innerHTML":_vm._s({
        competitiveness: '單一競爭國之市場競爭力歷年分數表',
        attraction: '單一國家之吸引力指標歷年分數表',
        toolcompetitiveness: '單一競爭國之農業機械市場競爭力歷年分數表',
        toolattraction: '單一國家之農業機械吸引力指標歷年分數表'
      }[_vm.analysisType])}}),_vm._v(" "),_c('div',{staticClass:"row-block close-button",style:({ width: '35px' })},[_c('img',{attrs:{"src":__webpack_require__("IREq")},on:{"click":function (e) { return _vm.$emit('changeModal'); }}})])]),_vm._v(" "),_c('div',{staticClass:"panel-container",style:({ flex: 1 })},[(_vm.onSearch)?_c('div',{staticClass:"mask center-block"},[_c('img',{attrs:{"src":__webpack_require__("5xS/"),"alt":""}})]):_vm._e(),_vm._v(" "),_c('analysisPanel',{attrs:{"dataType":'year',"country":_vm.param.country,"datas":_vm.datas,"tab":_vm.param.tab,"filterOptions":_vm.param.filterOptions,"conditions":_vm.param.conditions}})],1)])}
var analysis_staticRenderFns = []
var analysis_esExports = { render: analysis_render, staticRenderFns: analysis_staticRenderFns }
/* harmony default export */ var dialog_analysis = (analysis_esExports);
// CONCATENATED MODULE: ./src/components/dialog/analysis.vue
var analysis_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var analysis___vue_template_functional__ = false
/* styles */
var analysis___vue_styles__ = null
/* scopeId */
var analysis___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var analysis___vue_module_identifier__ = null
var analysis_Component = analysis_normalizeComponent(
  analysis,
  dialog_analysis,
  analysis___vue_template_functional__,
  analysis___vue_styles__,
  analysis___vue_scopeId__,
  analysis___vue_module_identifier__
)

/* harmony default export */ var components_dialog_analysis = (analysis_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/tool/customRowForm.vue





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var customRowForm = ({
  props: {
    forms: {
      type: Array,
      required: true
    },
    init: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    alerts: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    disabled: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    scope: {
      type: String,
      default: function _default() {
        return 'form';
      }
    }
  },
  data: function data() {
    return {
      result: {},
      output: {},
      display: true
    };
  },

  watch: {
    'forms': function forms() {},
    'init': function init() {
      this.initialResults();
    },

    'result': {
      handler: function () {
        var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
          return regenerator_default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return this.afterTreatment(this.result);

                case 2:
                  this.output = _context.sent;

                  this.$emit('change', this.output, this.$validator, this.errors);

                case 4:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function handler() {
          return _ref.apply(this, arguments);
        }

        return handler;
      }(),
      deep: true
    }
  },
  created: function created() {
    this.initialResults();
  },

  methods: {
    initialResults: function initialResults() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var input, initials;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this.preTreatment(_this.init);

              case 2:
                input = _context2.sent;
                initials = {
                  input: '',
                  password: '',
                  textarea: '',
                  boolean: false,
                  select: '',
                  datalist: '',
                  single: '',
                  multiple: [],
                  number: '',
                  date: '',
                  time: '',
                  datetime: '',
                  file: [],
                  text: ''
                };

                _this.result = _this.forms.reduce(function (s, c) {
                  return extends_default()({}, s, c.value ? defineProperty_default()({}, c.value, input[c.value] !== null && input[c.value] !== undefined ? input[c.value] : initials[c.type]) : {});
                }, {});

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    },
    preTreatment: function preTreatment(init) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var input, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, form;

        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                input = {};
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context4.prev = 4;
                _iterator = get_iterator_default()(_this2.forms);

              case 6:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context4.next = 16;
                  break;
                }

                form = _step.value;
                _context4.t0 = form.value;

                if (!_context4.t0) {
                  _context4.next = 13;
                  break;
                }

                _context4.next = 12;
                return (form.inputFormat || function () {
                  var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3(x) {
                    return regenerator_default.a.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            return _context3.abrupt('return', x);

                          case 1:
                          case 'end':
                            return _context3.stop();
                        }
                      }
                    }, _callee3, _this2);
                  }));

                  return function (_x) {
                    return _ref3.apply(this, arguments);
                  };
                }())(init[form.value], form);

              case 12:
                input[form.value] = _context4.sent;

              case 13:
                _iteratorNormalCompletion = true;
                _context4.next = 6;
                break;

              case 16:
                _context4.next = 22;
                break;

              case 18:
                _context4.prev = 18;
                _context4.t1 = _context4['catch'](4);
                _didIteratorError = true;
                _iteratorError = _context4.t1;

              case 22:
                _context4.prev = 22;
                _context4.prev = 23;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 25:
                _context4.prev = 25;

                if (!_didIteratorError) {
                  _context4.next = 28;
                  break;
                }

                throw _iteratorError;

              case 28:
                return _context4.finish(25);

              case 29:
                return _context4.finish(22);

              case 30:
                return _context4.abrupt('return', input);

              case 31:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this2, [[4, 18, 22, 30], [23,, 25, 29]]);
      }))();
    },
    afterTreatment: function afterTreatment(result) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
        var output, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, form;

        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                output = {};
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context6.prev = 4;
                _iterator2 = get_iterator_default()(_this3.forms);

              case 6:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context6.next = 16;
                  break;
                }

                form = _step2.value;
                _context6.t0 = form.value;

                if (!_context6.t0) {
                  _context6.next = 13;
                  break;
                }

                _context6.next = 12;
                return (form.outputFormat || function () {
                  var _ref4 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5(x) {
                    return regenerator_default.a.wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            return _context5.abrupt('return', x);

                          case 1:
                          case 'end':
                            return _context5.stop();
                        }
                      }
                    }, _callee5, _this3);
                  }));

                  return function (_x2) {
                    return _ref4.apply(this, arguments);
                  };
                }())(result[form.value], form);

              case 12:
                output[form.value] = _context6.sent;

              case 13:
                _iteratorNormalCompletion2 = true;
                _context6.next = 6;
                break;

              case 16:
                _context6.next = 22;
                break;

              case 18:
                _context6.prev = 18;
                _context6.t1 = _context6['catch'](4);
                _didIteratorError2 = true;
                _iteratorError2 = _context6.t1;

              case 22:
                _context6.prev = 22;
                _context6.prev = 23;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 25:
                _context6.prev = 25;

                if (!_didIteratorError2) {
                  _context6.next = 28;
                  break;
                }

                throw _iteratorError2;

              case 28:
                return _context6.finish(25);

              case 29:
                return _context6.finish(22);

              case 30:
                return _context6.abrupt('return', output);

              case 31:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this3, [[4, 18, 22, 30], [23,, 25, 29]]);
      }))();
    },
    datalistOnChange: function datalistOnChange(form, result) {
      setTimeout(function () {
        return (form.onChange || function () {})(result[form.value]);
      }, 50);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c4f2baaa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/customRowForm.vue
var customRowForm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"custom-row-form-container"}},_vm._l((_vm.forms.filter(function (form) { return form.display ? form.display(_vm.result) : true; })),function(form,index){return _c('div',{key:index,staticClass:"form-group",style:(form.width ? { flexBasis: form.width } : { flex: form.flex || 1 })},[_c('div',[(_vm.display)?_c('form',{attrs:{"data-vv-scope":_vm.scope}},[(form.type || form.title)?_c('div',[(form.title)?_c('div',{staticClass:"label row-block"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(form.title))]),_vm._v(" "),_c('div',{style:({ width: '2px' })}),_vm._v(" "),(form.validate && form.validate.includes('required'))?_c('span',{staticClass:"required"},[_vm._v(_vm._s((form.requiredMsg || (function () { return '*'; }))(form)))]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"description"},[_vm._v(_vm._s(form.description))]),_vm._v(" "),_c('span',{staticClass:"invisible"},[_vm._v(_vm._s(form.invisible))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]):_vm._e(),_vm._v(" "),(form.type && _vm.result[form.value] !== undefined)?_c('div',{staticClass:"options",class:[form.type],style:({ flex: 1 })},[(form.type === 'input')?[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.result[form.value]),expression:"result[form.value]"},{name:"validate",rawName:"v-validate",value:(form.validate),expression:"form.validate"}],attrs:{"type":"text","id":form.value,"name":form.value,"tabindex":form.tabindex,"disabled":_vm.disabled || (form.disabled || (function () { return false; }))(_vm.result),"placeholder":(form.placeholder || (function () { return ''; }))(form)},domProps:{"value":(_vm.result[form.value])},on:{"change":function (e) { return (form.onChange || (function () {}))(_vm.result[form.value]); },"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.result, form.value, $event.target.value)}}})])]:(form.type === 'password')?[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.result[form.value]),expression:"result[form.value]"},{name:"validate",rawName:"v-validate",value:(form.validate),expression:"form.validate"}],attrs:{"type":"password","id":form.value,"name":form.value,"tabindex":form.tabindex,"disabled":_vm.disabled || (form.disabled || (function () { return false; }))(_vm.result),"placeholder":(form.placeholder || (function () { return ''; }))(form)},domProps:{"value":(_vm.result[form.value])},on:{"change":function (e) { return (form.onChange || (function () {}))(_vm.result[form.value]); },"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.result, form.value, $event.target.value)}}})])]:(form.type === 'textarea')?[_c('div',{staticClass:"input-group"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.result[form.value]),expression:"result[form.value]"},{name:"validate",rawName:"v-validate",value:(form.validate),expression:"form.validate"}],attrs:{"id":form.value,"name":form.value,"tabindex":form.tabindex,"rows":form.row,"disabled":_vm.disabled || (form.disabled || (function () { return false; }))(_vm.result),"placeholder":(form.placeholder || (function () { return ''; }))(form)},domProps:{"value":(_vm.result[form.value])},on:{"change":function (e) { return (form.onChange || (function () {}))(_vm.result[form.value]); },"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.result, form.value, $event.target.value)}}})])]:(form.type === 'select')?[_c('div',{staticClass:"input-group"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.result[form.value]),expression:"result[form.value]"},{name:"validate",rawName:"v-validate",value:(form.validate),expression:"form.validate"}],style:(form.style ? form.style(_vm.result[form.value]) : _vm.result[form.value] ? {} : { color: '#777777' }),attrs:{"id":form.value,"name":form.value,"tabindex":form.tabindex,"disabled":_vm.disabled || (form.disabled || (function () { return false; }))(_vm.result)},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.result, form.value, $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[(form.placeholder)?_c('option',{attrs:{"value":"","disabled":""}},[_vm._v(_vm._s(form.placeholder(form)))]):_vm._e(),_vm._v(" "),_vm._l((form.options),function(option,index){return _c('option',{key:index,style:(option.style || {}),attrs:{"disabled":option.disabled},domProps:{"value":option.value || ''}},[_vm._v(_vm._s(option.title))])})],2)])]:_vm._e(),_vm._v(" "),(form.type === 'datalist')?[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.result[form.value]),expression:"result[form.value]"},{name:"validate",rawName:"v-validate",value:(form.validate),expression:"form.validate"}],attrs:{"type":"text","autocomplete":"off","id":form.value,"name":form.value,"list":form.value + '-list',"tabindex":form.tabindex,"disabled":_vm.disabled || (form.disabled || (function () { return false; }))(_vm.result),"placeholder":(form.placeholder || (function () { return ''; }))(form)},domProps:{"value":(_vm.result[form.value])},on:{"change":function (e) { return _vm.datalistOnChange(form, _vm.result); },"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.result, form.value, $event.target.value)}}}),_vm._v(" "),(form.customList)?[(form.lists && form.lists.length)?_c('div',{staticClass:"datalist"},_vm._l((form.lists),function(option,index){return _c('div',{key:index,staticClass:"option",on:{"click":function (e) { return _vm.result[form.value] = option; }}},[_vm._v(_vm._s(option))])}),0):_vm._e()]:[(form.lists && form.lists.length)?_c('datalist',{attrs:{"id":form.value + '-list'}},_vm._l((form.lists),function(option,index){return _c('option',{key:index},[_vm._v(_vm._s(option))])}),0):_vm._e()]],2)]:(form.type === 'boolean')?[_c('div',{staticClass:"input-group"},[_c('label',{class:{ diabled: (form.disabled || (function () { return false; }))(_vm.result) },attrs:{"for":form.value}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.result[form.value]),expression:"result[form.value]"},{name:"validate",rawName:"v-validate",value:(form.validate),expression:"form.validate"}],attrs:{"type":"checkbox","id":form.value,"name":form.value,"tabindex":form.tabindex,"disabled":_vm.disabled || (form.disabled || (function () { return false; }))(_vm.result)},domProps:{"checked":Array.isArray(_vm.result[form.value])?_vm._i(_vm.result[form.value],null)>-1:(_vm.result[form.value])},on:{"change":function($event){var $$a=_vm.result[form.value],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.result, form.value, $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.result, form.value, $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.result, form.value, $$c)}}}})])])]:(form.type === 'single')?_vm._l((form.options),function(option,index){return _c('div',{key:index,staticClass:"input-group"},[_c('label',{class:{ diabled: (form.disabled || (function () { return false; }))(_vm.result) },attrs:{"for":form.value + '_' + option.value}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.result[form.value]),expression:"result[form.value]"},{name:"validate",rawName:"v-validate",value:(form.validate),expression:"form.validate"}],attrs:{"type":"radio","id":form.value + '_' + option.value,"name":form.value,"disabled":_vm.disabled || (form.disabled || (function () { return false; }))(_vm.result)},domProps:{"value":option.value,"checked":_vm._q(_vm.result[form.value],option.value)},on:{"change":function($event){_vm.$set(_vm.result, form.value, option.value)}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(option.title))])])])}):(form.type === 'multiple')?_vm._l((form.options),function(option,index){return _c('div',{key:index,staticClass:"input-group"},[_c('label',{class:{ diabled: (form.disabled || (function () { return false; }))(_vm.result) || form.range && ((form.range[0] === (_vm.result[form.value] || []).length && _vm.result[form.value].includes(option.value)) || (form.range[1] === (_vm.result[form.value] || []).length && !_vm.result[form.value].includes(option.value))) },attrs:{"for":form.value + '_' + option.value}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.result[form.value]),expression:"result[form.value]"},{name:"validate",rawName:"v-validate",value:(form.validate),expression:"form.validate"}],attrs:{"type":"checkbox","id":form.value + '_' + option.value,"name":form.value,"disabled":_vm.disabled || (form.disabled || (function () { return false; }))(_vm.result) || (form.range && ((form.range[0] === (_vm.result[form.value] || []).length && _vm.result[form.value].includes(option.value)) || (form.range[1] === (_vm.result[form.value] || []).length && !_vm.result[form.value].includes(option.value))))},domProps:{"value":option.value,"checked":Array.isArray(_vm.result[form.value])?_vm._i(_vm.result[form.value],option.value)>-1:(_vm.result[form.value])},on:{"change":function($event){var $$a=_vm.result[form.value],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=option.value,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.result, form.value, $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.result, form.value, $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.result, form.value, $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(option.title))])])])}):(form.type === 'number')?[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.result[form.value]),expression:"result[form.value]"},{name:"validate",rawName:"v-validate",value:(form.validate),expression:"form.validate"}],attrs:{"type":"number","id":form.value,"name":form.value,"tabindex":form.tabindex,"step":form.step,"min":form.range ? form.range[0] : null,"max":form.range ? form.range[1] : null,"disabled":_vm.disabled || (form.disabled || (function () { return false; }))(_vm.result),"placeholder":(form.placeholder || (function () { return ''; }))(form)},domProps:{"value":(_vm.result[form.value])},on:{"change":function (e) { return (form.onChange || (function () {}))(_vm.result[form.value]); },"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.result, form.value, $event.target.value)}}})])]:(form.type === 'date')?[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.result[form.value]),expression:"result[form.value]"},{name:"validate",rawName:"v-validate",value:(form.validate),expression:"form.validate"}],style:(_vm.result[form.value] ? {} : { color: '#777777' }),attrs:{"type":"date","id":form.value,"name":form.value,"tabindex":form.tabindex,"min":form.range ? form.range[0] : null,"max":form.range ? form.range[1] : '9999-12-31',"disabled":_vm.disabled || (form.disabled || (function () { return false; }))(_vm.result),"placeholder":(form.placeholder || (function () { return ''; }))(form)},domProps:{"value":(_vm.result[form.value])},on:{"change":function (e) { return (form.onChange || (function () {}))(_vm.result[form.value]); },"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.result, form.value, $event.target.value)}}})])]:(form.type === 'time')?[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.result[form.value]),expression:"result[form.value]"},{name:"validate",rawName:"v-validate",value:(form.validate),expression:"form.validate"}],style:(_vm.result[form.value] ? {} : { color: '#777777' }),attrs:{"type":"time","id":form.value,"name":form.value,"tabindex":form.tabindex,"step":form.step,"min":form.range ? form.range[0] : null,"max":form.range ? form.range[1] : null,"disabled":_vm.disabled || (form.disabled || (function () { return false; }))(_vm.result),"placeholder":(form.placeholder || (function () { return ''; }))(form)},domProps:{"value":(_vm.result[form.value])},on:{"change":function (e) { return (form.onChange || (function () {}))(_vm.result[form.value]); },"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.result, form.value, $event.target.value)}}})])]:(form.type === 'datetime')?[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.result[form.value]),expression:"result[form.value]"},{name:"validate",rawName:"v-validate",value:(form.validate),expression:"form.validate"}],style:(_vm.result[form.value] ? {} : { color: '#777777' }),attrs:{"type":"datetime-local","id":form.value,"name":form.value,"tabindex":form.tabindex,"step":form.step,"min":form.range ? form.range[0] : null,"max":form.range ? form.range[1] : null,"disabled":_vm.disabled || (form.disabled || (function () { return false; }))(_vm.result),"placeholder":(form.placeholder || (function () { return ''; }))(form)},domProps:{"value":(_vm.result[form.value])},on:{"change":function (e) { return (form.onChange || (function () {}))(_vm.result[form.value]); },"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.result, form.value, $event.target.value)}}})])]:(form.type === 'file')?[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"},{name:"validate",rawName:"v-validate",value:(form.validate),expression:"form.validate"}],attrs:{"type":"file","id":form.value,"name":form.value,"multiple":form.multiple,"accept":form.accept,"disabled":_vm.disabled || (form.disabled || (function () { return false; }))(_vm.result)},on:{"change":function (e) { return e.target.files.length ? Array.from(e.target.files) : []; }}}),_vm._v(" "),_c('button',{attrs:{"tabindex":form.tabindex}},[_c('span',[_vm._v(_vm._s(form.text || 'select'))]),_vm._v(" "),_c('label',{class:{ diabled: (form.disabled || (function () { return false; }))(_vm.result) },attrs:{"for":form.value}})]),_vm._v(" "),(!_vm.$scopedSlots[form.value])?_vm._l((_vm.result[form.value] || []),function(file,index){return _c('div',{key:index},[_c('span',[_vm._v(_vm._s(file.name))])])}):_vm._e()],2)]:(form.type === 'text')?[_c('div',{staticClass:"input-group"},[_c('span',{style:((form.style || (function () { return ({}); }))(_vm.result[form.value]))},[_vm._v(_vm._s((form.displayText || (function (x) { return x; }))(_vm.result[form.value], form)))])])]:_vm._e(),_vm._v(" "),_c('div',{class:(_vm.alerts[form.value] || { type: 'error' }).type},[(_vm.alerts[form.value])?_c('span',[_vm._v(_vm._s(_vm.alerts[form.value].msg))]):(_vm.errors.has(_vm.scope + '.' + form.value) || form.error)?_c('span',[_vm._v(_vm._s((form.alert || (function () { return null; }))(form, _vm.errors.first(_vm.scope + '.' + form.value)) || (_vm.errors.first(_vm.scope + '.' + form.value) || form.error).replace(form.value, form.errorTitle || form.title)))]):_vm._e()])],2):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"custom",class:{ 'main-custom': !form.type && !form.title }},[(_vm.$scopedSlots[form.value])?_vm._t(form.value,null,{data:_vm.result,result:_vm.result[form.value],output:_vm.output[form.value],form:form}):_vm._e()],2)]):_vm._e()])])}),0)}
var customRowForm_staticRenderFns = []
var customRowForm_esExports = { render: customRowForm_render, staticRenderFns: customRowForm_staticRenderFns }
/* harmony default export */ var tool_customRowForm = (customRowForm_esExports);
// CONCATENATED MODULE: ./src/components/tool/customRowForm.vue
function customRowForm_injectStyle (ssrContext) {
  __webpack_require__("7Huh")
}
var customRowForm_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var customRowForm___vue_template_functional__ = false
/* styles */
var customRowForm___vue_styles__ = customRowForm_injectStyle
/* scopeId */
var customRowForm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var customRowForm___vue_module_identifier__ = null
var customRowForm_Component = customRowForm_normalizeComponent(
  customRowForm,
  tool_customRowForm,
  customRowForm___vue_template_functional__,
  customRowForm___vue_styles__,
  customRowForm___vue_scopeId__,
  customRowForm___vue_module_identifier__
)

/* harmony default export */ var components_tool_customRowForm = (customRowForm_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/editProductPrice.vue











//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var dialog_editProductPrice = ({
  components: {
    customRowForm: components_tool_customRowForm
  },
  mixins: [mixins_routeLoading, toastMethods["a" /* default */]],
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      productPrice: {
        date: '',
        kind: '',
        crop_name: '',
        user_name: '',
        country: '',
        product_name: '',
        packing_method: '',
        price: '',
        quantity: '',
        quantity_unit_category: '',
        quantity_unit: '',
        currency: '',
        currency_other: '',
        exchange_rate: '',
        market_kind: '',
        market_name: '',
        market_country: '',
        notes: '',
        // custom
        _FILES: ''
      },
      defaultData: {},
      // options
      cropDatas: [],
      currencyOthers: [],
      // files
      files: [],
      addFiles: [],
      removeFileIDs: [],
      // form
      alerts: {},
      result: {},
      validate: {},
      error: {},
      onSubmit: false,
      onReview: false
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['user', 'countrys']), {
    onError: function onError() {
      var _this = this;

      return values_default()(this.alerts).filter(function (alert) {
        return alert && alert.type === 'error';
      }).length || entries_default()(this.error).some(function (_ref) {
        var _ref2 = slicedToArray_default()(_ref, 2),
            field = _ref2[0],
            error = _ref2[1];

        return error.items.filter(function (item) {
          return _this.formOptions[field].map(function (form) {
            return form.value;
          }).includes(item.field);
        }).length;
      });
    },
    allFiles: function allFiles() {
      return this.files.concat(this.addFiles);
    },
    kindOptions: function kindOptions() {
      return [{ title: '蔬菜', value: 'vegetable' }, { title: '水果', value: 'fruit' }];
    },
    packingMethodOptions: function packingMethodOptions() {
      return [{ title: '散裝', value: 'bulk', style: { color: '#EF6577' } }, { title: '有包裝', value: 'packed', style: { color: '#3967A6' } }, { title: '截切', value: 'cut', style: { color: '#3967A6' } }];
    },
    quantityUnitCategoryOptions: function quantityUnitCategoryOptions() {
      return [{ title: '重量', value: 'weight' }, { title: '數量', value: 'count' }];
    },
    quantityUnitOptions: function quantityUnitOptions() {
      return [{ title: '公克', value: 'gram', type: 'weight' }, { title: '公斤', value: 'kilogram', type: 'weight' }, { title: '磅', value: 'pound', type: 'weight' }, { title: '個', value: 'number', type: 'count' }, { title: '包裝', value: 'package', type: 'count' }];
    },
    marketKindOptions: function marketKindOptions() {
      return [{ title: '傳統市場', value: 'traditional_market' }, { title: '批發市場', value: 'wholesale_market' }, { title: '超市', value: 'supermarket' }, { title: '量販店', value: 'hyper_market' }, { title: '便利商店', value: 'convenience_store' }, { title: '蔬果專賣店', value: 'vegetable_and_fruit_store' }, { title: '農夫(假日)市集', value: 'farmers_market' }];
    },
    countryOptions: function countryOptions() {
      return this.countrys.map(function (_ref3) {
        var _ref4 = slicedToArray_default()(_ref3, 2),
            key = _ref4[0],
            value = _ref4[1];

        return {
          title: value.chinese_name + '(' + value.iso_name + ')',
          value: key,
          country: value
        };
      });
    },
    currencyOptions: function currencyOptions() {
      return [{ title: '歐元', value: '歐元' }, { title: '美元', value: '美元' }, { title: '英鎊', value: '英鎊' }, { title: '日圓', value: '日圓' }, { title: '泰銖', value: '泰銖' }, { title: '馬幣', value: '馬幣' }, { title: '越南盾', value: '越南盾' }, { title: '澳元', value: '澳元' }, { title: '其他', value: '其他' }];
    },
    cropDataOptions: function cropDataOptions() {
      return this.cropDatas || [];
    },
    currencyOtherOptions: function currencyOtherOptions() {
      var _this2 = this;

      return (this.currencyOthers || []).filter(function (currency) {
        return !_this2.currencyOptions.some(function (option) {
          return option.value === currency;
        });
      });
    },
    editable: function editable() {
      return !!this.param.editable;
    },
    review: function review() {
      return !!this.param.review;
    },

    // static
    formOptions: function formOptions() {
      var _this3 = this;

      return {
        field1: [{
          title: '拍攝日期',
          value: 'date',
          type: this.editable ? 'date' : 'text',
          width: '200px',
          placeholder: function placeholder() {
            return '2020/03/12';
          },
          validate: this.editable ? 'required' : '',
          displayText: function displayText(value, form) {
            return _this3.editable ? value : (form.options ? (form.options.find(function (option) {
              return option.value === value;
            }) || {}).title : value) || '--';
          }
        }, {
          title: '產品類別',
          value: 'kind',
          type: this.editable ? 'select' : 'text',
          width: '200px',
          options: this.kindOptions,
          placeholder: function placeholder() {
            return '蔬菜 / 水果';
          },
          validate: this.editable ? 'required' : '',
          displayText: function displayText(value, form) {
            return _this3.editable ? value : (form.options ? (form.options.find(function (option) {
              return option.value === value;
            }) || {}).title : value) || '--';
          }
        }, {
          title: '作物(產品)',
          value: 'crop_name',
          type: this.editable ? 'datalist' : 'text',
          lists: this.cropDataOptions.filter(function (option) {
            return option.kind === _this3.result.kind;
          }).map(function (option) {
            return option.name;
          }),
          onChange: function onChange(value) {
            // if (value && !this.cropDatas.some(v => v === value)) {
            //   this.productPrice = {
            //     ...this.productPrice,
            //     ...this.result,
            //     crop_name: ''
            //   }
            // }
          },
          // width: '420px',
          placeholder: function placeholder() {
            return '請輸入農產品的作物名稱';
          },
          validate: this.editable ? 'required' : '',
          displayText: function displayText(value, form) {
            return _this3.editable ? value : (form.options ? (form.options.find(function (option) {
              return option.value === value;
            }) || {}).title : value) || '--';
          }
        }],
        field2: [{
          title: '上傳者',
          value: 'user_name',
          type: this.editable ? 'text' : 'text',
          width: '200px',
          displayText: function displayText(value, form) {
            return _this3.editable ? value : (form.options ? (form.options.find(function (option) {
              return option.value === value;
            }) || {}).title : value) || '--';
          }
        }, {
          title: '產地',
          value: 'country',
          type: this.editable ? 'datalist' : 'text',
          lists: [{ title: '無', country: { iso_name: '', chinese_name: '' } }].concat(toConsumableArray_default()(this.countryOptions)).map(function (option) {
            return option.title;
          }),
          onChange: function onChange(value) {
            if (value && value !== '無' && !_this3.countryOptions.some(function (option) {
              return option.title === value;
            })) {
              _this3.productPrice = extends_default()({}, _this3.productPrice, _this3.result, {
                country: ''
              });
            }
          },
          width: '200px',
          placeholder: function placeholder() {
            return '請選擇國家';
          },
          validate: this.editable ? 'required' : '',
          displayText: function displayText(value, form) {
            return _this3.editable ? value : (form.options ? (form.options.find(function (option) {
              return option.value === value;
            }) || {}).title : value) || '--';
          }
        }, {
          title: '品名',
          value: 'product_name',
          type: this.editable ? 'input' : 'text',
          // width: '420px',
          placeholder: function placeholder() {
            return '請輸入農產品上顯示的產品名稱';
          },
          displayText: function displayText(value, form) {
            return _this3.editable ? value : (form.options ? (form.options.find(function (option) {
              return option.value === value;
            }) || {}).title : value) || '--';
          }
        }],
        field3: [{
          title: '包裝方式',
          value: 'packing_method',
          type: this.editable ? 'select' : 'text',
          width: '200px',
          options: this.packingMethodOptions,
          style: function style(value) {
            return value ? {
              bulk: { color: '#EF6577' },
              packed: { color: '#3967A6' },
              cut: { color: '#3967A6' }
            }[value] : { color: '#777777' };
          },
          placeholder: function placeholder() {
            return '散裝 / 有包裝 / 截切';
          },
          validate: this.editable ? 'required' : '',
          displayText: function displayText(value, form) {
            return _this3.editable ? value : (form.options ? (form.options.find(function (option) {
              return option.value === value;
            }) || {}).title : value) || '--';
          }
        }, {
          title: '價格',
          value: 'price',
          type: this.editable ? 'number' : 'text',
          width: '200px',
          placeholder: function placeholder() {
            return '請輸入數字';
          },
          validate: this.editable ? 'required' : '',
          displayText: function displayText(value, form) {
            return _this3.editable ? value : (form.options ? (form.options.find(function (option) {
              return option.value === value;
            }) || {}).title : value) || '--';
          }
        }, {
          title: this.result.packing_method === 'bulk' ? '計價量' : '包裝量',
          value: 'quantity',
          type: this.editable ? 'number' : 'text',
          placeholder: function placeholder() {
            return '請輸入數字';
          },
          validate: this.editable ? 'required' : '',
          displayText: function displayText(value, form) {
            return _this3.editable ? value : (form.options ? (form.options.find(function (option) {
              return option.value === value;
            }) || {}).title : value) || '--';
          }
        }].concat(toConsumableArray_default()(this.editable ? [{
          title: this.result.packing_method === 'bulk' ? '計價單位' : '包裝單位',
          value: 'quantity_unit_category',
          type: this.editable ? 'select' : 'text',
          options: this.quantityUnitCategoryOptions,
          placeholder: function placeholder() {
            return '重量/數量';
          },
          validate: this.editable ? 'required' : '',
          displayText: function displayText(value, form) {
            return _this3.editable ? value : (form.options ? (form.options.find(function (option) {
              return option.value === value;
            }) || {}).title : value) || '--';
          }
        }] : []), [{
          title: this.editable ? '　' : this.result.packing_method === 'bulk' ? '計價單位' : '包裝單位',
          value: 'quantity_unit',
          type: this.editable ? 'select' : 'text',
          options: this.quantityUnitOptions.filter(function (option) {
            return !_this3.editable || option.type === _this3.result.quantity_unit_category;
          }),
          placeholder: function placeholder() {
            return {
              weight: '公斤/公克...',
              count: '個/包裝...'
            }[_this3.result.quantity_unit_category];
          },
          displayText: function displayText(value, form) {
            return _this3.editable ? value : (form.options ? (form.options.find(function (option) {
              return option.value === value;
            }) || {}).title : value) || '--';
          }
        }], toConsumableArray_default()(!this.editable ? [{
          title: '　',
          value: ''
        }] : [])),
        field4: [].concat(toConsumableArray_default()(this.editable ? [{
          title: '貨幣單位',
          value: 'currency',
          type: this.editable ? 'select' : 'text',
          options: this.currencyOptions,
          width: '200px',
          placeholder: function placeholder() {
            return '請選擇幣別 / 其他';
          },
          validate: this.editable ? 'required' : '',
          displayText: function displayText(value, form) {
            return _this3.editable ? value : (form.options ? (form.options.find(function (option) {
              return option.value === value;
            }) || {}).title : value) || '--';
          }
        }] : []), [{
          title: !this.editable ? '貨幣單位' : '　',
          value: 'currency_other',
          type: this.editable ? 'datalist' : 'text',
          lists: this.currencyOtherOptions,
          onChange: function onChange(value) {
            if (value && !_this3.currencyOthers.some(function (v) {
              return v === value;
            })) {
              // this.productPrice = {
              //   ...this.productPrice,
              //   ...this.result,
              //   currency_other: ''
              // }
            }
          },
          width: '200px',
          disabled: function disabled() {
            return _this3.result.currency !== '其他';
          },
          placeholder: function placeholder() {
            return '其他幣別';
          },
          displayText: function displayText(value, form) {
            return _this3.editable ? value : (form.options ? (form.options.find(function (option) {
              return option.value === value;
            }) || {}).title : value) || '--';
          }
        }], toConsumableArray_default()(!this.editable ? [{
          title: '　',
          value: '',
          width: '200px'
        }] : []), [{
          title: '貨幣匯率 (與美元相比)',
          value: 'exchange_rate',
          type: this.editable ? 'input' : 'text',
          errorTitle: '貨幣匯率',
          width: '200px',
          placeholder: function placeholder() {
            return '';
          },
          validate: this.editable ? 'required' : '',
          displayText: function displayText(value, form) {
            return _this3.editable ? value : (form.options ? (form.options.find(function (option) {
              return option.value === value;
            }) || {}).title : value) || '--';
          }
        }, {
          title: '　',
          value: ''
        }]),
        field5: [{
          title: '市場類型',
          value: 'market_kind',
          type: this.editable ? 'select' : 'text',
          options: this.marketKindOptions,
          width: '200px',
          placeholder: function placeholder() {
            return '請選擇市場類型';
          },
          validate: this.editable ? 'required' : '',
          displayText: function displayText(value, form) {
            return _this3.editable ? value : (form.options ? (form.options.find(function (option) {
              return option.value === value;
            }) || {}).title : value) || '--';
          }
        }, {
          title: '市場名稱',
          value: 'market_name',
          type: this.editable ? 'input' : 'text',
          // width: '420px',
          placeholder: function placeholder() {
            return '請輸入市場名稱';
          },
          validate: this.editable ? 'required' : '',
          displayText: function displayText(value, form) {
            return _this3.editable ? value : (form.options ? (form.options.find(function (option) {
              return option.value === value;
            }) || {}).title : value) || '--';
          }
        }, {
          title: '市場所在國家',
          value: 'market_country',
          type: this.editable ? 'datalist' : 'text',
          lists: this.countryOptions.map(function (option) {
            return option.title;
          }),
          onChange: function onChange(value) {
            if (value && !_this3.countryOptions.some(function (option) {
              return option.title === value;
            })) {
              _this3.productPrice = extends_default()({}, _this3.productPrice, _this3.result, {
                market_country: ''
              });
            }
          },
          width: '200px',
          placeholder: function placeholder() {
            return '請選擇國家';
          },
          validate: this.editable ? 'required' : '',
          displayText: function displayText(value, form) {
            return _this3.editable ? value : (form.options ? (form.options.find(function (option) {
              return option.value === value;
            }) || {}).title : value) || '--';
          }
        }],
        field6: [{
          title: '產品照片(最多上傳兩張照片)',
          value: '_FILES',
          validate: this.editable ? 'required' : ''
        }],
        field7: [{
          title: this.param.image ? '產品照片' : '產品照片(最多上傳兩張照片)',
          value: '_FILES',
          display: function display() {
            return _this3.param.image;
          },
          width: '420px',
          validate: this.editable ? 'required' : ''
        }, {
          title: '備註說明',
          value: 'notes',
          type: this.editable ? 'textarea' : 'text',
          row: this.param.image ? 5 : 3,
          placeholder: function placeholder() {
            return '';
          },
          displayText: function displayText(value, form) {
            return _this3.editable ? value : (form.options ? (form.options.find(function (option) {
              return option.value === value;
            }) || {}).title : value) || '--';
          }
        }]
      };
    },

    // global
    convertFileSize: function convertFileSize() {
      return util["a" /* convertFileSize */];
    },
    fileTypeCheck: function fileTypeCheck() {
      return util["d" /* fileTypeCheck */];
    }
  }),
  watch: {
    'result.quantity_unit_category': function resultQuantity_unit_category(nv, ov) {
      if (ov) {
        this.productPrice = extends_default()({}, this.productPrice, this.result, {
          quantity_unit: ''
        });
      }
      this.alerts = extends_default()({}, this.alerts, {
        quantity_unit: null
      });
    },
    'result.quantity_unit': function resultQuantity_unit() {
      this.alerts = extends_default()({}, this.alerts, {
        quantity_unit: null
      });
    },
    'result.currency': function resultCurrency(nv, ov) {
      if (ov) {
        this.productPrice = extends_default()({}, this.productPrice, this.result, {
          currency_other: ''
        });
      }
      this.alerts = extends_default()({}, this.alerts, {
        currency_other: null
      });
    },
    'result.currency_other': function resultCurrency_other(nv) {
      this.alerts = extends_default()({}, this.alerts, {
        currency_other: null
        // nv && this.searchData('currencyOther', nv)
      });
    },
    'result.crop_name': function resultCrop_name(nv) {
      // nv && this.searchData('cropName', nv)
    }
  },
  methods: {
    fetchData: function fetchData() {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this4.fetchCrops();

              case 2:
                _context.next = 4;
                return _this4.fetchCurrencys();

              case 4:
                _context.next = 6;
                return _this4.fetchProductPrice();

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    },
    fetchCrops: function fetchCrops() {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var config, response, datas;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                config = _this5.$ls.get('userInfo');
                _context2.next = 4;
                return Object(src_api["p" /* getCrops */])('', config);

              case 4:
                response = _context2.sent;
                datas = response.data.data;

                _this5.cropDatas = datas;
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](0);
                throw _context2.t0;

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5, [[0, 9]]);
      }))();
    },
    fetchCurrencys: function fetchCurrencys() {
      var _this6 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var config, response, datas;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                config = _this6.$ls.get('userInfo');
                _context3.next = 4;
                return Object(src_api["q" /* getCurrencys */])('', config);

              case 4:
                response = _context3.sent;
                datas = response.data.data;

                datas = datas.map(function (data) {
                  return data.name;
                });
                _this6.currencyOthers = datas;
                _context3.next = 13;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3['catch'](0);
                throw _context3.t0;

              case 13:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this6, [[0, 10]]);
      }))();
    },
    fetchProductPrice: function fetchProductPrice() {
      var _this7 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var config, id, api, response, defaultData;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!_this7.param.data) {
                  _context4.next = 20;
                  break;
                }

                _context4.prev = 1;
                config = _this7.$ls.get('userInfo');
                id = _this7.param.data.id;
                api = _this7.param.admin ? src_api["i" /* getAdminProductPrice */] : src_api["s" /* getProductPrice */];
                _context4.next = 7;
                return api(id, config);

              case 7:
                response = _context4.sent;
                defaultData = response.data.data;

                _this7.files = defaultData.photos.map(function (file) {
                  return {
                    id: file.id,
                    name: file.name,
                    size: file.file_size,
                    url: file.url
                  };
                });
                defaultData = extends_default()({}, defaultData, {
                  country: (_this7.countryOptions.find(function (option) {
                    return option.value === defaultData.country;
                  }) || {}).title || '無',
                  quantity_unit_category: (_this7.quantityUnitOptions.find(function (option) {
                    return option.value === defaultData.quantity_unit;
                  }) || {}).type,
                  currency: (_this7.currencyOptions.find(function (option) {
                    return option.value === defaultData.currency_name;
                  }) || {}).title || '其他',
                  currency_other: _this7.currencyOptions.some(function (option) {
                    return option.value === defaultData.currency_name;
                  }) ? '' : defaultData.currency_name,
                  market_country: (_this7.countryOptions.find(function (option) {
                    return option.value === defaultData.market_country;
                  }) || {}).title
                });
                if (!_this7.editable) {
                  defaultData = extends_default()({}, defaultData, {
                    currency_other: defaultData.currency === '其他' ? defaultData.currency_other : defaultData.currency
                  });
                }
                _this7.defaultData = defaultData;
                _context4.next = 18;
                break;

              case 15:
                _context4.prev = 15;
                _context4.t0 = _context4['catch'](1);
                throw _context4.t0;

              case 18:
                _context4.next = 21;
                break;

              case 20:
                _this7.defaultData = extends_default()({}, _this7.defaultData, {
                  packing_method: 'bulk'
                });

              case 21:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this7, [[1, 15]]);
      }))();
    },
    afterSetData: function afterSetData() {
      var _this8 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this8.productPrice = extends_default()({}, _this8.productPrice, _this8.defaultData, {
                  user_name: _this8.productPrice.uploader || _this8.user.name
                });

              case 1:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this8);
      }))();
    },

    // async searchData (type, query) {
    //   if (!this[type + 's'][query]) {
    //     try {
    //       let config = this.$ls.get('userInfo')
    //       let api = {
    //         cropName: getCrops,
    //         currencyOther: getCurrencys
    //       }[type]
    //       let response = await api(query, config)
    //       let datas = response.data.data
    //       datas = datas.filter(data => data.name.includes(query)).map(data => data.name)
    //       this[type + 's'] = {
    //         ...this[type + 's'],
    //         [query]: datas.length > 1 ? datas : []
    //       }
    //     } catch (error) {
    //       // this.addToast('error', !error.response ? error.message : error.response.data.message || error.response.data.errors.join('<br>'))
    //     }
    //   }
    // },
    formOnChange: function formOnChange(field, result, validate, errors) {
      this.$set(this.error, field, errors);
      this.$set(this.validate, field, validate);
      this.result = extends_default()({}, this.result, result);
    },
    customValidate: function customValidate(cols) {
      var _this9 = this;

      var rcols = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      // const isSubmit = !cols
      var validates = {
        quantity_unit: function quantity_unit(value) {
          if (_this9.result.quantity_unit_category && !value) {
            return {
              type: 'error',
              msg: '計價單位 為必填欄位'
            };
          }
        },
        currency_other: function currency_other(value) {
          if (_this9.result.currency === '其他' && !value) {
            return {
              type: 'error',
              msg: '貨幣單位 為必填欄位'
            };
          }
        },
        _FILES: function _FILES(value) {
          if (!_this9.allFiles.length) {
            return {
              type: 'error',
              msg: '產品照片 為必填欄位'
            };
          }
        }
      };
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(cols || keys_default()(this.productPrice)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var col = _step.value;

          var alert = (validates[col] || function () {})(this.result[col]);
          this.alerts = extends_default()({}, this.alerts, defineProperty_default()({}, col, alert || null));
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.alerts = extends_default()({}, this.alerts, rcols.reduce(function (s, c) {
        return extends_default()({}, s, defineProperty_default()({}, c, null));
      }, {}));
      return !values_default()(this.alerts).filter(function (x) {
        return x;
      }).length;
    },
    searchData: function searchData(type, query) {
      var _this10 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
        var config, api, response, datas;
        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (_this10[type + 's'][query]) {
                  _context6.next = 14;
                  break;
                }

                _context6.prev = 1;
                config = _this10.$ls.get('userInfo');
                api = {
                  cropName: src_api["p" /* getCrops */],
                  currencyOther: src_api["q" /* getCurrencys */]
                }[type];
                _context6.next = 6;
                return api(query, config);

              case 6:
                response = _context6.sent;
                datas = response.data.data;

                datas = datas.filter(function (data) {
                  return data.name.includes(query);
                }).map(function (data) {
                  return data.name;
                });
                _this10[type + 's'] = extends_default()({}, _this10[type + 's'], defineProperty_default()({}, query, datas.length > 1 ? datas : []));
                _context6.next = 14;
                break;

              case 12:
                _context6.prev = 12;
                _context6.t0 = _context6['catch'](1);

              case 14:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this10, [[1, 12]]);
      }))();
    },
    fileUpload: function fileUpload(e) {
      var _this11 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7() {
        var files, limit, urls, i;
        return regenerator_default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                files = from_default()(e.target.files);
                limit = Math.max(2 - _this11.allFiles.length, 0);

                e.target.value = '';
                files = files.slice(0, limit);
                _context7.next = 6;
                return Object(util["g" /* imageReader */])(files, 'blobUrl');

              case 6:
                urls = _context7.sent;

                for (i = 0; i < urls.length; i++) {
                  files[i].url = urls[i];
                }
                _this11.addFiles = [].concat(toConsumableArray_default()(_this11.addFiles), toConsumableArray_default()(files));
                _this11.alerts = extends_default()({}, _this11.alerts, {
                  _FILES: null
                });

              case 10:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this11);
      }))();
    },
    removeFile: function removeFile(file) {
      if (!file.lastModified) {
        this.removeFileIDs.push(file.id);
        this.files.splice(this.files.indexOf(file), 1);
      } else {
        this.addFiles.splice(this.addFiles.indexOf(file), 1);
      }
    },
    validateEditProductPrice: function validateEditProductPrice() {
      var _this12 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee8() {
        var result, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, kv;

        return regenerator_default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                result = {};

                _this12.onSubmit = true;
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context8.prev = 5;
                _iterator2 = get_iterator_default()(entries_default()(_this12.validate));

              case 7:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context8.next = 15;
                  break;
                }

                kv = _step2.value;
                _context8.next = 11;
                return kv[1].validate();

              case 11:
                result[kv[0]] = _context8.sent;

              case 12:
                _iteratorNormalCompletion2 = true;
                _context8.next = 7;
                break;

              case 15:
                _context8.next = 21;
                break;

              case 17:
                _context8.prev = 17;
                _context8.t0 = _context8['catch'](5);
                _didIteratorError2 = true;
                _iteratorError2 = _context8.t0;

              case 21:
                _context8.prev = 21;
                _context8.prev = 22;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 24:
                _context8.prev = 24;

                if (!_didIteratorError2) {
                  _context8.next = 27;
                  break;
                }

                throw _iteratorError2;

              case 27:
                return _context8.finish(24);

              case 28:
                return _context8.finish(21);

              case 29:
                result['custom'] = _this12.customValidate();

                if (values_default()(result).includes(false)) {
                  _context8.next = 33;
                  break;
                }

                _context8.next = 33;
                return _this12.editProductPrice();

              case 33:
                _this12.onSubmit = false;

              case 34:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this12, [[5, 17, 21, 29], [22,, 24, 28]]);
      }))();
    },
    editProductPrice: function editProductPrice(isReview) {
      var _this13 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee9() {
        var config, id, data, response;
        return regenerator_default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                config = _this13.$ls.get('userInfo');
                id = (_this13.param.data || {}).id;
                data = extends_default()({}, _this13.result, {
                  currency_name: _this13.result.currency === '其他' ? _this13.result.currency_other : _this13.result.currency,
                  country: (_this13.countryOptions.find(function (option) {
                    return option.title === _this13.result.country;
                  }) || {}).value || '',
                  market_country: (_this13.countryOptions.find(function (option) {
                    return option.title === _this13.result.market_country;
                  }) || {}).value,
                  photos: _this13.addFiles
                });

                if (id) {
                  data.remove_photo_ids = _this13.removeFileIDs;
                }

                if (!id) {
                  _context9.next = 11;
                  break;
                }

                _context9.next = 8;
                return Object(src_api["T" /* putAdminProductPrice */])(id, data, config);

              case 8:
                _context9.t0 = _context9.sent;
                _context9.next = 14;
                break;

              case 11:
                _context9.next = 13;
                return Object(src_api["O" /* postProductPrice */])(data, config);

              case 13:
                _context9.t0 = _context9.sent;

              case 14:
                response = _context9.t0;

                if (!isReview) {
                  _this13.addToast('success', response.data.result || (id ? '更新成功' : '上傳成功'));
                  _this13.$emit('changeModal', {}, true);
                }
                _context9.next = 21;
                break;

              case 18:
                _context9.prev = 18;
                _context9.t1 = _context9['catch'](0);

                _this13.addToast('error', !_context9.t1.response ? _context9.t1.message : _context9.t1.response.data.message || _context9.t1.response.data.errors.join('<br>'));

              case 21:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this13, [[0, 18]]);
      }))();
    },
    reviewProductPrice: function reviewProductPrice(result) {
      var _this14 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee10() {
        var config, id, response;
        return regenerator_default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _this14.onReview = true;
                _context10.next = 3;
                return _this14.editProductPrice(true);

              case 3:
                _context10.prev = 3;
                config = _this14.$ls.get('userInfo');
                id = _this14.param.data.id;
                _context10.next = 8;
                return Object(src_api["K" /* postAdminProductPriceReview */])(id, result, config);

              case 8:
                response = _context10.sent;

                _this14.addToast('success', response.data.result || '審核成功');
                _this14.$emit('changeModal', {}, true);
                _context10.next = 16;
                break;

              case 13:
                _context10.prev = 13;
                _context10.t0 = _context10['catch'](3);

                _this14.addToast('error', !_context10.t0.response ? _context10.t0.message : _context10.t0.response.data.message || _context10.t0.response.data.errors.join('<br>'));

              case 16:
                _this14.onReview = false;

              case 17:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this14, [[3, 13]]);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1299f9f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/editProductPrice.vue
var editProductPrice_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"edit-product-price-dailog container-block col-block"},[_c('div',{staticClass:"title-container row-block default-shadow"},[_c('div',{staticClass:"row-block",style:({ width: '35px' })}),_vm._v(" "),_c('div',{staticClass:"title",domProps:{"innerHTML":_vm._s(_vm.param.title)}}),_vm._v(" "),_c('div',{staticClass:"row-block close-button",style:({ width: '35px' })})]),_vm._v(" "),_c('div',{staticClass:"product-price-container col-block",style:({ flex: 1 })},[_c('customRowForm',{attrs:{"init":_vm.productPrice,"alerts":_vm.alerts,"disabled":!_vm.editable,"forms":_vm.formOptions['field1']},on:{"change":function (result, validate, errors) { return _vm.formOnChange('field1', result, validate, errors); }}}),_vm._v(" "),_c('customRowForm',{attrs:{"init":_vm.productPrice,"alerts":_vm.alerts,"disabled":!_vm.editable,"forms":_vm.formOptions['field2']},on:{"change":function (result, validate, errors) { return _vm.formOnChange('field2', result, validate, errors); }}}),_vm._v(" "),_c('div',{staticClass:"packing-container",class:[['bulk'].includes(_vm.result.packing_method) ? 'red' : ['packed', 'cut'].includes(_vm.result.packing_method) ? 'blue' : '']},[_c('customRowForm',{attrs:{"init":_vm.productPrice,"alerts":_vm.alerts,"disabled":!_vm.editable,"forms":_vm.formOptions['field3']},on:{"change":function (result, validate, errors) { return _vm.formOnChange('field3', result, validate, errors); }}})],1),_vm._v(" "),_c('customRowForm',{attrs:{"init":_vm.productPrice,"alerts":_vm.alerts,"disabled":!_vm.editable,"forms":_vm.formOptions['field4']},on:{"change":function (result, validate, errors) { return _vm.formOnChange('field4', result, validate, errors); }}}),_vm._v(" "),_c('customRowForm',{attrs:{"init":_vm.productPrice,"alerts":_vm.alerts,"disabled":!_vm.editable,"forms":_vm.formOptions['field5']},on:{"change":function (result, validate, errors) { return _vm.formOnChange('field5', result, validate, errors); }}}),_vm._v(" "),(!_vm.param.image)?_c('customRowForm',{attrs:{"init":_vm.productPrice,"alerts":_vm.alerts,"disabled":!_vm.editable,"forms":_vm.formOptions['field6']},on:{"change":function () {}},scopedSlots:_vm._u([{key:"_FILES",fn:function(props){return [_c('div',{staticClass:"_FILES",attrs:{"name":props}},[_c('div',{staticClass:"file-container row-block stretch"},[(_vm.editable)?[_c('div',{staticClass:"mask",class:{ disabled: _vm.allFiles.length >= 2 }},[_c('label',{attrs:{"for":"upload"}}),_vm._v(" "),_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"type":"file","id":"upload","accept":"image/gif,image/png,image/jpg,image/jpeg,image/webp","multiple":"","disabled":_vm.allFiles.length >= 2},on:{"change":function (e) { return _vm.fileTypeCheck(e, function (e) { return _vm.fileUpload(e); }, function () { return _vm.addToast('error', '圖檔'); }); }}}),_vm._v(" "),_c('button',{staticClass:"main-button"},[_c('span',[_vm._v("選擇檔案")])])]),_vm._v(" "),_c('div',{style:({ width: '20px' })})]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"file-list row-block",style:({ flex: 1, width: 0 })},_vm._l((_vm.allFiles),function(file,index){return _c('div',{key:index,staticClass:"file-block row-block"},[_c('a',{staticClass:"file-text row-block",attrs:{"href":file.url,"target":"_blank"}},[_c('div',{staticClass:"file-title",attrs:{"title":file.name}},[_vm._v(_vm._s(file.name))]),_vm._v(" "),_c('div',{style:({ width: '3px' })}),_vm._v(" "),_c('div',{staticClass:"file-size"},[_vm._v(_vm._s('(' + _vm.convertFileSize(file.size) + ')'))])]),_vm._v(" "),(_vm.editable)?[_c('div',{style:({ width: '15px' })}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("NBIZ"),"alt":""},on:{"click":function (e) { return _vm.removeFile(file); }}})]:_vm._e(),_vm._v(" "),_c('div',{style:({ flex: 1 })})],2)}),0),_vm._v(" "),(_vm.alerts['_FILES'] && _vm.alerts['_FILES'].type === 'error')?_c('div',{staticClass:"file-alert"},[_vm._v(_vm._s(_vm.alerts['_FILES'].msg))]):_vm._e()],2)])]}}])}):_vm._e(),_vm._v(" "),_c('customRowForm',{attrs:{"init":_vm.productPrice,"alerts":_vm.alerts,"disabled":!_vm.editable,"forms":_vm.formOptions['field7']},on:{"change":function (result, validate, errors) { return _vm.formOnChange('field6', result, validate, errors); }},scopedSlots:_vm._u([{key:"_FILES",fn:function(props){return [_c('div',{staticClass:"_FILES",attrs:{"name":props}},[_c('div',{staticClass:"file-container img col-block"},[_c('div',{staticClass:"img-list row-block",style:({ flex: 1 })},_vm._l((_vm.allFiles),function(file,index){return _c('div',{key:index,staticClass:"img-block col-block stretch"},[_c('div',{staticClass:"img-content center-block"},[_c('img',{attrs:{"src":file.url,"alt":""}})]),_vm._v(" "),_c('div',{style:({ height: '5px' })}),_vm._v(" "),_c('div',{staticClass:"img-options row-block"},[_c('a',{staticClass:"open",attrs:{"href":file.url,"target":"_blank"}},[_vm._v("在新分頁開啟照片")]),_vm._v(" "),(_vm.editable)?_c('div',{staticClass:"remove",on:{"click":function (e) { return _vm.removeFile(file); }}},[_vm._v("移除")]):_c('div')])])}),0),_vm._v(" "),(_vm.editable)?[_c('div',{staticClass:"mask",class:{ disabled: _vm.allFiles.length >= 2 }},[_c('label',{attrs:{"for":"upload"}}),_vm._v(" "),_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"type":"file","id":"upload","accept":"image/gif,image/png,image/jpg,image/jpeg,image/webp","multiple":"","disabled":_vm.allFiles.length >= 2},on:{"change":function (e) { return _vm.fileUpload(e); }}}),_vm._v(" "),_c('button',{staticClass:"main-button"},[_c('span',[_vm._v("選擇檔案")])])])]:_vm._e(),_vm._v(" "),(_vm.alerts['_FILES'] && _vm.alerts['_FILES'].type === 'error')?_c('div',{staticClass:"file-alert"},[_vm._v(_vm._s(_vm.alerts['_FILES'].msg))]):_vm._e()],2)])]}}])}),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),(_vm.review)?[_c('button',{staticClass:"alert-button",class:{ loading: _vm.onReview },attrs:{"type":"button","name":"button"},on:{"click":function (e) { return _vm.reviewProductPrice('fail'); }}},[_c('span',[_vm._v("不通過")])]),_vm._v(" "),_c('div',{style:({ flexBasis: '20px' })})]:_vm._e(),_vm._v(" "),_c('button',{staticClass:"gray-button",attrs:{"type":"button","name":"button"},on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s(_vm.editable ? '取消' : '返回'))])]),_vm._v(" "),(_vm.review)?[_c('div',{style:({ flexBasis: '20px' })}),_vm._v(" "),_c('button',{staticClass:"main-button",class:{ loading: _vm.onReview },attrs:{"type":"button","name":"button"},on:{"click":function (e) { return _vm.reviewProductPrice('pass'); }}},[_c('span',[_vm._v("通過")])])]:_vm._e(),_vm._v(" "),(_vm.editable && !_vm.review)?[_c('div',{style:({ flexBasis: '20px' })}),_vm._v(" "),_c('button',{staticClass:"main-button",class:{ loading: _vm.onSubmit },attrs:{"type":"button","name":"button","disabled":_vm.onError},on:{"click":function (e) { return _vm.validateEditProductPrice(); }}},[_c('span',[_vm._v(_vm._s(this.param.data ? '更新' : '送出'))])])]:_vm._e(),_vm._v(" "),_c('div',{style:({ flex: 1 })})],2)],1)])}
var editProductPrice_staticRenderFns = []
var editProductPrice_esExports = { render: editProductPrice_render, staticRenderFns: editProductPrice_staticRenderFns }
/* harmony default export */ var components_dialog_editProductPrice = (editProductPrice_esExports);
// CONCATENATED MODULE: ./src/components/dialog/editProductPrice.vue
var editProductPrice_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var editProductPrice___vue_template_functional__ = false
/* styles */
var editProductPrice___vue_styles__ = null
/* scopeId */
var editProductPrice___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var editProductPrice___vue_module_identifier__ = null
var editProductPrice_Component = editProductPrice_normalizeComponent(
  dialog_editProductPrice,
  components_dialog_editProductPrice,
  editProductPrice___vue_template_functional__,
  editProductPrice___vue_styles__,
  editProductPrice___vue_scopeId__,
  editProductPrice___vue_module_identifier__
)

/* harmony default export */ var src_components_dialog_editProductPrice = (editProductPrice_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-quill-editor/dist/vue-quill-editor.js
var vue_quill_editor = __webpack_require__("G0J2");
var vue_quill_editor_default = /*#__PURE__*/__webpack_require__.n(vue_quill_editor);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/tool/quillEditor.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var quillEditor = ({
  props: {
    content: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    options: {
      type: Object,
      required: true
    }
  },
  components: {
    quillEditor: vue_quill_editor["quillEditor"]
  },
  data: function data() {
    return {
      refresh: false,
      quillContent: ''
    };
  },

  watch: {
    'content': function content() {
      this.setContent();
    },
    'options': function options() {
      var _this = this;

      this.refresh = true;
      setTimeout(function () {
        _this.refresh = false;
        _this.setContainerHeight();
      }, 0);
    }
  },
  created: function created() {
    this.setContent();
    window.addEventListener('resize', this.setContainerHeight);
  },
  mounted: function mounted() {
    this.setContainerHeight();
  },

  methods: {
    setContainerHeight: function setContainerHeight() {
      var _this2 = this;

      var toolbar = document.getElementsByClassName('ql-toolbar ql-snow')[0];
      var container = document.getElementsByClassName('ql-container ql-snow')[0];
      if (toolbar && container) {
        container.style.height = 'calc(100% - ' + (toolbar.clientHeight + 1) + 'px)';
      } else {
        setTimeout(function () {
          _this2.setContainerHeight();
        }, 0);
      }
    },
    setContent: function setContent() {
      this.quillContent = this.content;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-280a4e37","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/quillEditor.vue
var quillEditor_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"quill-editor-container"}},[(!_vm.refresh)?_c('quill-editor',{attrs:{"options":_vm.options},on:{"blur":function (e) { return _vm.$emit('blur', e); },"focus":function (e) { return _vm.$emit('focus', e); },"input":function (e) { return _vm.$emit('input', e); },"change":function (e) { return _vm.$emit('change', e); },"ready":function (e) { return _vm.$emit('ready', e); }},model:{value:(_vm.quillContent),callback:function ($$v) {_vm.quillContent=$$v},expression:"quillContent"}}):_vm._e()],1)}
var quillEditor_staticRenderFns = []
var quillEditor_esExports = { render: quillEditor_render, staticRenderFns: quillEditor_staticRenderFns }
/* harmony default export */ var tool_quillEditor = (quillEditor_esExports);
// CONCATENATED MODULE: ./src/components/tool/quillEditor.vue
function quillEditor_injectStyle (ssrContext) {
  __webpack_require__("hD4v")
}
var quillEditor_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var quillEditor___vue_template_functional__ = false
/* styles */
var quillEditor___vue_styles__ = quillEditor_injectStyle
/* scopeId */
var quillEditor___vue_scopeId__ = "data-v-280a4e37"
/* moduleIdentifier (server only) */
var quillEditor___vue_module_identifier__ = null
var quillEditor_Component = quillEditor_normalizeComponent(
  quillEditor,
  tool_quillEditor,
  quillEditor___vue_template_functional__,
  quillEditor___vue_styles__,
  quillEditor___vue_scopeId__,
  quillEditor___vue_module_identifier__
)

/* harmony default export */ var components_tool_quillEditor = (quillEditor_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/editReport.vue











//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ var dialog_editReport = ({
  components: {
    reportComment: src_components_report_comment,
    customRowForm: components_tool_customRowForm,
    quillEditor: components_tool_quillEditor
  },
  mixins: [mixins_routeLoading, toastMethods["a" /* default */]],
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      report: {
        title: '',
        year: '',
        publish_time: Object(util["b" /* dateFormat */])(new Date(), 'yyyy-MM-ddThh:mm'),
        category: '',
        product_code: '',
        module: '',
        country: '',
        content: '',
        external_link: '',
        // custom
        _ADDCOUNTRY: '',
        _CONTENT: '',
        _COVERS: '',
        _FILES: ''
      },
      defaultData: {},
      selectedCountrys: [],
      // options
      productByCategorys: {},
      // covers
      covers: [],
      addCovers: [],
      removeCoverIDs: [],
      // files
      files: [],
      addFiles: [],
      removeFileIDs: [],
      // form
      alerts: {},
      result: {},
      validate: {},
      error: {},
      onSubmit: false
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['user', 'countrys']), {
    onError: function onError() {
      var _this = this;

      return values_default()(this.alerts).filter(function (alert) {
        return alert && alert.type === 'error';
      }).length || entries_default()(this.error).some(function (_ref) {
        var _ref2 = slicedToArray_default()(_ref, 2),
            field = _ref2[0],
            error = _ref2[1];

        return error.items.filter(function (item) {
          return _this.formOptions[field].map(function (form) {
            return form.value;
          }).includes(item.field);
        }).length;
      });
    },
    allCovers: function allCovers() {
      return this.covers.concat(this.addCovers);
    },
    allFiles: function allFiles() {
      return this.files.concat(this.addFiles);
    },
    editable: function editable() {
      return !!this.param.editable;
    },

    // static
    yearOptions: function yearOptions() {
      var year = new Date().getFullYear();
      return [{ title: '無', value: '無' }].concat(toConsumableArray_default()(new Array(year - 2000).fill('').map(function (_, i) {
        return { title: year - i + '', value: year - i + '' };
      })));
    },
    categoryOptions: function categoryOptions() {
      return [].concat(toConsumableArray_default()(keys_default()(this.productByCategorys).map(function (category) {
        return { title: category, value: category };
      })), [{ title: '其他', value: '其他' }]);
    },
    productOptions: function productOptions() {
      return [].concat(toConsumableArray_default()(Array.prototype.concat.apply([], entries_default()(this.productByCategorys).map(function (_ref3) {
        var _ref4 = slicedToArray_default()(_ref3, 2),
            category = _ref4[0],
            products = _ref4[1];

        return entries_default()(products).map(function (_ref5) {
          var _ref6 = slicedToArray_default()(_ref5, 2),
              code = _ref6[0],
              product = _ref6[1];

          return { title: product.chinese_name, value: code, type: product.product_type, category: category };
        });
      }))), [{ title: '其他', value: '其他', type: '其他', category: '其他' }]);
    },
    moduleOptions: function moduleOptions() {
      return [{ title: '市場吸引力', value: 'market_attractiveness' }, { title: '市場競爭力', value: 'market_competitiveness' }, { title: '零售價格分析', value: 'product_prices' }, { title: '其他', value: 'others' }];
    },
    countryOptions: function countryOptions() {
      return this.countrys.map(function (_ref7) {
        var _ref8 = slicedToArray_default()(_ref7, 2),
            key = _ref8[0],
            value = _ref8[1];

        return {
          title: value.chinese_name + '(' + value.iso_name + ')',
          value: key,
          country: value
        };
      });
    },
    formOptions: function formOptions() {
      var _this2 = this;

      return {
        field1: [{
          title: '報告名稱',
          value: 'title',
          type: 'input',
          placeholder: function placeholder() {
            return '報告名稱';
          },
          validate: 'required'
        }, {
          title: '報告年份',
          value: 'year',
          type: 'select',
          width: '200px',
          options: this.yearOptions,
          placeholder: function placeholder() {
            return '報告年份';
          }
        }, {
          title: '發表時間',
          value: 'publish_time',
          type: 'datetime',
          width: '200px',
          placeholder: function placeholder() {
            return '發表時間';
          },
          validate: 'required'
        }],
        field2: [{
          title: '產品類別',
          value: 'category',
          type: 'select',
          width: '200px',
          options: this.categoryOptions,
          placeholder: function placeholder() {
            return '產品類別';
          }
        }, {
          title: '產品名稱',
          value: 'product_code',
          type: 'select',
          options: this.productOptions.filter(function (option) {
            return option.category === _this2.result.category;
          }),
          placeholder: function placeholder() {
            return '產品名稱';
          }
        }, {
          title: '分析類別',
          value: 'module',
          type: 'select',
          width: '200px',
          options: this.moduleOptions,
          placeholder: function placeholder() {
            return '分析類別';
          }
        }],
        field3: [{
          title: '國家',
          value: 'country',
          type: 'datalist',
          lists: this.countryOptions.map(function (option) {
            return option.title;
          }),
          onChange: function onChange(value) {
            if (value && !_this2.countryOptions.some(function (option) {
              return option.title === value;
            })) {
              _this2.report = extends_default()({}, _this2.report, _this2.result, {
                country: ''
              });
            }
          },
          placeholder: function placeholder() {
            return '請選擇國家';
          }
        }, {
          title: '　',
          value: '_ADDCOUNTRY'
        }],
        field4: [{
          title: '報告內容',
          value: '_CONTENT'
        }],
        field5: [{
          title: '外部連結',
          value: 'external_link',
          type: 'input',
          placeholder: function placeholder() {
            return '外部連結';
          }
        }, {
          title: '封面照片',
          value: '_COVERS',
          width: '200px'
        }],
        field6: [{
          title: '附件檔案',
          value: '_FILES'
        }]
      };
    },
    quillOptions: function quillOptions() {
      var toolbar = [[// 文字大小: [small, normal, large, huge] - false為normal且會成為預設選項
      { 'size': ['small', false, 'large', 'huge'] }], ['bold', // 粗體
      'italic', // 斜體
      'underline', // 底線
      'strike', // 刪除線
      'link' // 鏈結
      ], [{ 'color': [] }, // 文字顏色
      { 'background': [] // 背景顏色
      }], [// 列表: [ordered, bullet]
      { 'list': 'ordered' }, { 'list': 'bullet' }], [{ 'align': [] // 文字對齊
      }], [// 縮排: 縮排多寡
      { 'indent': '-1' }, { 'indent': '+1' }], ['clean' // 清除樣式
      ]];
      return {
        modules: {
          toolbar: toolbar
        },
        placeholder: '',
        readonly: false,
        theme: 'snow'
      };
    },

    // global
    convertFileSize: function convertFileSize() {
      return util["a" /* convertFileSize */];
    },
    fileTypeCheck: function fileTypeCheck() {
      return util["d" /* fileTypeCheck */];
    }
  }),
  watch: {
    'result.category': function resultCategory(nv, ov) {
      if (ov) {
        this.report = extends_default()({}, this.report, this.result, {
          product_code: ''
        });
      }
    }
  },
  methods: {
    fetchData: function fetchData() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this3.fetchProductByCategorys();

              case 2:
                _context.next = 4;
                return _this3.fetchReport();

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    fetchProductByCategorys: function fetchProductByCategorys() {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var config, response, productByCategorys;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                config = _this4.$ls.get('userInfo');
                _context2.next = 4;
                return Object(src_api["r" /* getProductByCategorys */])(config);

              case 4:
                response = _context2.sent;
                productByCategorys = response.data;

                _this4.productByCategorys = productByCategorys;
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](0);
                throw _context2.t0;

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4, [[0, 9]]);
      }))();
    },
    fetchReport: function fetchReport() {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var config, id, response, defaultData;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!_this5.param.data) {
                  _context3.next = 18;
                  break;
                }

                _context3.prev = 1;
                config = _this5.$ls.get('userInfo');
                id = _this5.param.data.id;
                _context3.next = 6;
                return Object(src_api["k" /* getAdminReport */])(id, config);

              case 6:
                response = _context3.sent;
                defaultData = response.data.data;

                defaultData = extends_default()({}, defaultData, {
                  publish_time: Object(util["b" /* dateFormat */])(new Date(defaultData.publish_time), 'yyyy-MM-ddThh:mm'),
                  category: (_this5.productOptions.find(function (option) {
                    return option.value === defaultData.product_code;
                  }) || {}).category || '其他',
                  product_code: defaultData.product_code || '其他'
                });
                _this5.selectedCountrys = _this5.countryOptions.filter(function (option) {
                  return defaultData.countries.includes(option.value);
                });
                _this5.covers = defaultData.cover_photo ? [{
                  id: defaultData.cover_photo.id,
                  name: defaultData.cover_photo.name,
                  size: defaultData.cover_photo.file_size,
                  url: defaultData.cover_photo.url
                }] : [];
                _this5.files = defaultData.attachments.map(function (file) {
                  return {
                    id: file.id,
                    name: file.name,
                    size: file.file_size,
                    url: file.url
                  };
                });
                _this5.defaultData = defaultData;
                _context3.next = 18;
                break;

              case 15:
                _context3.prev = 15;
                _context3.t0 = _context3['catch'](1);
                throw _context3.t0;

              case 18:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5, [[1, 15]]);
      }))();
    },
    afterSetData: function afterSetData() {
      var _this6 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this6.report = extends_default()({}, _this6.report, _this6.defaultData);

              case 1:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this6);
      }))();
    },
    addCountry: function addCountry() {
      var _this7 = this;

      var country = this.countryOptions.find(function (option) {
        return option.title === _this7.result.country;
      });
      this.report = extends_default()({}, this.report, this.result, {
        country: ''
      });
      if (country) {
        this.selectedCountrys.push(country);
      }
    },
    removeCountry: function removeCountry(country) {
      this.selectedCountrys.splice(this.selectedCountrys.indexOf(country), 1);
    },
    fileUpload: function fileUpload(e) {
      var _this8 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        var files;
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                files = from_default()(e.target.files);
                // let limit = Math.max(2 - this.allFiles.length, 0)

                e.target.value = '';
                // files = files.slice(0, limit)
                _this8.addFiles = [].concat(toConsumableArray_default()(_this8.addFiles), toConsumableArray_default()(files));
                _this8.alerts = extends_default()({}, _this8.alerts, {
                  _FILES: null
                });

              case 4:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this8);
      }))();
    },
    removeFile: function removeFile(file) {
      if (!file.lastModified) {
        this.removeFileIDs.push(file.id);
        this.files.splice(this.files.indexOf(file), 1);
      } else {
        this.addFiles.splice(this.addFiles.indexOf(file), 1);
      }
    },
    coverUpload: function coverUpload(e) {
      var _this9 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
        var covers, limit, urls, i;
        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                covers = from_default()(e.target.files);
                limit = Math.max(1 - _this9.allCovers.length, 0);

                e.target.value = '';
                covers = covers.slice(0, limit);
                _context6.next = 6;
                return Object(util["g" /* imageReader */])(covers, 'blobUrl');

              case 6:
                urls = _context6.sent;

                for (i = 0; i < urls.length; i++) {
                  covers[i].url = urls[i];
                }
                _this9.addCovers = [].concat(toConsumableArray_default()(_this9.addCovers), toConsumableArray_default()(covers));
                _this9.alerts = extends_default()({}, _this9.alerts, {
                  _COVERS: null
                });

              case 10:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this9);
      }))();
    },
    removeCover: function removeCover(cover) {
      if (!cover.lastModified) {
        this.removeCoverIDs.push(cover.id);
        this.covers.splice(this.covers.indexOf(cover), 1);
      } else {
        this.addCovers.splice(this.addCovers.indexOf(cover), 1);
      }
    },
    onEditor: function onEditor(key, e) {
      if (key === 'change') {
        if (this.result.content !== e.html) {
          this.result = extends_default()({}, this.report, this.result, {
            content: e.html
          });
        }
      }
    },
    formOnChange: function formOnChange(field, result, validate, errors) {
      this.$set(this.error, field, errors);
      this.$set(this.validate, field, validate);
      this.result = extends_default()({}, this.result, result);
    },
    customValidate: function customValidate(cols) {
      var rcols = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      // const isSubmit = !cols
      var validates = {};
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(cols || keys_default()(this.report)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var col = _step.value;

          var alert = (validates[col] || function () {})(this.result[col]);
          this.alerts = extends_default()({}, this.alerts, defineProperty_default()({}, col, alert || null));
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.alerts = extends_default()({}, this.alerts, rcols.reduce(function (s, c) {
        return extends_default()({}, s, defineProperty_default()({}, c, null));
      }, {}));
      return !values_default()(this.alerts).filter(function (x) {
        return x;
      }).length;
    },
    validateEditReport: function validateEditReport() {
      var _this10 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7() {
        var result, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, kv;

        return regenerator_default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                result = {};

                _this10.onSubmit = true;
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context7.prev = 5;
                _iterator2 = get_iterator_default()(entries_default()(_this10.validate));

              case 7:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context7.next = 15;
                  break;
                }

                kv = _step2.value;
                _context7.next = 11;
                return kv[1].validate();

              case 11:
                result[kv[0]] = _context7.sent;

              case 12:
                _iteratorNormalCompletion2 = true;
                _context7.next = 7;
                break;

              case 15:
                _context7.next = 21;
                break;

              case 17:
                _context7.prev = 17;
                _context7.t0 = _context7['catch'](5);
                _didIteratorError2 = true;
                _iteratorError2 = _context7.t0;

              case 21:
                _context7.prev = 21;
                _context7.prev = 22;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 24:
                _context7.prev = 24;

                if (!_didIteratorError2) {
                  _context7.next = 27;
                  break;
                }

                throw _iteratorError2;

              case 27:
                return _context7.finish(24);

              case 28:
                return _context7.finish(21);

              case 29:
                result['custom'] = _this10.customValidate();

                if (values_default()(result).includes(false)) {
                  _context7.next = 33;
                  break;
                }

                _context7.next = 33;
                return _this10.editReport();

              case 33:
                _this10.onSubmit = false;

              case 34:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this10, [[5, 17, 21, 29], [22,, 24, 28]]);
      }))();
    },
    editReport: function editReport() {
      var _this11 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee8() {
        var config, id, data, response;
        return regenerator_default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                config = _this11.$ls.get('userInfo');
                id = (_this11.param.data || {}).id;
                data = extends_default()({}, _this11.result, {
                  year: _this11.result.year === '無' ? '' : _this11.result.year,
                  product_code: _this11.result.product_code === '其他' ? '' : _this11.result.product_code,
                  countries: _this11.selectedCountrys.map(function (country) {
                    return country.value;
                  }),
                  cover_photo: _this11.addCovers[0],
                  attachments: _this11.addFiles
                });

                if (id) {
                  data.remove_attachment_ids = _this11.removeFileIDs;
                  data.cover_photo = _this11.removeCoverIDs.length && !data.cover_photo ? '' : data.cover_photo;
                }

                if (!id) {
                  _context8.next = 11;
                  break;
                }

                _context8.next = 8;
                return Object(src_api["U" /* putAdminReport */])(id, data, config);

              case 8:
                _context8.t0 = _context8.sent;
                _context8.next = 14;
                break;

              case 11:
                _context8.next = 13;
                return Object(src_api["L" /* postAdminReport */])(data, config);

              case 13:
                _context8.t0 = _context8.sent;

              case 14:
                response = _context8.t0;

                _this11.addToast('success', response.data.result || (id ? '更新成功' : '上傳成功'));
                _this11.$emit('changeModal', {}, true);
                _context8.next = 22;
                break;

              case 19:
                _context8.prev = 19;
                _context8.t1 = _context8['catch'](0);

                _this11.addToast('error', !_context8.t1.response ? _context8.t1.message : _context8.t1.response.data.message || _context8.t1.response.data.errors.join('<br>'));

              case 22:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this11, [[0, 19]]);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e4aa4ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/editReport.vue
var editReport_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"edit-report-dailog container-block col-block"},[_c('div',{staticClass:"title-container row-block default-shadow"},[_c('div',{staticClass:"row-block",style:({ width: '35px' })}),_vm._v(" "),_c('div',{staticClass:"title",domProps:{"innerHTML":_vm._s(_vm.param.title)}}),_vm._v(" "),_c('div',{staticClass:"row-block close-button",style:({ width: '35px' })})]),_vm._v(" "),_c('div',{staticClass:"report-container col-block",style:({ flex: 1 })},[_c('customRowForm',{attrs:{"init":_vm.report,"alerts":_vm.alerts,"disabled":!_vm.param.editable,"forms":_vm.formOptions['field1']},on:{"change":function (result, validate, errors) { return _vm.formOnChange('field1', result, validate, errors); }}}),_vm._v(" "),_c('customRowForm',{attrs:{"init":_vm.report,"alerts":_vm.alerts,"disabled":!_vm.param.editable,"forms":_vm.formOptions['field2']},on:{"change":function (result, validate, errors) { return _vm.formOnChange('field2', result, validate, errors); }}}),_vm._v(" "),_c('customRowForm',{attrs:{"init":_vm.report,"alerts":_vm.alerts,"disabled":!_vm.param.editable,"forms":_vm.formOptions['field3']},on:{"change":function (result, validate, errors) { return _vm.formOnChange('field3', result, validate, errors); }},scopedSlots:_vm._u([{key:"_ADDCOUNTRY",fn:function(props){return [_c('div',{staticClass:"_ADDCOUNTRY",attrs:{"name":props}},[_c('div',{staticClass:"add-country-container row-block stretch"},[(_vm.editable)?[_c('button',{staticClass:"white-button",attrs:{"type":"button"},on:{"click":function (e) { return _vm.addCountry(); }}},[_c('span',[_vm._v("加入")])]),_vm._v(" "),_c('div',{style:({ width: '20px' })})]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"country-list row-block",style:({ flex: 1, width: 0 })},_vm._l((_vm.selectedCountrys),function(country,index){return _c('div',{key:index,staticClass:"country-block row-block"},[_c('div',{staticClass:"country-text row-block"},[_c('div',{staticClass:"country-title",attrs:{"title":country.title}},[_vm._v(_vm._s(country.country.chinese_name))])]),_vm._v(" "),(_vm.editable)?[_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("NBIZ"),"alt":""},on:{"click":function (e) { return _vm.removeCountry(country); }}})]:_vm._e(),_vm._v(" "),_c('div',{style:({ flex: 1 })})],2)}),0),_vm._v(" "),(_vm.alerts['_ADDCOUNTRY'] && _vm.alerts['_ADDCOUNTRY'].type === 'error')?_c('div',{staticClass:"country-alert"},[_vm._v(_vm._s(_vm.alerts['_ADDCOUNTRY'].msg))]):_vm._e()],2)])]}}])}),_vm._v(" "),_c('customRowForm',{attrs:{"init":_vm.report,"alerts":_vm.alerts,"disabled":!_vm.param.editable,"forms":_vm.formOptions['field4']},on:{"change":function (result, validate, errors) { return _vm.formOnChange('field4', result, validate, errors); }},scopedSlots:_vm._u([{key:"_CONTENT",fn:function(props){return [_c('div',{staticClass:"_CONTENT",attrs:{"name":props}},[_c('div',{staticClass:"content-container"},[(_vm.editable)?_c('quillEditor',{style:({ height: '300px' }),attrs:{"content":_vm.report.content,"options":_vm.quillOptions},on:{"blur":function (e) { return _vm.onEditor('blur', e); },"focus":function (e) { return _vm.onEditor('focus', e); },"input":function (e) { return _vm.onEditor('input', e); },"change":function (e) { return _vm.onEditor('change', e); },"ready":function (e) { return _vm.onEditor('ready', e); }}}):_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.report.content)}})],1)])]}}])}),_vm._v(" "),_c('customRowForm',{attrs:{"init":_vm.report,"alerts":_vm.alerts,"disabled":!_vm.param.editable,"forms":_vm.formOptions['field5']},on:{"change":function (result, validate, errors) { return _vm.formOnChange('field5', result, validate, errors); }},scopedSlots:_vm._u([{key:"_COVERS",fn:function(props){return [_c('div',{staticClass:"_COVERS",attrs:{"name":props}},[_c('div',{staticClass:"cover-container col-block stretch"},[(_vm.editable)?[_c('div',{staticClass:"mask",class:{ disabled: _vm.allCovers.length >= 1 }},[_c('label',{attrs:{"for":"upload-cover"}}),_vm._v(" "),_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"type":"file","id":"upload-cover","accept":"image/*","multiple":"","disabled":_vm.allCovers.length >= 1},on:{"change":function (e) { return _vm.fileTypeCheck(e, function (e) { return _vm.coverUpload(e); }, function () { return _vm.addToast('error', '圖檔'); }); }}}),_vm._v(" "),_c('button',{staticClass:"main-button"},[_c('span',[_vm._v("選擇檔案")])])]),_vm._v(" "),_c('div',{style:({ height: '5px' })})]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"cover-list row-block",style:({ flex: 1 })},_vm._l((_vm.allCovers),function(cover,index){return _c('div',{key:index,staticClass:"cover-block row-block"},[_c('a',{staticClass:"cover-text row-block",attrs:{"href":cover.url,"target":"_blank"}},[_c('div',{staticClass:"cover-title",attrs:{"title":cover.name}},[_vm._v(_vm._s(cover.name))]),_vm._v(" "),_c('div',{style:({ width: '3px' })}),_vm._v(" "),_c('div',{staticClass:"cover-size"},[_vm._v(_vm._s('(' + _vm.convertFileSize(cover.size) + ')'))])]),_vm._v(" "),(_vm.editable)?[_c('div',{style:({ width: '15px' })}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("NBIZ"),"alt":""},on:{"click":function (e) { return _vm.removeCover(cover); }}})]:_vm._e(),_vm._v(" "),_c('div',{style:({ flex: 1 })})],2)}),0),_vm._v(" "),(_vm.alerts['_COVERS'] && _vm.alerts['_COVERS'].type === 'error')?_c('div',{staticClass:"file-alert"},[_vm._v(_vm._s(_vm.alerts['_COVERS'].msg))]):_vm._e()],2)])]}}])}),_vm._v(" "),_c('customRowForm',{attrs:{"init":_vm.report,"alerts":_vm.alerts,"disabled":!_vm.param.editable,"forms":_vm.formOptions['field6']},on:{"change":function () {}},scopedSlots:_vm._u([{key:"_FILES",fn:function(props){return [_c('div',{staticClass:"_FILES",attrs:{"name":props}},[_c('div',{staticClass:"file-container row-block stretch"},[(_vm.editable)?[_c('div',{staticClass:"mask"},[_c('label',{attrs:{"for":"upload-file"}}),_vm._v(" "),_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"type":"file","id":"upload-file","multiple":""},on:{"change":function (e) { return _vm.fileUpload(e); }}}),_vm._v(" "),_c('button',{staticClass:"main-button"},[_c('span',[_vm._v("選擇檔案")])])]),_vm._v(" "),_c('div',{style:({ width: '20px' })})]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"file-list row-block",style:({ flex: 1, width: 0 })},_vm._l((_vm.allFiles),function(file,index){return _c('div',{key:index,staticClass:"file-block row-block"},[_c('a',{staticClass:"file-text row-block",attrs:{"href":file.url,"target":"_blank"}},[_c('div',{staticClass:"file-title",attrs:{"title":file.name}},[_vm._v(_vm._s(file.name))]),_vm._v(" "),_c('div',{style:({ width: '3px' })}),_vm._v(" "),_c('div',{staticClass:"file-size"},[_vm._v(_vm._s('(' + _vm.convertFileSize(file.size) + ')'))])]),_vm._v(" "),(_vm.editable)?[_c('div',{style:({ width: '15px' })}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("NBIZ"),"alt":""},on:{"click":function (e) { return _vm.removeFile(file); }}})]:_vm._e(),_vm._v(" "),_c('div',{style:({ flex: 1 })})],2)}),0),_vm._v(" "),(_vm.alerts['_FILES'] && _vm.alerts['_FILES'].type === 'error')?_c('div',{staticClass:"file-alert"},[_vm._v(_vm._s(_vm.alerts['_FILES'].msg))]):_vm._e()],2)])]}}])}),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),(_vm.param.data && _vm.defaultData.id)?[_c('reportComment',{attrs:{"reportID":_vm.param.data.id}}),_vm._v(" "),_c('div',{style:({ height: '30px' })})]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button",attrs:{"type":"button","name":"button"},on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s(_vm.editable ? '取消' : '返回'))])]),_vm._v(" "),(_vm.editable)?[_c('div',{style:({ flexBasis: '20px' })}),_vm._v(" "),_c('button',{staticClass:"main-button",class:{ loading: _vm.onSubmit },attrs:{"type":"button","name":"button","disabled":_vm.onError},on:{"click":function (e) { return _vm.validateEditReport(); }}},[_c('span',[_vm._v(_vm._s(_vm.param.data ? '更新' : '送出'))])])]:_vm._e(),_vm._v(" "),_c('div',{style:({ flex: 1 })})],2)],2)])}
var editReport_staticRenderFns = []
var editReport_esExports = { render: editReport_render, staticRenderFns: editReport_staticRenderFns }
/* harmony default export */ var components_dialog_editReport = (editReport_esExports);
// CONCATENATED MODULE: ./src/components/dialog/editReport.vue
var editReport_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var editReport___vue_template_functional__ = false
/* styles */
var editReport___vue_styles__ = null
/* scopeId */
var editReport___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var editReport___vue_module_identifier__ = null
var editReport_Component = editReport_normalizeComponent(
  dialog_editReport,
  components_dialog_editReport,
  editReport___vue_template_functional__,
  editReport___vue_styles__,
  editReport___vue_scopeId__,
  editReport___vue_module_identifier__
)

/* harmony default export */ var src_components_dialog_editReport = (editReport_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/reportDetail.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var reportDetail = ({
  components: {
    reportDetail: components_report_detail
  },
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  methods: {
    setFilter: function setFilter(tag) {
      this.param.func.setFilter(tag.filter);
      this.$emit('changeModal');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-882f0306","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/reportDetail.vue
var reportDetail_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"report-detail-dailog container-block col-block"},[_c('div',{staticClass:"close-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"row-block close-button",style:({ width: '25px' })},[_c('img',{attrs:{"src":__webpack_require__("IREq")},on:{"click":function (e) { return _vm.$emit('changeModal'); }}})])]),_vm._v(" "),_c('reportDetail',{style:({ 'margin-top': '-20px' }),attrs:{"reportID":_vm.param.data.id,"func":_vm.param.func},on:{"setFilter":function (tag) { return _vm.setFilter(tag); }}})],1)}
var reportDetail_staticRenderFns = []
var reportDetail_esExports = { render: reportDetail_render, staticRenderFns: reportDetail_staticRenderFns }
/* harmony default export */ var dialog_reportDetail = (reportDetail_esExports);
// CONCATENATED MODULE: ./src/components/dialog/reportDetail.vue
var reportDetail_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var reportDetail___vue_template_functional__ = false
/* styles */
var reportDetail___vue_styles__ = null
/* scopeId */
var reportDetail___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var reportDetail___vue_module_identifier__ = null
var reportDetail_Component = reportDetail_normalizeComponent(
  reportDetail,
  dialog_reportDetail,
  reportDetail___vue_template_functional__,
  reportDetail___vue_styles__,
  reportDetail___vue_scopeId__,
  reportDetail___vue_module_identifier__
)

/* harmony default export */ var components_dialog_reportDetail = (reportDetail_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/graphData.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var dialog_graphData = ({
  components: {
    pageButtons: components_tool_pageButtons,
    borCor: components_tool_borCor
  },
  mixins: [mixins_routeLoading, toastMethods["a" /* default */], mixins_userPermission],
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      datas: [],
      currentData: null,
      onSearch: false,
      pageData: {
        selectedPage: 1,
        display: 5,
        total: null,
        buttonRange: 7
      },
      sort: {
        value: [],
        order: []
      }
    };
  },

  computed: {
    // static
    tableOptions: function tableOptions() {
      var _this = this;

      return [{
        title: '拍攝日期',
        value: 'date',
        width: '120px',
        display: function display(value) {
          return value ? Object(util["b" /* dateFormat */])(new Date(value), 'yyyy/MM/dd') : '';
        }
      }, {
        title: '產地(國家)',
        value: 'country',
        width: '150px',
        display: function display(value) {
          return (_this.param.options.country.find(function (option) {
            return option.value === value;
          }) || {}).title || '無';
        }
      }, {
        title: '包裝方式',
        value: 'packing_method',
        width: '100px',
        display: function display(value) {
          return (_this.param.options.packingMethod.find(function (option) {
            return option.value === value;
          }) || {}).title;
        }
      }, {
        title: '價格',
        value: 'price',
        width: '80px'
      }, {
        title: '計價貨幣',
        value: 'currency_name',
        width: '100px'
      }, {
        title: '市場所在國家',
        value: 'market_country',
        width: '150px',
        display: function display(value) {
          return (_this.param.options.country.find(function (option) {
            return option.value === value;
          }) || {}).title;
        }
      }, {
        title: '市場類型',
        value: 'market_kind',
        display: function display(value) {
          return (_this.param.options.marketKind.find(function (option) {
            return option.value === value;
          }) || {}).title;
        }
      }];
    },
    dataOptions: function dataOptions() {
      var _this2 = this;

      return [[{ title: '拍攝日期', value: function value(data) {
          return data.date ? Object(util["b" /* dateFormat */])(new Date(data.date), 'yyyy/MM/dd') : '';
        } }, { title: '作物(產品)', value: function value(data) {
          return data.crop_name;
        } }, { title: '產地', value: function value(data) {
          return (_this2.param.options.country.find(function (option) {
            return option.value === data.country;
          }) || {}).title || '無';
        } }], [{ title: '包裝方式', value: function value(data) {
          return (_this2.param.options.packingMethod.find(function (option) {
            return option.value === data.packing_method;
          }) || {}).title;
        } }, { title: '品名', value: function value(data) {
          return data.product_name;
        }, flex: 2 }], [{ title: '價格', value: function value(data) {
          return data.price + ' ' + data.currency_name + '<br>' + '(1 ' + data.currency_name + ' = ' + data.exchange_rate + ' 美元)';
        }, description: '此為上傳者提供之匯率資訊，並非金融機構之即期匯率。' }, { title: '計價量', value: function value(data) {
          return data.quantity + ' ' + (_this2.param.options.quantity.find(function (option) {
            return option.value === data.quantity_unit;
          }) || { title: '--' }).title + ' (' + (_this2.param.options.quantity.find(function (option) {
            return option.value === data.quantity_unit;
          }) || { type: '--' }).type + '計價)';
        }, flex: 2 }], [{ title: '市場類型', value: function value(data) {
          return (_this2.param.options.marketKind.find(function (option) {
            return option.value === data.market_kind;
          }) || {}).title;
        } }, { title: '市場名稱', value: function value(data) {
          return data.market_name;
        } }, { title: '市場所在國', value: function value(data) {
          return (_this2.param.options.country.find(function (option) {
            return option.value === data.market_country;
          }) || {}).title;
        } }]].concat(toConsumableArray_default()(this.rolePermission(['advance', 'admin']) ? [[{ title: '照片', value: function value(data) {
          return data.photos.length ? data.photos : '';
        }, type: function type(data) {
          return data.photos.length ? 'image' : '';
        } }]] : []));
    }
  },
  methods: {
    fetchData: function fetchData() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this3.fetchProductPriceGraphDatas();

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    fetchProductPriceGraphDatas: function fetchProductPriceGraphDatas() {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var config, ids, data, response, datas;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                config = _this4.$ls.get('userInfo');
                ids = _this4.param.ids;
                data = {};

                _this4.pageData.selectedPage && (data.page = _this4.pageData.selectedPage);
                _this4.pageData.display && (data.item_per_page = _this4.pageData.display);
                _this4.sort.value[0] && (data.order_by = _this4.sort.value[0]);
                _this4.sort.order[0] && (data.order_method = _this4.sort.order[0].replace(/^-/, ''));
                _context2.next = 10;
                return Object(src_api["u" /* getProductPriceGraphDatas */])(ids, data, config);

              case 10:
                response = _context2.sent;
                datas = response.data.data.elements;

                _this4.pageData.total = response.data.data.items_count;
                _this4.datas = datas;
                _context2.next = 19;
                break;

              case 16:
                _context2.prev = 16;
                _context2.t0 = _context2['catch'](0);
                throw _context2.t0;

              case 19:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4, [[0, 16]]);
      }))();
    },
    fetchProductPriceGraphData: function fetchProductPriceGraphData(data) {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var config, id, response, currentData;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                config = _this5.$ls.get('userInfo');
                id = data.id;
                _context3.next = 5;
                return Object(src_api["t" /* getProductPriceGraphData */])(id, config);

              case 5:
                response = _context3.sent;
                currentData = response.data.data;

                _this5.currentData = currentData;
                _context3.next = 14;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3['catch'](0);

                _this5.addToast('error', !_context3.t0.response ? _context3.t0.message : _context3.t0.response.data.message || _context3.t0.response.data.errors.join('<br>'));
                setTimeout(function () {
                  return window.location.reload();
                }, 500);

              case 14:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5, [[0, 10]]);
      }))();
    },
    afterSetData: function afterSetData() {
      var _this6 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!_this6.param.defaultID) {
                  _context4.next = 3;
                  break;
                }

                _context4.next = 3;
                return _this6.fetchProductPriceGraphData({ id: _this6.param.defaultID });

              case 3:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this6);
      }))();
    },
    searchDatas: function searchDatas() {
      var _this7 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this7.onSearch = true;
                _context5.next = 3;
                return _this7.fetchData();

              case 3:
                _this7.onSearch = false;

              case 4:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this7);
      }))();
    },
    searchData: function searchData(data) {
      var _this8 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this8.onSearch = true;
                _context6.next = 3;
                return _this8.fetchProductPriceGraphData(data);

              case 3:
                _this8.onSearch = false;

              case 4:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this8);
      }))();
    },
    tableSortBy: function tableSortBy(value) {
      var position = this.sort.value.indexOf(value);
      if (position === 0) {
        var order = this.sort.order[position] === '-asc' ? '-desc' : '-asc';
        this.sort.order.splice(position, 1);
        this.sort.order.unshift(order);
      } else {
        var _order = position !== -1 ? this.sort.order[position] === '-asc' ? '-desc' : '-asc' : undefined;
        position = position !== -1 ? position : 0;
        this.sort.value.splice(position, 1);
        this.sort.order.splice(position, 1);
        this.sort.value.unshift(value);
        this.sort.order.unshift(_order || '-asc');
      }
      this.searchDatas();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59b25c66","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/graphData.vue
var graphData_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"graph-data-dailog container-block col-block"},[_c('div',{staticClass:"title-container row-block default-shadow"},[_c('div',{staticClass:"row-block",style:({ width: '35px' })}),_vm._v(" "),_c('div',{staticClass:"title",domProps:{"innerHTML":_vm._s('零售價格資料')}}),_vm._v(" "),_c('div',{staticClass:"row-block close-button",style:({ width: '35px' })},[_c('img',{attrs:{"src":__webpack_require__("IREq")},on:{"click":function (e) { return _vm.$emit('changeModal'); }}})])]),_vm._v(" "),_c('div',{staticClass:"graph-data-container col-block",style:({ flex: 1, height: 0 })},[(_vm.onSearch)?_c('div',{staticClass:"mask center-block"},[_c('img',{attrs:{"src":__webpack_require__("5xS/"),"alt":""}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"datas-container col-block"},[_c('div',{staticClass:"table-container col-block",style:({ height: '50px' })},[_c('div',{staticClass:"thead default-shadow"},[_c('div',{staticClass:"tr row-block"},_vm._l((_vm.tableOptions),function(option,index){return _c('div',{key:index,staticClass:"th row-block",class:option.class,style:(option.width ? { width: option.width } : { flex: 1 }),on:{"click":function (e) { return option.sort !== false && _vm.tableSortBy(option.value); }}},[_c('span',[_vm._v(_vm._s(option.title))]),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),(option.sort !== false)?_c('i',{class:['fa', 'fa-sort' + (_vm.sort.order[_vm.sort.value.indexOf(option.value)] || '')],attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "),_c('div',{style:({ flex: 1 })})])}),0)])]),_vm._v(" "),_c('div',{staticClass:"table-container col-block sub-shadow",style:({ flex: 1 })},[_c('div',{staticClass:"tbody",style:({ flex: 1 })},[_c('div',_vm._l((_vm.datas),function(data,cindex){return _c('div',{key:cindex,staticClass:"tr row-block",class:{ active: _vm.currentData && _vm.currentData.id === data.id },on:{"click":function (e) { return _vm.searchData(data); }}},[_c('div',{staticClass:"container-block row-block"},_vm._l((_vm.tableOptions),function(option,index){return _c('div',{key:index,staticClass:"td row-block",class:option.class,style:(option.width ? { width: option.width } : { flex: 1 })},[_c('span',{style:((option.style || (function () {}))(data[option.value])),attrs:{"title":(option.display || (function (x) { return x; }))(data[option.value], cindex)}},[_vm._v(_vm._s((option.display || (function (x) { return x; }))(data[option.value], cindex) || '--'))])])}),0)])}),0)])]),_vm._v(" "),_c('div',{staticClass:"page-container center-block"},[(_vm.pageData.total)?_c('pageButtons',{attrs:{"default":_vm.pageData.selectedPage,"display":_vm.pageData.display,"total":_vm.pageData.total,"buttonRange":_vm.pageData.buttonRange},on:{"selectPage":function (page) { _vm.pageData.selectedPage = page; _vm.searchDatas() }}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"data-container",style:({ flex: 1, height: 0 })},[(_vm.currentData)?_c('div',{staticClass:"data-field col-block"},_vm._l((_vm.dataOptions),function(datas,oindex){return _c('div',{key:oindex,staticClass:"data-row row-block"},_vm._l((datas),function(data,dindex){return _c('div',{key:dindex,staticClass:"data-block row-block",style:({ flex: data.flex || 1 })},[(data.title)?_c('div',{staticClass:"data-title row-block",style:({ width: '70px' })},_vm._l((data.title),function(c,cindex){return _c('span',{key:cindex},[_vm._v(_vm._s(c))])}),0):_vm._e(),_vm._v(" "),_c('div',{staticClass:"data-title",style:({ opacity: (data.type || (function () { return ''; }))(_vm.currentData) === 'image' ? 0 : 1 })},[_vm._v("：")]),_vm._v(" "),((data.type || (function () { return ''; }))(_vm.currentData) === 'image')?[_c('div',{staticClass:"data-image col-block"},_vm._l(((data.value || (function () { return ''; }))(_vm.currentData) || []),function(file,findex){return _c('div',{key:findex,staticClass:"image-block center-block"},[_c('img',{attrs:{"src":file.url,"alt":""}})])}),0),_vm._v(" "),_c('div',{style:({ flex: 1 })})]:[_c('div',{staticClass:"data-content-container row-block"},[(data.title)?_c('div',{staticClass:"data-content",domProps:{"innerHTML":_vm._s((data.value || (function () { return ''; }))(_vm.currentData) || '--')}}):_vm._e(),_vm._v(" "),(data.description)?[_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('borCor',{attrs:{"blockStyle":{
                      padding: '6px 8px'
                    }}},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('div',{staticClass:"img-container center-block"},[_c('img',{attrs:{"src":__webpack_require__("u/rF"),"alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"content",attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(data.description))])])])]:_vm._e()],2),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('div',{style:({ flex: 1 })})]],2)}),0)}),0):_vm._e()])])])}
var graphData_staticRenderFns = []
var graphData_esExports = { render: graphData_render, staticRenderFns: graphData_staticRenderFns }
/* harmony default export */ var components_dialog_graphData = (graphData_esExports);
// CONCATENATED MODULE: ./src/components/dialog/graphData.vue
var graphData_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var graphData___vue_template_functional__ = false
/* styles */
var graphData___vue_styles__ = null
/* scopeId */
var graphData___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var graphData___vue_module_identifier__ = null
var graphData_Component = graphData_normalizeComponent(
  dialog_graphData,
  components_dialog_graphData,
  graphData___vue_template_functional__,
  graphData___vue_styles__,
  graphData___vue_scopeId__,
  graphData___vue_module_identifier__
)

/* harmony default export */ var src_components_dialog_graphData = (graphData_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/batchUpload.vue











//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var dialog_batchUpload = ({
  components: {
    customRowForm: components_tool_customRowForm
  },
  mixins: [toastMethods["a" /* default */]],
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      batchUpload: {
        market_country: '',
        // custom
        _FILES: '',
        _IMAGES: ''
      },
      // files
      files: [],
      images: [],
      // form
      alerts: {},
      result: {},
      validate: {},
      error: {},
      onSubmit: false
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['countrys']), {
    onError: function onError() {
      var _this = this;

      return values_default()(this.alerts).filter(function (alert) {
        return alert && alert.type === 'error';
      }).length || entries_default()(this.error).some(function (_ref) {
        var _ref2 = slicedToArray_default()(_ref, 2),
            field = _ref2[0],
            error = _ref2[1];

        return error.items.filter(function (item) {
          return _this.formOptions[field].map(function (form) {
            return form.value;
          }).includes(item.field);
        }).length;
      });
    },
    countryOptions: function countryOptions() {
      return this.countrys.map(function (_ref3) {
        var _ref4 = slicedToArray_default()(_ref3, 2),
            key = _ref4[0],
            value = _ref4[1];

        return {
          title: value.chinese_name + '(' + value.iso_name + ')',
          value: key,
          country: value
        };
      });
    },

    // static
    formOptions: function formOptions() {
      var _this2 = this;

      return {
        field1: [{
          title: '市場所在國家',
          value: 'market_country',
          type: 'datalist',
          lists: this.countryOptions.map(function (option) {
            return option.title;
          }),
          onChange: function onChange(value) {
            if (value && !_this2.countryOptions.some(function (option) {
              return option.title === value;
            })) {
              _this2.batchUpload = extends_default()({}, _this2.batchUpload, _this2.result, {
                market_country: ''
              });
            }
          },
          placeholder: function placeholder() {
            return '請選擇國家';
          },
          validate: 'required'
        }, {
          title: '　'
        }],
        field2: [{
          title: '批次檔案excel',
          value: '_FILES',
          validate: 'required'
        }, {
          title: '零售價格照片ZIP',
          value: '_IMAGES',
          validate: 'required'
        }]
      };
    },

    // global
    fileTypeCheck: function fileTypeCheck() {
      return util["d" /* fileTypeCheck */];
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setModalAction', 'setUploadingAction']), {
    formOnChange: function formOnChange(field, result, validate, errors) {
      this.$set(this.error, field, errors);
      this.$set(this.validate, field, validate);
      this.result = extends_default()({}, this.result, result);
    },
    customValidate: function customValidate(cols) {
      var _this3 = this;

      var rcols = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      // const isSubmit = !cols
      var validates = {
        _FILES: function _FILES(value) {
          if (!_this3.files.length) {
            return {
              type: 'error',
              msg: '此為必填欄位，請上傳 批次檔案excel'
            };
          }
        },
        _IMAGES: function _IMAGES(value) {
          if (!_this3.images.length) {
            return {
              type: 'error',
              msg: '此為必填欄位，請上傳 零售價格照片ZIP'
            };
          }
        }
      };
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(cols || keys_default()(this.batchUpload)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var col = _step.value;

          var alert = (validates[col] || function () {})(this.result[col]);
          this.alerts = extends_default()({}, this.alerts, defineProperty_default()({}, col, alert || null));
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.alerts = extends_default()({}, this.alerts, rcols.reduce(function (s, c) {
        return extends_default()({}, s, defineProperty_default()({}, c, null));
      }, {}));
      return !values_default()(this.alerts).filter(function (x) {
        return x;
      }).length;
    },
    fileUpload: function fileUpload(e, value) {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var files, alertKeyMap;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                files = from_default()(e.target.files);

                e.target.value = '';
                _this4[value] = [].concat(toConsumableArray_default()(files));
                // alert
                alertKeyMap = {
                  files: '_FILES',
                  images: '_IMAGES'
                };

                _this4.alerts = extends_default()({}, _this4.alerts, defineProperty_default()({}, alertKeyMap[value], null));

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    },
    downloadExample: function downloadExample() {
      var url = api_config["a" /* API_ROOT */] + 'public/product_prices/batch_upload_example.xlsx';
      Object(util["c" /* downloadFile */])(null, url);
    },
    removeFile: function removeFile(file, value) {
      this[value].splice(this[value].indexOf(file), 1);
    },
    validateBatchUploadFile: function validateBatchUploadFile() {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var result, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, kv;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                result = {};

                _this5.onSubmit = true;
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context2.prev = 5;
                _iterator2 = get_iterator_default()(entries_default()(_this5.validate));

              case 7:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context2.next = 15;
                  break;
                }

                kv = _step2.value;
                _context2.next = 11;
                return kv[1].validate();

              case 11:
                result[kv[0]] = _context2.sent;

              case 12:
                _iteratorNormalCompletion2 = true;
                _context2.next = 7;
                break;

              case 15:
                _context2.next = 21;
                break;

              case 17:
                _context2.prev = 17;
                _context2.t0 = _context2['catch'](5);
                _didIteratorError2 = true;
                _iteratorError2 = _context2.t0;

              case 21:
                _context2.prev = 21;
                _context2.prev = 22;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 24:
                _context2.prev = 24;

                if (!_didIteratorError2) {
                  _context2.next = 27;
                  break;
                }

                throw _iteratorError2;

              case 27:
                return _context2.finish(24);

              case 28:
                return _context2.finish(21);

              case 29:
                result['custom'] = _this5.customValidate();

                if (values_default()(result).includes(false)) {
                  _context2.next = 33;
                  break;
                }

                _context2.next = 33;
                return _this5.batchUploadFile();

              case 33:
                _this5.onSubmit = false;

              case 34:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5, [[5, 17, 21, 29], [22,, 24, 28]]);
      }))();
    },
    batchUploadFile: function batchUploadFile() {
      var _this6 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var config, data, response, msg;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this6.setUploadingAction(null);
                _context3.prev = 1;
                config = _this6.$ls.get('userInfo');
                data = extends_default()({}, _this6.result, {
                  market_country: (_this6.countryOptions.find(function (option) {
                    return option.title === _this6.result.market_country;
                  }) || {}).value,
                  excel: _this6.files[0],
                  images_zip: _this6.images[0]
                });
                _context3.next = 6;
                return Object(src_api["J" /* postAdminProductPriceBatchUpload */])(data, config);

              case 6:
                response = _context3.sent;

                _this6.addToast('success', response.data.result || '上傳成功');
                _this6.$emit('changeModal', {}, true);
                _this6.setUploadingAction();
                _context3.next = 17;
                break;

              case 12:
                _context3.prev = 12;
                _context3.t0 = _context3['catch'](1);

                _this6.setUploadingAction();
                msg = !_context3.t0.response ? _context3.t0.message : _context3.t0.response.data.message || _context3.t0.response.data.errors.join('<br>');
                // this.addToast('error', msg)

                _this6.$emit('changeModal', {
                  action: 'toast',
                  width: '720px',
                  customStyles: {
                    padding: '0px'
                  },
                  param: {
                    type: 'error',
                    content: '<span>' + msg + '</span>',
                    buttons: [{
                      title: '關閉',
                      type: 'gray',
                      icon: 'fa-repeat',
                      style: {
                        padding: '10px 0',
                        width: '118px'
                      },
                      result: false
                    }]
                  }
                });

              case 17:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this6, [[1, 12]]);
      }))();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8cb95740","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/batchUpload.vue
var batchUpload_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"batch-upload-dailog container-block col-block"},[_c('div',{staticClass:"title-container row-block default-shadow"},[_c('div',{staticClass:"row-block",style:({ width: '35px' })}),_vm._v(" "),_c('div',{staticClass:"title",domProps:{"innerHTML":_vm._s('零售價格批次上傳')}}),_vm._v(" "),_c('div',{staticClass:"row-block close-button",style:({ width: '35px' })},[_c('img',{attrs:{"src":__webpack_require__("IREq")},on:{"click":function (e) { return _vm.$emit('changeModal'); }}})])]),_vm._v(" "),_c('div',{staticClass:"batch-upload-container col-block"},[_c('customRowForm',{attrs:{"init":_vm.batchUpload,"alerts":_vm.alerts,"forms":_vm.formOptions['field1']},on:{"change":function (result, validate, errors) { return _vm.formOnChange('field1', result, validate, errors); }}}),_vm._v(" "),_c('div',{staticClass:"example-container row-block"},[_c('div',{style:({ width: '125px' })}),_vm._v(" "),_c('div',{staticClass:"example-title",on:{"click":function (e) { return _vm.downloadExample(); }}},[_vm._v("範例excel下載")]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('customRowForm',{attrs:{"init":_vm.batchUpload,"alerts":_vm.alerts,"forms":_vm.formOptions['field2']},on:{"change":function () {}},scopedSlots:_vm._u([{key:"_FILES",fn:function(props){return [_c('div',{staticClass:"_FILES",attrs:{"name":props}},[_c('div',{staticClass:"file-container col-block"},[_c('div',{staticClass:"file-list col-block",style:({ flex: 1 })},_vm._l((_vm.files),function(file,index){return _c('div',{key:index,staticClass:"file-block row-block"},[_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('a',{staticClass:"file-title",attrs:{"title":file.name,"href":file.url,"target":"_blank"}},[_vm._v(_vm._s(file.name))]),_vm._v(" "),_c('div',{style:({ width: '10px' })}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("NBIZ"),"alt":""},on:{"click":function (e) { return _vm.removeFile(file, 'files'); }}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})])}),0),_vm._v(" "),_c('div',{style:({ height: '5px' })}),_vm._v(" "),_c('div',{staticClass:"mask"},[_c('label',{attrs:{"for":"upload-file"}}),_vm._v(" "),_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"type":"file","id":"upload-file","accept":"application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"},on:{"change":function (e) { return _vm.fileTypeCheck(e, function (e) { return _vm.fileUpload(e, 'files'); }, function () { return _vm.addToast('error', '請上傳excel檔'); }); }}}),_vm._v(" "),_c('button',{staticClass:"main-button"},[_c('span',[_vm._v("選擇檔案")])])]),_vm._v(" "),(_vm.alerts['_FILES'] && _vm.alerts['_FILES'].type === 'error')?_c('div',{staticClass:"file-alert"},[_vm._v(_vm._s(_vm.alerts['_FILES'].msg))]):_vm._e()])])]}},{key:"_IMAGES",fn:function(props){return [_c('div',{staticClass:"_IMAGES",attrs:{"name":props}},[_c('div',{staticClass:"file-container col-block"},[_c('div',{staticClass:"file-list col-block",style:({ flex: 1 })},_vm._l((_vm.images),function(file,index){return _c('div',{key:index,staticClass:"file-block row-block"},[_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('a',{staticClass:"file-title",attrs:{"title":file.name,"href":file.url,"target":"_blank"}},[_vm._v(_vm._s(file.name))]),_vm._v(" "),_c('div',{style:({ width: '10px' })}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("NBIZ"),"alt":""},on:{"click":function (e) { return _vm.removeFile(file, 'images'); }}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})])}),0),_vm._v(" "),_c('div',{style:({ height: '5px' })}),_vm._v(" "),_c('div',{staticClass:"mask"},[_c('label',{attrs:{"for":"upload-image"}}),_vm._v(" "),_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"type":"file","id":"upload-image","accept":"application/zip,application/x-zip-compressed"},on:{"change":function (e) { return _vm.fileTypeCheck(e, function (e) { return _vm.fileUpload(e, 'images'); }, function () { return _vm.addToast('error', '請上傳zip檔'); }); }}}),_vm._v(" "),_c('button',{staticClass:"main-button"},[_c('span',[_vm._v("選擇檔案")])])]),_vm._v(" "),(_vm.alerts['_IMAGES'] && _vm.alerts['_IMAGES'].type === 'error')?_c('div',{staticClass:"file-alert"},[_vm._v(_vm._s(_vm.alerts['_IMAGES'].msg))]):_vm._e()])])]}}])}),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button",attrs:{"type":"button","name":"button"},on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v("取消")])]),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('button',{staticClass:"main-button",class:{ loading: _vm.onSubmit },attrs:{"type":"button","name":"button","disabled":_vm.onError},on:{"click":function (e) { return _vm.validateBatchUploadFile(); }}},[_c('span',[_vm._v("批次上傳")])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])],1)])}
var batchUpload_staticRenderFns = []
var batchUpload_esExports = { render: batchUpload_render, staticRenderFns: batchUpload_staticRenderFns }
/* harmony default export */ var components_dialog_batchUpload = (batchUpload_esExports);
// CONCATENATED MODULE: ./src/components/dialog/batchUpload.vue
var batchUpload_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var batchUpload___vue_template_functional__ = false
/* styles */
var batchUpload___vue_styles__ = null
/* scopeId */
var batchUpload___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var batchUpload___vue_module_identifier__ = null
var batchUpload_Component = batchUpload_normalizeComponent(
  dialog_batchUpload,
  components_dialog_batchUpload,
  batchUpload___vue_template_functional__,
  batchUpload___vue_styles__,
  batchUpload___vue_scopeId__,
  batchUpload___vue_module_identifier__
)

/* harmony default export */ var src_components_dialog_batchUpload = (batchUpload_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-slider-component/dist/vue-slider-component.umd.min.js
var vue_slider_component_umd_min = __webpack_require__("lCKi");
var vue_slider_component_umd_min_default = /*#__PURE__*/__webpack_require__.n(vue_slider_component_umd_min);

// EXTERNAL MODULE: ./node_modules/vue-slider-component/theme/default.css
var theme_default = __webpack_require__("n1Sy");
var default_default = /*#__PURE__*/__webpack_require__.n(theme_default);

// EXTERNAL MODULE: ./src/components/tool/switchButton.vue + 2 modules
var switchButton = __webpack_require__("BdG8");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/tool/weightingFilter.vue





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var weightingFilter = ({
  components: {
    vueSlider: vue_slider_component_umd_min_default.a,
    switchButton: switchButton["a" /* default */]
  },
  props: {
    init: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    filters: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      conditions: {},
      output: {}
    };
  },

  watch: {
    'init': function init() {
      this.initialConditions();
    },
    'filters': function filters() {
      this.initialConditions();
    },

    'conditions': {
      handler: function () {
        var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
          return regenerator_default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return this.afterTreatment(this.conditions);

                case 2:
                  this.output = _context.sent;

                  this.$emit('change', this.output);

                case 4:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function handler() {
          return _ref.apply(this, arguments);
        }

        return handler;
      }(),
      deep: true
    }
  },
  created: function created() {
    this.initialConditions();
  },

  methods: {
    initialConditions: function initialConditions() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var input, initials;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this.preTreatment(_this.init);

              case 2:
                input = _context2.sent;
                initials = {
                  slider: function slider() {
                    return { active: true, value: 0 };
                  }
                };

                _this.conditions = _this.filters.reduce(function (s, c) {
                  return extends_default()({}, s, defineProperty_default()({}, c.value, input[c.value] || initials['slider']()));
                }, {});

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    },
    preTreatment: function preTreatment(init) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var input, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, filter;

        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                input = {};
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context4.prev = 4;
                _iterator = get_iterator_default()(_this2.filters);

              case 6:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context4.next = 14;
                  break;
                }

                filter = _step.value;
                _context4.next = 10;
                return (filter.inputFormat || function () {
                  var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3(x) {
                    return regenerator_default.a.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            return _context3.abrupt('return', x);

                          case 1:
                          case 'end':
                            return _context3.stop();
                        }
                      }
                    }, _callee3, _this2);
                  }));

                  return function (_x) {
                    return _ref2.apply(this, arguments);
                  };
                }())(init[filter.value]);

              case 10:
                input[filter.value] = _context4.sent;

              case 11:
                _iteratorNormalCompletion = true;
                _context4.next = 6;
                break;

              case 14:
                _context4.next = 20;
                break;

              case 16:
                _context4.prev = 16;
                _context4.t0 = _context4['catch'](4);
                _didIteratorError = true;
                _iteratorError = _context4.t0;

              case 20:
                _context4.prev = 20;
                _context4.prev = 21;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 23:
                _context4.prev = 23;

                if (!_didIteratorError) {
                  _context4.next = 26;
                  break;
                }

                throw _iteratorError;

              case 26:
                return _context4.finish(23);

              case 27:
                return _context4.finish(20);

              case 28:
                return _context4.abrupt('return', input);

              case 29:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this2, [[4, 16, 20, 28], [21,, 23, 27]]);
      }))();
    },
    afterTreatment: function afterTreatment(conditions) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
        var output, _loop, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, filter;

        return regenerator_default.a.wrap(function _callee6$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                output = {};
                _loop = /*#__PURE__*/regenerator_default.a.mark(function _loop(filter) {
                  return regenerator_default.a.wrap(function _loop$(_context6) {
                    while (1) {
                      switch (_context6.prev = _context6.next) {
                        case 0:
                          _context6.next = 2;
                          return (filter.outputFormat || function () {
                            var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5(x) {
                              return regenerator_default.a.wrap(function _callee5$(_context5) {
                                while (1) {
                                  switch (_context5.prev = _context5.next) {
                                    case 0:
                                      return _context5.abrupt('return', extends_default()({}, x, { title: filter.title }));

                                    case 1:
                                    case 'end':
                                      return _context5.stop();
                                  }
                                }
                              }, _callee5, _this3);
                            }));

                            return function (_x2) {
                              return _ref3.apply(this, arguments);
                            };
                          }())(conditions[filter.value]);

                        case 2:
                          output[filter.value] = _context6.sent;

                        case 3:
                        case 'end':
                          return _context6.stop();
                      }
                    }
                  }, _loop, _this3);
                });
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context7.prev = 5;
                _iterator2 = get_iterator_default()(_this3.filters);

              case 7:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context7.next = 13;
                  break;
                }

                filter = _step2.value;
                return _context7.delegateYield(_loop(filter), 't0', 10);

              case 10:
                _iteratorNormalCompletion2 = true;
                _context7.next = 7;
                break;

              case 13:
                _context7.next = 19;
                break;

              case 15:
                _context7.prev = 15;
                _context7.t1 = _context7['catch'](5);
                _didIteratorError2 = true;
                _iteratorError2 = _context7.t1;

              case 19:
                _context7.prev = 19;
                _context7.prev = 20;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 22:
                _context7.prev = 22;

                if (!_didIteratorError2) {
                  _context7.next = 25;
                  break;
                }

                throw _iteratorError2;

              case 25:
                return _context7.finish(22);

              case 26:
                return _context7.finish(19);

              case 27:
                return _context7.abrupt('return', output);

              case 28:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee6, _this3, [[5, 15, 19, 27], [20,, 22, 26]]);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f3c3de","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/weightingFilter.vue
var weightingFilter_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"weighting-filter-container"}},[_c('div',{staticClass:"weighting-title-container row-block"},[_c('div',{staticClass:"title"},[_vm._v("指標加權")]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_vm._l((_vm.filters),function(filter,index){return _c('div',{key:index,staticClass:"weighting-filter-group"},[(_vm.conditions[filter.value])?[_c('div',{staticClass:"title-block row-block"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(filter.title))]),_vm._v(" "),_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('switchButton',{attrs:{"type":"primary","size":"small","disabled":_vm.disabled,"checked":_vm.conditions[filter.value].active},on:{"input":function (value) { return _vm.conditions[filter.value].active = value; }}}),_vm._v(" "),_c('div',{style:({ width: '30px' })})],1),_vm._v(" "),_c('div',{staticClass:"options",class:['slider']},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"slider"},[_c('vueSlider',_vm._b({attrs:{"disabled":!_vm.conditions[filter.value].active,"tooltip":'none',"dotSize":9,"dotStyle":{
                background: '#555555'
              },"processStyle":{
                background: _vm.conditions[filter.value].active ? '#B4E04F' : '#444444'
              }},model:{value:(_vm.conditions[filter.value].value),callback:function ($$v) {_vm.$set(_vm.conditions[filter.value], "value", $$v)},expression:"conditions[filter.value].value"}},'vueSlider',filter.options,false))],1),_vm._v(" "),_c('div',{staticClass:"value"},[_c('span',[_vm._v(_vm._s(_vm.conditions[filter.value].active ? _vm.conditions[filter.value].value : 0))])])])])]:_vm._e()],2)})],2)}
var weightingFilter_staticRenderFns = []
var weightingFilter_esExports = { render: weightingFilter_render, staticRenderFns: weightingFilter_staticRenderFns }
/* harmony default export */ var tool_weightingFilter = (weightingFilter_esExports);
// CONCATENATED MODULE: ./src/components/tool/weightingFilter.vue
function weightingFilter_injectStyle (ssrContext) {
  __webpack_require__("9Z7k")
}
var weightingFilter_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var weightingFilter___vue_template_functional__ = false
/* styles */
var weightingFilter___vue_styles__ = weightingFilter_injectStyle
/* scopeId */
var weightingFilter___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var weightingFilter___vue_module_identifier__ = null
var weightingFilter_Component = weightingFilter_normalizeComponent(
  weightingFilter,
  tool_weightingFilter,
  weightingFilter___vue_template_functional__,
  weightingFilter___vue_styles__,
  weightingFilter___vue_scopeId__,
  weightingFilter___vue_module_identifier__
)

/* harmony default export */ var components_tool_weightingFilter = (weightingFilter_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/analysis/filter.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var analysis_filter = ({
  components: {
    customFilter: components_tool_customFilter,
    weightingFilter: components_tool_weightingFilter
  },
  props: {
    minHeight: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    filters: {
      type: Object,
      required: true
    },
    weightings: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      conditions: {
        filters: {},
        weightings: {}
      }
    };
  },

  methods: {
    filtersOnChange: function filtersOnChange(conditions) {
      // const init = !Object.values(this.conditions.filters).every(x => x)
      var init = false;
      this.conditions.filters = conditions;
      if (init) {
        this.updateFilter();
      }
    },
    updateFilter: function updateFilter() {
      this.$emit('changeFilters', JSON.parse(stringify_default()(this.conditions.filters)));
    },
    weightingsOnChange: function weightingsOnChange(conditions) {
      this.conditions.weightings = conditions;
      this.$emit('changeWeightings', JSON.parse(stringify_default()(this.conditions.weightings)));
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d89097d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/analysis/filter.vue
var analysis_filter_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"analysis-filter-page col-block default-shadow",style:({ height: _vm.minHeight })},[(_vm.disabled)?_c('div',{staticClass:"mask"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"title-container center-block"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"filter-container"},[_c('customFilter',{attrs:{"init":_vm.filters.init,"filters":_vm.filters.options},on:{"change":function (conditions) { return _vm.filtersOnChange(conditions); },"pressEnter":function () { return _vm.updateFilter(); }}}),_vm._v(" "),_c('div',{staticClass:"button"},[_c('button',{staticClass:"main-button",attrs:{"type":"button","name":"button"},on:{"click":function (e) { return _vm.updateFilter(); }}},[_c('span',[_vm._v("搜尋")])])])],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"weighting-container",style:({ flex: 1 })},[_c('weightingFilter',{attrs:{"init":_vm.weightings.init,"filters":_vm.weightings.options,"disabled":_vm.weightings.disabled},on:{"change":function (conditions) { return _vm.weightingsOnChange(conditions); }}})],1)])}
var analysis_filter_staticRenderFns = []
var analysis_filter_esExports = { render: analysis_filter_render, staticRenderFns: analysis_filter_staticRenderFns }
/* harmony default export */ var components_analysis_filter = (analysis_filter_esExports);
// CONCATENATED MODULE: ./src/components/analysis/filter.vue
var analysis_filter_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var analysis_filter___vue_template_functional__ = false
/* styles */
var analysis_filter___vue_styles__ = null
/* scopeId */
var analysis_filter___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var analysis_filter___vue_module_identifier__ = null
var analysis_filter_Component = analysis_filter_normalizeComponent(
  analysis_filter,
  components_analysis_filter,
  analysis_filter___vue_template_functional__,
  analysis_filter___vue_styles__,
  analysis_filter___vue_scopeId__,
  analysis_filter___vue_module_identifier__
)

/* harmony default export */ var src_components_analysis_filter = (analysis_filter_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/main/analysis.vue







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var main_analysis = ({
  components: {
    analysisFilter: src_components_analysis_filter,
    analysisPanel: src_components_analysis_panel
  },
  mixins: [mixins_routeLoading, toastMethods["a" /* default */]],
  props: {
    minHeight: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      datas: [],
      reportCountrys: [],
      options: {
        products: [],
        years: []
      },
      init: {
        filters: {},
        weightings: {}
      },
      conditions: {
        filters: {},
        weightings: {}
      },
      onSearch: false,
      tabState: 'table'
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['countrys']), {
    analysisType: function analysisType() {
      return this.$route.name;
    },
    countryOptions: function countryOptions() {
      return this.countrys.map(function (_ref) {
        var _ref2 = slicedToArray_default()(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        return {
          title: value.chinese_name + '(' + value.iso_name + ')',
          value: key,
          country: value
        };
      });
    },

    // static
    filterOptions: function filterOptions() {
      var _this = this;

      return {
        competitiveness: [{
          title: '產品項目',
          value: 'product',
          type: 'select',
          options: this.options.products,
          placeholder: function placeholder() {
            return '水果、蔬菜...';
          }
        }, {
          title: '目標市場',
          value: 'country',
          type: 'datalist',
          lists: function lists(value) {
            return _this.countryOptions.map(function (option) {
              return option.title;
            });
          },
          options: this.countryOptions,
          placeholder: function placeholder() {
            return '國家名稱...';
          },
          onChange: function onChange(value) {
            if (value && !_this.countryOptions.some(function (option) {
              return option.title === value;
            })) {
              _this.init.filters = extends_default()({}, _this.init.filters, _this.conditions.filters, {
                country: ''
              });
            }
          },
          outputFormat: function outputFormat(value) {
            return (_this.countryOptions.find(function (option) {
              return option.title === value;
            }) || {}).value;
          }
        }, {
          title: '年份',
          value: 'year',
          type: 'select',
          options: this.options.years,
          placeholder: function placeholder() {
            return '年份';
          }
        }],
        attraction: [{
          title: '產品項目',
          value: 'product',
          type: 'select',
          options: this.options.products,
          placeholder: function placeholder() {
            return '水果、蔬菜...';
          }
        }, {
          title: '年份',
          value: 'year',
          type: 'select',
          options: this.options.years,
          placeholder: function placeholder() {
            return '年份';
          }
        }],
        toolcompetitiveness: [{
          title: '產品項目',
          value: 'product',
          type: 'select',
          options: this.options.products,
          placeholder: function placeholder() {
            return '農業機械...';
          }
        }, {
          title: '目標市場',
          value: 'country',
          type: 'datalist',
          lists: function lists(value) {
            return _this.countryOptions.map(function (option) {
              return option.title;
            });
          },
          options: this.countryOptions,
          placeholder: function placeholder() {
            return '國家名稱...';
          },
          onChange: function onChange(value) {
            if (value && !_this.countryOptions.some(function (option) {
              return option.title === value;
            })) {
              _this.init.filters = extends_default()({}, _this.init.filters, _this.conditions.filters, {
                country: ''
              });
            }
          },
          outputFormat: function outputFormat(value) {
            return (_this.countryOptions.find(function (option) {
              return option.title === value;
            }) || {}).value;
          }
        }, {
          title: '年份',
          value: 'year',
          type: 'select',
          options: this.options.years,
          placeholder: function placeholder() {
            return '年份';
          }
        }],
        toolattraction: [{
          title: '產品項目',
          value: 'product',
          type: 'select',
          options: this.options.products,
          placeholder: function placeholder() {
            return '農業機械...';
          }
        }, {
          title: '年份',
          value: 'year',
          type: 'select',
          options: this.options.years,
          placeholder: function placeholder() {
            return '年份';
          }
        }]
      }[this.analysisType];
    },
    weightingOptions: function weightingOptions() {
      return {
        competitiveness: [{
          title: '產量',
          value: 'production_quantity'
        }, {
          title: '單位面積產量',
          value: 'yield'
        }, {
          title: '生產者價格',
          value: 'producer_price'
        }, {
          title: '進口單價',
          value: 'import_price'
        }, {
          title: 'RCA',
          value: 'RCA'
        }, {
          title: 'TII',
          value: 'TII'
        }, {
          title: '市場距離',
          value: 'distance'
        }],
        attraction: [{
          title: '產量',
          value: 'production_quantity'
        }, {
          title: '出口值',
          value: 'export_value'
        }, {
          title: '進口值',
          value: 'import_value'
        }, {
          title: '市場規模',
          value: 'market_size'
        }, {
          title: '進口市場成長趨勢',
          value: 'import_market_growth_trend'
        }, {
          title: 'TSI',
          value: 'TSI'
        }, {
          title: '市場距離',
          value: 'distance'
        }, {
          title: '佔全球貿易市場佔有率',
          value: 'market_share'
        }, {
          title: '平均每人GDP',
          value: 'GDP'
        }, {
          title: '人口數',
          value: 'total_population'
        }, {
          title: '市場成長相對強度',
          value: 'market_growth_intensity'
        }, {
          title: '進口市場表現',
          value: 'market_performance'
        }, {
          title: '市場開放程度',
          value: 'market_openness'
        }, {
          title: '市場相對優惠關稅',
          value: 'market_preferential_tariff'
        }],
        toolcompetitiveness: [{
          title: '進口單價',
          value: 'import_price'
        }, {
          title: 'RCA',
          value: 'RCA'
        }, {
          title: 'TII',
          value: 'TII'
        }],
        toolattraction: [{
          title: '出口值',
          value: 'export_value'
        }, {
          title: '進口值',
          value: 'import_value'
        }, {
          title: '進口市場成長趨勢',
          value: 'import_market_growth_trend'
        }, {
          title: 'TSI',
          value: 'TSI'
        }, {
          title: '佔全球貿易市場佔有率',
          value: 'market_share'
        }, {
          title: '平均每人GDP',
          value: 'GDP'
        }, {
          title: 'GNI',
          value: 'GNI'
        }, {
          title: '農業人口比率',
          value: 'agricultural_population_proportion'
        }, {
          title: '農業人口比率趨勢',
          value: 'agricultural_population_proportion_trend'
        }, {
          title: '耕地面積',
          value: 'cultivated_area'
        }, {
          title: '平均農業人口耕地面積',
          value: 'average_agricultural_population_cultivated_area'
        }, {
          title: '市場成長相對強度',
          value: 'market_growth_intensity'
        }, {
          title: '進口市場表現',
          value: 'market_performance'
        }, {
          title: '市場開放程度',
          value: 'market_openness'
        }, {
          title: '市場相對優惠關稅',
          value: 'market_preferential_tariff'
        }]
      }[this.analysisType].map(function (options) {
        return extends_default()({}, options, {
          options: {
            min: 0,
            max: 10,
            interval: 1
          }
        });
      });
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setModalAction']), {
    fetchData: function fetchData() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.fetchProducts();

              case 2:
                _context.next = 4;
                return _this2.fetchYears();

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    fetchProducts: function fetchProducts() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var config, type, response, products;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                config = _this3.$ls.get('userInfo');
                type = {
                  competitiveness: '農產品',
                  attraction: '農產品',
                  toolcompetitiveness: '農機具',
                  toolattraction: '農機具'
                }[_this3.analysisType];
                _context2.next = 5;
                return Object(src_api["y" /* getProducts */])(config);

              case 5:
                response = _context2.sent;
                products = response.data;

                _this3.options.products = entries_default()(products).filter(function (_ref3) {
                  var _ref4 = slicedToArray_default()(_ref3, 2),
                      key = _ref4[0],
                      value = _ref4[1];

                  return value.product_type === type;
                }).map(function (_ref5) {
                  var _ref6 = slicedToArray_default()(_ref5, 2),
                      key = _ref6[0],
                      value = _ref6[1];

                  return {
                    title: value.chinese_name + '(' + key + ')',
                    value: key
                  };
                });
                _this3.init.filters.product = null;
                _context2.next = 14;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2['catch'](0);
                throw _context2.t0;

              case 14:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[0, 11]]);
      }))();
    },
    fetchYears: function fetchYears() {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var config, response, years;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                config = _this4.$ls.get('userInfo');
                _context3.next = 4;
                return Object(src_api["H" /* getYears */])(config);

              case 4:
                response = _context3.sent;
                years = response.data;

                _this4.options.years = values_default()(years).map(function (year) {
                  return {
                    title: year,
                    value: year
                  };
                }).reverse();
                _this4.init.filters.year = null;
                _context3.next = 13;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3['catch'](0);
                throw _context3.t0;

              case 13:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4, [[0, 10]]);
      }))();
    },
    fetchDatas: function fetchDatas() {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var api, config, conditions, response, datas;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                api = {
                  competitiveness: src_api["n" /* getCompetitivenessDatas */],
                  attraction: src_api["m" /* getAttractionDatas */],
                  toolcompetitiveness: src_api["n" /* getCompetitivenessDatas */],
                  toolattraction: src_api["m" /* getAttractionDatas */]
                }[_this5.analysisType];
                config = _this5.$ls.get('userInfo');
                conditions = {
                  competitiveness: {
                    product: _this5.conditions.filters.product,
                    year: _this5.conditions.filters.year,
                    partner: _this5.conditions.filters.country
                  },
                  attraction: {
                    product: _this5.conditions.filters.product,
                    year: _this5.conditions.filters.year
                  },
                  toolcompetitiveness: {
                    product: _this5.conditions.filters.product,
                    year: _this5.conditions.filters.year,
                    partner: _this5.conditions.filters.country
                  },
                  toolattraction: {
                    product: _this5.conditions.filters.product,
                    year: _this5.conditions.filters.year
                  }
                }[_this5.analysisType];
                _context4.next = 6;
                return api(conditions, config);

              case 6:
                response = _context4.sent;
                datas = response.data;

                _this5.datas = datas;
                if (['070511', '070690', '070959', '080290', '080390', '081090'].includes(_this5.conditions.filters.product)) {
                  _this5.dataAlert();
                }
                _context4.next = 16;
                break;

              case 12:
                _context4.prev = 12;
                _context4.t0 = _context4['catch'](0);

                _this5.datas = [];
                if (_context4.t0.response.status === 429) {
                  _this5.addToast('error', '您的操作過於頻繁，請稍後再繼續。');
                }

              case 16:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5, [[0, 12]]);
      }))();
    },
    fetchReportCountrys: function fetchReportCountrys() {
      var _this6 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        var config, conditions, response, reportCountrys;
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                config = _this6.$ls.get('userInfo');
                conditions = {
                  competitiveness: {
                    product_code: _this6.conditions.filters.product,
                    country: _this6.conditions.filters.country,
                    module: 'market_competitiveness'
                  },
                  attraction: {
                    product_code: _this6.conditions.filters.product,
                    module: 'market_attractiveness'
                  },
                  toolcompetitiveness: {
                    product_code: _this6.conditions.filters.product,
                    country: _this6.conditions.filters.country,
                    module: 'market_competitiveness'
                  },
                  toolattraction: {
                    product_code: _this6.conditions.filters.product,
                    module: 'market_attractiveness'
                  }
                }[_this6.analysisType];
                _context5.next = 5;
                return Object(src_api["B" /* getReportCountrys */])(conditions, config);

              case 5:
                response = _context5.sent;
                reportCountrys = response.data.data;

                _this6.reportCountrys = reportCountrys;
                _context5.next = 13;
                break;

              case 10:
                _context5.prev = 10;
                _context5.t0 = _context5['catch'](0);
                throw _context5.t0;

              case 13:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this6, [[0, 10]]);
      }))();
    },
    afterSetData: function afterSetData(active) {
      var _this7 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this7.init.weightings = {
                  competitiveness: ['production_quantity', 'yield', 'producer_price', 'import_price', 'RCA', 'TII', 'distance'],
                  attraction: ['production_quantity', 'export_value', 'import_value', 'market_size', 'import_market_growth_trend', 'TSI', 'distance', 'market_share', 'GDP', 'total_population', 'market_growth_intensity', 'market_performance', 'market_openness', 'market_preferential_tariff'],
                  toolcompetitiveness: ['import_price', 'RCA', 'TII'],
                  toolattraction: ['export_value', 'import_value', 'import_market_growth_trend', 'TSI', 'market_share', 'GDP', 'GNI', 'agricultural_population_proportion', 'agricultural_population_proportion_trend', 'cultivated_area', 'average_agricultural_population_cultivated_area', 'market_growth_intensity', 'market_performance', 'market_openness', 'market_preferential_tariff']
                }[_this7.analysisType].reduce(function (s, c) {
                  return extends_default()({}, s, defineProperty_default()({}, c, active ? { active: true, value: 1 } : { active: false, value: 0 }));
                }, {});

              case 1:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this7);
      }))();
    },
    searchDatas: function searchDatas(setData) {
      var _this8 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7() {
        return regenerator_default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this8.onSearch = true;
                _context7.next = 3;
                return _this8.fetchDatas();

              case 3:
                _context7.next = 5;
                return _this8.fetchReportCountrys();

              case 5:
                if (!(_this8.datas.length && setData)) {
                  _context7.next = 8;
                  break;
                }

                _context7.next = 8;
                return _this8.afterSetData(true);

              case 8:
                _this8.onSearch = false;

              case 9:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this8);
      }))();
    },
    dataAlert: function dataAlert() {
      var _this9 = this;

      this.setModalAction({
        action: 'toast',
        customStyles: {
          padding: '0px'
        },
        param: {
          type: 'success',
          content: '<span>此產品項目為多品項，其產量、單位面積產量與生產者價格為混合資料，若需精準數值，請至其他網站查詢。</span>',
          buttons: [{
            title: '關閉',
            type: 'gray',
            icon: 'fa-repeat',
            result: false
          }]
        },
        callback: function () {
          var _ref7 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee8(result) {
            return regenerator_default.a.wrap(function _callee8$(_context8) {
              while (1) {
                switch (_context8.prev = _context8.next) {
                  case 0:
                  case 'end':
                    return _context8.stop();
                }
              }
            }, _callee8, _this9);
          }));

          return function callback(_x) {
            return _ref7.apply(this, arguments);
          };
        }()
      });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01b496da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/main/analysis.vue
var main_analysis_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"analysis-page row-block",style:({ minHeight: _vm.minHeight })},[_c('div',{staticClass:"filter-container",style:({ width: '250px' })},[_c('analysisFilter',{attrs:{"minHeight":_vm.minHeight,"disabled":_vm.tabState === 'graph',"title":{
        competitiveness: '市場競爭力分析',
        attraction: '市場吸引力分析',
        toolcompetitiveness: '農業機械市場競爭力分析',
        toolattraction: '農業機械市場吸引力分析'
      }[_vm.analysisType],"filters":{
        init: _vm.init.filters,
        options: _vm.filterOptions
      },"weightings":{
        init: _vm.init.weightings,
        options: _vm.weightingOptions,
        disabled: !this.datas.length
      }},on:{"changeFilters":function (c) { _vm.conditions.filters = c; _vm.searchDatas(true) },"changeWeightings":function (c) { return _vm.conditions.weightings = c; }}})],1),_vm._v(" "),_c('div',{staticClass:"panel-container",style:({ flex: 1 })},[(_vm.onSearch)?_c('div',{staticClass:"mask center-block"},[_c('img',{attrs:{"src":__webpack_require__("5xS/"),"alt":""}})]):_vm._e(),_vm._v(" "),_c('analysisPanel',{attrs:{"dataType":'country',"minHeight":_vm.minHeight,"datas":_vm.datas,"reportCountrys":_vm.reportCountrys || [],"filterOptions":{
        filters: _vm.filterOptions,
        weightings: _vm.weightingOptions
      },"conditions":_vm.conditions},on:{"changeState":function (s) { return _vm.tabState = s; }}})],1)])}
var main_analysis_staticRenderFns = []
var main_analysis_esExports = { render: main_analysis_render, staticRenderFns: main_analysis_staticRenderFns }
/* harmony default export */ var pages_main_analysis = (main_analysis_esExports);
// CONCATENATED MODULE: ./src/pages/main/analysis.vue
var main_analysis_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var main_analysis___vue_template_functional__ = false
/* styles */
var main_analysis___vue_styles__ = null
/* scopeId */
var main_analysis___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var main_analysis___vue_module_identifier__ = null
var main_analysis_Component = main_analysis_normalizeComponent(
  main_analysis,
  pages_main_analysis,
  main_analysis___vue_template_functional__,
  main_analysis___vue_styles__,
  main_analysis___vue_scopeId__,
  main_analysis___vue_module_identifier__
)

/* harmony default export */ var src_pages_main_analysis = (main_analysis_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













// main











// modals










var mainattraction = src_pages_main_analysis;
var maincompetitiveness = src_pages_main_analysis;
var maintoolattraction = src_pages_main_analysis;
var maintoolcompetitiveness = src_pages_main_analysis;

__webpack_require__("5W8o");

/* harmony default export */ var App = ({
  name: 'app',
  components: {
    layoutHeader: components_layout_header,
    layoutFooter: components_layout_footer,
    layoutToast: components_tool_toast,
    layoutLoading: components_layout_loading,
    layoutUploading: components_layout_uploading,
    // main
    mainmain: pages_main_main,
    mainforgot: pages_main_forgot,
    mainreset: src_pages_main_reset,
    mainredirect: src_pages_main_redirect,
    mainattraction: mainattraction,
    maincompetitiveness: maincompetitiveness,
    maintoolattraction: maintoolattraction,
    maintoolcompetitiveness: maintoolcompetitiveness,
    mainadmin: src_pages_main_admin,
    mainadminProductPrice: pages_main_adminProductPrice,
    mainadminReport: pages_main_adminReport,
    mainadminAccessLog: pages_main_adminAccessLog,
    maintutorial: pages_main_tutorial,
    mainproductPrice: src_pages_main_productPrice,
    mainreport: src_pages_main_report,
    // modals
    modal: components_dialog_container,
    toast: src_components_dialog_toast,
    analysis: components_dialog_analysis,
    editProductPrice: src_components_dialog_editProductPrice,
    editReport: src_components_dialog_editReport,
    reportDetail: components_dialog_reportDetail,
    graphData: src_components_dialog_graphData,
    batchUpload: src_components_dialog_batchUpload
  },
  mixins: [mixins_responsitive, loginData["a" /* default */], toastMethods["a" /* default */]],
  data: function data() {
    return {
      minHeight: '300px',
      loading: {
        timer: null,
        value: false
      }
    };
  },

  watch: {
    '$route': function $route() {
      var _document = document,
          body = _document.body;

      body.scroll(0, 0);
      this.setModalAction({});
    },
    'isLogin': function isLogin(n, o) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(o !== null)) {
                  _context.next = 9;
                  break;
                }

                _this.setLoadingAction(true);
                _context.next = 4;
                return _this.preFetchDataGuest();

              case 4:
                if (!n) {
                  _context.next = 7;
                  break;
                }

                _context.next = 7;
                return _this.preFetchData();

              case 7:
                _this.appInitialAction(n);
                _this.setLoadingAction(false);

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },

    // loading
    'isLoading': function isLoading(nv) {
      var _this2 = this;

      if (nv) {
        this.loading.value = true;
      } else {
        setTimeout(function () {
          _this2.loading.value = false;
        }, 150);
      }
    }
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['normalPage', 'userPage', 'adminPage', 'isLogin', 'isLoading', 'isDialogLoading', 'isUploading', 'modal']), {
    needBackground: function needBackground() {
      return this.$route.name && ['main', 'forgot', 'reset', 'redirect', 'register', 'user', ''].includes(this.$route.name);
    },
    isMainPage: function isMainPage() {
      return this.$route.name && ['main', 'forgot', 'reset', 'redirect', 'attraction', 'competitiveness', 'toolattraction', 'toolcompetitiveness', 'admin', 'adminProductPrice', 'adminReport', 'adminAccessLog', 'report', 'tutorial', 'productPrice', ''].includes(this.$route.name);
    },
    maxWidthStyle: function maxWidthStyle() {
      return extends_default()({
        minHeight: this.minHeight,
        display: this.isMainPage ? 'flex' : 'block',
        'align-items': 'center'
      }, this.$route.name === 'casePolicy' ? { minWidth: 0 } : {});
    }
  }),
  created: function created() {
    var _this3 = this;

    this.setModalAction({});
    this.setLoadingAction(true);
    var validateLogin = function validateLogin() {
      if (_this3.$route.name) {
        _this3.validateLogin();
      } else {
        setTimeout(function () {
          return validateLogin();
        }, 100);
      }
    };
    validateLogin();
  },
  beforeMount: function beforeMount() {
    var _this4 = this;

    var _document2 = document,
        body = _document2.body;

    var handler = function handler() {
      if (!document.hidden) {
        var rect = body.getBoundingClientRect();
        var headerHeight = 70;
        var footerHeight = 40;
        var height = rect.height - headerHeight - footerHeight + 0;
        _this4.minHeight = height + 'px';
      }
    };
    document.addEventListener('visibilitychange', handler);
    window.addEventListener('DOMContentLoaded', handler);
    window.addEventListener('resize', handler);
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['appInitialAction', 'setLoadingAction', 'setDialogLoadingAction', 'clearLoadingAction', 'clearDialogLoadingAction', 'setModalAction', 'setSourceAction', 'setCountrysAction']), {
    preFetchDataGuest: function preFetchDataGuest() {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this5.fetchSource();

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5);
      }))();
    },
    fetchSource: function fetchSource() {
      var _this6 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var response, source;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return Object(src_api["D" /* getSource */])();

              case 3:
                response = _context3.sent;
                source = response.data;

                _this6.setSourceAction(source);
                _context3.next = 11;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3['catch'](0);

                _this6.addToast('error', !_context3.t0.response ? _context3.t0.message : _context3.t0.response.data.message || _context3.t0.response.data.errors.join('<br>'));

              case 11:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this6, [[0, 8]]);
      }))();
    },
    preFetchData: function preFetchData() {
      var _this7 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this7.fetchCountrys();

              case 2:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this7);
      }))();
    },
    fetchCountrys: function fetchCountrys() {
      var _this8 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        var config, response, countrys;
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                config = _this8.$ls.get('userInfo');
                _context5.next = 4;
                return Object(src_api["o" /* getCountrys */])(config);

              case 4:
                response = _context5.sent;
                countrys = response.data;

                countrys = Object(util["j" /* sortData */])(entries_default()(countrys), function (kv) {
                  return kv[1].iso_name;
                });
                _this8.setCountrysAction(countrys);
                _context5.next = 13;
                break;

              case 10:
                _context5.prev = 10;
                _context5.t0 = _context5['catch'](0);

                _this8.addToast('error', !_context5.t0.response ? _context5.t0.message : _context5.t0.response.data.message || _context5.t0.response.data.errors.join('<br>'));

              case 13:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this8, [[0, 10]]);
      }))();
    },
    validateLogin: function validateLogin() {
      var _this9 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
        var userInfo;
        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                userInfo = _this9.$ls.get('userInfo') || {};
                _context6.next = 3;
                return _this9.preFetchDataGuest();

              case 3:
                if (!userInfo['access_token']) {
                  _context6.next = 10;
                  break;
                }

                _context6.next = 6;
                return _this9.preFetchData();

              case 6:
                _context6.next = 8;
                return _this9.getUserByToken(userInfo);

              case 8:
                _context6.next = 13;
                break;

              case 10:
                _this9.setUserData(null);
                _this9.appInitialAction(false);
                _this9.validateRoute(false);

              case 13:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this9);
      }))();
    },
    getUserByToken: function getUserByToken(data) {
      var _this10 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7() {
        var response, user;
        return regenerator_default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return Object(src_api["G" /* getUserToken */])(data);

              case 3:
                response = _context7.sent;
                user = response.data.data || { role: {} };

                _this10.setUserData(response, data['access_token']);
                _this10.appInitialAction(true);
                _this10.validateRoute(true, null, user.role === 'admin');
                _context7.next = 16;
                break;

              case 10:
                _context7.prev = 10;
                _context7.t0 = _context7['catch'](0);

                _this10.setUserData(null);
                _this10.appInitialAction(true);
                _this10.addToast('error', !_context7.t0.response ? _context7.t0.message : _context7.t0.response.data.message || _context7.t0.response.data.errors.join('<br>'));
                _this10.validateRoute(false);

              case 16:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this10, [[0, 10]]);
      }))();
    },
    validateRoute: function validateRoute(isLogin, role, admin) {
      var array = [];
      if (isLogin) {
        switch (role) {
          default:
            {
              array = lodash_default.a.union(this.userPage, this.normalPage);
            }
        }
      } else {
        array = this.normalPage;
      }
      if (admin) {
        array = lodash_default.a.union(array, this.adminPage);
      }
      this.validateRole(isLogin, array);
    },
    validateRole: function validateRole(isLogin, pages) {
      var routeName = this.$route.name;
      if (routeName && !lodash_default.a.includes(pages, routeName)) {
        this.addToast('error', isLogin ? '權限不足' : '請先登入');
        this.$router.push({ name: !isLogin ? 'main' : 'tutorial' });
        this.setLoadingAction(false);
      } else {
        if (isLogin && lodash_default.a.includes(this.normalPage, routeName) && routeName !== 'redirect') {
          this.$router.push({ name: 'tutorial' });
        }
        this.setLoadingAction(false);
      }
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cd1093e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-root",attrs:{"id":"app"}},[_c('layout-header'),_vm._v(" "),_c('div',{staticClass:"app-container",style:({ position: _vm.modal.action && !_vm.isDialogLoading ? 'relative' : 'relative' })},[_c('div',{staticClass:"app-pages"},[_c('div',{staticClass:"app-background",class:{ filter: !_vm.isMainPage, cover: _vm.isMainPage },style:(_vm.needBackground ? { backgroundImage: 'url(' + __webpack_require__("TuFs") + ')', backgroundSize: 'cover' } : { background: '#777777' })}),_vm._v(" "),_c('div',{staticClass:"max-width",class:{ 'all-width': _vm.isMainPage },style:(_vm.maxWidthStyle)},[(!_vm.isMainPage)?_c('div',{staticClass:"view-container",class:{ mobile: _vm.$route.name === 'casePolicy' }},[_c('div',{staticClass:"view-field default-shadow"},[_c('router-view')],1)]):_c('div',{staticClass:"app-main-container"},[_c('main' + _vm.$route.name,{tag:"component",attrs:{"minHeight":_vm.minHeight}})],1)]),_vm._v(" "),_c('layout-footer')],1)]),_vm._v(" "),_c('div',{staticClass:"modal-container"},[(_vm.modal.action)?_c('modal',{style:(!_vm.isDialogLoading ? {} : { display: 'none' }),attrs:{"width":_vm.modal.width,"height":_vm.modal.height,"customStyles":_vm.modal.customStyles},on:{"hide":function () {
      _vm.modal.callback && _vm.modal.callback()
      _vm.setModalAction({})
    }}},[_c(_vm.modal.action,{tag:"component",attrs:{"param":_vm.modal.param},on:{"changeModal":function (option, param) {
        _vm.modal.callback && _vm.modal.callback(param)
        this$1.setModalAction(option || {})
      }}})],1):_vm._e()],1),_vm._v(" "),_c('layout-toast'),_vm._v(" "),(_vm.loading.value)?_c('layoutLoading'):_vm._e(),_vm._v(" "),(_vm.isUploading !== undefined)?_c('layoutUploading',{attrs:{"content":_vm.isUploading}}):_vm._e()],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("s/Mx")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./src/router/index.js



vue_esm["default"].use(vue_router_esm["a" /* default */]);

/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },

  routes: [{
    path: '/',
    name: 'root',
    redirect: { name: 'main' }
  }, {
    path: '/main',
    name: 'main'
  }, {
    path: '/forgot',
    name: 'forgot'
  }, {
    path: '/reset',
    name: 'reset'
  }, {
    path: '/redirect/:type',
    name: 'redirect'
  }, {
    path: '/attraction',
    name: 'attraction'
  }, {
    path: '/competitiveness',
    name: 'competitiveness'
  }, {
    path: '/toolattraction',
    name: 'toolattraction'
  }, {
    path: '/toolcompetitiveness',
    name: 'toolcompetitiveness'
  }, {
    path: '/admin',
    name: 'admin'
  }, {
    path: '/adminProductPrice',
    name: 'adminProductPrice'
  }, {
    path: '/adminReport',
    name: 'adminReport'
  }, {
    path: '/adminAccessLog',
    name: 'adminAccessLog'
  }, {
    path: '/report',
    name: 'report'
  }, {
    path: '/tutorial',
    name: 'tutorial'
  }, {
    path: '/productPrice',
    name: 'productPrice'
  }, {
    path: '/register',
    name: 'register',
    component: function component(resolve) {
      __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("1cHr")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/user',
    name: 'user',
    component: function component(resolve) {
      __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("R1Qy")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '*',
    redirect: { name: 'main' }
  }]
}));
// CONCATENATED MODULE: ./src/store/modules/app.js


var _mutations;

var app_state = {
  initial: null,
  isLogin: null,
  isLoading: [],
  isDialogLoading: [],
  isUploading: undefined,
  modal: {
    action: null,
    param: null,
    callback: null,
    height: null,
    width: null,
    closeButton: true,
    customStyles: {}
  },
  messages: [],
  // const
  normalPage: ['main', 'forgot', 'reset', 'redirect', 'register'],
  userPage: ['user', 'tutorial', 'analysis', 'attraction', 'competitiveness', 'toolattraction', 'toolcompetitiveness', 'productPrice', 'report'],
  adminPage: ['admin', 'adminProductPrice', 'adminReport', 'adminAccessLog']
};

var getters = {
  initial: function initial(state) {
    return state.initial;
  },
  isLogin: function isLogin(state) {
    return state.isLogin;
  },
  isLoading: function isLoading(state) {
    return state.isLoading.length > 0;
  },
  isDialogLoading: function isDialogLoading(state) {
    return state.isDialogLoading.length > 0;
  },
  isUploading: function isUploading(state) {
    return state.isUploading;
  },
  modal: function modal(state) {
    return state.modal;
  },
  messages: function messages(state) {
    return state.messages;
  },
  // const
  normalPage: function normalPage(state) {
    return state.normalPage;
  },
  userPage: function userPage(state) {
    return state.userPage;
  },
  adminPage: function adminPage(state) {
    return state.adminPage;
  }
};

var types = {
  appInitial: 'app/appInitial',
  setLogin: 'app/setLogin',
  setLoading: 'app/setLoading',
  clearLoading: 'app/clearLoading',
  setDialogLoading: 'app/setDialogLoading',
  clearDialogLoading: 'app/clearDialogLoading',
  setUploading: 'app/setUploading',
  setModal: 'app/setModal',
  addToast: 'app/addToast',
  deleteToast: 'app/deleteToast'
};

var mutations = (_mutations = {}, defineProperty_default()(_mutations, types.appInitial, function (state, boolean) {
  state.initial = boolean;
}), defineProperty_default()(_mutations, types.setLogin, function (state, boolean) {
  state.isLogin = boolean;
}), defineProperty_default()(_mutations, types.setLoading, function (state, boolean) {
  if (boolean !== undefined) {
    if (boolean) {
      state.isLoading.push('');
    } else {
      state.isLoading.pop();
    }
  }
}), defineProperty_default()(_mutations, types.clearLoading, function (state) {
  state.isLoading = [];
}), defineProperty_default()(_mutations, types.setDialogLoading, function (state, boolean) {
  if (boolean !== undefined) {
    if (boolean) {
      state.isDialogLoading.push('');
    } else {
      state.isDialogLoading.pop();
    }
  }
}), defineProperty_default()(_mutations, types.clearDialogLoading, function (state) {
  state.isDialogLoading = [];
}), defineProperty_default()(_mutations, types.setUploading, function (state, content) {
  state.isUploading = content;
}), defineProperty_default()(_mutations, types.setModal, function (state, object) {
  state.modal = object;
}), defineProperty_default()(_mutations, types.addToast, function (state, object) {
  state.messages.push(object);
  setTimeout(function () {
    state.messages.splice(0, 1);
  }, 5000);
}), defineProperty_default()(_mutations, types.deleteToast, function (state, index) {
  state.messages.splice(index, 1);
}), _mutations);

var actions = {
  appInitialAction: function appInitialAction(_ref, boolean) {
    var commit = _ref.commit;

    commit(types.appInitial, boolean);
  },
  setLoginAction: function setLoginAction(_ref2, boolean) {
    var commit = _ref2.commit;

    commit(types.setLogin, boolean);
  },
  setLoadingAction: function setLoadingAction(_ref3, boolean) {
    var commit = _ref3.commit;

    commit(types.setLoading, boolean);
  },
  clearLoadingAction: function clearLoadingAction(_ref4) {
    var commit = _ref4.commit;

    commit(types.clearLoading);
  },
  setDialogLoadingAction: function setDialogLoadingAction(_ref5, boolean) {
    var commit = _ref5.commit;

    commit(types.setDialogLoading, boolean);
  },
  clearDialogLoadingAction: function clearDialogLoadingAction(_ref6) {
    var commit = _ref6.commit;

    commit(types.clearDialogLoading);
  },
  setUploadingAction: function setUploadingAction(_ref7, content) {
    var commit = _ref7.commit;

    commit(types.setUploading, content);
  },
  setModalAction: function setModalAction(_ref8, string) {
    var commit = _ref8.commit;

    commit(types.setModal, string);
  },
  addToastAction: function addToastAction(_ref9, object) {
    var commit = _ref9.commit;

    commit(types.addToast, object);
  },
  deleteToastAction: function deleteToastAction(_ref10, index) {
    var commit = _ref10.commit;

    commit(types.deleteToast, index);
  }
};

/* harmony default export */ var app = ({
  state: app_state,
  getters: getters,
  mutations: mutations,
  actions: actions
});
// CONCATENATED MODULE: ./src/store/modules/global.js


var global__mutations;

var global_state = {
  source: null,
  countrys: null
};

var global_getters = {
  source: function source(state) {
    return state.source;
  },
  countrys: function countrys(state) {
    return state.countrys || [];
  }
};

var global_types = {
  setSource: 'global/setSource',
  setCountrys: 'global/setCountrys'
};

var global_mutations = (global__mutations = {}, defineProperty_default()(global__mutations, global_types.setSource, function (state, object) {
  state.source = object;
}), defineProperty_default()(global__mutations, global_types.setCountrys, function (state, object) {
  state.countrys = object;
}), global__mutations);

var global_actions = {
  setSourceAction: function setSourceAction(_ref, object) {
    var commit = _ref.commit;

    commit(global_types.setSource, object);
  },
  setCountrysAction: function setCountrysAction(_ref2, object) {
    var commit = _ref2.commit;

    commit(global_types.setCountrys, object);
  }
};

/* harmony default export */ var global = ({
  state: global_state,
  getters: global_getters,
  mutations: global_mutations,
  actions: global_actions
});
// CONCATENATED MODULE: ./src/store/modules/user.js



var user__mutations;

var user_state = {
  data: null,
  info: null
};

var user_getters = {
  user: function user(state) {
    return state.data ? extends_default()({}, state.data) : state.data;
  },
  userInfo: function userInfo(state) {
    return state.info ? extends_default()({}, state.info) : state.info;
  }
};

var user_types = {
  setUser: 'user/setUser',
  setUserInfo: 'user/setUserInfo'
};

var user_mutations = (user__mutations = {}, defineProperty_default()(user__mutations, user_types.setUser, function (state, object) {
  state.data = object;
}), defineProperty_default()(user__mutations, user_types.setUserInfo, function (state, object) {
  state.info = object;
}), user__mutations);

var user_actions = {
  setUserAction: function setUserAction(_ref, object) {
    var commit = _ref.commit;

    commit(user_types.setUser, object);
  },
  setUserInfoAction: function setUserInfoAction(_ref2, object) {
    var commit = _ref2.commit;

    commit(user_types.setUserInfo, object);
  }
};

/* harmony default export */ var modules_user = ({
  state: user_state,
  getters: user_getters,
  mutations: user_mutations,
  actions: user_actions
});
// CONCATENATED MODULE: ./src/store/index.js







vue_esm["default"].use(vuex_esm["a" /* default */]);

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  modules: {
    app: app,
    global: global,
    user: modules_user
  }
}));
// EXTERNAL MODULE: ./node_modules/vee-validate/dist/vee-validate.esm.js
var vee_validate_esm = __webpack_require__("sUu7");

// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






vee_validate_esm["a" /* Validator */].extend('youtubeLink', {
  getMessage: function getMessage() {
    return '';
  },
  validate: function validate(value) {
    return (/(?:src="|^)https:\/\/www\.youtube\.com\/embed\/([a-zA-Z0-9]+)(?="|$)/.test(value)
    );
  }
});

__webpack_require__("DBs5");
__webpack_require__("598Q");

vue_esm["default"].config.productionTip = false;

/* eslint-disable no-new */
new vue_esm["default"]({
  el: '#app',
  router: router,
  store: store,
  template: '<App/>',
  components: { App: src_App }
});

/***/ }),

/***/ "P6mg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/mixins/loginData.vue




/* harmony default export */ var loginData = ({
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setUserAction', 'setLoginAction', 'setUserInfoAction']), {
    setUserData: function setUserData(response, token) {
      this.setUserAction(response ? response.data.user || response.data.data : null);
      this.setLoginAction(!!response);
      this.setUserInfo(token || response ? response.data.metadata : null);
      if (!response) {
        this.setUserInfoAction(null);
        this.$ls.remove('userInfo');
      }
    },
    setUserInfo: function setUserInfo(token) {
      if (token) {
        // let expiry = new Date(token.expired_at) - new Date()
        var info = {
          access_token: token.access_token
        };
        this.setUserInfoAction(info);
        this.$ls.set('userInfo', info);
      } else {
        // this.setUserInfoAction(null)
        // this.$ls.remove('userInfo')
      }
    }
  })
});
// CONCATENATED MODULE: ./src/mixins/loginData.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  loginData,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var mixins_loginData = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QLzv":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./tutorial-normal-competitiveness-1.jpg": "jomD",
	"./tutorial-tool-competitiveness-1.jpg": "/Zy+"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "QLzv";

/***/ }),

/***/ "R/qx":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tutorial-tool-attraction-1.75b505a.jpg";

/***/ }),

/***/ "SPQO":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNSIgaGVpZ2h0PSIxNSIgdmlld0JveD0iMCAwIDE1IDE1Ij4KICA8cGF0aCBpZD0iY2hlY2stY2lyY2xlLXNvbGlkIiBkPSJNMjMsMTUuNUE3LjUsNy41LDAsMSwxLDE1LjUsOCw3LjUsNy41LDAsMCwxLDIzLDE1LjVabS04LjM2OCwzLjk3MUwyMC4yLDEzLjkwN2EuNDg0LjQ4NCwwLDAsMCwwLS42ODRsLS42ODQtLjY4NGEuNDg0LjQ4NCwwLDAsMC0uNjg0LDBMMTQuMjksMTcuMDc2bC0yLjExOS0yLjExOWEuNDg0LjQ4NCwwLDAsMC0uNjg0LDBsLS42ODQuNjg0YS40ODQuNDg0LDAsMCwwLDAsLjY4NGwzLjE0NSwzLjE0NWEuNDg0LjQ4NCwwLDAsMCwuNjg0LDBaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtOCAtOCkiIGZpbGw9IiNiNGUwNGYiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "SZ5X":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./tutorial-normal-attraction-1.jpg": "27GY",
	"./tutorial-tool-attraction-1.jpg": "R/qx"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "SZ5X";

/***/ }),

/***/ "T452":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API_ROOT; });
var API_ROOT = 'https://agritrade.tari.gov.tw/api/';

/***/ }),

/***/ "TEyu":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./checkbox-false.svg": "5Ivo",
	"./checkbox-minus.svg": "Z77G",
	"./checkbox-true.svg": "7kqe"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "TEyu";

/***/ }),

/***/ "TuFs":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/main-background.74a75d2.jpg";

/***/ }),

/***/ "Ut5Q":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tutorial-normal-attraction-2.4846187.jpg";

/***/ }),

/***/ "XTQ4":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNSIgaGVpZ2h0PSIxNSIgdmlld0JveD0iMCAwIDE1IDE1Ij4KICA8cGF0aCBpZD0idGltZXMtY2lyY2xlLXNvbGlkIiBkPSJNMTUuNSw4QTcuNSw3LjUsMCwxLDAsMjMsMTUuNSw3LjUsNy41LDAsMCwwLDE1LjUsOFptMy42NzcsOS40NjlhLjM2My4zNjMsMCwwLDEsMCwuNTE0bC0xLjIsMS4xOTVhLjM2My4zNjMsMCwwLDEtLjUxNCwwTDE1LjUsMTcuMTk0bC0xLjk2OSwxLjk4NGEuMzYzLjM2MywwLDAsMS0uNTE0LDBsLTEuMTk1LTEuMmEuMzYzLjM2MywwLDAsMSwwLS41MTRMMTMuODA2LDE1LjVsLTEuOTg0LTEuOTY5YS4zNjMuMzYzLDAsMCwxLDAtLjUxNGwxLjItMS4yYS4zNjMuMzYzLDAsMCwxLC41MTQsMEwxNS41LDEzLjgwNmwxLjk2OS0xLjk4NGEuMzYzLjM2MywwLDAsMSwuNTE0LDBsMS4yLDEuMmEuMzYzLjM2MywwLDAsMSwwLC41MTRMMTcuMTk0LDE1LjVaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtOCAtOCkiIGZpbGw9IiNmMDNjM2MiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "YXKW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Z1H5":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "Z77G":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICA8ZyBpZD0i44Kw44Or44O844OXXzM0NTIiIGRhdGEtbmFtZT0i44Kw44Or44O844OXIDM0NTIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yODIuNSAtNTQ4KSI+CiAgICA8cGF0aCBpZD0ibWludXMtc3F1YXJlLXNvbGlkIiBkPSJNMTIuNSwzMkgxLjVBMS41LDEuNSwwLDAsMCwwLDMzLjV2MTFBMS41LDEuNSwwLDAsMCwxLjUsNDZoMTFBMS41LDEuNSwwLDAsMCwxNCw0NC41di0xMUExLjUsMS41LDAsMCwwLDEyLjUsMzJaTTIuODc1LDQwLjI1YS4zNzYuMzc2LDAsMCwxLS4zNzUtLjM3NXYtMS43NWEuMzc2LjM3NiwwLDAsMSwuMzc1LS4zNzVoOC4yNWEuMzc2LjM3NiwwLDAsMSwuMzc1LjM3NXYxLjc1YS4zNzYuMzc2LDAsMCwxLS4zNzUuMzc1WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjgzLjUgNTE3KSIgZmlsbD0iIzliYzczNyIvPgogICAgPGcgaWQ9IumVt+aWueW9ol8xOTAxIiBkYXRhLW5hbWU9IumVt+aWueW9oiAxOTAxIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyODIuNSA1NDgpIiBmaWxsPSJyZ2JhKDI1NSwyNTUsMjU1LDApIiBzdHJva2U9IiM3NzciIHN0cm9rZS13aWR0aD0iMSI+CiAgICAgIDxyZWN0IHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgcng9IjMiIHN0cm9rZT0ibm9uZSIvPgogICAgICA8cmVjdCB4PSIwLjUiIHk9IjAuNSIgd2lkdGg9IjE1IiBoZWlnaHQ9IjE1IiByeD0iMi41IiBmaWxsPSJub25lIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "ZMG5":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./tutorial-normal-attraction-3.jpg": "7Sse",
	"./tutorial-tool-attraction-3.jpg": "4fS2"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ZMG5";

/***/ }),

/***/ "benM":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNSIgaGVpZ2h0PSIxNi41NTIiIHZpZXdCb3g9IjAgMCAxNSAxNi41NTIiPgogIDxwYXRoIGlkPSJwYXBlcmNsaXAtcmVndWxhciIgZD0iTTI1LjQwNywxNS4xNDVhNC44LDQuOCwwLDAsMSwwLTYuNzg3bDcuMjc0LTcuMjc1YTMuNywzLjcsMCwxLDEsNS4yMzQsNS4yMzVMMzEuNzksMTIuNDQ0QTIuNiwyLjYsMCwxLDEsMjguMTA3LDguNzZsNS4xODctNS4xODhhLjM4OC4zODgsMCwwLDEsLjU0OSwwbC41NDkuNTQ5YS4zODguMzg4LDAsMCwxLDAsLjU0OUwyOS4yLDkuODU3YTEuMDUzLDEuMDUzLDAsMSwwLDEuNDg5LDEuNDg5bDYuMTI1LTYuMTI2YTIuMTUsMi4xNSwwLDEsMC0zLjA0LTMuMDQxTDI2LjUsOS40NTVhMy4yNDgsMy4yNDgsMCwxLDAsNC42LDQuNTkxcTMuMTY4LTMuMTc1LDYuMzM2LTYuMzM5YS4zODYuMzg2LDAsMCwxLC41NDUsMGwuNTQ5LjU0OWEuMzg4LjM4OCwwLDAsMSwwLC41NDhxLTMuMTU4LDMuMTYxLTYuMzI2LDYuMzM0YTQuOCw0LjgsMCwwLDEtNi44LDBaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjQgMCkiIGZpbGw9IiNiYmIiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "cEEl":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tutorial-product-price-2.8d8af11.jpg";

/***/ }),

/***/ "cEaC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.674f50d.eot";

/***/ }),

/***/ "cmUn":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.674f50d.eot";

/***/ }),

/***/ "ct0j":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2MiIgaGVpZ2h0PSI2MiIgdmlld0JveD0iMCAwIDYyIDYyIj4KICA8cGF0aCBpZD0iZXhjbGFtYXRpb24tY2lyY2xlLXJlZ3VsYXIiIGQ9Ik0zOSw4QTMxLDMxLDAsMSwwLDcwLDM5LDMxLDMxLDAsMCwwLDM5LDhabTAsNTZBMjUsMjUsMCwxLDEsNjQsMzksMjQuOTg1LDI0Ljk4NSwwLDAsMSwzOSw2NFptNS4yNS0xM0E1LjI1LDUuMjUsMCwxLDEsMzksNDUuNzUsNS4yNTYsNS4yNTYsMCwwLDEsNDQuMjUsNTFaTTM0LjA3OSwyNC41NzVsLjg1LDE3QTEuNSwxLjUsMCwwLDAsMzYuNDI3LDQzaDUuMTQ2YTEuNSwxLjUsMCwwLDAsMS41LTEuNDI1bC44NS0xN0ExLjUsMS41LDAsMCwwLDQyLjQyMywyM0gzNS41NzdBMS41LDEuNSwwLDAsMCwzNC4wNzksMjQuNTc1WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTggLTgpIiBmaWxsPSIjOWJjNzM3Ii8+Cjwvc3ZnPgo="

/***/ }),

/***/ "eJjw":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./tutorial-normal-competitiveness-2.jpg": "klOU",
	"./tutorial-tool-competitiveness-2.jpg": "tPka"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "eJjw";

/***/ }),

/***/ "eXbr":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tutorial-product-price-1.ae40013.jpg";

/***/ }),

/***/ "fc/Z":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2MiIgaGVpZ2h0PSI2MiIgdmlld0JveD0iMCAwIDYyIDYyIj4KICA8cGF0aCBpZD0iZXhjbGFtYXRpb24tY2lyY2xlLXJlZ3VsYXIiIGQ9Ik0zOSw4QTMxLDMxLDAsMSwwLDcwLDM5LDMxLDMxLDAsMCwwLDM5LDhabTAsNTZBMjUsMjUsMCwxLDEsNjQsMzksMjQuOTg1LDI0Ljk4NSwwLDAsMSwzOSw2NFptNS4yNS0xM0E1LjI1LDUuMjUsMCwxLDEsMzksNDUuNzUsNS4yNTYsNS4yNTYsMCwwLDEsNDQuMjUsNTFaTTM0LjA3OSwyNC41NzVsLjg1LDE3QTEuNSwxLjUsMCwwLDAsMzYuNDI3LDQzaDUuMTQ2YTEuNSwxLjUsMCwwLDAsMS41LTEuNDI1bC44NS0xN0ExLjUsMS41LDAsMCwwLDQyLjQyMywyM0gzNS41NzdBMS41LDEuNSwwLDAsMCwzNC4wNzksMjQuNTc1WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTggLTgpIiBmaWxsPSIjZWExNDE0Ii8+Cjwvc3ZnPgo="

/***/ }),

/***/ "fwQm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gyMJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return getSource; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return postConfirmEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getCurrencys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getCrops; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getProductByCategorys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getAccounts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return deleteAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return putUpdateAccountRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getAdminProductPrices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getAdminProductPrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return putAdminProductPrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return deleteAdminProductPrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return postAdminProductPriceReview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return postAdminProductPriceBatchUpload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getAdminCrops; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getAdminReports; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getAdminReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return postAdminReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return putAdminReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return deleteAdminReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getAdminAccessLogs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return postAccessLog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return getUserToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return postUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return deleteUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return postRegisterUser; });
/* unused harmony export postEnableUser */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return postForgotUserPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return postResetUserPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return putUpdateUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return putUserPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return getProducts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getCountrys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return getYears; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getCompetitivenessDatas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getAttractionDatas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return getReportCountrys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return getStations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return getStationSummarys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return getProductPrices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return getProductPrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return postProductPrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return getProductPriceGraphProducts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return getProductPriceResults; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return getProductPriceGraphDatas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return getProductPriceGraphData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return getReports; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return getReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return getReportComments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return postReportComment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return deleteReportComment; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios__ = __webpack_require__("Rf8U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__("T452");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_global_util__ = __webpack_require__("Cduz");








__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_2_axios___default.a);

// global
var getSource = function getSource() {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'database/source');
};
var postConfirmEmail = function postConfirmEmail(data) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'users/confirm_email', data);
};
var getCurrencys = function getCurrencys(query, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'currencies', { params: config });
};
var getCrops = function getCrops(query, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'crops', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { q: query }) });
};
var getProductByCategorys = function getProductByCategorys(config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'database/product_by_category', { params: config });
};
// admin
var getAccounts = function getAccounts(data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'users', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, data) });
};
var deleteAccount = function deleteAccount(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.delete(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'users/' + id, { params: config });
};
var putUpdateAccountRole = function putUpdateAccountRole(id, role, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'users/' + id + '/change_role', { role: role }, { params: config });
};
// admin product price
var getAdminProductPrices = function getAdminProductPrices(data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'admin/product_prices', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, data) });
};
var getAdminProductPrice = function getAdminProductPrice(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'admin/product_prices/' + id, { params: config });
};
var putAdminProductPrice = function putAdminProductPrice(id, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'admin/product_prices/' + id, Object(__WEBPACK_IMPORTED_MODULE_5__constants_global_util__["l" /* toFormdata */])(data), { params: config });
};
var deleteAdminProductPrice = function deleteAdminProductPrice(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.delete(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'admin/product_prices/' + id, { params: config });
};
var postAdminProductPriceReview = function postAdminProductPriceReview(id, result, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'admin/product_prices/' + id + '/review', { result: result }, { params: config });
};
var postAdminProductPriceBatchUpload = function postAdminProductPriceBatchUpload(data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'admin/product_prices/batch_upload', Object(__WEBPACK_IMPORTED_MODULE_5__constants_global_util__["l" /* toFormdata */])(data), { params: config });
};
var getAdminCrops = function getAdminCrops(query, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'admin/product_prices/crops', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { q: query }) });
};
// admin report
var getAdminReports = function getAdminReports(data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'admin/reports', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, data) });
};
var getAdminReport = function getAdminReport(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'admin/reports/' + id, { params: config });
};
var postAdminReport = function postAdminReport(data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'admin/reports', Object(__WEBPACK_IMPORTED_MODULE_5__constants_global_util__["l" /* toFormdata */])(data), { params: config });
};
var putAdminReport = function putAdminReport(id, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'admin/reports/' + id, Object(__WEBPACK_IMPORTED_MODULE_5__constants_global_util__["l" /* toFormdata */])(data), { params: config });
};
var deleteAdminReport = function deleteAdminReport(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.delete(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'admin/reports/' + id, { params: config });
};
// admin access log
var getAdminAccessLogs = function getAdminAccessLogs(data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'admin/access_logs', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, data) });
};
var postAccessLog = function postAccessLog(type, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'access_logs/' + type, data, { params: config });
};
// user
var getUserToken = function getUserToken(config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'users/current_user', { params: config });
};
var postUser = function postUser(data) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'users/sign_in', data);
};
var deleteUser = function deleteUser(config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.delete(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'users/sign_out', { params: config });
};
var postRegisterUser = function postRegisterUser(data) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'users/sign_up', data);
};
var postEnableUser = function postEnableUser(data) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'users/enable_user', data);
};
var postForgotUserPassword = function postForgotUserPassword(data) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'users/forget_password', data);
};
var postResetUserPassword = function postResetUserPassword(data) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'users/reset_password', data);
};
var putUpdateUser = function putUpdateUser(data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'users/current_user', data, { params: config });
};
var putUserPassword = function putUserPassword(data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'users/current_user/password', data, { params: config });
};
// analysis
var getProducts = function getProducts(config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'database/product', { params: config });
};
var getCountrys = function getCountrys(config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'database/country', { params: config });
};
var getYears = function getYears(config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'database/year', { params: config });
};
var getCompetitivenessDatas = function getCompetitivenessDatas(conditions, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'database/market_competitiveness', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, conditions) });
};
var getAttractionDatas = function getAttractionDatas(conditions, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'database/market_attraction', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, conditions) });
};
var getReportCountrys = function getReportCountrys(conditions, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'report_countries', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, conditions) });
};
var getStations = function getStations(country, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'database/stations', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { country: country }) });
};
var getStationSummarys = function getStationSummarys(stationID, type, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'database/stations/' + stationID + '/' + type, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, data) });
};
// product price
var getProductPrices = function getProductPrices(data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'current_user/product_prices', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, data) });
};
var getProductPrice = function getProductPrice(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'current_user/product_prices/' + id, { params: config });
};
var postProductPrice = function postProductPrice(data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'current_user/product_prices', Object(__WEBPACK_IMPORTED_MODULE_5__constants_global_util__["l" /* toFormdata */])(data), { params: config });
};
var getProductPriceGraphProducts = function getProductPriceGraphProducts(config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'product_prices/crops', { params: config });
};
var getProductPriceResults = function getProductPriceResults(conditions, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'product_prices/scatter_plots', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, conditions) });
};
var getProductPriceGraphDatas = function getProductPriceGraphDatas(ids, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'product_prices', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, data, { ids: ids }) });
};
var getProductPriceGraphData = function getProductPriceGraphData(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'product_prices/' + id, { params: config });
};
// report
var getReports = function getReports(data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'reports', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, data) });
};
var getReport = function getReport(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'reports/' + id, { params: config });
};
var getReportComments = function getReportComments(reportID, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'reports/' + reportID + '/comments', { params: config });
};
var postReportComment = function postReportComment(reportID, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'reports/' + reportID + '/comments', data, { params: config });
};
var deleteReportComment = function deleteReportComment(id, reportID, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.delete(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'reports/' + reportID + '/comments/' + id, { params: config });
};

/***/ }),

/***/ "hD4v":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hp+x":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/report-default-cover.778c436.jpeg";

/***/ }),

/***/ "hxho":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ia3f":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMCIgaGVpZ2h0PSIxMCIgdmlld0JveD0iMCAwIDEwIDEwIj4KICA8cGF0aCBpZD0iaW5mby1jaXJjbGUtcmVndWxhciIgZD0iTTEzLDhhNSw1LDAsMSwwLDUsNUE1LDUsMCwwLDAsMTMsOFptMCw5LjAzMkE0LjAzMiw0LjAzMiwwLDEsMSwxNy4wMzIsMTMsNC4wMyw0LjAzLDAsMCwxLDEzLDE3LjAzMlptMC02LjgxNWEuODQ3Ljg0NywwLDEsMS0uODQ3Ljg0N0EuODQ3Ljg0NywwLDAsMSwxMywxMC4yMThabTEuMTI5LDUuMTIxYS4yNDIuMjQyLDAsMCwxLS4yNDIuMjQySDEyLjExM2EuMjQyLjI0MiwwLDAsMS0uMjQyLS4yNDJ2LS40ODRhLjI0Mi4yNDIsMCwwLDEsLjI0Mi0uMjQyaC4yNDJ2LTEuMjloLS4yNDJhLjI0Mi4yNDIsMCwwLDEtLjI0Mi0uMjQyVjEyLjZhLjI0Mi4yNDIsMCwwLDEsLjI0Mi0uMjQySDEzLjRhLjI0Mi4yNDIsMCwwLDEsLjI0Mi4yNDJ2Mi4wMTZoLjI0MmEuMjQyLjI0MiwwLDAsMSwuMjQyLjI0MloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC04IC04KSIgZmlsbD0iI2ZmZiIvPgo8L3N2Zz4K"

/***/ }),

/***/ "jNsU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.fee66e7.woff";

/***/ }),

/***/ "jomD":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tutorial-normal-competitiveness-1.e3d4839.jpg";

/***/ }),

/***/ "ka30":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMCIgaGVpZ2h0PSIxMCIgdmlld0JveD0iMCAwIDEwIDEwIj4KICA8cGF0aCBpZD0iaW5mby1jaXJjbGUtcmVndWxhciIgZD0iTTEzLDhhNSw1LDAsMSwwLDUsNUE1LDUsMCwwLDAsMTMsOFptMCw5LjAzMkE0LjAzMiw0LjAzMiwwLDEsMSwxNy4wMzIsMTMsNC4wMyw0LjAzLDAsMCwxLDEzLDE3LjAzMlptMC02LjgxNWEuODQ3Ljg0NywwLDEsMS0uODQ3Ljg0N0EuODQ3Ljg0NywwLDAsMSwxMywxMC4yMThabTEuMTI5LDUuMTIxYS4yNDIuMjQyLDAsMCwxLS4yNDIuMjQySDEyLjExM2EuMjQyLjI0MiwwLDAsMS0uMjQyLS4yNDJ2LS40ODRhLjI0Mi4yNDIsMCwwLDEsLjI0Mi0uMjQyaC4yNDJ2LTEuMjloLS4yNDJhLjI0Mi4yNDIsMCwwLDEtLjI0Mi0uMjQyVjEyLjZhLjI0Mi4yNDIsMCwwLDEsLjI0Mi0uMjQySDEzLjRhLjI0Mi4yNDIsMCwwLDEsLjI0Mi4yNDJ2Mi4wMTZoLjI0MmEuMjQyLjI0MiwwLDAsMSwuMjQyLjI0MloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC04IC04KSIgZmlsbD0iI2YwM2MzYyIvPgo8L3N2Zz4K"

/***/ }),

/***/ "klOU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tutorial-normal-competitiveness-2.bb5edc0.jpg";

/***/ }),

/***/ "km+N":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "l9jg":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIxMCIgdmlld0JveD0iMCAwIDIwIDEwIj4KICA8cGF0aCBpZD0i44OR44K5XzEyNzQiIGRhdGEtbmFtZT0i44OR44K5IDEyNzQiIGQ9Ik0xMiwxMy4wNzksMiw0LjQ0MiwzLjU1MywzLjA3OSwxMiwxMC41ODdsOC43LTcuNTA4TDIyLDQuNDQyWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTIgLTMuMDc5KSIgZmlsbD0iIzU1NSIvPgo8L3N2Zz4K"

/***/ }),

/***/ "lCiF":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/search-man.77fcee3.png";

/***/ }),

/***/ "n/Hc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "n1Sy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oNTV":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDMwIDMwIj4KICA8cGF0aCBpZD0iZXhjbGFtYXRpb24tY2lyY2xlLXJlZ3VsYXIiIGQ9Ik0yMyw4QTE1LDE1LDAsMSwwLDM4LDIzLDE1LDE1LDAsMCwwLDIzLDhabTAsMjcuMUExMi4xLDEyLjEsMCwxLDEsMzUuMSwyMywxMi4wOSwxMi4wOSwwLDAsMSwyMywzNS4xWm0yLjU0LTYuMjlBMi41NCwyLjU0LDAsMSwxLDIzLDI2LjI2NiwyLjU0MywyLjU0MywwLDAsMSwyNS41NCwyOC44MDZaTTIwLjYxOSwxNi4wMmwuNDExLDguMjI2YS43MjYuNzI2LDAsMCwwLC43MjUuNjloMi40OWEuNzI2LjcyNiwwLDAsMCwuNzI1LS42OWwuNDExLTguMjI2YS43MjYuNzI2LDAsMCwwLS43MjUtLjc2MkgyMS4zNDRBLjcyNi43MjYsMCwwLDAsMjAuNjE5LDE2LjAyWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTggLTgpIiBmaWxsPSIjZjAzYzNjIi8+Cjwvc3ZnPgo="

/***/ }),

/***/ "of+2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.af7ae50.woff2";

/***/ }),

/***/ "pBN0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pVaX":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tutorial-tool-competitiveness-4.82792dc.jpg";

/***/ }),

/***/ "qPRf":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tutorial-tool-attraction-2.9ba99b5.jpg";

/***/ }),

/***/ "rjy3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tutorial-normal-attraction-4.90ea7cc.jpg";

/***/ }),

/***/ "rlvA":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNSIgaGVpZ2h0PSIxNSIgdmlld0JveD0iMCAwIDE1IDE1Ij4KICA8cGF0aCBpZD0iY2hlY2stY2lyY2xlLXNvbGlkIiBkPSJNMjMsMTUuNUE3LjUsNy41LDAsMSwxLDE1LjUsOCw3LjUsNy41LDAsMCwxLDIzLDE1LjVabS04LjM2OCwzLjk3MUwyMC4yLDEzLjkwN2EuNDg0LjQ4NCwwLDAsMCwwLS42ODRsLS42ODQtLjY4NGEuNDg0LjQ4NCwwLDAsMC0uNjg0LDBMMTQuMjksMTcuMDc2bC0yLjExOS0yLjExOWEuNDg0LjQ4NCwwLDAsMC0uNjg0LDBsLS42ODQuNjg0YS40ODQuNDg0LDAsMCwwLDAsLjY4NGwzLjE0NSwzLjE0NWEuNDg0LjQ4NCwwLDAsMCwuNjg0LDBaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtOCAtOCkiIGZpbGw9IiNiNGUwNGYiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "s/Mx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tPka":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tutorial-tool-competitiveness-2.b324ae9.jpg";

/***/ }),

/***/ "u/rF":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMCIgaGVpZ2h0PSIxMCIgdmlld0JveD0iMCAwIDEwIDEwIj4KICA8cGF0aCBpZD0iaW5mby1jaXJjbGUtcmVndWxhciIgZD0iTTEzLDhhNSw1LDAsMSwwLDUsNUE1LDUsMCwwLDAsMTMsOFptMCw5LjAzMkE0LjAzMiw0LjAzMiwwLDEsMSwxNy4wMzIsMTMsNC4wMyw0LjAzLDAsMCwxLDEzLDE3LjAzMlptMC02LjgxNWEuODQ3Ljg0NywwLDEsMS0uODQ3Ljg0N0EuODQ3Ljg0NywwLDAsMSwxMywxMC4yMThabTEuMTI5LDUuMTIxYS4yNDIuMjQyLDAsMCwxLS4yNDIuMjQySDEyLjExM2EuMjQyLjI0MiwwLDAsMS0uMjQyLS4yNDJ2LS40ODRhLjI0Mi4yNDIsMCwwLDEsLjI0Mi0uMjQyaC4yNDJ2LTEuMjloLS4yNDJhLjI0Mi4yNDIsMCwwLDEtLjI0Mi0uMjQyVjEyLjZhLjI0Mi4yNDIsMCwwLDEsLjI0Mi0uMjQySDEzLjRhLjI0Mi4yNDIsMCwwLDEsLjI0Mi4yNDJ2Mi4wMTZoLjI0MmEuMjQyLjI0MiwwLDAsMSwuMjQyLjI0MloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC04IC04KSIgZmlsbD0iIzU1NSIvPgo8L3N2Zz4K"

/***/ }),

/***/ "urdl":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tutorial-normal-competitiveness-4.82792dc.jpg";

/***/ }),

/***/ "usg8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "v3Qp":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOC4wMDEiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxOC4wMDEgMTQiPgogIDxwYXRoIGlkPSJjb21tZW50cy1saWdodCIgZD0iTTE3LjgsNDQuNzgyYTcuOTUyLDcuOTUyLDAsMCwxLTEuMTg0LTEuNzE1QTQuMyw0LjMsMCwwLDAsMTcuOTg5LDQwYzAtMi41LTIuMzktNC41NjUtNS41MDUtNC45MzNBNi43NDksNi43NDksMCwwLDAsNi40OTIsMzJjLTMuNTksMC02LjUsMi4yMzctNi41LDVhNC4zMTMsNC4zMTMsMCwwLDAsMS4zNzUsMy4wNjhBOC4xODEsOC4xODEsMCwwLDEsLjE5LDQxLjc4Mi43MjMuNzIzLDAsMCwwLC43MTUsNDNhNy4xODIsNy4xODIsMCwwLDAsMy45MTItMS4yMTIsNy44NTYsNy44NTYsMCwwLDAsLjg3NS4xNUE2Ljc1Nyw2Ljc1NywwLDAsMCwxMS40OTQsNDVhOC4yNyw4LjI3LDAsMCwwLDEuODY4LS4yMTJBNy4yLDcuMiwwLDAsMCwxNy4yNzQsNDZhLjcyMy43MjMsMCwwLDAsLjUyNS0xLjIxOFpNNC44NDksNDAuODExbC0uNDEyLS4wOTQtLjM1Ni4yMzFhNi40MzQsNi40MzQsMCwwLDEtMi43NCwxLjAxNSw4LjY5Miw4LjY5MiwwLDAsMCwuOTIyLTEuNDVsLjMyNS0uNjUtLjUxNi0uNTA5QTMuMzM2LDMuMzM2LDAsMCwxLC45OTMsMzdjMC0yLjIwNiwyLjQ2OC00LDUuNS00czUuNSwxLjc5Myw1LjUsNC0yLjQ2OCw0LTUuNSw0QTcuMjY1LDcuMjY1LDAsMCwxLDQuODQ5LDQwLjgxMVpNMTMuOSw0My45NDdsLS4zNTYtLjIzMS0uNDEyLjFBNy4yNjUsNy4yNjUsMCwwLDEsMTEuNDkxLDQ0YTYuMDg1LDYuMDg1LDAsMCwxLTQuNzYxLTIuMDA5YzMuNDc3LS4xLDYuMjYxLTIuMjkzLDYuMjYxLTQuOTkzYTMuOTc1LDMuOTc1LDAsMCwwLS4xLS44NjVjMi4zNTYuNDUzLDQuMSwyLjAxMiw0LjEsMy44NjVhMy4zMzYsMy4zMzYsMCwwLDEtMS4wNzgsMi4zNTZsLS41MTYuNTA5LjMyMi42NDdhOC44MzYsOC44MzYsMCwwLDAsLjkyMiwxLjQ1QTYuNDM2LDYuNDM2LDAsMCwxLDEzLjksNDMuOTQ3WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4wMDcgLTMyKSIgZmlsbD0iIzU1NSIvPgo8L3N2Zz4K"

/***/ }),

/***/ "vBfX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "x2hU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return apiI18n; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return occupationOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return roleOptions; });
var apiI18n = {
  not_found: {
    'zh-TW': '找不到資源',
    'en': 'TEMP_MESSAGE'
  },
  unauthorized: {
    'zh-TW': '未授權的帳號',
    'en': 'TEMP_MESSAGE'
  },
  invalid_parameter: {
    'zh-TW': '參數錯誤',
    'en': 'TEMP_MESSAGE'
  },
  email_registered: {
    'zh-TW': '電子信箱已註冊',
    'en': 'TEMP_MESSAGE'
  },
  email_unregistered: {
    'zh-TW': '電子信箱未註冊',
    'en': 'TEMP_MESSAGE'
  },
  sign_up_success: {
    'zh-TW': '註冊成功，請至註冊時填寫的電子信箱收取確認信',
    'en': 'TEMP_MESSAGE'
  },
  email_unconfirmed: {
    'zh-TW': '電子信箱未驗證',
    'en': 'TEMP_MESSAGE'
  },
  user_disabled: {
    'zh-TW': '帳號未啟用',
    'en': 'TEMP_MESSAGE'
  },
  sign_out_success: {
    'zh-TW': '帳號已登出',
    'en': 'TEMP_MESSAGE'
  },
  sent_email_confirmation_link: {
    'zh-TW': '電子信箱確認連結已寄到使用者電子信箱',
    'en': 'TEMP_MESSAGE'
  },
  confirm_email_success_wait_enable: {
    'zh-TW': '電子信箱驗證成功，請等待業務人員啟用帳號',
    'en': 'TEMP_MESSAGE'
  },
  confirm_email_success: {
    'zh-TW': '電子信箱驗證成功',
    'en': 'TEMP_MESSAGE'
  },
  confirm_email_failed: {
    'zh-TW': '電子信箱驗證失敗',
    'en': 'TEMP_MESSAGE'
  },
  sent_reset_password_link: {
    'zh-TW': '重置密碼連結已寄到使用者電子信箱',
    'en': 'TEMP_MESSAGE'
  },
  user_not_found: {
    'zh-TW': '找不到使用者',
    'en': 'TEMP_MESSAGE'
  },
  reset_password_success: {
    'zh-TW': '重置密碼成功，請重新登入',
    'en': 'TEMP_MESSAGE'
  },
  invalid_reset_password_token: {
    'zh-TW': '重置密碼權杖錯誤',
    'en': 'TEMP_MESSAGE'
  },
  email_confirmed: {
    'zh-TW': '電子信箱已驗證',
    'en': 'TEMP_MESSAGE'
  },
  wrong_original_password: {
    'zh-TW': '舊密碼不正確',
    'en': 'TEMP_MESSAGE'
  },
  create_subuser_success_wait_confirm: {
    'zh-TW': '成功建立子帳號，確認連結已寄到使用者的電子信箱',
    'en': 'TEMP_MESSAGE'
  },
  delete_subuser_success: {
    'zh-TW': '成功刪除子帳號',
    'en': 'TEMP_MESSAGE'
  },
  delete_subuser_failed: {
    'zh-TW': '刪除子帳號失敗',
    'en': 'TEMP_MESSAGE'
  },
  require_hospital_medical_license: {
    'zh-TW': '必須有醫院執照才可以進行此操作',
    'en': 'TEMP_MESSAGE'
  },
  require_medical_license: {
    'zh-TW': '必須有醫生執照才可以進行此操作',
    'en': 'TEMP_MESSAGE'
  },
  create_case_success_wait_agree: {
    'zh-TW': '案件已提交，等待使用者同意中',
    'en': 'TEMP_MESSAGE'
  },
  create_case_success: {
    'zh-TW': '成功建立案件',
    'en': 'TEMP_MESSAGE'
  },
  agree_user_policy_success: {
    'zh-TW': '您已同意使用者條款，成功建立案件',
    'en': 'TEMP_MESSAGE'
  },
  disagree_user_policy_success: {
    'zh-TW': '您已拒絕使用者條款，案件不成立',
    'en': 'TEMP_MESSAGE'
  },
  user_policy_failed: {
    'zh-TW': '使用者條款建立失敗',
    'en': 'TEMP_MESSAGE'
  },
  enable_user_success: {
    'zh-TW': '啟用帳號成功',
    'en': 'TEMP_MESSAGE'
  },
  invalid_enable_user_token: {
    'zh-TW': '啟用帳號權杖錯誤',
    'en': 'TEMP_MESSAGE'
  }
};

var occupationOptions = [{ title: '貿易商', value: '貿易商' }, { title: '農政人員', value: '農政人員' }, { title: '研究人員', value: '研究人員' }, { title: '農產品經營業者', value: '農產品經營業者' }, { title: '其他', value: 'other' }];

var roleOptions = [{ title: '一般', value: '' }, { title: '進階', value: 'advance' }];

/***/ }),

/***/ "xPuW":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./tutorial-normal-attraction-2.jpg": "Ut5Q",
	"./tutorial-tool-attraction-2.jpg": "qPRf"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "xPuW";

/***/ }),

/***/ "xYqJ":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./tutorial-normal-competitiveness-4.jpg": "urdl",
	"./tutorial-tool-competitiveness-4.jpg": "pVaX"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "xYqJ";

/***/ }),

/***/ "xuiG":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMy4xMjUiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAxMy4xMjUgMTUiPgogIDxwYXRoIGlkPSJ0cmFzaC1hbHQtcmVndWxhciIgZD0iTTcuODUyLDEyLjE4N2guN2EuMzUyLjM1MiwwLDAsMCwuMzUyLS4zNTJWNS41MDhhLjM1Mi4zNTIsMCwwLDAtLjM1Mi0uMzUyaC0uN2EuMzUyLjM1MiwwLDAsMC0uMzUyLjM1MnY2LjMyOEEuMzUyLjM1MiwwLDAsMCw3Ljg1MiwxMi4xODdabTQuOC05Ljg0NEgxMC4yNDJsLTEtMS42NjFBMS40MDYsMS40MDYsMCwwLDAsOC4wMzksMEg1LjA4NkExLjQwNiwxLjQwNiwwLDAsMCwzLjg4LjY4M2wtMSwxLjY2MUguNDY5QS40NjkuNDY5LDAsMCwwLDAsMi44MTJ2LjQ2OWEuNDY5LjQ2OSwwLDAsMCwuNDY5LjQ2OUguOTM4djkuODQ0QTEuNDA2LDEuNDA2LDAsMCwwLDIuMzQ0LDE1aDguNDM4YTEuNDA2LDEuNDA2LDAsMCwwLDEuNDA2LTEuNDA2VjMuNzVoLjQ2OWEuNDY5LjQ2OSwwLDAsMCwuNDY5LS40NjlWMi44MTJBLjQ2OS40NjksMCwwLDAsMTIuNjU2LDIuMzQ0Wk01LjAzNCwxLjQ5MWEuMTc2LjE3NiwwLDAsMSwuMTUxLS4wODVINy45MzlhLjE3Ni4xNzYsMCwwLDEsLjE1MS4wODVsLjUxMi44NTJINC41MjNabTUuNzQ3LDEyLjFIMi4zNDRWMy43NWg4LjQzOFpNNC41NywxMi4xODdoLjdhLjM1Mi4zNTIsMCwwLDAsLjM1Mi0uMzUyVjUuNTA4YS4zNTIuMzUyLDAsMCwwLS4zNTItLjM1MmgtLjdhLjM1Mi4zNTIsMCwwLDAtLjM1Mi4zNTJ2Ni4zMjhBLjM1Mi4zNTIsMCwwLDAsNC41NywxMi4xODdaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDApIiBmaWxsPSIjZjAzYzNjIi8+Cjwvc3ZnPgo="

/***/ }),

/***/ "yBtO":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMS40ODYiIGhlaWdodD0iMTEuMzUiIHZpZXdCb3g9IjAgMCAyMS40ODYgMTEuMzUiPgogIDxwYXRoIGlkPSLjg5HjgrlfMTI2OSIgZGF0YS1uYW1lPSLjg5HjgrkgMTI2OSIgZD0iTTEyLDEzLjA3OSwyLDQuNDQyLDMuNTUzLDMuMDc5LDEyLDEwLjU4N2w4LjctNy41MDhMMjIsNC40NDJaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMS4yMzggLTIuMzkpIiBmaWxsPSIjOWJjNzM3IiBzdHJva2U9IiM5YmM3MzciIHN0cm9rZS13aWR0aD0iMSIvPgo8L3N2Zz4K"

/***/ }),

/***/ "yJA0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tutorial-tool-attraction-4.90ea7cc.jpg";

/***/ }),

/***/ "ykZO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "z3m9":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./tutorial-normal-attraction-4.jpg": "rjy3",
	"./tutorial-tool-attraction-4.jpg": "yJA0"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "z3m9";

/***/ }),

/***/ "zscX":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tutorial-report-1.c6e3b24.jpg";

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.3d0a0fd2aee2f9d1b742.js